import { customFetch } from '../../custom-fetch';
export const getMeApiMeGetUrl = () => {
    return `/api/me`;
};
/**
 * @summary Me
 */
export const meApiMeGet = async (options) => {
    return customFetch(getMeApiMeGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateMeApiMePatchUrl = () => {
    return `/api/me`;
};
/**
 * @summary Update Me
 */
export const updateMeApiMePatch = async (userSessionUpdate, options) => {
    return customFetch(getUpdateMeApiMePatchUrl(), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(userSessionUpdate)
    });
};
export const getLogoutApiLogoutGetUrl = () => {
    return `/api/logout`;
};
/**
 * @summary Logout
 */
export const logoutApiLogoutGet = async (options) => {
    return customFetch(getLogoutApiLogoutGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetLoginOptionsApiLoginOptionsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/login-options?${stringifiedParams}` : `/api/login-options`;
};
/**
 * @summary Get Login Options
 */
export const getLoginOptionsApiLoginOptionsGet = async (params, options) => {
    return customFetch(getGetLoginOptionsApiLoginOptionsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getEmailMagicLinkApiEmailMagicLinkGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/email-magic-link?${stringifiedParams}` : `/api/email-magic-link`;
};
/**
 * @summary Email Magic Link
 */
export const emailMagicLinkApiEmailMagicLinkGet = async (params, options) => {
    return customFetch(getEmailMagicLinkApiEmailMagicLinkGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getValidateLoginTokenGetApiValidateLoginTokenGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/validate-login-token?${stringifiedParams}` : `/api/validate-login-token`;
};
/**
 * Legacy entry: does not consume the token (avoids email security prefetch).
 * @summary Validate Login Token Get
 */
export const validateLoginTokenGetApiValidateLoginTokenGet = async (params, options) => {
    return customFetch(getValidateLoginTokenGetApiValidateLoginTokenGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getValidateLoginTokenPostApiValidateLoginTokenPostUrl = () => {
    return `/api/validate-login-token`;
};
/**
 * Consumes the magic link token (not used by link prefetchers that only GET).
 * @summary Validate Login Token Post
 */
export const validateLoginTokenPostApiValidateLoginTokenPost = async (options) => {
    return customFetch(getValidateLoginTokenPostApiValidateLoginTokenPostUrl(), {
        ...options,
        method: 'POST'
    });
};
export const getLoginMicrosoftApiLoginMicrosoftGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/login/microsoft?${stringifiedParams}` : `/api/login/microsoft`;
};
/**
 * @summary Login Microsoft
 */
export const loginMicrosoftApiLoginMicrosoftGet = async (params, options) => {
    return customFetch(getLoginMicrosoftApiLoginMicrosoftGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getAuthMicrosoftApiAuthMicrosoftGetUrl = () => {
    return `/api/auth/microsoft`;
};
/**
 * @summary Auth Microsoft
 */
export const authMicrosoftApiAuthMicrosoftGet = async (options) => {
    return customFetch(getAuthMicrosoftApiAuthMicrosoftGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getLoginGoogleApiLoginGoogleGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/login/google?${stringifiedParams}` : `/api/login/google`;
};
/**
 * @summary Login Google
 */
export const loginGoogleApiLoginGoogleGet = async (params, options) => {
    return customFetch(getLoginGoogleApiLoginGoogleGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getAuthGoogleApiAuthGoogleGetUrl = () => {
    return `/api/auth/google`;
};
/**
 * @summary Auth Google
 */
export const authGoogleApiAuthGoogleGet = async (options) => {
    return customFetch(getAuthGoogleApiAuthGoogleGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getLoginOktaApiLoginOktaGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/login/okta?${stringifiedParams}` : `/api/login/okta`;
};
/**
 * @summary Login Okta
 */
export const loginOktaApiLoginOktaGet = async (params, options) => {
    return customFetch(getLoginOktaApiLoginOktaGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getAuthOktaApiAuthOktaGetUrl = () => {
    return `/api/auth/okta`;
};
/**
 * @summary Auth Okta
 */
export const authOktaApiAuthOktaGet = async (options) => {
    return customFetch(getAuthOktaApiAuthOktaGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetDiagnosticsApiAdminDiagnosticsGetUrl = () => {
    return `/api/admin/diagnostics`;
};
/**
 * @summary Get Diagnostics
 */
export const getDiagnosticsApiAdminDiagnosticsGet = async (options) => {
    return customFetch(getGetDiagnosticsApiAdminDiagnosticsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetSaasTenantsApiAdminSaasTenantsGetUrl = () => {
    return `/api/admin/saas_tenants`;
};
/**
 * @summary Get Saas Tenants
 */
export const getSaasTenantsApiAdminSaasTenantsGet = async (options) => {
    return customFetch(getGetSaasTenantsApiAdminSaasTenantsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getCreateSaasTenantApiAdminSaasTenantsPostUrl = () => {
    return `/api/admin/saas_tenants`;
};
/**
 * @summary Create Saas Tenant
 */
export const createSaasTenantApiAdminSaasTenantsPost = async (surfaceCoreSystemEntitiesSaasTenantSaasTenantInput, options) => {
    return customFetch(getCreateSaasTenantApiAdminSaasTenantsPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(surfaceCoreSystemEntitiesSaasTenantSaasTenantInput)
    });
};
export const getGetSaasTenantApiAdminSaasTenantsSaasTenantIdGetUrl = ({ saasTenantId }) => {
    return `/api/admin/saas_tenants/${saasTenantId}`;
};
/**
 * @summary Get Saas Tenant
 */
export const getSaasTenantApiAdminSaasTenantsSaasTenantIdGet = async ({ saasTenantId }, options) => {
    return customFetch(getGetSaasTenantApiAdminSaasTenantsSaasTenantIdGetUrl({ saasTenantId }), {
        ...options,
        method: 'GET'
    });
};
export const getUpsertSaasTenantLicensedFeatureApiAdminSaasTenantsSaasTenantIdLicensedFeaturesPostUrl = ({ saasTenantId }) => {
    return `/api/admin/saas_tenants/${saasTenantId}/licensed-features`;
};
/**
 * Create or update a licensed feature for a SaaS tenant.
 *
 * Behaves as an upsert: when ``licensed_feature.id`` matches an existing
 * license for the tenant, that license is updated; otherwise a new license
 * is created (and a fresh id is allocated when none is supplied).
 *
 * Validations (mirror the per-property licensed-feature endpoint):
 * - License date ranges cannot overlap with another non-deleted license of
 *   the same feature type for the same tenant.
 * - If an existing license has no end date, a new license that starts in
 *   the future is rejected — the open-ended license must be closed first.
 * @summary Upsert Saas Tenant Licensed Feature
 */
export const upsertSaasTenantLicensedFeatureApiAdminSaasTenantsSaasTenantIdLicensedFeaturesPost = async ({ saasTenantId }, surfaceCoreApiEntitiesLicensedFeature, options) => {
    return customFetch(getUpsertSaasTenantLicensedFeatureApiAdminSaasTenantsSaasTenantIdLicensedFeaturesPostUrl({ saasTenantId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(surfaceCoreApiEntitiesLicensedFeature)
    });
};
export const getGetOktaSsoConfigApiAdminSaasTenantsSaasTenantIdOktaSsoConfigGetUrl = ({ saasTenantId }) => {
    return `/api/admin/saas_tenants/${saasTenantId}/okta-sso-config`;
};
/**
 * Return the (secret-stripped) Okta SSO config for the org, or null
 * if not configured. The issuer lives in the DB; the client_id is
 * sourced from AWS Secrets Manager.
 * @summary Get Okta Sso Config
 */
export const getOktaSsoConfigApiAdminSaasTenantsSaasTenantIdOktaSsoConfigGet = async ({ saasTenantId }, options) => {
    return customFetch(getGetOktaSsoConfigApiAdminSaasTenantsSaasTenantIdOktaSsoConfigGetUrl({ saasTenantId }), {
        ...options,
        method: 'GET'
    });
};
export const getUpsertOktaSsoConfigApiAdminSaasTenantsSaasTenantIdOktaSsoConfigPutUrl = ({ saasTenantId }) => {
    return `/api/admin/saas_tenants/${saasTenantId}/okta-sso-config`;
};
/**
 * @summary Upsert Okta Sso Config
 */
export const upsertOktaSsoConfigApiAdminSaasTenantsSaasTenantIdOktaSsoConfigPut = async ({ saasTenantId }, _oktaSSOConfigRequest, options) => {
    return customFetch(getUpsertOktaSsoConfigApiAdminSaasTenantsSaasTenantIdOktaSsoConfigPutUrl({ saasTenantId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(_oktaSSOConfigRequest)
    });
};
export const getDeleteOktaSsoConfigApiAdminSaasTenantsSaasTenantIdOktaSsoConfigDeleteUrl = ({ saasTenantId }) => {
    return `/api/admin/saas_tenants/${saasTenantId}/okta-sso-config`;
};
/**
 * @summary Delete Okta Sso Config
 */
export const deleteOktaSsoConfigApiAdminSaasTenantsSaasTenantIdOktaSsoConfigDelete = async ({ saasTenantId }, options) => {
    return customFetch(getDeleteOktaSsoConfigApiAdminSaasTenantsSaasTenantIdOktaSsoConfigDeleteUrl({ saasTenantId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getGetDialogueAsAdminApiAdminDialoguesDialogueIdGetUrl = ({ dialogueId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/dialogues/${dialogueId}?${stringifiedParams}` : `/api/admin/dialogues/${dialogueId}`;
};
/**
 * @summary Get Dialogue As Admin
 */
export const getDialogueAsAdminApiAdminDialoguesDialogueIdGet = async ({ dialogueId }, params, options) => {
    return customFetch(getGetDialogueAsAdminApiAdminDialoguesDialogueIdGetUrl({ dialogueId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getSearchDialoguesApiAdminDialoguesSearchPostUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/dialogues/search?${stringifiedParams}` : `/api/admin/dialogues/search`;
};
/**
 * @summary Search Dialogues
 */
export const searchDialoguesApiAdminDialoguesSearchPost = async (params, options) => {
    return customFetch(getSearchDialoguesApiAdminDialoguesSearchPostUrl(params), {
        ...options,
        method: 'POST'
    });
};
export const getCreateUserApiAdminUsersPostUrl = () => {
    return `/api/admin/users`;
};
/**
 * @summary Create User
 */
export const createUserApiAdminUsersPost = async (surfaceCoreSystemEntitiesUserUserCreate, options) => {
    return customFetch(getCreateUserApiAdminUsersPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(surfaceCoreSystemEntitiesUserUserCreate)
    });
};
export const getGetUsersApiAdminUsersGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/users?${stringifiedParams}` : `/api/admin/users`;
};
/**
 * @summary Get Users
 */
export const getUsersApiAdminUsersGet = async (params, options) => {
    return customFetch(getGetUsersApiAdminUsersGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateUserApiAdminUsersUserIdPutUrl = ({ userId }) => {
    return `/api/admin/users/${userId}`;
};
/**
 * @summary Update User
 */
export const updateUserApiAdminUsersUserIdPut = async ({ userId }, surfaceCoreSystemEntitiesUserUserUpdate, options) => {
    return customFetch(getUpdateUserApiAdminUsersUserIdPutUrl({ userId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(surfaceCoreSystemEntitiesUserUserUpdate)
    });
};
export const getGetUserApiAdminUsersUserIdGetUrl = ({ userId }) => {
    return `/api/admin/users/${userId}`;
};
/**
 * @summary Get User
 */
export const getUserApiAdminUsersUserIdGet = async ({ userId }, options) => {
    return customFetch(getGetUserApiAdminUsersUserIdGetUrl({ userId }), {
        ...options,
        method: 'GET'
    });
};
export const getSpoofUserApiAdminSpoofUserPutUrl = () => {
    return `/api/admin/spoof-user/`;
};
/**
 * @summary Spoof User
 */
export const spoofUserApiAdminSpoofUserPut = async (userInput, options) => {
    return customFetch(getSpoofUserApiAdminSpoofUserPutUrl(), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(userInput)
    });
};
export const getClearSpoofUserApiAdminSpoofUserDeleteUrl = () => {
    return `/api/admin/spoof-user/`;
};
/**
 * @summary Clear Spoof User
 */
export const clearSpoofUserApiAdminSpoofUserDelete = async (options) => {
    return customFetch(getClearSpoofUserApiAdminSpoofUserDeleteUrl(), {
        ...options,
        method: 'DELETE'
    });
};
export const getSpoofUserByEmailApiAdminSpoofUserByEmailPostUrl = () => {
    return `/api/admin/spoof-user-by-email/`;
};
/**
 * @summary Spoof User By Email
 */
export const spoofUserByEmailApiAdminSpoofUserByEmailPost = async (spoofUserByEmailRequest, options) => {
    return customFetch(getSpoofUserByEmailApiAdminSpoofUserByEmailPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(spoofUserByEmailRequest)
    });
};
export const getGetUsers2ApiAdminUsers2GetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/users2?${stringifiedParams}` : `/api/admin/users2`;
};
/**
 * @summary Get Users2
 */
export const getUsers2ApiAdminUsers2Get = async (params, options) => {
    return customFetch(getGetUsers2ApiAdminUsers2GetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetCustomersApiAdminCustomersGetUrl = () => {
    return `/api/admin/customers`;
};
/**
 * @summary Get Customers
 */
export const getCustomersApiAdminCustomersGet = async (options) => {
    return customFetch(getGetCustomersApiAdminCustomersGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getCreateCustomerApiAdminCustomersPostUrl = () => {
    return `/api/admin/customers`;
};
/**
 * @summary Create Customer
 */
export const createCustomerApiAdminCustomersPost = async (customerInput, options) => {
    return customFetch(getCreateCustomerApiAdminCustomersPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(customerInput)
    });
};
export const getGetCustomerByNameApiAdminCustomersByNameGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/customers/by-name?${stringifiedParams}` : `/api/admin/customers/by-name`;
};
/**
 * @summary Get Customer By Name
 */
export const getCustomerByNameApiAdminCustomersByNameGet = async (params, options) => {
    return customFetch(getGetCustomerByNameApiAdminCustomersByNameGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateCustomerApiAdminCustomersCustomerIdPutUrl = ({ customerId }) => {
    return `/api/admin/customers/${customerId}`;
};
/**
 * @summary Update Customer
 */
export const updateCustomerApiAdminCustomersCustomerIdPut = async ({ customerId }, customerInput, options) => {
    return customFetch(getUpdateCustomerApiAdminCustomersCustomerIdPutUrl({ customerId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(customerInput)
    });
};
export const getGetCustomerApiAdminCustomersCustomerIdGetUrl = ({ customerId }) => {
    return `/api/admin/customers/${customerId}`;
};
/**
 * @summary Get Customer
 */
export const getCustomerApiAdminCustomersCustomerIdGet = async ({ customerId }, options) => {
    return customFetch(getGetCustomerApiAdminCustomersCustomerIdGetUrl({ customerId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetSurfacePropertiesForCustomerApiAdminCustomersCustomerIdSurfacePropertiesGetUrl = ({ customerId }) => {
    return `/api/admin/customers/${customerId}/surface-properties`;
};
/**
 * @summary Get Surface Properties For Customer
 */
export const getSurfacePropertiesForCustomerApiAdminCustomersCustomerIdSurfacePropertiesGet = async ({ customerId }, options) => {
    return customFetch(getGetSurfacePropertiesForCustomerApiAdminCustomersCustomerIdSurfacePropertiesGetUrl({ customerId }), {
        ...options,
        method: 'GET'
    });
};
export const getIngestCustomerIdMappingApiAdminCustomersCustomerIdIngestCustomerIdMappingPostUrl = ({ customerId }) => {
    return `/api/admin/customers/${customerId}/ingest-customer-id-mapping`;
};
/**
 * @summary Ingest Customer Id Mapping
 */
export const ingestCustomerIdMappingApiAdminCustomersCustomerIdIngestCustomerIdMappingPost = async ({ customerId }, bodyIngestCustomerIdMappingApiAdminCustomersCustomerIdIngestCustomerIdMappingPost, options) => {
    const formData = new FormData();
    formData.append(`customer_id_mapping`, bodyIngestCustomerIdMappingApiAdminCustomersCustomerIdIngestCustomerIdMappingPost.customer_id_mapping);
    return customFetch(getIngestCustomerIdMappingApiAdminCustomersCustomerIdIngestCustomerIdMappingPostUrl({ customerId }), {
        ...options,
        method: 'POST',
        body: formData
    });
};
export const getGetProductsApiAdminProductsGetUrl = () => {
    return `/api/admin/products`;
};
/**
 * @summary Get Products
 */
export const getProductsApiAdminProductsGet = async (options) => {
    return customFetch(getGetProductsApiAdminProductsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getCreateProductApiAdminProductsPostUrl = () => {
    return `/api/admin/products`;
};
/**
 * @summary Create Product
 */
export const createProductApiAdminProductsPost = async (product, options) => {
    return customFetch(getCreateProductApiAdminProductsPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(product)
    });
};
export const getUpdateProductApiAdminProductsProductIdPutUrl = ({ productId }) => {
    return `/api/admin/products/${productId}`;
};
/**
 * @summary Update Product
 */
export const updateProductApiAdminProductsProductIdPut = async ({ productId }, product, options) => {
    return customFetch(getUpdateProductApiAdminProductsProductIdPutUrl({ productId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(product)
    });
};
export const getGetProductApiAdminProductsProductIdGetUrl = ({ productId }) => {
    return `/api/admin/products/${productId}`;
};
/**
 * @summary Get Product
 */
export const getProductApiAdminProductsProductIdGet = async ({ productId }, options) => {
    return customFetch(getGetProductApiAdminProductsProductIdGetUrl({ productId }), {
        ...options,
        method: 'GET'
    });
};
export const getCreateOrderApiAdminOrdersPostUrl = () => {
    return `/api/admin/orders`;
};
/**
 * @summary Create Order
 */
export const createOrderApiAdminOrdersPost = async (orderInput, options) => {
    return customFetch(getCreateOrderApiAdminOrdersPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(orderInput)
    });
};
export const getGetOrdersApiAdminOrdersGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/orders?${stringifiedParams}` : `/api/admin/orders`;
};
/**
 * List orders with optional filters. Used by Orders Portal.
 * @summary Get Orders
 */
export const getOrdersApiAdminOrdersGet = async (params, options) => {
    return customFetch(getGetOrdersApiAdminOrdersGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateOrderApiAdminOrdersOrderIdPutUrl = ({ orderId }) => {
    return `/api/admin/orders/${orderId}`;
};
/**
 * @summary Update Order
 */
export const updateOrderApiAdminOrdersOrderIdPut = async ({ orderId }, orderInput, options) => {
    return customFetch(getUpdateOrderApiAdminOrdersOrderIdPutUrl({ orderId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(orderInput)
    });
};
export const getDeleteOrderApiAdminOrdersOrderIdDeleteUrl = ({ orderId }) => {
    return `/api/admin/orders/${orderId}`;
};
/**
 * @summary Delete Order
 */
export const deleteOrderApiAdminOrdersOrderIdDelete = async ({ orderId }, options) => {
    return customFetch(getDeleteOrderApiAdminOrdersOrderIdDeleteUrl({ orderId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getGetOrderApiAdminOrdersOrderIdGetUrl = ({ orderId }) => {
    return `/api/admin/orders/${orderId}`;
};
/**
 * @summary Get Order
 */
export const getOrderApiAdminOrdersOrderIdGet = async ({ orderId }, options) => {
    return customFetch(getGetOrderApiAdminOrdersOrderIdGetUrl({ orderId }), {
        ...options,
        method: 'GET'
    });
};
export const getPlaceOrderApiAdminOrdersOrderIdPlacePostUrl = ({ orderId }) => {
    return `/api/admin/orders/${orderId}/place`;
};
/**
 * @summary Place Order
 */
export const placeOrderApiAdminOrdersOrderIdPlacePost = async ({ orderId }, options) => {
    return customFetch(getPlaceOrderApiAdminOrdersOrderIdPlacePostUrl({ orderId }), {
        ...options,
        method: 'POST'
    });
};
export const getCreateOrderFromOrderFormPdfApiAdminOrdersCreateFromOrderFormPdfPostUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/orders/create-from-order-form-pdf?${stringifiedParams}` : `/api/admin/orders/create-from-order-form-pdf`;
};
/**
 * @summary Create Order From Order Form Pdf
 */
export const createOrderFromOrderFormPdfApiAdminOrdersCreateFromOrderFormPdfPost = async (bodyCreateOrderFromOrderFormPdfApiAdminOrdersCreateFromOrderFormPdfPost, params, options) => {
    const formData = new FormData();
    formData.append(`order_form_pdf`, bodyCreateOrderFromOrderFormPdfApiAdminOrdersCreateFromOrderFormPdfPost.order_form_pdf);
    return customFetch(getCreateOrderFromOrderFormPdfApiAdminOrdersCreateFromOrderFormPdfPostUrl(params), {
        ...options,
        method: 'POST',
        body: formData
    });
};
export const getExtractOrderFromOrderFormPdfApiAdminOrdersExtractFromOrderFormPdfPostUrl = () => {
    return `/api/admin/orders/extract-from-order-form-pdf`;
};
/**
 * @summary Extract Order From Order Form Pdf
 */
export const extractOrderFromOrderFormPdfApiAdminOrdersExtractFromOrderFormPdfPost = async (bodyExtractOrderFromOrderFormPdfApiAdminOrdersExtractFromOrderFormPdfPost, options) => {
    const formData = new FormData();
    formData.append(`order_form_pdf`, bodyExtractOrderFromOrderFormPdfApiAdminOrdersExtractFromOrderFormPdfPost.order_form_pdf);
    return customFetch(getExtractOrderFromOrderFormPdfApiAdminOrdersExtractFromOrderFormPdfPostUrl(), {
        ...options,
        method: 'POST',
        body: formData
    });
};
export const getAddOrderNoteApiAdminOrdersOrderIdNotesPostUrl = ({ orderId }) => {
    return `/api/admin/orders/${orderId}/notes`;
};
/**
 * @summary Add Order Note
 */
export const addOrderNoteApiAdminOrdersOrderIdNotesPost = async ({ orderId }, orderNote, options) => {
    return customFetch(getAddOrderNoteApiAdminOrdersOrderIdNotesPostUrl({ orderId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(orderNote)
    });
};
export const getFindPropertyOrdersByPartialPropertyNameApiAdminPropertyOrdersFindByPartialPropertyNameGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/property-orders/find-by-partial-property-name?${stringifiedParams}` : `/api/admin/property-orders/find-by-partial-property-name`;
};
/**
 * @summary Find Property Orders By Partial Property Name
 */
export const findPropertyOrdersByPartialPropertyNameApiAdminPropertyOrdersFindByPartialPropertyNameGet = async (params, options) => {
    return customFetch(getFindPropertyOrdersByPartialPropertyNameApiAdminPropertyOrdersFindByPartialPropertyNameGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetSurfacePropertyMissingOrderInfosApiAdminPropertiesMissingOrderInfosGetUrl = () => {
    return `/api/admin/properties/missing-order-infos`;
};
/**
 * Enabled properties whose current or future licenses are not covered by a placed order.
 * @summary Get Surface Property Missing Order Infos
 */
export const getSurfacePropertyMissingOrderInfosApiAdminPropertiesMissingOrderInfosGet = async (options) => {
    return customFetch(getGetSurfacePropertyMissingOrderInfosApiAdminPropertiesMissingOrderInfosGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetPurchasedLicensedFeaturesForPropertyApiAdminPropertiesPropertyIdPurchasedLicensedFeaturesGetUrl = ({ propertyId }) => {
    return `/api/admin/properties/${propertyId}/purchased-licensed-features`;
};
/**
 * Licensed features on placed orders for a surface property.
 * @summary Get Purchased Licensed Features For Property
 */
export const getPurchasedLicensedFeaturesForPropertyApiAdminPropertiesPropertyIdPurchasedLicensedFeaturesGet = async ({ propertyId }, options) => {
    return customFetch(getGetPurchasedLicensedFeaturesForPropertyApiAdminPropertiesPropertyIdPurchasedLicensedFeaturesGetUrl({ propertyId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetUnlinkedLicensedFeatureOrderCandidatesApiAdminPropertiesUnlinkedLicensedFeatureOrderCandidatesPostUrl = () => {
    return `/api/admin/properties/unlinked-licensed-feature-order-candidates`;
};
/**
 * Unlinked order-item properties whose names match the given surface properties.
 * @summary Get Unlinked Licensed Feature Order Candidates
 */
export const getUnlinkedLicensedFeatureOrderCandidatesApiAdminPropertiesUnlinkedLicensedFeatureOrderCandidatesPost = async (unlinkedLicensedFeatureOrderCandidatesRequest, options) => {
    return customFetch(getGetUnlinkedLicensedFeatureOrderCandidatesApiAdminPropertiesUnlinkedLicensedFeatureOrderCandidatesPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(unlinkedLicensedFeatureOrderCandidatesRequest)
    });
};
export const getLinkOrderItemPropertiesApiAdminPropertiesLinkOrderItemPropertiesPostUrl = () => {
    return `/api/admin/properties/link-order-item-properties`;
};
/**
 * Append each surface property id onto the chosen order item properties.
 * @summary Link Order Item Properties
 */
export const linkOrderItemPropertiesApiAdminPropertiesLinkOrderItemPropertiesPost = async (linkOrderItemPropertiesRequest, options) => {
    return customFetch(getLinkOrderItemPropertiesApiAdminPropertiesLinkOrderItemPropertiesPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(linkOrderItemPropertiesRequest)
    });
};
export const getUpdateOrderItemApiAdminOrderItemsOrderItemIdPutUrl = ({ orderItemId }) => {
    return `/api/admin/order-items/${orderItemId}`;
};
/**
 * @summary Update Order Item
 */
export const updateOrderItemApiAdminOrderItemsOrderItemIdPut = async ({ orderItemId }, orderItemUpdate, options) => {
    return customFetch(getUpdateOrderItemApiAdminOrderItemsOrderItemIdPutUrl({ orderItemId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(orderItemUpdate)
    });
};
export const getUpdateOrderItemPropertyApiAdminOrderItemPropertiesOrderItemPropertyIdPutUrl = ({ orderItemPropertyId }) => {
    return `/api/admin/order-item-properties/${orderItemPropertyId}`;
};
/**
 * @summary Update Order Item Property
 */
export const updateOrderItemPropertyApiAdminOrderItemPropertiesOrderItemPropertyIdPut = async ({ orderItemPropertyId }, orderItemPropertyUpdate, options) => {
    return customFetch(getUpdateOrderItemPropertyApiAdminOrderItemPropertiesOrderItemPropertyIdPutUrl({ orderItemPropertyId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(orderItemPropertyUpdate)
    });
};
export const getGetUtilizationPrepurchaseLedgerViewsApiAdminUtilizationPrepurchaseLedgerViewsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/utilization-prepurchase-ledger-views?${stringifiedParams}` : `/api/admin/utilization-prepurchase-ledger-views`;
};
/**
 * @summary Get Utilization Prepurchase Ledger Views
 */
export const getUtilizationPrepurchaseLedgerViewsApiAdminUtilizationPrepurchaseLedgerViewsGet = async (params, options) => {
    return customFetch(getGetUtilizationPrepurchaseLedgerViewsApiAdminUtilizationPrepurchaseLedgerViewsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetUtilizationPrepurchaseLedgerViewApiAdminUtilizationPrepurchaseLedgerViewsLedgerIdGetUrl = ({ ledgerId }) => {
    return `/api/admin/utilization-prepurchase-ledger-views/${ledgerId}`;
};
/**
 * @summary Get Utilization Prepurchase Ledger View
 */
export const getUtilizationPrepurchaseLedgerViewApiAdminUtilizationPrepurchaseLedgerViewsLedgerIdGet = async ({ ledgerId }, options) => {
    return customFetch(getGetUtilizationPrepurchaseLedgerViewApiAdminUtilizationPrepurchaseLedgerViewsLedgerIdGetUrl({ ledgerId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetUserRolesApiAdminPropertyRolesGetUrl = () => {
    return `/api/admin/property-roles`;
};
/**
 * @summary Get User Roles
 */
export const getUserRolesApiAdminPropertyRolesGet = async (options) => {
    return customFetch(getGetUserRolesApiAdminPropertyRolesGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetConfigDiffFromS3ApiAdminConfigDiffDiffUuidGetUrl = ({ diffUuid }) => {
    return `/api/admin/config-diff/${diffUuid}`;
};
/**
 * Retrieve and display HTML diff report from S3 using a UUID identifier.
 *
 * The diff_uuid parameter should be a UUID that corresponds to an HTML file
 * in the surface-agent-reports bucket at config-commander/{diff_uuid}.html.
 * @summary Get Config Diff From S3
 */
export const getConfigDiffFromS3ApiAdminConfigDiffDiffUuidGet = async ({ diffUuid }, options) => {
    return customFetch(getGetConfigDiffFromS3ApiAdminConfigDiffDiffUuidGetUrl({ diffUuid }), {
        ...options,
        method: 'GET'
    });
};
export const getGetAgentReportFromS3ApiAdminAgentReportsReportTypeReportUuidGetUrl = ({ reportType, reportUuid }) => {
    return `/api/admin/agent-reports/${reportType}/${reportUuid}`;
};
/**
 * Retrieve an agent-generated report from S3 (HTML inline, other formats as a download).
 *
 * Objects live in the surface-agent-reports bucket at {report_type}/{report_uuid}.{ext}
 * (html, pdf, xlsx, csv).
 * @summary Get Agent Report From S3
 */
export const getAgentReportFromS3ApiAdminAgentReportsReportTypeReportUuidGet = async ({ reportType, reportUuid }, options) => {
    return customFetch(getGetAgentReportFromS3ApiAdminAgentReportsReportTypeReportUuidGetUrl({ reportType, reportUuid }), {
        ...options,
        method: 'GET'
    });
};
export const getGetIndustriesForSaasTenantApiAdminDemographicNormalizationIndustriesGetUrl = () => {
    return `/api/admin/demographic-normalization/industries`;
};
/**
 * @summary Get Industries For Saas Tenant
 */
export const getIndustriesForSaasTenantApiAdminDemographicNormalizationIndustriesGet = async (options) => {
    return customFetch(getGetIndustriesForSaasTenantApiAdminDemographicNormalizationIndustriesGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getUpsertIndustriesForSaasTenantApiAdminDemographicNormalizationIndustriesPutUrl = () => {
    return `/api/admin/demographic-normalization/industries`;
};
/**
 * @summary Upsert Industries For Saas Tenant
 */
export const upsertIndustriesForSaasTenantApiAdminDemographicNormalizationIndustriesPut = async (upsertIndustriesForSaasTenantApiAdminDemographicNormalizationIndustriesPutBody, options) => {
    return customFetch(getUpsertIndustriesForSaasTenantApiAdminDemographicNormalizationIndustriesPutUrl(), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(upsertIndustriesForSaasTenantApiAdminDemographicNormalizationIndustriesPutBody)
    });
};
export const getGetOccupationsForSaasTenantApiAdminDemographicNormalizationOccupationsGetUrl = () => {
    return `/api/admin/demographic-normalization/occupations`;
};
/**
 * @summary Get Occupations For Saas Tenant
 */
export const getOccupationsForSaasTenantApiAdminDemographicNormalizationOccupationsGet = async (options) => {
    return customFetch(getGetOccupationsForSaasTenantApiAdminDemographicNormalizationOccupationsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getUpsertOccupationsForSaasTenantApiAdminDemographicNormalizationOccupationsPutUrl = () => {
    return `/api/admin/demographic-normalization/occupations`;
};
/**
 * @summary Upsert Occupations For Saas Tenant
 */
export const upsertOccupationsForSaasTenantApiAdminDemographicNormalizationOccupationsPut = async (upsertOccupationsForSaasTenantApiAdminDemographicNormalizationOccupationsPutBody, options) => {
    return customFetch(getUpsertOccupationsForSaasTenantApiAdminDemographicNormalizationOccupationsPutUrl(), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(upsertOccupationsForSaasTenantApiAdminDemographicNormalizationOccupationsPutBody)
    });
};
export const getGetInfraConfigApiAdminInfraConfigGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/infra/config?${stringifiedParams}` : `/api/admin/infra/config`;
};
/**
 * @summary Get Infra Config
 */
export const getInfraConfigApiAdminInfraConfigGet = async (params, options) => {
    return customFetch(getGetInfraConfigApiAdminInfraConfigGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetAppByIdApiCoreApplicationsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/core/applications?${stringifiedParams}` : `/api/core/applications`;
};
/**
 * @summary Get App By Id
 */
export const getAppByIdApiCoreApplicationsGet = async (params, options) => {
    return customFetch(getGetAppByIdApiCoreApplicationsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetUnitByNumberApiCoreUnitsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/core/units?${stringifiedParams}` : `/api/core/units`;
};
/**
 * @summary Get Unit By Number
 */
export const getUnitByNumberApiCoreUnitsGet = async (params, options) => {
    return customFetch(getGetUnitByNumberApiCoreUnitsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getEvalDialoguesApiAdminEvalDialoguesPostUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/eval-dialogues?${stringifiedParams}` : `/api/admin/eval-dialogues`;
};
/**
 * @summary Eval Dialogues
 */
export const evalDialoguesApiAdminEvalDialoguesPost = async (dialogueEvalRequest, params, options) => {
    return customFetch(getEvalDialoguesApiAdminEvalDialoguesPostUrl(params), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(dialogueEvalRequest)
    });
};
export const getGetGlobalChargeTypeMappingsApiAdminChargeCodesGlobalMappingGetUrl = () => {
    return `/api/admin/charge_codes/global_mapping/`;
};
/**
 * @summary Get Global Charge Type Mappings
 */
export const getGlobalChargeTypeMappingsApiAdminChargeCodesGlobalMappingGet = async (options) => {
    return customFetch(getGetGlobalChargeTypeMappingsApiAdminChargeCodesGlobalMappingGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetGlobalChargeTypeMappingApiAdminChargeCodesGlobalMappingChargeCodeNameGetUrl = ({ chargeCodeName }) => {
    return `/api/admin/charge_codes/global_mapping/${chargeCodeName}`;
};
/**
 * @summary Get Global Charge Type Mapping
 */
export const getGlobalChargeTypeMappingApiAdminChargeCodesGlobalMappingChargeCodeNameGet = async ({ chargeCodeName }, options) => {
    return customFetch(getGetGlobalChargeTypeMappingApiAdminChargeCodesGlobalMappingChargeCodeNameGetUrl({ chargeCodeName }), {
        ...options,
        method: 'GET'
    });
};
export const getUpsertGlobalChargeTypeMappingApiAdminChargeCodesGlobalMappingChargeCodeNamePutUrl = ({ chargeCodeName }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/charge_codes/global_mapping/${chargeCodeName}?${stringifiedParams}` : `/api/admin/charge_codes/global_mapping/${chargeCodeName}`;
};
/**
 * @summary Upsert Global Charge Type Mapping
 */
export const upsertGlobalChargeTypeMappingApiAdminChargeCodesGlobalMappingChargeCodeNamePut = async ({ chargeCodeName }, params, options) => {
    return customFetch(getUpsertGlobalChargeTypeMappingApiAdminChargeCodesGlobalMappingChargeCodeNamePutUrl({ chargeCodeName }, params), {
        ...options,
        method: 'PUT'
    });
};
export const getDeleteGlobalChargeTypeMappingApiAdminChargeCodesGlobalMappingChargeCodeNameDeleteUrl = ({ chargeCodeName }) => {
    return `/api/admin/charge_codes/global_mapping/${chargeCodeName}`;
};
/**
 * @summary Delete Global Charge Type Mapping
 */
export const deleteGlobalChargeTypeMappingApiAdminChargeCodesGlobalMappingChargeCodeNameDelete = async ({ chargeCodeName }, options) => {
    return customFetch(getDeleteGlobalChargeTypeMappingApiAdminChargeCodesGlobalMappingChargeCodeNameDeleteUrl({ chargeCodeName }), {
        ...options,
        method: 'DELETE'
    });
};
export const getGetLlmNormalizationLogsApiAdminChargeCodesLlmNormalizationLogsChargeCodeNameGetUrl = ({ chargeCodeName }) => {
    return `/api/admin/charge_codes/llm_normalization_logs/${chargeCodeName}`;
};
/**
 * @summary Get Llm Normalization Logs
 */
export const getLlmNormalizationLogsApiAdminChargeCodesLlmNormalizationLogsChargeCodeNameGet = async ({ chargeCodeName }, options) => {
    return customFetch(getGetLlmNormalizationLogsApiAdminChargeCodesLlmNormalizationLogsChargeCodeNameGetUrl({ chargeCodeName }), {
        ...options,
        method: 'GET'
    });
};
export const getGetFunctionDefinitionsApiAdminFunctionDefinitionsGetUrl = () => {
    return `/api/admin/function_definitions`;
};
/**
 * @summary Get Function Definitions
 */
export const getFunctionDefinitionsApiAdminFunctionDefinitionsGet = async (options) => {
    return customFetch(getGetFunctionDefinitionsApiAdminFunctionDefinitionsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditDebugApiAdminLeaseAuditDebugGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/lease-audit-debug?${stringifiedParams}` : `/api/admin/lease-audit-debug`;
};
/**
 * @summary Get Lease Audit Debug
 */
export const getLeaseAuditDebugApiAdminLeaseAuditDebugGet = async (params, options) => {
    return customFetch(getGetLeaseAuditDebugApiAdminLeaseAuditDebugGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditDocumentPmsComparisonApiAdminLeaseAuditDebugDocumentPmsComparisonGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/lease-audit-debug/document-pms-comparison?${stringifiedParams}` : `/api/admin/lease-audit-debug/document-pms-comparison`;
};
/**
 * Compare lease documents stored in Surface to the current PMS list (Entrata IDs or Yardi file names).
 * @summary Get Lease Audit Document Pms Comparison
 */
export const getLeaseAuditDocumentPmsComparisonApiAdminLeaseAuditDebugDocumentPmsComparisonGet = async (params, options) => {
    return customFetch(getGetLeaseAuditDocumentPmsComparisonApiAdminLeaseAuditDebugDocumentPmsComparisonGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditDebugTokenCostsApiAdminLeaseAuditDebugTokenCostsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/lease-audit-debug/token-costs?${stringifiedParams}` : `/api/admin/lease-audit-debug/token-costs`;
};
/**
 * HTML fragment for lease audit token costs (loaded on demand from the debug page).
 * @summary Get Lease Audit Debug Token Costs
 */
export const getLeaseAuditDebugTokenCostsApiAdminLeaseAuditDebugTokenCostsGet = async (params, options) => {
    return customFetch(getGetLeaseAuditDebugTokenCostsApiAdminLeaseAuditDebugTokenCostsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditDebugRelatedJobRunsApiAdminLeaseAuditDebugRelatedJobRunsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/lease-audit-debug/related-job-runs?${stringifiedParams}` : `/api/admin/lease-audit-debug/related-job-runs`;
};
/**
 * HTML document for related job runs (loaded on demand from the debug page).
 * @summary Get Lease Audit Debug Related Job Runs
 */
export const getLeaseAuditDebugRelatedJobRunsApiAdminLeaseAuditDebugRelatedJobRunsGet = async (params, options) => {
    return customFetch(getGetLeaseAuditDebugRelatedJobRunsApiAdminLeaseAuditDebugRelatedJobRunsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditReconciliationHtmlApiAdminLeaseAuditDebugReconciliationHtmlGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/lease-audit-debug/reconciliation-html?${stringifiedParams}` : `/api/admin/lease-audit-debug/reconciliation-html`;
};
/**
 * Returns just the reconciliation HTML fragment for embedding in a modal.
 * Uses the same inputs as get_lease_audit_debug (property_id, lease_audit_id, lease_audit_run_id).
 * @summary Get Lease Audit Reconciliation Html
 */
export const getLeaseAuditReconciliationHtmlApiAdminLeaseAuditDebugReconciliationHtmlGet = async (params, options) => {
    return customFetch(getGetLeaseAuditReconciliationHtmlApiAdminLeaseAuditDebugReconciliationHtmlGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetDocumentExtractionApiAdminDocumentExtractionGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/document-extraction?${stringifiedParams}` : `/api/admin/document-extraction`;
};
/**
 * @summary Get Document Extraction
 */
export const getDocumentExtractionApiAdminDocumentExtractionGet = async (params, options) => {
    return customFetch(getGetDocumentExtractionApiAdminDocumentExtractionGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getDeleteDocumentExtractionApiAdminDocumentExtractionsDeleteUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/document-extractions?${stringifiedParams}` : `/api/admin/document-extractions`;
};
/**
 * @summary Delete Document Extraction
 */
export const deleteDocumentExtractionApiAdminDocumentExtractionsDelete = async (params, options) => {
    return customFetch(getDeleteDocumentExtractionApiAdminDocumentExtractionsDeleteUrl(params), {
        ...options,
        method: 'DELETE'
    });
};
export const getDeleteDocumentProfileApiAdminDocumentProfileDeleteUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/document-profile?${stringifiedParams}` : `/api/admin/document-profile`;
};
/**
 * @summary Delete Document Profile
 */
export const deleteDocumentProfileApiAdminDocumentProfileDelete = async (params, options) => {
    return customFetch(getDeleteDocumentProfileApiAdminDocumentProfileDeleteUrl(params), {
        ...options,
        method: 'DELETE'
    });
};
export const getGetDocumentTimelineApiAdminDocumentTimelineGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/document-timeline?${stringifiedParams}` : `/api/admin/document-timeline`;
};
/**
 * @summary Get Document Timeline
 */
export const getDocumentTimelineApiAdminDocumentTimelineGet = async (params, options) => {
    return customFetch(getGetDocumentTimelineApiAdminDocumentTimelineGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetPmsLeaseDocumentApiAdminPropertiesPropertyIdPmsLeaseDocumentsDocumentIdGetUrl = ({ propertyId, documentId }) => {
    return `/api/admin/properties/${propertyId}/pms-lease-documents/${documentId}`;
};
/**
 * Serves the contents of a PMS lease document by document ID
 * @summary Get Pms Lease Document
 */
export const getPmsLeaseDocumentApiAdminPropertiesPropertyIdPmsLeaseDocumentsDocumentIdGet = async ({ propertyId, documentId }, options) => {
    return customFetch(getGetPmsLeaseDocumentApiAdminPropertiesPropertyIdPmsLeaseDocumentsDocumentIdGetUrl({ propertyId, documentId }), {
        ...options,
        method: 'GET'
    });
};
export const getSaveLeaseAuditTagApiAdminLeaseAuditsTagsPostUrl = () => {
    return `/api/admin/lease-audits/tags`;
};
/**
 * @summary Save Lease Audit Tag
 */
export const saveLeaseAuditTagApiAdminLeaseAuditsTagsPost = async (bodySaveLeaseAuditTagApiAdminLeaseAuditsTagsPost, options) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(`property_id`, bodySaveLeaseAuditTagApiAdminLeaseAuditsTagsPost.property_id);
    formUrlEncoded.append(`lease_audit_id`, bodySaveLeaseAuditTagApiAdminLeaseAuditsTagsPost.lease_audit_id);
    formUrlEncoded.append(`lease_audit_run_id`, bodySaveLeaseAuditTagApiAdminLeaseAuditsTagsPost.lease_audit_run_id);
    formUrlEncoded.append(`tag`, bodySaveLeaseAuditTagApiAdminLeaseAuditsTagsPost.tag);
    return customFetch(getSaveLeaseAuditTagApiAdminLeaseAuditsTagsPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', ...options?.headers },
        body: formUrlEncoded
    });
};
export const getGetYardiLeaseDocumentsPayloadsApiAdminPmsProxyYardiLeaseDocumentsPayloadsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/pms-proxy/yardi/lease-documents-payloads?${stringifiedParams}` : `/api/admin/pms-proxy/yardi/lease-documents-payloads`;
};
/**
 * @summary Get Yardi Lease Documents Payloads
 */
export const getYardiLeaseDocumentsPayloadsApiAdminPmsProxyYardiLeaseDocumentsPayloadsGet = async (params, options) => {
    return customFetch(getGetYardiLeaseDocumentsPayloadsApiAdminPmsProxyYardiLeaseDocumentsPayloadsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetYardiResidentDocumentPayloadsApiAdminPmsProxyYardiResidentDocumentPayloadsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/pms-proxy/yardi/resident-document-payloads?${stringifiedParams}` : `/api/admin/pms-proxy/yardi/resident-document-payloads`;
};
/**
 * @summary Get Yardi Resident Document Payloads
 */
export const getYardiResidentDocumentPayloadsApiAdminPmsProxyYardiResidentDocumentPayloadsGet = async (params, options) => {
    return customFetch(getGetYardiResidentDocumentPayloadsApiAdminPmsProxyYardiResidentDocumentPayloadsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetEntrataLeaseDocumentsApiAdminPmsProxyEntrataLeaseDocumentsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/pms-proxy/entrata/lease-documents?${stringifiedParams}` : `/api/admin/pms-proxy/entrata/lease-documents`;
};
/**
 * @summary Get Entrata Lease Documents
 */
export const getEntrataLeaseDocumentsApiAdminPmsProxyEntrataLeaseDocumentsGet = async (params, options) => {
    return customFetch(getGetEntrataLeaseDocumentsApiAdminPmsProxyEntrataLeaseDocumentsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetEntrataLeaseDocumentContentApiAdminPmsProxyEntrataLeaseDocumentContentGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/pms-proxy/entrata/lease-document-content?${stringifiedParams}` : `/api/admin/pms-proxy/entrata/lease-document-content`;
};
/**
 * Get a specific lease document content from Entrata PMS via the proxy service.
 * Returns the PDF/document content directly from Entrata's base64 FileData.
 * @summary Get Entrata Lease Document Content
 */
export const getEntrataLeaseDocumentContentApiAdminPmsProxyEntrataLeaseDocumentContentGet = async (params, options) => {
    return customFetch(getGetEntrataLeaseDocumentContentApiAdminPmsProxyEntrataLeaseDocumentContentGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetYardiLeaseDocumentContentApiAdminPmsProxyYardiLeaseDocumentContentGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/pms-proxy/yardi/lease-document-content?${stringifiedParams}` : `/api/admin/pms-proxy/yardi/lease-document-content`;
};
/**
 * Get a specific lease document content from Yardi PMS via the proxy service.
 * Returns the PDF/document content directly from Yardi's GetTenantDocument API.
 *
 * For Yardi, document_id is the lease_document.fileName (Yardi FileName).
 * Optional interface (BillingPayments / ILSGuestCard) selects which Voyager
 * interface to use; when omitted the proxy falls back to resident_document or tries both.
 * @summary Get Yardi Lease Document Content
 */
export const getYardiLeaseDocumentContentApiAdminPmsProxyYardiLeaseDocumentContentGet = async (params, options) => {
    return customFetch(getGetYardiLeaseDocumentContentApiAdminPmsProxyYardiLeaseDocumentContentGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetEntrataLeasePayloadApiAdminPmsProxyEntrataLeasePayloadGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/pms-proxy/entrata/lease-payload?${stringifiedParams}` : `/api/admin/pms-proxy/entrata/lease-payload`;
};
/**
 * Get the raw lease payload from Entrata PMS via the proxy service.
 * Returns the full JSON response from Entrata's API for the specific lease.
 * @summary Get Entrata Lease Payload
 */
export const getEntrataLeasePayloadApiAdminPmsProxyEntrataLeasePayloadGet = async (params, options) => {
    return customFetch(getGetEntrataLeasePayloadApiAdminPmsProxyEntrataLeasePayloadGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetEntrataLedgerApiAdminPmsProxyEntrataLedgerGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/pms-proxy/entrata/ledger?${stringifiedParams}` : `/api/admin/pms-proxy/entrata/ledger`;
};
/**
 * Get the ledger data from Entrata PMS via the proxy service.
 * Returns the full JSON response from Entrata's ledger API for the specific lease.
 * @summary Get Entrata Ledger
 */
export const getEntrataLedgerApiAdminPmsProxyEntrataLedgerGet = async (params, options) => {
    return customFetch(getGetEntrataLedgerApiAdminPmsProxyEntrataLedgerGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetEntrataLeadEventsApiAdminPmsProxyEntrataLeadEventsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/pms-proxy/entrata/lead-events?${stringifiedParams}` : `/api/admin/pms-proxy/entrata/lead-events`;
};
/**
 * Live Entrata lead events (getLeadEvents) via PMS proxy. Window is computed on the proxy
 * from lease_period_start (ISO date): six months before through six months after.
 * @summary Get Entrata Lead Events
 */
export const getEntrataLeadEventsApiAdminPmsProxyEntrataLeadEventsGet = async (params, options) => {
    return customFetch(getGetEntrataLeadEventsApiAdminPmsProxyEntrataLeadEventsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetAwsLogsForJobApiAdminAwsLogsJobqueueJobIdGetUrl = ({ jobId }) => {
    return `/api/admin/aws-logs/jobqueue/${jobId}`;
};
/**
 * @summary Get Aws Logs For Job
 */
export const getAwsLogsForJobApiAdminAwsLogsJobqueueJobIdGet = async ({ jobId }, options) => {
    return customFetch(getGetAwsLogsForJobApiAdminAwsLogsJobqueueJobIdGetUrl({ jobId }), {
        ...options,
        method: 'GET'
    });
};
export const getQueueRefreshDocumentStateApiAdminQueueRefreshDocumentStatePostUrl = () => {
    return `/api/admin/queue-refresh-document-state`;
};
/**
 * @summary Queue Refresh Document State
 */
export const queueRefreshDocumentStateApiAdminQueueRefreshDocumentStatePost = async (options) => {
    return customFetch(getQueueRefreshDocumentStateApiAdminQueueRefreshDocumentStatePostUrl(), {
        ...options,
        method: 'POST'
    });
};
export const getQueueForceSyncLeaseDocumentsApiAdminQueueForceSyncLeaseDocumentsPostUrl = () => {
    return `/api/admin/queue-force-sync-lease-documents`;
};
/**
 * @summary Queue Force Sync Lease Documents
 */
export const queueForceSyncLeaseDocumentsApiAdminQueueForceSyncLeaseDocumentsPost = async (options) => {
    return customFetch(getQueueForceSyncLeaseDocumentsApiAdminQueueForceSyncLeaseDocumentsPostUrl(), {
        ...options,
        method: 'POST'
    });
};
export const getQueueLedgerHistorySyncApiAdminQueueLedgerHistorySyncPostUrl = () => {
    return `/api/admin/queue-ledger-history-sync`;
};
/**
 * @summary Queue Ledger History Sync
 */
export const queueLedgerHistorySyncApiAdminQueueLedgerHistorySyncPost = async (options) => {
    return customFetch(getQueueLedgerHistorySyncApiAdminQueueLedgerHistorySyncPostUrl(), {
        ...options,
        method: 'POST'
    });
};
export const getQueueDocumentContentSyncApiAdminQueueDocumentContentSyncPostUrl = () => {
    return `/api/admin/queue-document-content-sync`;
};
/**
 * @summary Queue Document Content Sync
 */
export const queueDocumentContentSyncApiAdminQueueDocumentContentSyncPost = async (options) => {
    return customFetch(getQueueDocumentContentSyncApiAdminQueueDocumentContentSyncPostUrl(), {
        ...options,
        method: 'POST'
    });
};
export const getQueueDocumentExtractionsApiAdminQueueDocumentExtractionsPostUrl = () => {
    return `/api/admin/queue-document-extractions`;
};
/**
 * Find documents matching criteria and enqueue individual extraction jobs.
 * If document_ids is provided, it takes precedence over property_ids/classifications.
 * @summary Queue Document Extractions
 */
export const queueDocumentExtractionsApiAdminQueueDocumentExtractionsPost = async (queueDocumentExtractionsRequest, options) => {
    return customFetch(getQueueDocumentExtractionsApiAdminQueueDocumentExtractionsPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(queueDocumentExtractionsRequest)
    });
};
export const getGetJobDirectivesRedirectApiAdminJobDirectivesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/job-directives?${stringifiedParams}` : `/api/admin/job-directives`;
};
/**
 * Redirect to the new job-queue endpoint.
 * This endpoint is deprecated, use /job-queue/job-directives instead.
 * @summary Get Job Directives Redirect
 */
export const getJobDirectivesRedirectApiAdminJobDirectivesGet = async (params, options) => {
    return customFetch(getGetJobDirectivesRedirectApiAdminJobDirectivesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getCheckFeatureFlagApiAdminFeatureFlagFeatureNameGetUrl = ({ featureName }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/admin/feature-flag/${featureName}?${stringifiedParams}` : `/api/admin/feature-flag/${featureName}`;
};
/**
 * Check the value of a feature flag.
 *
 * Args:
 *     feature_name: The name of the feature flag to check
 *     property_id: Optional property ID for property-specific overrides
 *
 * Returns:
 *     dict: Feature flag status and details
 * @summary Check Feature Flag
 */
export const checkFeatureFlagApiAdminFeatureFlagFeatureNameGet = async ({ featureName }, params, options) => {
    return customFetch(getCheckFeatureFlagApiAdminFeatureFlagFeatureNameGetUrl({ featureName }, params), {
        ...options,
        method: 'GET'
    });
};
export const getSaveLeaseAuditCheckTagApiAdminLeaseAuditsCheckTagsPutUrl = () => {
    return `/api/admin/lease-audits/check-tags`;
};
/**
 * @summary Save Lease Audit Check Tag
 */
export const saveLeaseAuditCheckTagApiAdminLeaseAuditsCheckTagsPut = async (bodySaveLeaseAuditCheckTagApiAdminLeaseAuditsCheckTagsPut, options) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(`property_id`, bodySaveLeaseAuditCheckTagApiAdminLeaseAuditsCheckTagsPut.property_id);
    formUrlEncoded.append(`lease_audit_id`, bodySaveLeaseAuditCheckTagApiAdminLeaseAuditsCheckTagsPut.lease_audit_id);
    formUrlEncoded.append(`check_type`, bodySaveLeaseAuditCheckTagApiAdminLeaseAuditsCheckTagsPut.check_type);
    formUrlEncoded.append(`tag`, bodySaveLeaseAuditCheckTagApiAdminLeaseAuditsCheckTagsPut.tag);
    if (bodySaveLeaseAuditCheckTagApiAdminLeaseAuditsCheckTagsPut.internal_issue_id !== undefined && bodySaveLeaseAuditCheckTagApiAdminLeaseAuditsCheckTagsPut.internal_issue_id !== null) {
        formUrlEncoded.append(`internal_issue_id`, bodySaveLeaseAuditCheckTagApiAdminLeaseAuditsCheckTagsPut.internal_issue_id.toString());
    }
    if (bodySaveLeaseAuditCheckTagApiAdminLeaseAuditsCheckTagsPut.github_issue_url !== undefined && bodySaveLeaseAuditCheckTagApiAdminLeaseAuditsCheckTagsPut.github_issue_url !== null) {
        formUrlEncoded.append(`github_issue_url`, bodySaveLeaseAuditCheckTagApiAdminLeaseAuditsCheckTagsPut.github_issue_url);
    }
    return customFetch(getSaveLeaseAuditCheckTagApiAdminLeaseAuditsCheckTagsPutUrl(), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', ...options?.headers },
        body: formUrlEncoded
    });
};
export const getQueueRevenueRealizationApiAdminQueueRevenueRealizationPostUrl = () => {
    return `/api/admin/queue-revenue-realization`;
};
/**
 * @summary Queue Revenue Realization
 */
export const queueRevenueRealizationApiAdminQueueRevenueRealizationPost = async (options) => {
    return customFetch(getQueueRevenueRealizationApiAdminQueueRevenueRealizationPostUrl(), {
        ...options,
        method: 'POST'
    });
};
export const getJobQueueHomeApiJobQueueGetUrl = () => {
    return `/api/job-queue`;
};
/**
 * Job Queue Management Interface with tabs for job directives and job processes
 * @summary Job Queue Home
 */
export const jobQueueHomeApiJobQueueGet = async (options) => {
    return customFetch(getJobQueueHomeApiJobQueueGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getRedirectOldJobDirectivesApiJobQueueJobDirectivesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/job-queue/job-directives?${stringifiedParams}` : `/api/job-queue/job-directives`;
};
/**
 * Redirect old endpoint to new tabbed interface
 * @summary Redirect Old Job Directives
 */
export const redirectOldJobDirectivesApiJobQueueJobDirectivesGet = async (params, options) => {
    return customFetch(getRedirectOldJobDirectivesApiJobQueueJobDirectivesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetJobDirectivesTableApiJobQueueApiJobDirectivesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/job-queue/api/job-directives?${stringifiedParams}` : `/api/job-queue/api/job-directives`;
};
/**
 * Get job directives table content (API endpoint for AJAX loading)
 *
 * Args:
 *     job_type: Optional job type filter
 *     worker_image_type: Optional worker image type filter
 *     status: Optional status filter ('completed', 'failed', 'running', 'queued')
 *     job_id: Optional specific job ID to look up
 *     process_id: Optional process ID to filter by
 *     directive_key: Optional directive key to filter by
 *     directive_value: Optional directive value to filter by (must be used with directive_key)
 *     limit: Maximum number of results to return (default 100)
 * @summary Get Job Directives Table
 */
export const getJobDirectivesTableApiJobQueueApiJobDirectivesGet = async (params, options) => {
    return customFetch(getGetJobDirectivesTableApiJobQueueApiJobDirectivesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetJobProcessesTableApiJobQueueApiJobProcessesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/job-queue/api/job-processes?${stringifiedParams}` : `/api/job-queue/api/job-processes`;
};
/**
 * Get job processes table content (API endpoint for AJAX loading)
 *
 * Args:
 *     process_type: Optional process type filter
 *     status: Optional status filter ('completed' or 'in_progress')
 *     process_id: Optional specific job process ID to look up
 *     limit: Maximum number of results to return (default 100)
 * @summary Get Job Processes Table
 */
export const getJobProcessesTableApiJobQueueApiJobProcessesGet = async (params, options) => {
    return customFetch(getGetJobProcessesTableApiJobQueueApiJobProcessesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetJobDirectiveDetailsApiJobQueueApiJobDirectiveDetailsJobIdGetUrl = ({ jobId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/job-queue/api/job-directive-details/${jobId}?${stringifiedParams}` : `/api/job-queue/api/job-directive-details/${jobId}`;
};
/**
 * Get detailed information about a specific job directive
 * @summary Get Job Directive Details
 */
export const getJobDirectiveDetailsApiJobQueueApiJobDirectiveDetailsJobIdGet = async ({ jobId }, params, options) => {
    return customFetch(getGetJobDirectiveDetailsApiJobQueueApiJobDirectiveDetailsJobIdGetUrl({ jobId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getClearRunAfterForJobApiJobQueueApiClearRunAfterJobIdPostUrl = ({ jobId }) => {
    return `/api/job-queue/api/clear-run-after/${jobId}`;
};
/**
 * Clear ``run_after_date`` on an unfinished job so it becomes eligible for workers immediately.
 * @summary Clear Run After For Job
 */
export const clearRunAfterForJobApiJobQueueApiClearRunAfterJobIdPost = async ({ jobId }, options) => {
    return customFetch(getClearRunAfterForJobApiJobQueueApiClearRunAfterJobIdPostUrl({ jobId }), {
        ...options,
        method: 'POST'
    });
};
export const getClearReservedByApiJobQueueApiClearReservedByJobIdPostUrl = ({ jobId }) => {
    return `/api/job-queue/api/clear-reserved-by/${jobId}`;
};
/**
 * Clear ``reserved_by`` on an unfinished job so another worker can pick it up.
 * @summary Clear Reserved By
 */
export const clearReservedByApiJobQueueApiClearReservedByJobIdPost = async ({ jobId }, options) => {
    return customFetch(getClearReservedByApiJobQueueApiClearReservedByJobIdPostUrl({ jobId }), {
        ...options,
        method: 'POST'
    });
};
export const getReplayJobApiJobQueueApiReplayJobJobIdPostUrl = ({ jobId }) => {
    return `/api/job-queue/api/replay-job/${jobId}`;
};
/**
 * Replay a job directive by resetting its state
 * @summary Replay Job
 */
export const replayJobApiJobQueueApiReplayJobJobIdPost = async ({ jobId }, options) => {
    return customFetch(getReplayJobApiJobQueueApiReplayJobJobIdPostUrl({ jobId }), {
        ...options,
        method: 'POST'
    });
};
export const getUpdatePriorityApiJobQueueApiUpdatePriorityJobIdPostUrl = ({ jobId }) => {
    return `/api/job-queue/api/update-priority/${jobId}`;
};
/**
 * Update the priority score of a job directive
 * @summary Update Priority
 */
export const updatePriorityApiJobQueueApiUpdatePriorityJobIdPost = async ({ jobId }, options) => {
    return customFetch(getUpdatePriorityApiJobQueueApiUpdatePriorityJobIdPostUrl({ jobId }), {
        ...options,
        method: 'POST'
    });
};
export const getMarkJobUnsuccessfulApiJobQueueApiMarkJobUnsuccessfulJobIdPostUrl = ({ jobId }) => {
    return `/api/job-queue/api/mark-job-unsuccessful/${jobId}`;
};
/**
 * Mark a job as unsuccessful by setting was_successful to False and date_finished to now.
 * This is useful for jobs that get OOM killed but still persist in the queue.
 * @summary Mark Job Unsuccessful
 */
export const markJobUnsuccessfulApiJobQueueApiMarkJobUnsuccessfulJobIdPost = async ({ jobId }, options) => {
    return customFetch(getMarkJobUnsuccessfulApiJobQueueApiMarkJobUnsuccessfulJobIdPostUrl({ jobId }), {
        ...options,
        method: 'POST'
    });
};
export const getMarkJobNeverRunApiJobQueueApiMarkJobNeverRunJobIdPostUrl = ({ jobId }) => {
    return `/api/job-queue/api/mark-job-never-run/${jobId}`;
};
/**
 * Cancel a job without executing: set date_started and date_finished to the same UTC time (now),
 * clear reserved_by, and mark as unsuccessful with a cancellation reason.
 * @summary Mark Job Never Run
 */
export const markJobNeverRunApiJobQueueApiMarkJobNeverRunJobIdPost = async ({ jobId }, options) => {
    return customFetch(getMarkJobNeverRunApiJobQueueApiMarkJobNeverRunJobIdPostUrl({ jobId }), {
        ...options,
        method: 'POST'
    });
};
export const getGetJobProcessDetailsApiJobQueueApiJobProcessDetailsProcessIdGetUrl = ({ processId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/job-queue/api/job-process-details/${processId}?${stringifiedParams}` : `/api/job-queue/api/job-process-details/${processId}`;
};
/**
 * Get detailed information about a specific job process
 * @summary Get Job Process Details
 */
export const getJobProcessDetailsApiJobQueueApiJobProcessDetailsProcessIdGet = async ({ processId }, params, options) => {
    return customFetch(getGetJobProcessDetailsApiJobQueueApiJobProcessDetailsProcessIdGetUrl({ processId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetQueueOverviewApiJobQueueApiQueueOverviewGetUrl = () => {
    return `/api/job-queue/api/queue-overview`;
};
/**
 * Get queue overview showing job counts grouped by job type, image type, and priority score
 * @summary Get Queue Overview
 */
export const getQueueOverviewApiJobQueueApiQueueOverviewGet = async (options) => {
    return customFetch(getGetQueueOverviewApiJobQueueApiQueueOverviewGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getEnqueueJobApiJobQueueApiEnqueuePostUrl = () => {
    return `/api/job-queue/api/enqueue`;
};
/**
 * General purpose job enqueuer for admins.
 * Accepts a JSON directive with job_type, worker_image_type, and directive parameters.
 * @summary Enqueue Job
 */
export const enqueueJobApiJobQueueApiEnqueuePost = async (enqueueJobRequest, options) => {
    return customFetch(getEnqueueJobApiJobQueueApiEnqueuePostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(enqueueJobRequest)
    });
};
export const getPmsPortalApiPmsPortalGetUrl = () => {
    return `/api/pms-portal`;
};
/**
 * PMS Portal - Property database explorer interface
 * @summary Pms Portal
 */
export const pmsPortalApiPmsPortalGet = async (options) => {
    return customFetch(getPmsPortalApiPmsPortalGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetTenantsForPmsPortalApiPmsPortalTenantsGetUrl = () => {
    return `/api/pms-portal/tenants`;
};
/**
 * Get all SaaS tenants for the PMS portal autocomplete
 * @summary Get Tenants For Pms Portal
 */
export const getTenantsForPmsPortalApiPmsPortalTenantsGet = async (options) => {
    return customFetch(getGetTenantsForPmsPortalApiPmsPortalTenantsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetPropertiesForPmsPortalApiPmsPortalPropertiesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pms-portal/properties?${stringifiedParams}` : `/api/pms-portal/properties`;
};
/**
 * Get all properties for a specific tenant for the PMS portal autocomplete
 * @summary Get Properties For Pms Portal
 */
export const getPropertiesForPmsPortalApiPmsPortalPropertiesGet = async (params, options) => {
    return customFetch(getGetPropertiesForPmsPortalApiPmsPortalPropertiesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getSearchLeaseByIdForTenantApiPmsPortalSearchLeaseByIdGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pms-portal/search-lease-by-id?${stringifiedParams}` : `/api/pms-portal/search-lease-by-id`;
};
/**
 * Search for a lease by ID within a single SaaS tenant's properties.
 * Returns the lease with its tenant and property information.
 * @summary Search Lease By Id For Tenant
 */
export const searchLeaseByIdForTenantApiPmsPortalSearchLeaseByIdGet = async (params, options) => {
    return customFetch(getSearchLeaseByIdForTenantApiPmsPortalSearchLeaseByIdGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeasesForPmsPortalApiPmsPortalLeasesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pms-portal/leases?${stringifiedParams}` : `/api/pms-portal/leases`;
};
/**
 * Get leases for the PMS portal with pagination
 * @summary Get Leases For Pms Portal
 */
export const getLeasesForPmsPortalApiPmsPortalLeasesGet = async (params, options) => {
    return customFetch(getGetLeasesForPmsPortalApiPmsPortalLeasesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseDetailForPmsPortalApiPmsPortalLeaseDetailGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pms-portal/lease-detail?${stringifiedParams}` : `/api/pms-portal/lease-detail`;
};
/**
 * Get detailed lease information for the PMS portal
 * @summary Get Lease Detail For Pms Portal
 */
export const getLeaseDetailForPmsPortalApiPmsPortalLeaseDetailGet = async (params, options) => {
    return customFetch(getGetLeaseDetailForPmsPortalApiPmsPortalLeaseDetailGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getQueueLeaseAuditForPmsPortalApiPmsPortalQueueLeaseAuditPostUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pms-portal/queue-lease-audit?${stringifiedParams}` : `/api/pms-portal/queue-lease-audit`;
};
/**
 * Queue a lease audit for the PMS portal
 * @summary Queue Lease Audit For Pms Portal
 */
export const queueLeaseAuditForPmsPortalApiPmsPortalQueueLeaseAuditPost = async (params, options) => {
    return customFetch(getQueueLeaseAuditForPmsPortalApiPmsPortalQueueLeaseAuditPostUrl(params), {
        ...options,
        method: 'POST'
    });
};
export const getGetLeaseDocumentsForPmsPortalApiPmsPortalLeaseDocumentsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pms-portal/lease-documents?${stringifiedParams}` : `/api/pms-portal/lease-documents`;
};
/**
 * Get all lease documents for a specific lease in the PMS portal
 * @summary Get Lease Documents For Pms Portal
 */
export const getLeaseDocumentsForPmsPortalApiPmsPortalLeaseDocumentsGet = async (params, options) => {
    return customFetch(getGetLeaseDocumentsForPmsPortalApiPmsPortalLeaseDocumentsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetPropertyStatisticsForPmsPortalApiPmsPortalPropertyStatisticsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pms-portal/property-statistics?${stringifiedParams}` : `/api/pms-portal/property-statistics`;
};
/**
 * Get property statistics for specified properties or all properties in a SaaS tenant.
 * @summary Get Property Statistics For Pms Portal
 */
export const getPropertyStatisticsForPmsPortalApiPmsPortalPropertyStatisticsGet = async (params, options) => {
    return customFetch(getGetPropertyStatisticsForPmsPortalApiPmsPortalPropertyStatisticsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetPropertyDetailForPmsPortalApiPmsPortalPropertyDetailGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pms-portal/property-detail?${stringifiedParams}` : `/api/pms-portal/property-detail`;
};
/**
 * Get detailed property information for the PMS portal
 * @summary Get Property Detail For Pms Portal
 */
export const getPropertyDetailForPmsPortalApiPmsPortalPropertyDetailGet = async (params, options) => {
    return customFetch(getGetPropertyDetailForPmsPortalApiPmsPortalPropertyDetailGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetUnitsForPmsPortalApiPmsPortalUnitsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pms-portal/units?${stringifiedParams}` : `/api/pms-portal/units`;
};
/**
 * Get all units for a property for the PMS portal
 * Uses occupancy_status from unit spaces only (no lease lookups)
 * @summary Get Units For Pms Portal
 */
export const getUnitsForPmsPortalApiPmsPortalUnitsGet = async (params, options) => {
    return customFetch(getGetUnitsForPmsPortalApiPmsPortalUnitsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetUnitDetailForPmsPortalApiPmsPortalUnitDetailGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pms-portal/unit-detail?${stringifiedParams}` : `/api/pms-portal/unit-detail`;
};
/**
 * Get detailed unit information for the PMS portal, including lease history for the unit.
 * @summary Get Unit Detail For Pms Portal
 */
export const getUnitDetailForPmsPortalApiPmsPortalUnitDetailGet = async (params, options) => {
    return customFetch(getGetUnitDetailForPmsPortalApiPmsPortalUnitDetailGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetYardiLeasesForPmsPortalApiPmsPortalYardiLeasesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pms-portal/yardi-leases?${stringifiedParams}` : `/api/pms-portal/yardi-leases`;
};
/**
 * Proxy endpoint to get Yardi GetResidents for a property via the yardiproxy service.
 *
 * Pass ``format=html`` for a readable high-level resident table (default is JSON).
 * @summary Get Yardi Leases For Pms Portal
 */
export const getYardiLeasesForPmsPortalApiPmsPortalYardiLeasesGet = async (params, options) => {
    return customFetch(getGetYardiLeasesForPmsPortalApiPmsPortalYardiLeasesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetYardiLeasesByStatusForPmsPortalApiPmsPortalYardiLeasesByStatusGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pms-portal/yardi-leases-by-status?${stringifiedParams}` : `/api/pms-portal/yardi-leases-by-status`;
};
/**
 * Proxy endpoint for Yardi GetResidentsByStatus via the yardiproxy service.
 *
 * Pass ``format=html`` for a readable high-level resident table (default is JSON).
 * @summary Get Yardi Leases By Status For Pms Portal
 */
export const getYardiLeasesByStatusForPmsPortalApiPmsPortalYardiLeasesByStatusGet = async (params, options) => {
    return customFetch(getGetYardiLeasesByStatusForPmsPortalApiPmsPortalYardiLeasesByStatusGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetYardiAttachmentTypesForPmsPortalApiPmsPortalYardiAttachmentTypesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pms-portal/yardi-attachment-types?${stringifiedParams}` : `/api/pms-portal/yardi-attachment-types`;
};
/**
 * Proxy endpoint to get Yardi attachment types for a tenant via the yardiproxy service.
 * If property_id is provided, uses that property to find the Yardi external property.
 * If property_id is not provided, uses tenant_id directly (assuming it's the saas_tenant_id).
 * @summary Get Yardi Attachment Types For Pms Portal
 */
export const getYardiAttachmentTypesForPmsPortalApiPmsPortalYardiAttachmentTypesGet = async (params, options) => {
    return customFetch(getGetYardiAttachmentTypesForPmsPortalApiPmsPortalYardiAttachmentTypesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetYardiLeaseDocumentsForPmsPortalApiPmsPortalYardiLeaseDocumentsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pms-portal/yardi-lease-documents?${stringifiedParams}` : `/api/pms-portal/yardi-lease-documents`;
};
/**
 * Proxy endpoint to get Yardi lease documents for a specific lease via the yardiproxy service
 * @summary Get Yardi Lease Documents For Pms Portal
 */
export const getYardiLeaseDocumentsForPmsPortalApiPmsPortalYardiLeaseDocumentsGet = async (params, options) => {
    return customFetch(getGetYardiLeaseDocumentsForPmsPortalApiPmsPortalYardiLeaseDocumentsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetYardiLeaseDocumentContentDebugForPmsPortalApiPmsPortalYardiLeaseDocumentContentDebugGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pms-portal/yardi-lease-document-content-debug?${stringifiedParams}` : `/api/pms-portal/yardi-lease-document-content-debug`;
};
/**
 * Proxy endpoint to get Yardi lease document content debug payloads (raw Voyager responses per interface).
 * For debugging only.
 * @summary Get Yardi Lease Document Content Debug For Pms Portal
 */
export const getYardiLeaseDocumentContentDebugForPmsPortalApiPmsPortalYardiLeaseDocumentContentDebugGet = async (params, options) => {
    return customFetch(getGetYardiLeaseDocumentContentDebugForPmsPortalApiPmsPortalYardiLeaseDocumentContentDebugGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetYardiResidentForPmsPortalApiPmsPortalYardiResidentGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pms-portal/yardi-resident?${stringifiedParams}` : `/api/pms-portal/yardi-resident`;
};
/**
 * Proxy endpoint to get Yardi resident information for a specific lease via the yardiproxy service
 * @summary Get Yardi Resident For Pms Portal
 */
export const getYardiResidentForPmsPortalApiPmsPortalYardiResidentGet = async (params, options) => {
    return customFetch(getGetYardiResidentForPmsPortalApiPmsPortalYardiResidentGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetYardiPermissionsForPmsPortalApiPmsPortalYardiPermissionsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pms-portal/yardi-permissions?${stringifiedParams}` : `/api/pms-portal/yardi-permissions`;
};
/**
 * Proxy endpoint to get Yardi permissions for a tenant via the yardiproxy service.
 * If property_id is provided, uses that property to find the Yardi external property.
 * If property_id is not provided, uses tenant_id directly (assuming it's the saas_tenant_id).
 * @summary Get Yardi Permissions For Pms Portal
 */
export const getYardiPermissionsForPmsPortalApiPmsPortalYardiPermissionsGet = async (params, options) => {
    return customFetch(getGetYardiPermissionsForPmsPortalApiPmsPortalYardiPermissionsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetYardiPropertiesForPmsPortalApiPmsPortalYardiPropertiesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pms-portal/yardi-properties?${stringifiedParams}` : `/api/pms-portal/yardi-properties`;
};
/**
 * Proxy endpoint to get Yardi property configurations for a tenant via the yardiproxy service.
 * If property_id is provided, uses that property to find the Yardi external property.
 * If property_id is not provided, uses tenant_id directly (assuming it's the saas_tenant_id).
 * @summary Get Yardi Properties For Pms Portal
 */
export const getYardiPropertiesForPmsPortalApiPmsPortalYardiPropertiesGet = async (params, options) => {
    return customFetch(getGetYardiPropertiesForPmsPortalApiPmsPortalYardiPropertiesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetEntrataPropertiesForPmsPortalApiPmsPortalEntrataPropertiesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pms-portal/entrata-properties?${stringifiedParams}` : `/api/pms-portal/entrata-properties`;
};
/**
 * Proxy endpoint to get all Entrata properties for a tenant via the entrataproxy service.
 *
 * Pass ``format=html`` for a readable HTML report (default is JSON).
 * @summary Get Entrata Properties For Pms Portal
 */
export const getEntrataPropertiesForPmsPortalApiPmsPortalEntrataPropertiesGet = async (params, options) => {
    return customFetch(getGetEntrataPropertiesForPmsPortalApiPmsPortalEntrataPropertiesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetEntrataLeasePayloadForPmsPortalApiPmsPortalEntrataLeasePayloadGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pms-portal/entrata-lease-payload?${stringifiedParams}` : `/api/pms-portal/entrata-lease-payload`;
};
/**
 * Proxy endpoint to get Entrata lease payload for a specific lease via the entrataproxy service
 * @summary Get Entrata Lease Payload For Pms Portal
 */
export const getEntrataLeasePayloadForPmsPortalApiPmsPortalEntrataLeasePayloadGet = async (params, options) => {
    return customFetch(getGetEntrataLeasePayloadForPmsPortalApiPmsPortalEntrataLeasePayloadGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetDocumentApiPmsPortalPropertyIdLeaseDocumentsExternalDocIdGetUrl = ({ propertyId, externalDocId }) => {
    return `/api/pms-portal/${propertyId}/lease-documents/${externalDocId}`;
};
/**
 * @summary Get Document
 */
export const getDocumentApiPmsPortalPropertyIdLeaseDocumentsExternalDocIdGet = async ({ propertyId, externalDocId }, options) => {
    return customFetch(getGetDocumentApiPmsPortalPropertyIdLeaseDocumentsExternalDocIdGetUrl({ propertyId, externalDocId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseEventsForPmsPortalApiPmsPortalLeaseEventsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pms-portal/lease-events?${stringifiedParams}` : `/api/pms-portal/lease-events`;
};
/**
 * Get events for a lease using LeadEventService.get_events_for_lease_id
 * @summary Get Lease Events For Pms Portal
 */
export const getLeaseEventsForPmsPortalApiPmsPortalLeaseEventsGet = async (params, options) => {
    return customFetch(getGetLeaseEventsForPmsPortalApiPmsPortalLeaseEventsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getOrdersPortalApiOrdersPortalGetUrl = () => {
    return `/api/orders-portal`;
};
/**
 * Orders Portal - Order management interface with grid and detail views.
 * @summary Orders Portal
 */
export const ordersPortalApiOrdersPortalGet = async (options) => {
    return customFetch(getOrdersPortalApiOrdersPortalGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getYardiMappingHomeApiYardiMappingGetUrl = () => {
    return `/api/yardi-mapping`;
};
/**
 * Yardi Attachment Type to Document Classification Mapping Interface
 * @summary Yardi Mapping Home
 */
export const yardiMappingHomeApiYardiMappingGet = async (options) => {
    return customFetch(getYardiMappingHomeApiYardiMappingGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetTenantsApiYardiMappingApiTenantsGetUrl = () => {
    return `/api/yardi-mapping/api/tenants`;
};
/**
 * Get tenants that have at least one Yardi property enabled
 * @summary Get Tenants
 */
export const getTenantsApiYardiMappingApiTenantsGet = async (options) => {
    return customFetch(getGetTenantsApiYardiMappingApiTenantsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetDocumentClassificationsApiYardiMappingApiDocumentClassificationsGetUrl = () => {
    return `/api/yardi-mapping/api/document-classifications`;
};
/**
 * Get all document classification values
 * @summary Get Document Classifications
 */
export const getDocumentClassificationsApiYardiMappingApiDocumentClassificationsGet = async (options) => {
    return customFetch(getGetDocumentClassificationsApiYardiMappingApiDocumentClassificationsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetAttachmentTypesCatalogApiYardiMappingApiTenantsTenantIdAttachmentTypesCatalogGetUrl = ({ tenantId }) => {
    return `/api/yardi-mapping/api/tenants/${tenantId}/attachment-types-catalog`;
};
/**
 * Proxy to PMS service to get cataloged attachment types
 * @summary Get Attachment Types Catalog
 */
export const getAttachmentTypesCatalogApiYardiMappingApiTenantsTenantIdAttachmentTypesCatalogGet = async ({ tenantId }, options) => {
    return customFetch(getGetAttachmentTypesCatalogApiYardiMappingApiTenantsTenantIdAttachmentTypesCatalogGetUrl({ tenantId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetAttachmentMappingsApiYardiMappingApiTenantsTenantIdAttachmentMappingsGetUrl = ({ tenantId }) => {
    return `/api/yardi-mapping/api/tenants/${tenantId}/attachment-mappings`;
};
/**
 * Proxy to PMS service to get attachment mappings
 * @summary Get Attachment Mappings
 */
export const getAttachmentMappingsApiYardiMappingApiTenantsTenantIdAttachmentMappingsGet = async ({ tenantId }, options) => {
    return customFetch(getGetAttachmentMappingsApiYardiMappingApiTenantsTenantIdAttachmentMappingsGetUrl({ tenantId }), {
        ...options,
        method: 'GET'
    });
};
export const getSaveAttachmentMappingsApiYardiMappingApiTenantsTenantIdAttachmentMappingsPostUrl = ({ tenantId }) => {
    return `/api/yardi-mapping/api/tenants/${tenantId}/attachment-mappings`;
};
/**
 * Proxy to PMS service to save attachment mappings
 * @summary Save Attachment Mappings
 */
export const saveAttachmentMappingsApiYardiMappingApiTenantsTenantIdAttachmentMappingsPost = async ({ tenantId }, saveMappingsRequest, options) => {
    return customFetch(getSaveAttachmentMappingsApiYardiMappingApiTenantsTenantIdAttachmentMappingsPostUrl({ tenantId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(saveMappingsRequest)
    });
};
export const getRefreshAttachmentTypesApiYardiMappingApiTenantsTenantIdRefreshAttachmentTypesPostUrl = ({ tenantId }) => {
    return `/api/yardi-mapping/api/tenants/${tenantId}/refresh-attachment-types`;
};
/**
 * Proxy to PMS service to refresh attachment types from Yardi
 * @summary Refresh Attachment Types
 */
export const refreshAttachmentTypesApiYardiMappingApiTenantsTenantIdRefreshAttachmentTypesPost = async ({ tenantId }, options) => {
    return customFetch(getRefreshAttachmentTypesApiYardiMappingApiTenantsTenantIdRefreshAttachmentTypesPostUrl({ tenantId }), {
        ...options,
        method: 'POST'
    });
};
export const getGetHappycoCustomersPageApiBusinessPartnersHappycoGetUrl = () => {
    return `/api/business-partners/happyco`;
};
/**
 * Display HappyCo business partner customers with their properties.
 * Read-only view for monitoring customer subscription state.
 * @summary Get Happyco Customers Page
 */
export const getHappycoCustomersPageApiBusinessPartnersHappycoGet = async (options) => {
    return customFetch(getGetHappycoCustomersPageApiBusinessPartnersHappycoGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetHappycoChangelogPageApiBusinessPartnersHappycoChangelogGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/business-partners/happyco/changelog?${stringifiedParams}` : `/api/business-partners/happyco/changelog`;
};
/**
 * Browse sync changelog for HappyCo. Job IDs link to AWS job logs for the run.
 * @summary Get Happyco Changelog Page
 */
export const getHappycoChangelogPageApiBusinessPartnersHappycoChangelogGet = async (params, options) => {
    return customFetch(getGetHappycoChangelogPageApiBusinessPartnersHappycoChangelogGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGreetingApiGreetingGetUrl = () => {
    return `/api/greeting`;
};
/**
 * @summary Greeting
 */
export const greetingApiGreetingGet = async (options) => {
    return customFetch(getGreetingApiGreetingGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getSuggestionsApiSuggestionsGetUrl = () => {
    return `/api/suggestions`;
};
/**
 * @summary Suggestions
 */
export const suggestionsApiSuggestionsGet = async (options) => {
    return customFetch(getSuggestionsApiSuggestionsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getAskHistoryApiAskHistoryGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/ask/history?${stringifiedParams}` : `/api/ask/history`;
};
/**
 * @summary Askhistory
 */
export const askHistoryApiAskHistoryGet = async (params, options) => {
    return customFetch(getAskHistoryApiAskHistoryGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getAskApiAskPostUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/ask?${stringifiedParams}` : `/api/ask`;
};
/**
 * @summary Ask
 */
export const askApiAskPost = async (dialogueIn, params, options) => {
    return customFetch(getAskApiAskPostUrl(params), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(dialogueIn)
    });
};
export const getGetSavedDialoguesApiAskSavedDialoguesGetUrl = () => {
    return `/api/ask/saved-dialogues`;
};
/**
 * @summary Get Saved Dialogues
 */
export const getSavedDialoguesApiAskSavedDialoguesGet = async (options) => {
    return customFetch(getGetSavedDialoguesApiAskSavedDialoguesGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getSaveDialogueApiAskSavedDialoguesPostUrl = () => {
    return `/api/ask/saved-dialogues`;
};
/**
 * @summary Save Dialogue
 */
export const saveDialogueApiAskSavedDialoguesPost = async (createSavedDialogue, options) => {
    return customFetch(getSaveDialogueApiAskSavedDialoguesPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(createSavedDialogue)
    });
};
export const getRemoveSavedDialogueApiAskSavedDialoguesDialogueIdDeleteUrl = ({ dialogueId }) => {
    return `/api/ask/saved-dialogues/${dialogueId}`;
};
/**
 * @summary Remove Saved Dialogue
 */
export const removeSavedDialogueApiAskSavedDialoguesDialogueIdDelete = async ({ dialogueId }, options) => {
    return customFetch(getRemoveSavedDialogueApiAskSavedDialoguesDialogueIdDeleteUrl({ dialogueId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getGetDialogueApiAskDialogueIdGetUrl = ({ dialogueId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/ask/${dialogueId}?${stringifiedParams}` : `/api/ask/${dialogueId}`;
};
/**
 * Get a specific dialogue by ID.
 *
 * Examples:
 * - dialogue_id: "1" - Returns a completed dialogue with answer
 * - dialogue_id: "2" - Returns a dialogue that is still processing
 * - dialogue_id: "3" - Returns a dialogue with streaming chunks
 * @summary Get Dialogue
 */
export const getDialogueApiAskDialogueIdGet = async ({ dialogueId }, params, options) => {
    return customFetch(getGetDialogueApiAskDialogueIdGetUrl({ dialogueId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getCancelAskApiAskDialogueIdCancelPutUrl = ({ dialogueId }) => {
    return `/api/ask/${dialogueId}/cancel`;
};
/**
 * @summary Cancel Ask
 */
export const cancelAskApiAskDialogueIdCancelPut = async ({ dialogueId }, options) => {
    return customFetch(getCancelAskApiAskDialogueIdCancelPutUrl({ dialogueId }), {
        ...options,
        method: 'PUT'
    });
};
export const getAskSourcesApiAskDialogueIdSourcesGetUrl = ({ dialogueId }) => {
    return `/api/ask/${dialogueId}/sources`;
};
/**
 * @summary Ask Sources
 */
export const askSourcesApiAskDialogueIdSourcesGet = async ({ dialogueId }, options) => {
    return customFetch(getAskSourcesApiAskDialogueIdSourcesGetUrl({ dialogueId }), {
        ...options,
        method: 'GET'
    });
};
export const getAskSourceApiAskDialogueIdSourcesSourceIdGetUrl = ({ dialogueId, sourceId }) => {
    return `/api/ask/${dialogueId}/sources/${sourceId}`;
};
/**
 * @summary Ask Source
 */
export const askSourceApiAskDialogueIdSourcesSourceIdGet = async ({ dialogueId, sourceId }, options) => {
    return customFetch(getAskSourceApiAskDialogueIdSourcesSourceIdGetUrl({ dialogueId, sourceId }), {
        ...options,
        method: 'GET'
    });
};
export const getAskSourceItemsApiAskDialogueIdSourcesSourceIdItemsGetUrl = ({ dialogueId, sourceId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/ask/${dialogueId}/sources/${sourceId}/items?${stringifiedParams}` : `/api/ask/${dialogueId}/sources/${sourceId}/items`;
};
/**
 * @summary Ask Source Items
 */
export const askSourceItemsApiAskDialogueIdSourcesSourceIdItemsGet = async ({ dialogueId, sourceId }, params, options) => {
    return customFetch(getAskSourceItemsApiAskDialogueIdSourcesSourceIdItemsGetUrl({ dialogueId, sourceId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getSaveFeedbackApiAskDialogueIdFeedbackPostUrl = ({ dialogueId }) => {
    return `/api/ask/${dialogueId}/feedback`;
};
/**
 * @summary Save Feedback
 */
export const saveFeedbackApiAskDialogueIdFeedbackPost = async ({ dialogueId }, dialogueFeedback, options) => {
    return customFetch(getSaveFeedbackApiAskDialogueIdFeedbackPostUrl({ dialogueId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(dialogueFeedback)
    });
};
export const getDailyReportApiAskUsagereportGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/ask/usagereport/?${stringifiedParams}` : `/api/ask/usagereport/`;
};
/**
 * @summary Daily Report
 */
export const dailyReportApiAskUsagereportGet = async (params, options) => {
    return customFetch(getDailyReportApiAskUsagereportGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getSmsApiSmsInboundPostUrl = () => {
    return `/api/sms-inbound`;
};
/**
 * @summary Sms
 */
export const smsApiSmsInboundPost = async (options) => {
    return customFetch(getSmsApiSmsInboundPostUrl(), {
        ...options,
        method: 'POST'
    });
};
export const getTasksApiWorkspaceTasksGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["sort", "custom_statuses", "failing_lease_audit_checks", "lease_audit_check_failure_types", "lease_audit_check_failure_priorities", "lease_terms", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/tasks?${stringifiedParams}` : `/api/workspace/tasks`;
};
/**
 * @summary Tasks
 */
export const tasksApiWorkspaceTasksGet = async (params, options) => {
    return customFetch(getTasksApiWorkspaceTasksGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getTasksExportApiWorkspaceTasksExportGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["sort", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/tasks/export?${stringifiedParams}` : `/api/workspace/tasks/export`;
};
/**
 * @summary Tasks Export
 */
export const tasksExportApiWorkspaceTasksExportGet = async (params, options) => {
    return customFetch(getTasksExportApiWorkspaceTasksExportGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getTasksFacetsApiWorkspaceTasksFacetsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/tasks/facets?${stringifiedParams}` : `/api/workspace/tasks/facets`;
};
/**
 * @summary Tasks Facets
 */
export const tasksFacetsApiWorkspaceTasksFacetsGet = async (params, options) => {
    return customFetch(getTasksFacetsApiWorkspaceTasksFacetsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetDelinquencyAgentHistoryForTaskApiWorkspacePropertyIdTasksIdDelinquencyAgentHistoryGetUrl = ({ propertyId, id }) => {
    return `/api/workspace/${propertyId}/tasks/${id}/delinquency/agent-history`;
};
/**
 * @summary Get Delinquency Agent History For Task
 */
export const getDelinquencyAgentHistoryForTaskApiWorkspacePropertyIdTasksIdDelinquencyAgentHistoryGet = async ({ propertyId, id }, options) => {
    return customFetch(getGetDelinquencyAgentHistoryForTaskApiWorkspacePropertyIdTasksIdDelinquencyAgentHistoryGetUrl({ propertyId, id }), {
        ...options,
        method: 'GET'
    });
};
export const getGetTaskApiWorkspacePropertyIdTasksIdGetUrl = ({ propertyId, id }) => {
    return `/api/workspace/${propertyId}/tasks/${id}`;
};
/**
 * @summary Get Task
 */
export const getTaskApiWorkspacePropertyIdTasksIdGet = async ({ propertyId, id }, options) => {
    return customFetch(getGetTaskApiWorkspacePropertyIdTasksIdGetUrl({ propertyId, id }), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateTaskAssignmentApiWorkspacePropertyIdTasksIdAssignmentPutUrl = ({ propertyId, id }) => {
    return `/api/workspace/${propertyId}/tasks/${id}/assignment`;
};
/**
 * Assigns a task to a user.
 * The user assigning must have update permissions for the task.
 * The user being assigned must have read permissions for the task.
 * @summary Update Task Assignment
 */
export const updateTaskAssignmentApiWorkspacePropertyIdTasksIdAssignmentPut = async ({ propertyId, id }, assignTaskRequest, options) => {
    return customFetch(getUpdateTaskAssignmentApiWorkspacePropertyIdTasksIdAssignmentPutUrl({ propertyId, id }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(assignTaskRequest)
    });
};
export const getUpdateTaskAssignmentBulkApiWorkspaceTasksAssignmentBulkPutUrl = () => {
    return `/api/workspace/tasks/assignment_bulk`;
};
/**
 * Assigns a task to a user.
 * The user assigning must have update permissions for the task.
 * The user being assigned must have read permissions for the task.
 * @summary Update Task Assignment Bulk
 */
export const updateTaskAssignmentBulkApiWorkspaceTasksAssignmentBulkPut = async (bulkAssignTaskRequest, options) => {
    return customFetch(getUpdateTaskAssignmentBulkApiWorkspaceTasksAssignmentBulkPutUrl(), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(bulkAssignTaskRequest)
    });
};
export const getUpdateTaskStatusApiWorkspacePropertyIdTasksIdStatusPutUrl = ({ propertyId, id }) => {
    return `/api/workspace/${propertyId}/tasks/${id}/status`;
};
/**
 * @summary Update Task Status
 */
export const updateTaskStatusApiWorkspacePropertyIdTasksIdStatusPut = async ({ propertyId, id }, updateTaskStatusRequest, options) => {
    return customFetch(getUpdateTaskStatusApiWorkspacePropertyIdTasksIdStatusPutUrl({ propertyId, id }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(updateTaskStatusRequest)
    });
};
export const getUpdateTaskCustomStatusApiWorkspacePropertyIdTasksIdCustomStatusPutUrl = ({ propertyId, id }) => {
    return `/api/workspace/${propertyId}/tasks/${id}/custom_status`;
};
/**
 * @summary Update Task Custom Status
 */
export const updateTaskCustomStatusApiWorkspacePropertyIdTasksIdCustomStatusPut = async ({ propertyId, id }, updateTaskCustomStatusRequest, options) => {
    return customFetch(getUpdateTaskCustomStatusApiWorkspacePropertyIdTasksIdCustomStatusPutUrl({ propertyId, id }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(updateTaskCustomStatusRequest)
    });
};
export const getUpdateTaskCustomStatusBulkApiWorkspaceTasksCustomStatusBulkPutUrl = () => {
    return `/api/workspace/tasks/custom_status_bulk`;
};
/**
 * @summary Update Task Custom Status Bulk
 */
export const updateTaskCustomStatusBulkApiWorkspaceTasksCustomStatusBulkPut = async (bulkUpdateTaskCustomStatusRequest, options) => {
    return customFetch(getUpdateTaskCustomStatusBulkApiWorkspaceTasksCustomStatusBulkPutUrl(), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(bulkUpdateTaskCustomStatusRequest)
    });
};
export const getUpdateTaskWorkItemApiWorkspacePropertyIdTasksIdWorkItemsTaskWorkItemIdPutUrl = ({ propertyId, id, taskWorkItemId }) => {
    return `/api/workspace/${propertyId}/tasks/${id}/work_items/${taskWorkItemId}`;
};
/**
 * @summary Update Task Work Item
 */
export const updateTaskWorkItemApiWorkspacePropertyIdTasksIdWorkItemsTaskWorkItemIdPut = async ({ propertyId, id, taskWorkItemId }, updateTaskWorkItemRequest, options) => {
    return customFetch(getUpdateTaskWorkItemApiWorkspacePropertyIdTasksIdWorkItemsTaskWorkItemIdPutUrl({ propertyId, id, taskWorkItemId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(updateTaskWorkItemRequest)
    });
};
export const getEvalTasksForTemporalUpdatesApiWorkspaceSaasTenantIdEvalTasksForTemporalUpdatesGetUrl = ({ saasTenantId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/${saasTenantId}/eval_tasks_for_temporal_updates?${stringifiedParams}` : `/api/workspace/${saasTenantId}/eval_tasks_for_temporal_updates`;
};
/**
 * @summary Eval Tasks For Temporal Updates
 */
export const evalTasksForTemporalUpdatesApiWorkspaceSaasTenantIdEvalTasksForTemporalUpdatesGet = async ({ saasTenantId }, params, options) => {
    return customFetch(getEvalTasksForTemporalUpdatesApiWorkspaceSaasTenantIdEvalTasksForTemporalUpdatesGetUrl({ saasTenantId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetSurfaceFileApiWorkspaceSurfaceFilesSurfaceFileIdGetUrl = ({ surfaceFileId }) => {
    return `/api/workspace/surface-files/${surfaceFileId}`;
};
/**
 * @summary Get Surface File
 */
export const getSurfaceFileApiWorkspaceSurfaceFilesSurfaceFileIdGet = async ({ surfaceFileId }, options) => {
    return customFetch(getGetSurfaceFileApiWorkspaceSurfaceFilesSurfaceFileIdGetUrl({ surfaceFileId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditBaseOperationalReportApiWorkspaceTaskreportsLeaseauditsBaseOperationalReportGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/base-operational-report?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/base-operational-report`;
};
/**
 * @summary Get Lease Audit Base Operational Report
 */
export const getLeaseAuditBaseOperationalReportApiWorkspaceTaskreportsLeaseauditsBaseOperationalReportGet = async (params, options) => {
    return customFetch(getGetLeaseAuditBaseOperationalReportApiWorkspaceTaskreportsLeaseauditsBaseOperationalReportGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditFailingChecksByCheckTypeApiWorkspaceTaskreportsLeaseauditsFailingChecksByCheckTypeGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/failing-checks-by-check-type?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/failing-checks-by-check-type`;
};
/**
 * @summary Get Lease Audit Failing Checks By Check Type
 */
export const getLeaseAuditFailingChecksByCheckTypeApiWorkspaceTaskreportsLeaseauditsFailingChecksByCheckTypeGet = async (params, options) => {
    return customFetch(getGetLeaseAuditFailingChecksByCheckTypeApiWorkspaceTaskreportsLeaseauditsFailingChecksByCheckTypeGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditFailingChecksByPropertiesApiWorkspaceTaskreportsLeaseauditsFailingChecksByPropertiesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["check_types", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/failing-checks-by-properties?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/failing-checks-by-properties`;
};
/**
 * @summary Get Lease Audit Failing Checks By Properties
 */
export const getLeaseAuditFailingChecksByPropertiesApiWorkspaceTaskreportsLeaseauditsFailingChecksByPropertiesGet = async (params, options) => {
    return customFetch(getGetLeaseAuditFailingChecksByPropertiesApiWorkspaceTaskreportsLeaseauditsFailingChecksByPropertiesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditFailingChecksByDaysOpenApiWorkspaceTaskreportsLeaseauditsFailingChecksByDaysOpenGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["check_types", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/failing-checks-by-days-open?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/failing-checks-by-days-open`;
};
/**
 * Returns a report showing the number of failing lease audit checks grouped by CheckType and the number of days the check has been failing.
 *
 * Example Response:
 *
 * ```text
 * {
 *     unique_labels: ["ADMINISTRATION FEE", "AMENITY FEE"],
 *     groups: [
 *                 {
 *                     label: "ADMINISTRATION FEE",
 *                     metrics: [
 *                         CountMetric(label="0-7 days", count=12, percentage=60.0),
 *                         CountMetric(label="8-30 days", count=4, percentage=20.0),
 *                         CountMetric(label="31-60 days", count=2, percentage=10.0),
 *                         CountMetric(label="> 60 days", count=2, percentage=10.0),
 *                     ]
 *                 },
 *                 {
 *                     label="AMENITY FEE",
 *                     metrics=[
 *                         CountMetric(label="0-7 days", count=12, percentage=60.0),
 *                         CountMetric(label="8-30 days", count=4, percentage=20.0),
 *                         CountMetric(label="31-60 days", count=2, percentage=10.0),
 *                         CountMetric(label="> 60 days", count=2, percentage=10.0),
 *                     ]
 *                 }
 *             ]
 * }
 * ```
 * @summary Get Lease Audit Failing Checks By Days Open
 */
export const getLeaseAuditFailingChecksByDaysOpenApiWorkspaceTaskreportsLeaseauditsFailingChecksByDaysOpenGet = async (params, options) => {
    return customFetch(getGetLeaseAuditFailingChecksByDaysOpenApiWorkspaceTaskreportsLeaseauditsFailingChecksByDaysOpenGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditBaseReportOverTimeApiWorkspaceTaskreportsLeaseauditsBaseReportOverTimeGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/base-report-over-time?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/base-report-over-time`;
};
/**
 * @summary Get Lease Audit Base Report Over Time
 */
export const getLeaseAuditBaseReportOverTimeApiWorkspaceTaskreportsLeaseauditsBaseReportOverTimeGet = async (params, options) => {
    return customFetch(getGetLeaseAuditBaseReportOverTimeApiWorkspaceTaskreportsLeaseauditsBaseReportOverTimeGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditCheckStatusOverTimeApiWorkspaceTaskreportsLeaseauditsCheckStatusOverTimeGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["check_types", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/check-status-over-time?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/check-status-over-time`;
};
/**
 * @summary Get Lease Audit Check Status Over Time
 */
export const getLeaseAuditCheckStatusOverTimeApiWorkspaceTaskreportsLeaseauditsCheckStatusOverTimeGet = async (params, options) => {
    return customFetch(getGetLeaseAuditCheckStatusOverTimeApiWorkspaceTaskreportsLeaseauditsCheckStatusOverTimeGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditOverridesOverTimeApiWorkspaceTaskreportsLeaseauditsOverridesOverTimeGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["check_types", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/overrides-over-time?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/overrides-over-time`;
};
/**
 * @summary Get Lease Audit Overrides Over Time
 */
export const getLeaseAuditOverridesOverTimeApiWorkspaceTaskreportsLeaseauditsOverridesOverTimeGet = async (params, options) => {
    return customFetch(getGetLeaseAuditOverridesOverTimeApiWorkspaceTaskreportsLeaseauditsOverridesOverTimeGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditAuditOutcomesOverTimeApiWorkspaceTaskreportsLeaseauditsAuditOutcomesOverTimeGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/audit-outcomes-over-time?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/audit-outcomes-over-time`;
};
/**
 * @summary Get Lease Audit Audit Outcomes Over Time
 */
export const getLeaseAuditAuditOutcomesOverTimeApiWorkspaceTaskreportsLeaseauditsAuditOutcomesOverTimeGet = async (params, options) => {
    return customFetch(getGetLeaseAuditAuditOutcomesOverTimeApiWorkspaceTaskreportsLeaseauditsAuditOutcomesOverTimeGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditReportFacetsApiWorkspaceTaskreportsLeaseauditFacetsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudit/facets?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudit/facets`;
};
/**
 * @summary Get Lease Audit Report Facets
 */
export const getLeaseAuditReportFacetsApiWorkspaceTaskreportsLeaseauditFacetsGet = async (params, options) => {
    return customFetch(getGetLeaseAuditReportFacetsApiWorkspaceTaskreportsLeaseauditFacetsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditSummaryReportApiWorkspaceTaskreportsLeaseauditSummaryGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudit/summary?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudit/summary`;
};
/**
 * @summary Get Lease Audit Summary Report
 */
export const getLeaseAuditSummaryReportApiWorkspaceTaskreportsLeaseauditSummaryGet = async (params, options) => {
    return customFetch(getGetLeaseAuditSummaryReportApiWorkspaceTaskreportsLeaseauditSummaryGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditReportFailingChecksCountApiWorkspaceTaskreportsLeaseauditFailingcountbycheckGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudit/failingcountbycheck?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudit/failingcountbycheck`;
};
/**
 * @summary Get Lease Audit Report Failing Checks Count
 */
export const getLeaseAuditReportFailingChecksCountApiWorkspaceTaskreportsLeaseauditFailingcountbycheckGet = async (params, options) => {
    return customFetch(getGetLeaseAuditReportFailingChecksCountApiWorkspaceTaskreportsLeaseauditFailingcountbycheckGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditReportFailingCheckCountByPropertyApiWorkspaceTaskreportsLeaseauditFailingcheckcountbypropertyGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudit/failingcheckcountbyproperty?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudit/failingcheckcountbyproperty`;
};
/**
 * @summary Get Lease Audit Report Failing Check Count By Property
 */
export const getLeaseAuditReportFailingCheckCountByPropertyApiWorkspaceTaskreportsLeaseauditFailingcheckcountbypropertyGet = async (params, options) => {
    return customFetch(getGetLeaseAuditReportFailingCheckCountByPropertyApiWorkspaceTaskreportsLeaseauditFailingcheckcountbypropertyGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetDdHappycoProfileDataExportJobApiWorkspaceTaskreportsDdHappycoProfileDataExportJobGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/dd_happyco_profile_data/export_job?${stringifiedParams}` : `/api/workspace/taskreports/dd_happyco_profile_data/export_job`;
};
/**
 * @summary Get Dd Happyco Profile Data Export Job
 */
export const getDdHappycoProfileDataExportJobApiWorkspaceTaskreportsDdHappycoProfileDataExportJobGet = async (params, options) => {
    return customFetch(getGetDdHappycoProfileDataExportJobApiWorkspaceTaskreportsDdHappycoProfileDataExportJobGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetDdLeaseAuditReportExportJobApiWorkspaceTaskreportsDdLeaseauditExportJobGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["custom_statuses", "failing_lease_audit_checks", "lease_terms", "check_failure_types", "check_failure_priorities", "lease_stages", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/dd_leaseaudit/export_job?${stringifiedParams}` : `/api/workspace/taskreports/dd_leaseaudit/export_job`;
};
/**
 * @summary Get Dd Lease Audit Report Export Job
 */
export const getDdLeaseAuditReportExportJobApiWorkspaceTaskreportsDdLeaseauditExportJobGet = async (params, options) => {
    return customFetch(getGetDdLeaseAuditReportExportJobApiWorkspaceTaskreportsDdLeaseauditExportJobGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetUserDownloadApiWorkspaceUserDownloadsJobIdGetUrl = ({ jobId }) => {
    return `/api/workspace/user_downloads/${jobId}`;
};
/**
 * Stream a previously-generated user file (e.g. report) back to the client.
 *
 * Looks up the file in S3 by (user_id, job_id) via SurfaceUserFileService,
 * then uses the file's async stream to back a StreamingResponse.
 * @summary Get User Download
 */
export const getUserDownloadApiWorkspaceUserDownloadsJobIdGet = async ({ jobId }, options) => {
    return customFetch(getGetUserDownloadApiWorkspaceUserDownloadsJobIdGetUrl({ jobId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetDashboardCardsApiWorkspaceTaskreportsLeaseauditsCardsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["lease_terms", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/cards?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/cards`;
};
/**
 * @summary Get Dashboard Cards
 */
export const getDashboardCardsApiWorkspaceTaskreportsLeaseauditsCardsGet = async (params, options) => {
    return customFetch(getGetDashboardCardsApiWorkspaceTaskreportsLeaseauditsCardsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseStatusCardsApiWorkspaceTaskreportsLeaseauditsLeaseStatusCardsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["lease_terms", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/lease-status-cards?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/lease-status-cards`;
};
/**
 * Lease-status scorecards over active (auditable) lease periods:
 *
 * - **Passing Leases** — periods whose audit passed, split Current / Future.
 * - **Failing Leases** — periods with real (non lease-document) failing
 *   checks, split by priority (high / medium / low).
 * - **Failing With Document Not Found** — periods failing the lease-document
 *   check, split by document failure type (missing / not signed).
 * @summary Get Lease Status Cards
 */
export const getLeaseStatusCardsApiWorkspaceTaskreportsLeaseauditsLeaseStatusCardsGet = async (params, options) => {
    return customFetch(getGetLeaseStatusCardsApiWorkspaceTaskreportsLeaseauditsLeaseStatusCardsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetRevenueReportingStartDatesExportApiWorkspaceTaskreportsLeaseauditsRevenueReportingStartDatesExportGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/revenue-reporting-start-dates-export?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/revenue-reporting-start-dates-export`;
};
/**
 * CSV export of each property's effective revenue reporting start date.
 *
 * Columns: `Property Name`, `Revenue Reporting Start Date` (dd/mm/yyyy).
 * Properties with no configured date get a blank value.
 * @summary Get Revenue Reporting Start Dates Export
 */
export const getRevenueReportingStartDatesExportApiWorkspaceTaskreportsLeaseauditsRevenueReportingStartDatesExportGet = async (params, options) => {
    return customFetch(getGetRevenueReportingStartDatesExportApiWorkspaceTaskreportsLeaseauditsRevenueReportingStartDatesExportGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetRevenueCardsApiWorkspaceTaskreportsLeaseauditsRevenueCardsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["lease_terms", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/revenue-cards?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/revenue-cards`;
};
/**
 * ### Revenue realization semantics
 *
 * These routes read **persisted** `LeaseAuditCheckRevenueRealizationWindow` rows attached to lease audit check metrics. Dollar math (lost vs potential, proration, one-time vs recurring) is implemented in `surface_core.auditing.reporting.financial.services.revenue_realization` and stored on each window.
 *
 * **Common filtering**
 *
 * - Omit check types excluded from revenue reports (`is_revenue_report_excluded_check_type`).
 * - Omit windows with a non-null `exclusion_reason` on the stored row.
 * - **Recoverable**-family endpoints (and **Recovered revenue**) omit **concession** check types (e.g. one-time and monthly concessions). They also omit **negative revenue windows** — typically `revenue_multiplicand < 0` when set, else inferred: non-concession rent roll **above** lease document, or concession rent roll **below** lease document. Those negative-revenue windows are *included* intentionally on **overcharging** / **under-concessing** / **over-concessing** reports.
 *
 * **`potential_revenue` in dimensional responses**
 *
 * Per included window, the API sums **remaining modeled potential** after first failure through the end of the revenue window: `post_first_failure_revenue_amount` when `fixed_date` is null, otherwise `0` (see `_potential_revenue_for_unfixed_window` in this router). This is **not** the same as cumulative “lost” (`pre_fixed_revenue_amount`).
 *
 * **`totals` in dimensional responses**
 *
 * May include `total_potential_revenue`, `recurring_potential_revenue`, and `one_time_potential_revenue` from the same per-window potential, split by stored charge frequency (`ONCE` vs `MONTHLY`).
 *
 * ### This endpoint
 * Returns two KPI cards served cache-first via `LeaseAuditReportingServiceProxy.run_revenue_cards_report`: **Potential Revenue** = sum of cached recoverable `potential_revenue` (`RECOVERABLE_REVENUE_BY_CHECK`, same source as the by-check chart); **Potential $ / Impacted Lease** = that sum divided by cached **Failing Lease Audits** (`DASHBOARD_CARDS.failing_lease_audits`), not every audited lease -- dividing by the full audited-lease count would spread potential revenue across leases with no open issue (the same denominator bug fixed on the hot spot "Impact / Lease" card in #10483). Falls back to live dashboard cards + live recoverable-by-check when the cache is cold or date filters are applied.
 * @summary Recoverable revenue dashboard cards
 */
export const getRevenueCardsApiWorkspaceTaskreportsLeaseauditsRevenueCardsGet = async (params, options) => {
    return customFetch(getGetRevenueCardsApiWorkspaceTaskreportsLeaseauditsRevenueCardsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetAuditableLeaseTermsApiWorkspaceTaskreportsLeaseauditsAuditableLeaseTermsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/auditable-lease-terms?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/auditable-lease-terms`;
};
/**
 * @summary Get Auditable Lease Terms
 */
export const getAuditableLeaseTermsApiWorkspaceTaskreportsLeaseauditsAuditableLeaseTermsGet = async (params, options) => {
    return customFetch(getGetAuditableLeaseTermsApiWorkspaceTaskreportsLeaseauditsAuditableLeaseTermsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseHealthByPropertyApiWorkspaceTaskreportsLeaseauditsLeaseHealthByPropertyGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["lease_terms", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/lease-health-by-property?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/lease-health-by-property`;
};
/**
 * Per-property audit health: units, lease periods, and the open / closed / AI-issue audit buckets with an `open_pct`.
 *
 * Two money measures ride along when they can be served from cache: **Potential Revenue**, the per-property sum of `RECOVERABLE_REVENUE_BY_CHECK.potential_revenue` (the same source as the Potential Revenue card, so the column sums to it), and **Potential $ / Impacted Lease**, that sum divided by `open_audits + ai_issue_open_audits` -- the leases with a failing audit whose task is still open, the per-property equivalent of `DASHBOARD_CARDS.failing_lease_audits`. Dividing by every audited lease instead would spread potential revenue across leases with no open issue (the denominator bug fixed in #10619, and #10483 before it).
 *
 * Both are cache-only: applying any lease filter or date window, or a cold revenue cache, drops the two measures and their defs from the response rather than reporting zero.
 * @summary Get Lease Health By Property
 */
export const getLeaseHealthByPropertyApiWorkspaceTaskreportsLeaseauditsLeaseHealthByPropertyGet = async (params, options) => {
    return customFetch(getGetLeaseHealthByPropertyApiWorkspaceTaskreportsLeaseauditsLeaseHealthByPropertyGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseHealthByPropertyDownloadApiWorkspaceTaskreportsLeaseauditsLeaseHealthByPropertyDownloadGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["lease_terms", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/lease-health-by-property-download?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/lease-health-by-property-download`;
};
/**
 * @summary Get Lease Health By Property Download
 */
export const getLeaseHealthByPropertyDownloadApiWorkspaceTaskreportsLeaseauditsLeaseHealthByPropertyDownloadGet = async (params, options) => {
    return customFetch(getGetLeaseHealthByPropertyDownloadApiWorkspaceTaskreportsLeaseauditsLeaseHealthByPropertyDownloadGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetPropertyHealthChartExportJobApiWorkspaceTaskreportsLeaseauditsChartExportJobGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["additional_group_by", "check_types", "priorities", "lease_terms", "check_failure_types", "check_failure_priorities", "lease_stages", "custom_statuses", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/chart_export_job?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/chart_export_job`;
};
/**
 * Queues a CSV export of one Property Health financial chart and returns the job. The user is notified in-app when the file is ready.
 *
 * The CSV follows the chart's grouping: with `group_by_dimension` set the rows are the aggregate report broken out by property or occupancy type, split further by any `additional_group_by` dimensions; with it omitted the rows are the individual failing checks behind the chart, matching the audit-checks table in the drilldown dialog. Pass the same filters used to render the chart so the file matches what is on screen.
 * @summary Export a Property Health chart as CSV
 */
export const getPropertyHealthChartExportJobApiWorkspaceTaskreportsLeaseauditsChartExportJobGet = async (params, options) => {
    return customFetch(getGetPropertyHealthChartExportJobApiWorkspaceTaskreportsLeaseauditsChartExportJobGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetHighPriorityFailuresApiWorkspaceTaskreportsLeaseauditsHighPriorityFailuresGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["lease_terms", "check_types", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/high-priority-failures?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/high-priority-failures`;
};
/**
 * @summary Get High Priority Failures
 */
export const getHighPriorityFailuresApiWorkspaceTaskreportsLeaseauditsHighPriorityFailuresGet = async (params, options) => {
    return customFetch(getGetHighPriorityFailuresApiWorkspaceTaskreportsLeaseauditsHighPriorityFailuresGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetFailingCheckOccurrencesApiWorkspaceTaskreportsLeaseauditsFailingCheckOccurrencesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["lease_terms", "check_types", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/failing-check-occurrences?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/failing-check-occurrences`;
};
/**
 * @summary Get Failing Check Occurrences
 */
export const getFailingCheckOccurrencesApiWorkspaceTaskreportsLeaseauditsFailingCheckOccurrencesGet = async (params, options) => {
    return customFetch(getGetFailingCheckOccurrencesApiWorkspaceTaskreportsLeaseauditsFailingCheckOccurrencesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetCheckResultDistributionApiWorkspaceTaskreportsLeaseauditsCheckResultDistributionGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["lease_terms", "check_types", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/check-result-distribution?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/check-result-distribution`;
};
/**
 * Pass/fail split per check type across the latest audits. Due diligence
 * only — the property scope is gated on that license, unlike the
 * lease-audit reports on this router.
 * @summary Get Check Result Distribution
 */
export const getCheckResultDistributionApiWorkspaceTaskreportsLeaseauditsCheckResultDistributionGet = async (params, options) => {
    return customFetch(getGetCheckResultDistributionApiWorkspaceTaskreportsLeaseauditsCheckResultDistributionGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditCheckResultDistributionApiWorkspaceTaskreportsLeaseauditsLeaseAuditCheckResultDistributionGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["lease_terms", "check_types", "check_failure_priorities", "check_failure_types", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/lease-audit-check-result-distribution?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/lease-audit-check-result-distribution`;
};
/**
 * Natural check outcomes and override activity for Lease Audits.
 * @summary Get Lease Audit Check Result Distribution
 */
export const getLeaseAuditCheckResultDistributionApiWorkspaceTaskreportsLeaseauditsLeaseAuditCheckResultDistributionGet = async (params, options) => {
    return customFetch(getGetLeaseAuditCheckResultDistributionApiWorkspaceTaskreportsLeaseauditsLeaseAuditCheckResultDistributionGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetFailureStatusOfLatestAuditApiWorkspaceTaskreportsLeaseauditsFailureStatusOfLatestAuditGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["lease_terms", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/failure-status-of-latest-audit?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/failure-status-of-latest-audit`;
};
/**
 * @summary Get Failure Status Of Latest Audit
 */
export const getFailureStatusOfLatestAuditApiWorkspaceTaskreportsLeaseauditsFailureStatusOfLatestAuditGet = async (params, options) => {
    return customFetch(getGetFailureStatusOfLatestAuditApiWorkspaceTaskreportsLeaseauditsFailureStatusOfLatestAuditGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetChecksWithHighPriorityFailuresApiWorkspaceTaskreportsLeaseauditsChecksWithHighPriorityFailuresGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["lease_terms", "check_types", "failure_types", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/checks-with-high-priority-failures?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/checks-with-high-priority-failures`;
};
/**
 * @summary Get Checks With High Priority Failures
 */
export const getChecksWithHighPriorityFailuresApiWorkspaceTaskreportsLeaseauditsChecksWithHighPriorityFailuresGet = async (params, options) => {
    return customFetch(getGetChecksWithHighPriorityFailuresApiWorkspaceTaskreportsLeaseauditsChecksWithHighPriorityFailuresGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetFailingChecksByPropertyApiWorkspaceTaskreportsLeaseauditsFailingChecksByPropertyGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["lease_terms", "check_types", "failure_types", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/failing-checks-by-property?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/failing-checks-by-property`;
};
/**
 * @summary Get Failing Checks By Property
 */
export const getFailingChecksByPropertyApiWorkspaceTaskreportsLeaseauditsFailingChecksByPropertyGet = async (params, options) => {
    return customFetch(getGetFailingChecksByPropertyApiWorkspaceTaskreportsLeaseauditsFailingChecksByPropertyGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetRecoverableRevenueByCheckApiWorkspaceTaskreportsLeaseauditsRecoverableRevenueByCheckGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["check_types", "lease_terms", "additional_group_by", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/recoverable-revenue-by-check?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/recoverable-revenue-by-check`;
};
/**
 * ### Revenue realization semantics
 *
 * These routes read **persisted** `LeaseAuditCheckRevenueRealizationWindow` rows attached to lease audit check metrics. Dollar math (lost vs potential, proration, one-time vs recurring) is implemented in `surface_core.auditing.reporting.financial.services.revenue_realization` and stored on each window.
 *
 * **Common filtering**
 *
 * - Omit check types excluded from revenue reports (`is_revenue_report_excluded_check_type`).
 * - Omit windows with a non-null `exclusion_reason` on the stored row.
 * - **Recoverable**-family endpoints (and **Recovered revenue**) omit **concession** check types (e.g. one-time and monthly concessions). They also omit **negative revenue windows** — typically `revenue_multiplicand < 0` when set, else inferred: non-concession rent roll **above** lease document, or concession rent roll **below** lease document. Those negative-revenue windows are *included* intentionally on **overcharging** / **under-concessing** / **over-concessing** reports.
 *
 * **`potential_revenue` in dimensional responses**
 *
 * Per included window, the API sums **remaining modeled potential** after first failure through the end of the revenue window: `post_first_failure_revenue_amount` when `fixed_date` is null, otherwise `0` (see `_potential_revenue_for_unfixed_window` in this router). This is **not** the same as cumulative “lost” (`pre_fixed_revenue_amount`).
 *
 * **`totals` in dimensional responses**
 *
 * May include `total_potential_revenue`, `recurring_potential_revenue`, and `one_time_potential_revenue` from the same per-window potential, split by stored charge frequency (`ONCE` vs `MONTHLY`).
 *
 * ### This endpoint
 * Dimensional report: **`potential_revenue`** summed by lease-audit **check type** (e.g. RENT, PET_FEE). Uses recoverable row filter above; rows may be narrowed by `check_types` query.
 * @summary Recoverable potential revenue by check type
 */
export const getRecoverableRevenueByCheckApiWorkspaceTaskreportsLeaseauditsRecoverableRevenueByCheckGet = async (params, options) => {
    return customFetch(getGetRecoverableRevenueByCheckApiWorkspaceTaskreportsLeaseauditsRecoverableRevenueByCheckGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetRecoverableRevenueByPriorityApiWorkspaceTaskreportsLeaseauditsRecoverableRevenueByPriorityGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["check_types", "lease_terms", "additional_group_by", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/recoverable-revenue-by-priority?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/recoverable-revenue-by-priority`;
};
/**
 * ### Revenue realization semantics
 *
 * These routes read **persisted** `LeaseAuditCheckRevenueRealizationWindow` rows attached to lease audit check metrics. Dollar math (lost vs potential, proration, one-time vs recurring) is implemented in `surface_core.auditing.reporting.financial.services.revenue_realization` and stored on each window.
 *
 * **Common filtering**
 *
 * - Omit check types excluded from revenue reports (`is_revenue_report_excluded_check_type`).
 * - Omit windows with a non-null `exclusion_reason` on the stored row.
 * - **Recoverable**-family endpoints (and **Recovered revenue**) omit **concession** check types (e.g. one-time and monthly concessions). They also omit **negative revenue windows** — typically `revenue_multiplicand < 0` when set, else inferred: non-concession rent roll **above** lease document, or concession rent roll **below** lease document. Those negative-revenue windows are *included* intentionally on **overcharging** / **under-concessing** / **over-concessing** reports.
 *
 * **`potential_revenue` in dimensional responses**
 *
 * Per included window, the API sums **remaining modeled potential** after first failure through the end of the revenue window: `post_first_failure_revenue_amount` when `fixed_date` is null, otherwise `0` (see `_potential_revenue_for_unfixed_window` in this router). This is **not** the same as cumulative “lost” (`pre_fixed_revenue_amount`).
 *
 * **`totals` in dimensional responses**
 *
 * May include `total_potential_revenue`, `recurring_potential_revenue`, and `one_time_potential_revenue` from the same per-window potential, split by stored charge frequency (`ONCE` vs `MONTHLY`).
 *
 * ### This endpoint
 * Same **`potential_revenue`** measure as recoverable-by-check, grouped by the metric’s **failure priority** (high / medium / low / unknown).
 * @summary Recoverable potential revenue by failure priority
 */
export const getRecoverableRevenueByPriorityApiWorkspaceTaskreportsLeaseauditsRecoverableRevenueByPriorityGet = async (params, options) => {
    return customFetch(getGetRecoverableRevenueByPriorityApiWorkspaceTaskreportsLeaseauditsRecoverableRevenueByPriorityGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetRecoverableRevenueExpiringLeasesApiWorkspaceTaskreportsLeaseauditsRecoverableRevenueExpiringLeasesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["check_types", "lease_terms", "additional_group_by", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/recoverable-revenue-expiring-leases?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/recoverable-revenue-expiring-leases`;
};
/**
 * ### Revenue realization semantics
 *
 * These routes read **persisted** `LeaseAuditCheckRevenueRealizationWindow` rows attached to lease audit check metrics. Dollar math (lost vs potential, proration, one-time vs recurring) is implemented in `surface_core.auditing.reporting.financial.services.revenue_realization` and stored on each window.
 *
 * **Common filtering**
 *
 * - Omit check types excluded from revenue reports (`is_revenue_report_excluded_check_type`).
 * - Omit windows with a non-null `exclusion_reason` on the stored row.
 * - **Recoverable**-family endpoints (and **Recovered revenue**) omit **concession** check types (e.g. one-time and monthly concessions). They also omit **negative revenue windows** — typically `revenue_multiplicand < 0` when set, else inferred: non-concession rent roll **above** lease document, or concession rent roll **below** lease document. Those negative-revenue windows are *included* intentionally on **overcharging** / **under-concessing** / **over-concessing** reports.
 *
 * **`potential_revenue` in dimensional responses**
 *
 * Per included window, the API sums **remaining modeled potential** after first failure through the end of the revenue window: `post_first_failure_revenue_amount` when `fixed_date` is null, otherwise `0` (see `_potential_revenue_for_unfixed_window` in this router). This is **not** the same as cumulative “lost” (`pre_fixed_revenue_amount`).
 *
 * **`totals` in dimensional responses**
 *
 * May include `total_potential_revenue`, `recurring_potential_revenue`, and `one_time_potential_revenue` from the same per-window potential, split by stored charge frequency (`ONCE` vs `MONTHLY`).
 *
 * ### This endpoint
 * Same recoverable **`potential_revenue`** logic and grouping by **check type**, but the underlying window query is restricted to leases whose end date falls in **[today, today + expiring_within_days]**.
 * @summary Recoverable potential revenue (leases expiring soon)
 */
export const getRecoverableRevenueExpiringLeasesApiWorkspaceTaskreportsLeaseauditsRecoverableRevenueExpiringLeasesGet = async (params, options) => {
    return customFetch(getGetRecoverableRevenueExpiringLeasesApiWorkspaceTaskreportsLeaseauditsRecoverableRevenueExpiringLeasesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetRecoverableRevenueByFailureApiWorkspaceTaskreportsLeaseauditsRecoverableRevenueByFailureGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["priorities", "check_types", "lease_terms", "additional_group_by", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/recoverable-revenue-by-failure?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/recoverable-revenue-by-failure`;
};
/**
 * ### Revenue realization semantics
 *
 * These routes read **persisted** `LeaseAuditCheckRevenueRealizationWindow` rows attached to lease audit check metrics. Dollar math (lost vs potential, proration, one-time vs recurring) is implemented in `surface_core.auditing.reporting.financial.services.revenue_realization` and stored on each window.
 *
 * **Common filtering**
 *
 * - Omit check types excluded from revenue reports (`is_revenue_report_excluded_check_type`).
 * - Omit windows with a non-null `exclusion_reason` on the stored row.
 * - **Recoverable**-family endpoints (and **Recovered revenue**) omit **concession** check types (e.g. one-time and monthly concessions). They also omit **negative revenue windows** — typically `revenue_multiplicand < 0` when set, else inferred: non-concession rent roll **above** lease document, or concession rent roll **below** lease document. Those negative-revenue windows are *included* intentionally on **overcharging** / **under-concessing** / **over-concessing** reports.
 *
 * **`potential_revenue` in dimensional responses**
 *
 * Per included window, the API sums **remaining modeled potential** after first failure through the end of the revenue window: `post_first_failure_revenue_amount` when `fixed_date` is null, otherwise `0` (see `_potential_revenue_for_unfixed_window` in this router). This is **not** the same as cumulative “lost” (`pre_fixed_revenue_amount`).
 *
 * **`totals` in dimensional responses**
 *
 * May include `total_potential_revenue`, `recurring_potential_revenue`, and `one_time_potential_revenue` from the same per-window potential, split by stored charge frequency (`ONCE` vs `MONTHLY`).
 *
 * ### This endpoint
 * **`potential_revenue`** allocated to each **failure type** on the metric (a window can contribute to multiple failure-type buckets). Optional filters: `priorities`, `check_types`.
 * @summary Recoverable potential revenue by failure type
 */
export const getRecoverableRevenueByFailureApiWorkspaceTaskreportsLeaseauditsRecoverableRevenueByFailureGet = async (params, options) => {
    return customFetch(getGetRecoverableRevenueByFailureApiWorkspaceTaskreportsLeaseauditsRecoverableRevenueByFailureGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetOverchargingByCheckApiWorkspaceTaskreportsLeaseauditsOverchargingByCheckGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["check_types", "lease_terms", "additional_group_by", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/overcharging-by-check?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/overcharging-by-check`;
};
/**
 * ### Revenue realization semantics
 *
 * These routes read **persisted** `LeaseAuditCheckRevenueRealizationWindow` rows attached to lease audit check metrics. Dollar math (lost vs potential, proration, one-time vs recurring) is implemented in `surface_core.auditing.reporting.financial.services.revenue_realization` and stored on each window.
 *
 * **Common filtering**
 *
 * - Omit check types excluded from revenue reports (`is_revenue_report_excluded_check_type`).
 * - Omit windows with a non-null `exclusion_reason` on the stored row.
 * - **Recoverable**-family endpoints (and **Recovered revenue**) omit **concession** check types (e.g. one-time and monthly concessions). They also omit **negative revenue windows** — typically `revenue_multiplicand < 0` when set, else inferred: non-concession rent roll **above** lease document, or concession rent roll **below** lease document. Those negative-revenue windows are *included* intentionally on **overcharging** / **under-concessing** / **over-concessing** reports.
 *
 * **`potential_revenue` in dimensional responses**
 *
 * Per included window, the API sums **remaining modeled potential** after first failure through the end of the revenue window: `post_first_failure_revenue_amount` when `fixed_date` is null, otherwise `0` (see `_potential_revenue_for_unfixed_window` in this router). This is **not** the same as cumulative “lost” (`pre_fixed_revenue_amount`).
 *
 * **`totals` in dimensional responses**
 *
 * May include `total_potential_revenue`, `recurring_potential_revenue`, and `one_time_potential_revenue` from the same per-window potential, split by stored charge frequency (`ONCE` vs `MONTHLY`).
 *
 * ### This endpoint
 * Restricts to **non-concession** windows where **rent roll value > lease document value** (`_is_overcharge_window`). Sums the same **`potential_revenue`** (`_potential_revenue_for_unfixed_window`) by check type. Negative-revenue exclusion used on *recoverable* routes does **not** apply here — these rows are the overcharging slice.
 * @summary Potential revenue from overcharging (by check type)
 */
export const getOverchargingByCheckApiWorkspaceTaskreportsLeaseauditsOverchargingByCheckGet = async (params, options) => {
    return customFetch(getGetOverchargingByCheckApiWorkspaceTaskreportsLeaseauditsOverchargingByCheckGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetOverchargingByPriorityApiWorkspaceTaskreportsLeaseauditsOverchargingByPriorityGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["check_types", "lease_terms", "additional_group_by", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/overcharging-by-priority?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/overcharging-by-priority`;
};
/**
 * ### Revenue realization semantics
 *
 * These routes read **persisted** `LeaseAuditCheckRevenueRealizationWindow` rows attached to lease audit check metrics. Dollar math (lost vs potential, proration, one-time vs recurring) is implemented in `surface_core.auditing.reporting.financial.services.revenue_realization` and stored on each window.
 *
 * **Common filtering**
 *
 * - Omit check types excluded from revenue reports (`is_revenue_report_excluded_check_type`).
 * - Omit windows with a non-null `exclusion_reason` on the stored row.
 * - **Recoverable**-family endpoints (and **Recovered revenue**) omit **concession** check types (e.g. one-time and monthly concessions). They also omit **negative revenue windows** — typically `revenue_multiplicand < 0` when set, else inferred: non-concession rent roll **above** lease document, or concession rent roll **below** lease document. Those negative-revenue windows are *included* intentionally on **overcharging** / **under-concessing** / **over-concessing** reports.
 *
 * **`potential_revenue` in dimensional responses**
 *
 * Per included window, the API sums **remaining modeled potential** after first failure through the end of the revenue window: `post_first_failure_revenue_amount` when `fixed_date` is null, otherwise `0` (see `_potential_revenue_for_unfixed_window` in this router). This is **not** the same as cumulative “lost” (`pre_fixed_revenue_amount`).
 *
 * **`totals` in dimensional responses**
 *
 * May include `total_potential_revenue`, `recurring_potential_revenue`, and `one_time_potential_revenue` from the same per-window potential, split by stored charge frequency (`ONCE` vs `MONTHLY`).
 *
 * ### This endpoint
 * Same **`potential_revenue`** measure and overcharging row filter as overcharging-by-check, grouped by **failure priority**.
 * @summary Potential revenue from overcharging (by priority)
 */
export const getOverchargingByPriorityApiWorkspaceTaskreportsLeaseauditsOverchargingByPriorityGet = async (params, options) => {
    return customFetch(getGetOverchargingByPriorityApiWorkspaceTaskreportsLeaseauditsOverchargingByPriorityGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetChargesNotFoundInDocumentByCheckApiWorkspaceTaskreportsLeaseauditsChargesNotFoundInDocumentByCheckGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["check_types", "priorities", "lease_terms", "additional_group_by", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/charges-not-found-in-document-by-check?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/charges-not-found-in-document-by-check`;
};
/**
 * ### Revenue realization semantics
 *
 * These routes read **persisted** `LeaseAuditCheckRevenueRealizationWindow` rows attached to lease audit check metrics. Dollar math (lost vs potential, proration, one-time vs recurring) is implemented in `surface_core.auditing.reporting.financial.services.revenue_realization` and stored on each window.
 *
 * **Common filtering**
 *
 * - Omit check types excluded from revenue reports (`is_revenue_report_excluded_check_type`).
 * - Omit windows with a non-null `exclusion_reason` on the stored row.
 * - **Recoverable**-family endpoints (and **Recovered revenue**) omit **concession** check types (e.g. one-time and monthly concessions). They also omit **negative revenue windows** — typically `revenue_multiplicand < 0` when set, else inferred: non-concession rent roll **above** lease document, or concession rent roll **below** lease document. Those negative-revenue windows are *included* intentionally on **overcharging** / **under-concessing** / **over-concessing** reports.
 *
 * **`potential_revenue` in dimensional responses**
 *
 * Per included window, the API sums **remaining modeled potential** after first failure through the end of the revenue window: `post_first_failure_revenue_amount` when `fixed_date` is null, otherwise `0` (see `_potential_revenue_for_unfixed_window` in this router). This is **not** the same as cumulative “lost” (`pre_fixed_revenue_amount`).
 *
 * **`totals` in dimensional responses**
 *
 * May include `total_potential_revenue`, `recurring_potential_revenue`, and `one_time_potential_revenue` from the same per-window potential, split by stored charge frequency (`ONCE` vs `MONTHLY`).
 *
 * ### This endpoint
 * Restricts to **non-concession** windows where the check's `failure_types` array contains **`charge_not_found_in_lease_document`**. Sums **`potential_revenue`** (`_potential_revenue_for_unfixed_window`) by **check type**. Supports optional filtering by `priorities`. These rows represent charges present in the rent roll but not yet reflected in official lease documentation; `revenue_multiplicand` is typically negative (rent roll exceeds document). Negative-revenue exclusion used on *recoverable* routes does **not** apply here.
 * @summary Potential revenue from charges not found in lease document (by check type)
 */
export const getChargesNotFoundInDocumentByCheckApiWorkspaceTaskreportsLeaseauditsChargesNotFoundInDocumentByCheckGet = async (params, options) => {
    return customFetch(getGetChargesNotFoundInDocumentByCheckApiWorkspaceTaskreportsLeaseauditsChargesNotFoundInDocumentByCheckGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetChargesNotFoundInDocumentByPriorityApiWorkspaceTaskreportsLeaseauditsChargesNotFoundInDocumentByPriorityGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["check_types", "lease_terms", "additional_group_by", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/charges-not-found-in-document-by-priority?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/charges-not-found-in-document-by-priority`;
};
/**
 * ### Revenue realization semantics
 *
 * These routes read **persisted** `LeaseAuditCheckRevenueRealizationWindow` rows attached to lease audit check metrics. Dollar math (lost vs potential, proration, one-time vs recurring) is implemented in `surface_core.auditing.reporting.financial.services.revenue_realization` and stored on each window.
 *
 * **Common filtering**
 *
 * - Omit check types excluded from revenue reports (`is_revenue_report_excluded_check_type`).
 * - Omit windows with a non-null `exclusion_reason` on the stored row.
 * - **Recoverable**-family endpoints (and **Recovered revenue**) omit **concession** check types (e.g. one-time and monthly concessions). They also omit **negative revenue windows** — typically `revenue_multiplicand < 0` when set, else inferred: non-concession rent roll **above** lease document, or concession rent roll **below** lease document. Those negative-revenue windows are *included* intentionally on **overcharging** / **under-concessing** / **over-concessing** reports.
 *
 * **`potential_revenue` in dimensional responses**
 *
 * Per included window, the API sums **remaining modeled potential** after first failure through the end of the revenue window: `post_first_failure_revenue_amount` when `fixed_date` is null, otherwise `0` (see `_potential_revenue_for_unfixed_window` in this router). This is **not** the same as cumulative “lost” (`pre_fixed_revenue_amount`).
 *
 * **`totals` in dimensional responses**
 *
 * May include `total_potential_revenue`, `recurring_potential_revenue`, and `one_time_potential_revenue` from the same per-window potential, split by stored charge frequency (`ONCE` vs `MONTHLY`).
 *
 * ### This endpoint
 * Same **`potential_revenue`** measure and charge-not-found-in-document row filter as charges-not-found-in-document-by-check, grouped by **failure priority**.
 * @summary Potential revenue from charges not found in lease document (by priority)
 */
export const getChargesNotFoundInDocumentByPriorityApiWorkspaceTaskreportsLeaseauditsChargesNotFoundInDocumentByPriorityGet = async (params, options) => {
    return customFetch(getGetChargesNotFoundInDocumentByPriorityApiWorkspaceTaskreportsLeaseauditsChargesNotFoundInDocumentByPriorityGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetUnderConcessingByCheckApiWorkspaceTaskreportsLeaseauditsUnderConcessingByCheckGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["check_types", "lease_terms", "additional_group_by", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/under-concessing-by-check?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/under-concessing-by-check`;
};
/**
 * ### Revenue realization semantics
 *
 * These routes read **persisted** `LeaseAuditCheckRevenueRealizationWindow` rows attached to lease audit check metrics. Dollar math (lost vs potential, proration, one-time vs recurring) is implemented in `surface_core.auditing.reporting.financial.services.revenue_realization` and stored on each window.
 *
 * **Common filtering**
 *
 * - Omit check types excluded from revenue reports (`is_revenue_report_excluded_check_type`).
 * - Omit windows with a non-null `exclusion_reason` on the stored row.
 * - **Recoverable**-family endpoints (and **Recovered revenue**) omit **concession** check types (e.g. one-time and monthly concessions). They also omit **negative revenue windows** — typically `revenue_multiplicand < 0` when set, else inferred: non-concession rent roll **above** lease document, or concession rent roll **below** lease document. Those negative-revenue windows are *included* intentionally on **overcharging** / **under-concessing** / **over-concessing** reports.
 *
 * **`potential_revenue` in dimensional responses**
 *
 * Per included window, the API sums **remaining modeled potential** after first failure through the end of the revenue window: `post_first_failure_revenue_amount` when `fixed_date` is null, otherwise `0` (see `_potential_revenue_for_unfixed_window` in this router). This is **not** the same as cumulative “lost” (`pre_fixed_revenue_amount`).
 *
 * **`totals` in dimensional responses**
 *
 * May include `total_potential_revenue`, `recurring_potential_revenue`, and `one_time_potential_revenue` from the same per-window potential, split by stored charge frequency (`ONCE` vs `MONTHLY`).
 *
 * ### This endpoint
 * Restricts to **concession** check types where **rent roll < lease document** (`_is_under_concession_window`). Sums **`potential_revenue`** by check type.
 * @summary Potential revenue from under-concessing (by check type)
 */
export const getUnderConcessingByCheckApiWorkspaceTaskreportsLeaseauditsUnderConcessingByCheckGet = async (params, options) => {
    return customFetch(getGetUnderConcessingByCheckApiWorkspaceTaskreportsLeaseauditsUnderConcessingByCheckGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetOverConcessingByCheckApiWorkspaceTaskreportsLeaseauditsOverConcessingByCheckGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["check_types", "lease_terms", "additional_group_by", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/over-concessing-by-check?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/over-concessing-by-check`;
};
/**
 * ### Revenue realization semantics
 *
 * These routes read **persisted** `LeaseAuditCheckRevenueRealizationWindow` rows attached to lease audit check metrics. Dollar math (lost vs potential, proration, one-time vs recurring) is implemented in `surface_core.auditing.reporting.financial.services.revenue_realization` and stored on each window.
 *
 * **Common filtering**
 *
 * - Omit check types excluded from revenue reports (`is_revenue_report_excluded_check_type`).
 * - Omit windows with a non-null `exclusion_reason` on the stored row.
 * - **Recoverable**-family endpoints (and **Recovered revenue**) omit **concession** check types (e.g. one-time and monthly concessions). They also omit **negative revenue windows** — typically `revenue_multiplicand < 0` when set, else inferred: non-concession rent roll **above** lease document, or concession rent roll **below** lease document. Those negative-revenue windows are *included* intentionally on **overcharging** / **under-concessing** / **over-concessing** reports.
 *
 * **`potential_revenue` in dimensional responses**
 *
 * Per included window, the API sums **remaining modeled potential** after first failure through the end of the revenue window: `post_first_failure_revenue_amount` when `fixed_date` is null, otherwise `0` (see `_potential_revenue_for_unfixed_window` in this router). This is **not** the same as cumulative “lost” (`pre_fixed_revenue_amount`).
 *
 * **`totals` in dimensional responses**
 *
 * May include `total_potential_revenue`, `recurring_potential_revenue`, and `one_time_potential_revenue` from the same per-window potential, split by stored charge frequency (`ONCE` vs `MONTHLY`).
 *
 * ### This endpoint
 * Restricts to **concession** check types where **rent roll > lease document** (`_is_over_concession_window`). Sums **`potential_revenue`** by check type.
 * @summary Potential revenue from over-concessing (by check type)
 */
export const getOverConcessingByCheckApiWorkspaceTaskreportsLeaseauditsOverConcessingByCheckGet = async (params, options) => {
    return customFetch(getGetOverConcessingByCheckApiWorkspaceTaskreportsLeaseauditsOverConcessingByCheckGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetRecoveredRevenueByChargeTypeApiWorkspaceTaskreportsLeaseauditsRecoveredRevenueByChargeTypeGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["check_types", "lease_terms", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/recovered-revenue-by-charge-type?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/recovered-revenue-by-charge-type`;
};
/**
 * ### Revenue realization semantics
 *
 * These routes read **persisted** `LeaseAuditCheckRevenueRealizationWindow` rows attached to lease audit check metrics. Dollar math (lost vs potential, proration, one-time vs recurring) is implemented in `surface_core.auditing.reporting.financial.services.revenue_realization` and stored on each window.
 *
 * **Common filtering**
 *
 * - Omit check types excluded from revenue reports (`is_revenue_report_excluded_check_type`).
 * - Omit windows with a non-null `exclusion_reason` on the stored row.
 * - **Recoverable**-family endpoints (and **Recovered revenue**) omit **concession** check types (e.g. one-time and monthly concessions). They also omit **negative revenue windows** — typically `revenue_multiplicand < 0` when set, else inferred: non-concession rent roll **above** lease document, or concession rent roll **below** lease document. Those negative-revenue windows are *included* intentionally on **overcharging** / **under-concessing** / **over-concessing** reports.
 *
 * **`potential_revenue` in dimensional responses**
 *
 * Per included window, the API sums **remaining modeled potential** after first failure through the end of the revenue window: `post_first_failure_revenue_amount` when `fixed_date` is null, otherwise `0` (see `_potential_revenue_for_unfixed_window` in this router). This is **not** the same as cumulative “lost” (`pre_fixed_revenue_amount`).
 *
 * **`totals` in dimensional responses**
 *
 * May include `total_potential_revenue`, `recurring_potential_revenue`, and `one_time_potential_revenue` from the same per-window potential, split by stored charge frequency (`ONCE` vs `MONTHLY`).
 *
 * ### This endpoint
 * **Different measure:** only windows that are **fixed** (`fixed_date` set) *and* pass the same recoverable filters (non-excluded, not negative-revenue). Each row’s contribution is **`pre_fixed_revenue_amount`** (modeled loss through fix / last observation), rolled up by **`charge_type`** on the window. Measures: **`recovered_revenue`** and share **`recovered_revenue_pct`**.
 * @summary Recovered revenue by PMS charge type (fixed windows)
 */
export const getRecoveredRevenueByChargeTypeApiWorkspaceTaskreportsLeaseauditsRecoveredRevenueByChargeTypeGet = async (params, options) => {
    return customFetch(getGetRecoveredRevenueByChargeTypeApiWorkspaceTaskreportsLeaseauditsRecoveredRevenueByChargeTypeGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetDepositDiscrepanciesApiWorkspaceTaskreportsLeaseauditsDepositDiscrepanciesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/workspace/taskreports/leaseaudits/deposit-discrepancies?${stringifiedParams}` : `/api/workspace/taskreports/leaseaudits/deposit-discrepancies`;
};
/**
 * ### Revenue realization semantics
 *
 * These routes read **persisted** `LeaseAuditCheckRevenueRealizationWindow` rows attached to lease audit check metrics. Dollar math (lost vs potential, proration, one-time vs recurring) is implemented in `surface_core.auditing.reporting.financial.services.revenue_realization` and stored on each window.
 *
 * **Common filtering**
 *
 * - Omit check types excluded from revenue reports (`is_revenue_report_excluded_check_type`).
 * - Omit windows with a non-null `exclusion_reason` on the stored row.
 * - **Recoverable**-family endpoints (and **Recovered revenue**) omit **concession** check types (e.g. one-time and monthly concessions). They also omit **negative revenue windows** — typically `revenue_multiplicand < 0` when set, else inferred: non-concession rent roll **above** lease document, or concession rent roll **below** lease document. Those negative-revenue windows are *included* intentionally on **overcharging** / **under-concessing** / **over-concessing** reports.
 *
 * **`potential_revenue` in dimensional responses**
 *
 * Per included window, the API sums **remaining modeled potential** after first failure through the end of the revenue window: `post_first_failure_revenue_amount` when `fixed_date` is null, otherwise `0` (see `_potential_revenue_for_unfixed_window` in this router). This is **not** the same as cumulative “lost” (`pre_fixed_revenue_amount`).
 *
 * **`totals` in dimensional responses**
 *
 * May include `total_potential_revenue`, `recurring_potential_revenue`, and `one_time_potential_revenue` from the same per-window potential, split by stored charge frequency (`ONCE` vs `MONTHLY`).
 *
 * ### This endpoint
 * Identify excessive and insufficient deposits from deposit checks.
 * @summary Identify excessive and insufficient deposits from deposit checks
 */
export const getDepositDiscrepanciesApiWorkspaceTaskreportsLeaseauditsDepositDiscrepanciesGet = async (params, options) => {
    return customFetch(getGetDepositDiscrepanciesApiWorkspaceTaskreportsLeaseauditsDepositDiscrepanciesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetPropertySettingsApiPropertiesPropertyIdSettingsGetUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/settings`;
};
/**
 * return external system settings for the current property. currently, all properties within a tenant use the same
 * external system. in the future we expect heterogeneous setups
 * @summary Get Property Settings
 */
export const getPropertySettingsApiPropertiesPropertyIdSettingsGet = async ({ propertyId }, options) => {
    return customFetch(getGetPropertySettingsApiPropertiesPropertyIdSettingsGetUrl({ propertyId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetResidentListApiPropertiesPropertyIdResidentListGetUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/resident-list`;
};
/**
 * @summary Get Resident List
 */
export const getResidentListApiPropertiesPropertyIdResidentListGet = async ({ propertyId }, options) => {
    return customFetch(getGetResidentListApiPropertiesPropertyIdResidentListGetUrl({ propertyId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetResidentApiPropertiesPropertyIdResidentsResidentIdGetUrl = ({ propertyId, residentId }) => {
    return `/api/properties/${propertyId}/residents/${residentId}`;
};
/**
 * @summary Get Resident
 */
export const getResidentApiPropertiesPropertyIdResidentsResidentIdGet = async ({ propertyId, residentId }, options) => {
    return customFetch(getGetResidentApiPropertiesPropertyIdResidentsResidentIdGetUrl({ propertyId, residentId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetWorkOrderSummariesForResidentApiPropertiesPropertyIdResidentsResidentIdWorkordersGetUrl = ({ propertyId, residentId }) => {
    return `/api/properties/${propertyId}/residents/${residentId}/workorders`;
};
/**
 * @summary Get Work Order Summaries For Resident
 */
export const getWorkOrderSummariesForResidentApiPropertiesPropertyIdResidentsResidentIdWorkordersGet = async ({ propertyId, residentId }, options) => {
    return customFetch(getGetWorkOrderSummariesForResidentApiPropertiesPropertyIdResidentsResidentIdWorkordersGetUrl({ propertyId, residentId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetPossibleRepeatWorkOrderSummariesApiPropertiesPropertyIdWorkordersWorkOrderIdPossibleRepeatWorkordersGetUrl = ({ propertyId, workOrderId }) => {
    return `/api/properties/${propertyId}/workorders/${workOrderId}/possible_repeat_workorders`;
};
/**
 * @summary Get Possible Repeat Work Order Summaries
 */
export const getPossibleRepeatWorkOrderSummariesApiPropertiesPropertyIdWorkordersWorkOrderIdPossibleRepeatWorkordersGet = async ({ propertyId, workOrderId }, options) => {
    return customFetch(getGetPossibleRepeatWorkOrderSummariesApiPropertiesPropertyIdWorkordersWorkOrderIdPossibleRepeatWorkordersGetUrl({ propertyId, workOrderId }), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateLeaseDocumentLeasesApiPropertiesPropertyIdLeaseDocumentsLeaseDocumentIdLeasesPutUrl = ({ propertyId, leaseDocumentId }) => {
    return `/api/properties/${propertyId}/lease-documents/${leaseDocumentId}/leases`;
};
/**
 * Associate a document with a lease by lease ID.
 * @summary Update Lease Document Leases
 */
export const updateLeaseDocumentLeasesApiPropertiesPropertyIdLeaseDocumentsLeaseDocumentIdLeasesPut = async ({ propertyId, leaseDocumentId }, updateLeaseDocumentLeasesRequest, options) => {
    return customFetch(getUpdateLeaseDocumentLeasesApiPropertiesPropertyIdLeaseDocumentsLeaseDocumentIdLeasesPutUrl({ propertyId, leaseDocumentId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(updateLeaseDocumentLeasesRequest)
    });
};
export const getUpdateLeaseDocumentApiPropertiesPropertyIdLeaseDocumentsLeaseDocumentIdPostUrl = ({ propertyId, leaseDocumentId }) => {
    return `/api/properties/${propertyId}/lease-documents/${leaseDocumentId}`;
};
/**
 * @summary Update Lease Document
 */
export const updateLeaseDocumentApiPropertiesPropertyIdLeaseDocumentsLeaseDocumentIdPost = async ({ propertyId, leaseDocumentId }, leaseDocumentUpdate, options) => {
    return customFetch(getUpdateLeaseDocumentApiPropertiesPropertyIdLeaseDocumentsLeaseDocumentIdPostUrl({ propertyId, leaseDocumentId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(leaseDocumentUpdate)
    });
};
export const getGetLeaseDocumentApiPropertiesPropertyIdLeaseDocumentsLeaseDocumentIdGetUrl = ({ propertyId, leaseDocumentId }) => {
    return `/api/properties/${propertyId}/lease-documents/${leaseDocumentId}`;
};
/**
 * @summary Get Lease Document
 */
export const getLeaseDocumentApiPropertiesPropertyIdLeaseDocumentsLeaseDocumentIdGet = async ({ propertyId, leaseDocumentId }, options) => {
    return customFetch(getGetLeaseDocumentApiPropertiesPropertyIdLeaseDocumentsLeaseDocumentIdGetUrl({ propertyId, leaseDocumentId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseDocumentsForPropertiesApiPropertiesLeaseDocumentsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/lease-documents?${stringifiedParams}` : `/api/properties/lease-documents`;
};
/**
 * @summary Get Lease Documents For Properties
 */
export const getLeaseDocumentsForPropertiesApiPropertiesLeaseDocumentsGet = async (params, options) => {
    return customFetch(getGetLeaseDocumentsForPropertiesApiPropertiesLeaseDocumentsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseDocumentsApiPropertiesPropertyIdLeaseDocumentsGetUrl = ({ propertyId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/lease-documents?${stringifiedParams}` : `/api/properties/${propertyId}/lease-documents`;
};
/**
 * @summary Get Lease Documents
 */
export const getLeaseDocumentsApiPropertiesPropertyIdLeaseDocumentsGet = async ({ propertyId }, params, options) => {
    return customFetch(getGetLeaseDocumentsApiPropertiesPropertyIdLeaseDocumentsGetUrl({ propertyId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetIndexedDocumentContentsApiPropertiesPropertyIdIndexedDocumentsDocumentIdContentGetUrl = ({ propertyId, documentId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/indexed-documents/${documentId}/content?${stringifiedParams}` : `/api/properties/${propertyId}/indexed-documents/${documentId}/content`;
};
/**
 * @summary Get Indexed Document Contents
 */
export const getIndexedDocumentContentsApiPropertiesPropertyIdIndexedDocumentsDocumentIdContentGet = async ({ propertyId, documentId }, params, options) => {
    return customFetch(getGetIndexedDocumentContentsApiPropertiesPropertyIdIndexedDocumentsDocumentIdContentGetUrl({ propertyId, documentId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetIndexedDocumentContentMetadataApiPropertiesPropertyIdIndexedDocumentsDocumentIdContentMetadataGetUrl = ({ propertyId, documentId }) => {
    return `/api/properties/${propertyId}/indexed-documents/${documentId}/content/metadata`;
};
/**
 * @summary Get Indexed Document Content Metadata
 */
export const getIndexedDocumentContentMetadataApiPropertiesPropertyIdIndexedDocumentsDocumentIdContentMetadataGet = async ({ propertyId, documentId }, options) => {
    return customFetch(getGetIndexedDocumentContentMetadataApiPropertiesPropertyIdIndexedDocumentsDocumentIdContentMetadataGetUrl({ propertyId, documentId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetIndexedDocumentTextApiPropertiesPropertyIdIndexedDocumentsDocumentIdTextGetUrl = ({ propertyId, documentId }) => {
    return `/api/properties/${propertyId}/indexed-documents/${documentId}/text`;
};
/**
 * @summary Get Indexed Document Text
 */
export const getIndexedDocumentTextApiPropertiesPropertyIdIndexedDocumentsDocumentIdTextGet = async ({ propertyId, documentId }, options) => {
    return customFetch(getGetIndexedDocumentTextApiPropertiesPropertyIdIndexedDocumentsDocumentIdTextGetUrl({ propertyId, documentId }), {
        ...options,
        method: 'GET'
    });
};
export const getReindexIndexDocumentApiPropertiesPropertyIdIndexedDocumentsDocumentIdReindexPostUrl = ({ propertyId, documentId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/indexed-documents/${documentId}/reindex?${stringifiedParams}` : `/api/properties/${propertyId}/indexed-documents/${documentId}/reindex`;
};
/**
 * @summary Reindex Index Document
 */
export const reindexIndexDocumentApiPropertiesPropertyIdIndexedDocumentsDocumentIdReindexPost = async ({ propertyId, documentId }, params, options) => {
    return customFetch(getReindexIndexDocumentApiPropertiesPropertyIdIndexedDocumentsDocumentIdReindexPostUrl({ propertyId, documentId }, params), {
        ...options,
        method: 'POST'
    });
};
export const getGetEnrichedDocumentStatsApiPropertiesEnrichedDocumentsMetricsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["source_files", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/enriched-documents/metrics?${stringifiedParams}` : `/api/properties/enriched-documents/metrics`;
};
/**
 * @summary Get Enriched Document Stats
 */
export const getEnrichedDocumentStatsApiPropertiesEnrichedDocumentsMetricsGet = async (params, options) => {
    return customFetch(getGetEnrichedDocumentStatsApiPropertiesEnrichedDocumentsMetricsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetEnrichedDocumentApiPropertiesPropertyIdEnrichedDocumentsDocumentIdGetUrl = ({ propertyId, documentId }) => {
    return `/api/properties/${propertyId}/enriched-documents/${documentId}`;
};
/**
 * @summary Get Enriched Document
 */
export const getEnrichedDocumentApiPropertiesPropertyIdEnrichedDocumentsDocumentIdGet = async ({ propertyId, documentId }, options) => {
    return customFetch(getGetEnrichedDocumentApiPropertiesPropertyIdEnrichedDocumentsDocumentIdGetUrl({ propertyId, documentId }), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateLeaseDocumentProfileApiPropertiesPropertyIdLeaseDocumentsLeaseDocumentIdProfilePutUrl = ({ propertyId, leaseDocumentId }) => {
    return `/api/properties/${propertyId}/lease-documents/${leaseDocumentId}/profile`;
};
/**
 * @summary Update Lease Document Profile
 */
export const updateLeaseDocumentProfileApiPropertiesPropertyIdLeaseDocumentsLeaseDocumentIdProfilePut = async ({ propertyId, leaseDocumentId }, updateLeaseDocumentProfileApiPropertiesPropertyIdLeaseDocumentsLeaseDocumentIdProfilePutBody, options) => {
    return customFetch(getUpdateLeaseDocumentProfileApiPropertiesPropertyIdLeaseDocumentsLeaseDocumentIdProfilePutUrl({ propertyId, leaseDocumentId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(updateLeaseDocumentProfileApiPropertiesPropertyIdLeaseDocumentsLeaseDocumentIdProfilePutBody)
    });
};
export const getGetLeaseDocumentProfilesApiPropertiesSchemasLeaseDocumentsProfilesGetUrl = () => {
    return `/api/properties/schemas/lease-documents/profiles/`;
};
/**
 * Returns a list of valid profile types for lease documents with friendly names.
 * @summary Get Lease Document Profiles
 */
export const getLeaseDocumentProfilesApiPropertiesSchemasLeaseDocumentsProfilesGet = async (options) => {
    return customFetch(getGetLeaseDocumentProfilesApiPropertiesSchemasLeaseDocumentsProfilesGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseDocumentProfileSchemaApiPropertiesSchemasLeaseDocumentsProfilesProfileTypeGetUrl = ({ profileType }) => {
    return `/api/properties/schemas/lease-documents/profiles/${profileType}`;
};
/**
 * @summary Get Lease Document Profile Schema
 */
export const getLeaseDocumentProfileSchemaApiPropertiesSchemasLeaseDocumentsProfilesProfileTypeGet = async ({ profileType }, options) => {
    return customFetch(getGetLeaseDocumentProfileSchemaApiPropertiesSchemasLeaseDocumentsProfilesProfileTypeGetUrl({ profileType }), {
        ...options,
        method: 'GET'
    });
};
export const getGetExtractedDocumentApiPropertiesPropertyIdExtractedDocumentsDocumentIdGetUrl = ({ propertyId, documentId }) => {
    return `/api/properties/${propertyId}/extracted-documents/${documentId}`;
};
/**
 * @summary Get Extracted Document
 */
export const getExtractedDocumentApiPropertiesPropertyIdExtractedDocumentsDocumentIdGet = async ({ propertyId, documentId }, options) => {
    return customFetch(getGetExtractedDocumentApiPropertiesPropertyIdExtractedDocumentsDocumentIdGetUrl({ propertyId, documentId }), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateExtractedDocumentApiPropertiesPropertyIdExtractedDocumentsDocumentIdPutUrl = ({ propertyId, documentId }) => {
    return `/api/properties/${propertyId}/extracted-documents/${documentId}`;
};
/**
 * @summary Update Extracted Document
 */
export const updateExtractedDocumentApiPropertiesPropertyIdExtractedDocumentsDocumentIdPut = async ({ propertyId, documentId }, extractedDocumentUpdate, options) => {
    return customFetch(getUpdateExtractedDocumentApiPropertiesPropertyIdExtractedDocumentsDocumentIdPutUrl({ propertyId, documentId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(extractedDocumentUpdate)
    });
};
export const getGetRealTimeApiStatsApiPropertiesPropertyIdRealTimeApiStatsGetUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/real-time-api/stats`;
};
/**
 * @summary Get Real Time Api Stats
 */
export const getRealTimeApiStatsApiPropertiesPropertyIdRealTimeApiStatsGet = async ({ propertyId }, options) => {
    return customFetch(getGetRealTimeApiStatsApiPropertiesPropertyIdRealTimeApiStatsGetUrl({ propertyId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetRealTimeApiFunctionsApiRealTimeApiFunctionsGetUrl = () => {
    return `/api/real-time-api/functions`;
};
/**
 * @summary Get Real Time Api Functions
 */
export const getRealTimeApiFunctionsApiRealTimeApiFunctionsGet = async (options) => {
    return customFetch(getGetRealTimeApiFunctionsApiRealTimeApiFunctionsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getExecuteRealTimeApiFunctionApiPropertiesPropertyIdRealTimeApiExecuteFunctionPostUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/real-time-api/execute-function`;
};
/**
 * @summary Execute Real Time Api Function
 */
export const executeRealTimeApiFunctionApiPropertiesPropertyIdRealTimeApiExecuteFunctionPost = async ({ propertyId }, executeRealTimeApiFunctionApiPropertiesPropertyIdRealTimeApiExecuteFunctionPostBody, options) => {
    return customFetch(getExecuteRealTimeApiFunctionApiPropertiesPropertyIdRealTimeApiExecuteFunctionPostUrl({ propertyId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(executeRealTimeApiFunctionApiPropertiesPropertyIdRealTimeApiExecuteFunctionPostBody)
    });
};
export const getGetPropertyDataViewApiPropertiesPropertyIdDataViewGetUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/data-view`;
};
/**
 * Consolidated data-validation view for a single property.
 *
 * Returns top-of-page unit/lease counts, a per-floor-plan Unit Types
 * breakdown, and Current/Future charge totals — built from the canonical
 * unit/unit_space/floor_plan/lease/lease_period/lease_period_charge
 * tables. Used by the DD setup screen to verify the rent roll ingest.
 *
 * Requires ``Leases.Read``.
 * @summary Get Property Data View
 */
export const getPropertyDataViewApiPropertiesPropertyIdDataViewGet = async ({ propertyId }, options) => {
    return customFetch(getGetPropertyDataViewApiPropertiesPropertyIdDataViewGetUrl({ propertyId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeasesApiPropertiesPropertyIdLeasesGetUrl = ({ propertyId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/leases/?${stringifiedParams}` : `/api/properties/${propertyId}/leases/`;
};
/**
 * @summary Get Leases
 */
export const getLeasesApiPropertiesPropertyIdLeasesGet = async ({ propertyId }, params, options) => {
    return customFetch(getGetLeasesApiPropertiesPropertyIdLeasesGetUrl({ propertyId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetMatchedLeasesApiPropertiesPropertyIdMatchedLeasesGetUrl = ({ propertyId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["match_status"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/matched_leases/?${stringifiedParams}` : `/api/properties/${propertyId}/matched_leases/`;
};
/**
 * @summary Get Matched Leases
 */
export const getMatchedLeasesApiPropertiesPropertyIdMatchedLeasesGet = async ({ propertyId }, params, options) => {
    return customFetch(getGetMatchedLeasesApiPropertiesPropertyIdMatchedLeasesGetUrl({ propertyId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseApiPropertiesPropertyIdLeasesLeaseIdGetUrl = ({ propertyId, leaseId }) => {
    return `/api/properties/${propertyId}/leases/${leaseId}`;
};
/**
 * @summary Get Lease
 */
export const getLeaseApiPropertiesPropertyIdLeasesLeaseIdGet = async ({ propertyId, leaseId }, options) => {
    return customFetch(getGetLeaseApiPropertiesPropertyIdLeasesLeaseIdGetUrl({ propertyId, leaseId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseLedgerEntriesApiPropertiesPropertyIdLeasesLeaseIdLedgerEntriesGetUrl = ({ propertyId, leaseId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/leases/${leaseId}/ledger-entries?${stringifiedParams}` : `/api/properties/${propertyId}/leases/${leaseId}/ledger-entries`;
};
/**
 * @summary Get Lease Ledger Entries
 */
export const getLeaseLedgerEntriesApiPropertiesPropertyIdLeasesLeaseIdLedgerEntriesGet = async ({ propertyId, leaseId }, params, options) => {
    return customFetch(getGetLeaseLedgerEntriesApiPropertiesPropertyIdLeasesLeaseIdLedgerEntriesGetUrl({ propertyId, leaseId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseChargesApiPropertiesPropertyIdLeasesLeaseIdChargesGetUrl = ({ propertyId, leaseId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/leases/${leaseId}/charges?${stringifiedParams}` : `/api/properties/${propertyId}/leases/${leaseId}/charges`;
};
/**
 * @summary Get Lease Charges
 */
export const getLeaseChargesApiPropertiesPropertyIdLeasesLeaseIdChargesGet = async ({ propertyId, leaseId }, params, options) => {
    return customFetch(getGetLeaseChargesApiPropertiesPropertyIdLeasesLeaseIdChargesGetUrl({ propertyId, leaseId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetEnrichedDocumentsForPropertiesApiPropertiesEnrichedDocumentsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["document_ids", "lease_ids", "lease_audit_ids", "lease_audit_run_ids", "lease_audit_statuses", "lease_audit_check_types", "lease_audit_check_statuses", "document_profile_types", "document_index_classification", "source_files", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/enriched-documents?${stringifiedParams}` : `/api/properties/enriched-documents`;
};
/**
 * Get lease documents for agent endpoints with advanced audit filtering capabilities.
 *
 * Parameters:
 * - property_ids: List of property IDs to search (from user permissions)
 * - document_ids: List of document IDs to filter
 * - doc_title_search_text: Text to search in document titles
 * - lease_ids: List of lease IDs in format "property_id|lease_id"
 * - lease_audit_ids: List of lease audit IDs (globally unique)
 * - lease_audit_run_ids: List of lease audit run IDs (globally unique)
 * - lease_types: Filter by lease association type (null, no_lease, any_lease_type)
 * - lease_audit_statuses: Filter by audit status (no_audits, any_audits, failed_audits, passed_audits, resolved_audits)
 * - lease_audit_check_types: Filter by check types that use the document
 * - lease_audit_check_statuses: Filter by check statuses (passed_checks, failed_checks, resolved_checks, passed_or_resolved_checks)
 * - document_profile_types: Filter by document profile types (e.g., AnimalAddendum, EarlyMoveInAddendum)
 * - document_index_classification: Filter by document index classification (e.g., Lease, Animal Addendum)
 * - start_datetime: Filter documents created after this datetime
 * - end_datetime: Filter documents created before this datetime
 * - lease_match_status: Filter by lease match status (matched, unmatched)
 * - document_archive_status: Filter by document archive status (archived, active)
 * - signed: Filter by whether the document is signed (true, false)
 * - source_files: Filter by source file/archive name; accepts multiple values
 * - limit: Maximum number of results to return (default: 15)
 * - offset: Number of results to skip
 *
 * Note: Cannot specify both lease_ids and lease_period_ids parameters.
 * lease_audit_check_statuses cannot be used without lease_audit_check_types.
 * @summary Get Enriched Documents For Properties
 */
export const getEnrichedDocumentsForPropertiesApiPropertiesEnrichedDocumentsGet = async (params, options) => {
    return customFetch(getGetEnrichedDocumentsForPropertiesApiPropertiesEnrichedDocumentsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseResidentsApiPropertiesPropertyIdLeasesLeaseIdResidentsGetUrl = ({ propertyId, leaseId }) => {
    return `/api/properties/${propertyId}/leases/${leaseId}/residents`;
};
/**
 * @summary Get Lease Residents
 */
export const getLeaseResidentsApiPropertiesPropertyIdLeasesLeaseIdResidentsGet = async ({ propertyId, leaseId }, options) => {
    return customFetch(getGetLeaseResidentsApiPropertiesPropertyIdLeasesLeaseIdResidentsGetUrl({ propertyId, leaseId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetRentRollExportApiPropertiesPropertyIdRentRollExportGetUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/rent_roll_export`;
};
/**
 * @summary Get Rent Roll Export
 */
export const getRentRollExportApiPropertiesPropertyIdRentRollExportGet = async ({ propertyId }, options) => {
    return customFetch(getGetRentRollExportApiPropertiesPropertyIdRentRollExportGetUrl({ propertyId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetPropertyFileExportsApiPropertiesPropertyIdPropertyFileExportsGetUrl = ({ propertyId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/property_file_exports/?${stringifiedParams}` : `/api/properties/${propertyId}/property_file_exports/`;
};
/**
 * Stream a previously-generated file (e.g. report) back to the client.
 * then uses the file's async stream to back a StreamingResponse.
 * @summary Get Property File Exports
 */
export const getPropertyFileExportsApiPropertiesPropertyIdPropertyFileExportsGet = async ({ propertyId }, params, options) => {
    return customFetch(getGetPropertyFileExportsApiPropertiesPropertyIdPropertyFileExportsGetUrl({ propertyId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetPropertyFileExportApiPropertiesPropertyIdPropertyFileExportsPropertyFileExportIdGetUrl = ({ propertyId, propertyFileExportId }) => {
    return `/api/properties/${propertyId}/property_file_exports/${propertyFileExportId}`;
};
/**
 * Stream a previously-generated file (e.g. report) back to the client.
 * then uses the file's async stream to back a StreamingResponse.
 * @summary Get Property File Export
 */
export const getPropertyFileExportApiPropertiesPropertyIdPropertyFileExportsPropertyFileExportIdGet = async ({ propertyId, propertyFileExportId }, options) => {
    return customFetch(getGetPropertyFileExportApiPropertiesPropertyIdPropertyFileExportsPropertyFileExportIdGetUrl({ propertyId, propertyFileExportId }), {
        ...options,
        method: 'GET'
    });
};
export const getDeletePropertyFileExportApiPropertiesPropertyIdPropertyFileExportsPropertyFileExportIdDeleteUrl = ({ propertyId, propertyFileExportId }) => {
    return `/api/properties/${propertyId}/property_file_exports/${propertyFileExportId}`;
};
/**
 * @summary Delete Property File Export
 */
export const deletePropertyFileExportApiPropertiesPropertyIdPropertyFileExportsPropertyFileExportIdDelete = async ({ propertyId, propertyFileExportId }, options) => {
    return customFetch(getDeletePropertyFileExportApiPropertiesPropertyIdPropertyFileExportsPropertyFileExportIdDeleteUrl({ propertyId, propertyFileExportId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getUpdatePropertyFileExportApiPropertiesPropertyIdPropertyFileExportsPropertyFileExportIdPutUrl = ({ propertyId, propertyFileExportId }) => {
    return `/api/properties/${propertyId}/property_file_exports/${propertyFileExportId}`;
};
/**
 * @summary Update Property File Export
 */
export const updatePropertyFileExportApiPropertiesPropertyIdPropertyFileExportsPropertyFileExportIdPut = async ({ propertyId, propertyFileExportId }, propertyFileExportUpdate, options) => {
    return customFetch(getUpdatePropertyFileExportApiPropertiesPropertyIdPropertyFileExportsPropertyFileExportIdPutUrl({ propertyId, propertyFileExportId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(propertyFileExportUpdate)
    });
};
export const getUpdatePropertyFileExportContentsApiPropertiesPropertyIdPropertyFileExportsPropertyFileExportIdContentsPutUrl = ({ propertyId, propertyFileExportId }) => {
    return `/api/properties/${propertyId}/property_file_exports/${propertyFileExportId}/contents`;
};
/**
 * @summary Update Property File Export Contents
 */
export const updatePropertyFileExportContentsApiPropertiesPropertyIdPropertyFileExportsPropertyFileExportIdContentsPut = async ({ propertyId, propertyFileExportId }, bodyUpdatePropertyFileExportContentsApiPropertiesPropertyIdPropertyFileExportsPropertyFileExportIdContentsPut, options) => {
    const formData = new FormData();
    formData.append(`file`, bodyUpdatePropertyFileExportContentsApiPropertiesPropertyIdPropertyFileExportsPropertyFileExportIdContentsPut.file);
    return customFetch(getUpdatePropertyFileExportContentsApiPropertiesPropertyIdPropertyFileExportsPropertyFileExportIdContentsPutUrl({ propertyId, propertyFileExportId }), {
        ...options,
        method: 'PUT',
        body: formData
    });
};
export const getCreatePropertyFileExportApiPropertiesPropertyIdPropertyFileExportsPostUrl = ({ propertyId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/property_file_exports?${stringifiedParams}` : `/api/properties/${propertyId}/property_file_exports`;
};
/**
 * @summary Create Property File Export
 */
export const createPropertyFileExportApiPropertiesPropertyIdPropertyFileExportsPost = async ({ propertyId }, bodyCreatePropertyFileExportApiPropertiesPropertyIdPropertyFileExportsPost, params, options) => {
    const formData = new FormData();
    formData.append(`file`, bodyCreatePropertyFileExportApiPropertiesPropertyIdPropertyFileExportsPost.file);
    return customFetch(getCreatePropertyFileExportApiPropertiesPropertyIdPropertyFileExportsPostUrl({ propertyId }, params), {
        ...options,
        method: 'POST',
        body: formData
    });
};
export const getSearchLeaseAuditsApiLeaseAuditsSearchGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["audit_results", "assigned_tos", "check_assignees", "custom_statuses", "failing_check_types", "check_failure_types", "check_failure_priorities", "lease_stages", "lease_terms", "sort", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/search?${stringifiedParams}` : `/api/lease-audits/search`;
};
/**
 * @summary Search Lease Audits
 */
export const searchLeaseAuditsApiLeaseAuditsSearchGet = async (params, options) => {
    return customFetch(getSearchLeaseAuditsApiLeaseAuditsSearchGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getSearchLeaseAuditChecksApiLeaseAuditsSearchChecksGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["check_types", "check_failure_types", "assigned_tos", "check_assignees", "check_failure_priorities", "lease_stages", "lease_terms", "custom_statuses", "sort", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/search-checks?${stringifiedParams}` : `/api/lease-audits/search-checks`;
};
/**
 * @summary Search Lease Audit Checks
 */
export const searchLeaseAuditChecksApiLeaseAuditsSearchChecksGet = async (params, options) => {
    return customFetch(getSearchLeaseAuditChecksApiLeaseAuditsSearchChecksGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditHotspotsApiLeaseAuditsHotspotsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["lease_terms", "check_types", "check_failure_priorities", "check_failure_types", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/hotspots?${stringifiedParams}` : `/api/lease-audits/hotspots`;
};
/**
 * @summary Get Lease Audit Hotspots
 */
export const getLeaseAuditHotspotsApiLeaseAuditsHotspotsGet = async (params, options) => {
    return customFetch(getGetLeaseAuditHotspotsApiLeaseAuditsHotspotsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditHotspotCardsApiLeaseAuditsHotspotsCheckTypeCheckFailureTypeCardsGetUrl = ({ checkType, checkFailureType }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["check_failure_priorities", "lease_terms", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/hotspots/${checkType}/${checkFailureType}/cards?${stringifiedParams}` : `/api/lease-audits/hotspots/${checkType}/${checkFailureType}/cards`;
};
/**
 * @summary Get Lease Audit Hotspot Cards
 */
export const getLeaseAuditHotspotCardsApiLeaseAuditsHotspotsCheckTypeCheckFailureTypeCardsGet = async ({ checkType, checkFailureType }, params, options) => {
    return customFetch(getGetLeaseAuditHotspotCardsApiLeaseAuditsHotspotsCheckTypeCheckFailureTypeCardsGetUrl({ checkType, checkFailureType }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditHotspotChecksApiLeaseAuditsHotspotsCheckTypeCheckFailureTypeChecksGetUrl = ({ checkType, checkFailureType }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["lease_terms", "assigned_tos", "check_failure_priorities", "sort", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/hotspots/${checkType}/${checkFailureType}/checks?${stringifiedParams}` : `/api/lease-audits/hotspots/${checkType}/${checkFailureType}/checks`;
};
/**
 * @summary Get Lease Audit Hotspot Checks
 */
export const getLeaseAuditHotspotChecksApiLeaseAuditsHotspotsCheckTypeCheckFailureTypeChecksGet = async ({ checkType, checkFailureType }, params, options) => {
    return customFetch(getGetLeaseAuditHotspotChecksApiLeaseAuditsHotspotsCheckTypeCheckFailureTypeChecksGetUrl({ checkType, checkFailureType }, params), {
        ...options,
        method: 'GET'
    });
};
export const getEmailLeaseAuditHotspotApiLeaseAuditsHotspotsEmailPostUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/hotspots/email?${stringifiedParams}` : `/api/lease-audits/hotspots/email`;
};
/**
 * @summary Email Lease Audit Hotspot
 */
export const emailLeaseAuditHotspotApiLeaseAuditsHotspotsEmailPost = async (hotSpotEmailRequest, params, options) => {
    return customFetch(getEmailLeaseAuditHotspotApiLeaseAuditsHotspotsEmailPostUrl(params), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(hotSpotEmailRequest)
    });
};
export const getGetLeaseAuditsApiLeaseAuditsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["lease_audit_ids", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits?${stringifiedParams}` : `/api/lease-audits`;
};
/**
 * @summary Get Lease Audits
 */
export const getLeaseAuditsApiLeaseAuditsGet = async (params, options) => {
    return customFetch(getGetLeaseAuditsApiLeaseAuditsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getDeleteLeaseAuditApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdDeleteUrl = ({ propertyId, leaseAuditId }) => {
    return `/api/properties/${propertyId}/lease-audits/${leaseAuditId}`;
};
/**
 * @summary Delete Lease Audit
 */
export const deleteLeaseAuditApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdDelete = async ({ propertyId, leaseAuditId }, options) => {
    return customFetch(getDeleteLeaseAuditApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdDeleteUrl({ propertyId, leaseAuditId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getGetLeaseAuditApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdGetUrl = ({ propertyId, leaseAuditId }) => {
    return `/api/properties/${propertyId}/lease-audits/${leaseAuditId}`;
};
/**
 * @summary Get Lease Audit
 */
export const getLeaseAuditApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdGet = async ({ propertyId, leaseAuditId }, options) => {
    return customFetch(getGetLeaseAuditApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdGetUrl({ propertyId, leaseAuditId }), {
        ...options,
        method: 'GET'
    });
};
export const getDeleteLeaseAuditRunApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdDeleteUrl = ({ propertyId, leaseAuditId, runId }) => {
    return `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/runs/${runId}`;
};
/**
 * @summary Delete Lease Audit Run
 */
export const deleteLeaseAuditRunApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdDelete = async ({ propertyId, leaseAuditId, runId }, options) => {
    return customFetch(getDeleteLeaseAuditRunApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdDeleteUrl({ propertyId, leaseAuditId, runId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getGetLeaseAuditRunApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdGetUrl = ({ propertyId, leaseAuditId, runId }) => {
    return `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/runs/${runId}`;
};
/**
 * @summary Get Lease Audit Run
 */
export const getLeaseAuditRunApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdGet = async ({ propertyId, leaseAuditId, runId }, options) => {
    return customFetch(getGetLeaseAuditRunApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdGetUrl({ propertyId, leaseAuditId, runId }), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateLeaseAuditRunApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdPatchUrl = ({ propertyId, leaseAuditId, runId }) => {
    return `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/runs/${runId}`;
};
/**
 * @summary Update Lease Audit Run
 */
export const updateLeaseAuditRunApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdPatch = async ({ propertyId, leaseAuditId, runId }, leaseAuditRunInput, options) => {
    return customFetch(getUpdateLeaseAuditRunApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdPatchUrl({ propertyId, leaseAuditId, runId }), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(leaseAuditRunInput)
    });
};
export const getCreateLeaseAuditApiPropertiesPropertyIdLeaseAuditsPostUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/lease-audits`;
};
/**
 * Initiate a lease audit
 * @summary Create Lease Audit
 */
export const createLeaseAuditApiPropertiesPropertyIdLeaseAuditsPost = async ({ propertyId }, createLeaseAuditRequest, options) => {
    return customFetch(getCreateLeaseAuditApiPropertiesPropertyIdLeaseAuditsPostUrl({ propertyId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(createLeaseAuditRequest)
    });
};
export const getDeleteLeaseAuditsForLeaseStageApiPropertiesPropertyIdLeaseAuditsDeleteByLeaseStagePostUrl = ({ propertyId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/lease-audits/delete-by-lease-stage?${stringifiedParams}` : `/api/properties/${propertyId}/lease-audits/delete-by-lease-stage`;
};
/**
 * @summary Delete Lease Audits For Lease Stage
 */
export const deleteLeaseAuditsForLeaseStageApiPropertiesPropertyIdLeaseAuditsDeleteByLeaseStagePost = async ({ propertyId }, params, options) => {
    return customFetch(getDeleteLeaseAuditsForLeaseStageApiPropertiesPropertyIdLeaseAuditsDeleteByLeaseStagePostUrl({ propertyId }, params), {
        ...options,
        method: 'POST'
    });
};
export const getDeleteLeaseAuditsByLeasePeriodIdsApiPropertiesPropertyIdLeaseAuditsDeleteByLeasePeriodIdsPostUrl = ({ propertyId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["lease_period_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/lease-audits/delete-by-lease-period-ids?${stringifiedParams}` : `/api/properties/${propertyId}/lease-audits/delete-by-lease-period-ids`;
};
/**
 * @summary Delete Lease Audits By Lease Period Ids
 */
export const deleteLeaseAuditsByLeasePeriodIdsApiPropertiesPropertyIdLeaseAuditsDeleteByLeasePeriodIdsPost = async ({ propertyId }, params, options) => {
    return customFetch(getDeleteLeaseAuditsByLeasePeriodIdsApiPropertiesPropertyIdLeaseAuditsDeleteByLeasePeriodIdsPostUrl({ propertyId }, params), {
        ...options,
        method: 'POST'
    });
};
export const getDeleteLeaseAuditsByLeaseAuditIdsApiPropertiesPropertyIdLeaseAuditsDeleteByLeaseAuditIdsPostUrl = ({ propertyId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["lease_audit_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/lease-audits/delete-by-lease-audit-ids?${stringifiedParams}` : `/api/properties/${propertyId}/lease-audits/delete-by-lease-audit-ids`;
};
/**
 * @summary Delete Lease Audits By Lease Audit Ids
 */
export const deleteLeaseAuditsByLeaseAuditIdsApiPropertiesPropertyIdLeaseAuditsDeleteByLeaseAuditIdsPost = async ({ propertyId }, params, options) => {
    return customFetch(getDeleteLeaseAuditsByLeaseAuditIdsApiPropertiesPropertyIdLeaseAuditsDeleteByLeaseAuditIdsPostUrl({ propertyId }, params), {
        ...options,
        method: 'POST'
    });
};
export const getCreateLeaseAuditRunApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsPostUrl = ({ propertyId, leaseAuditId }) => {
    return `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/runs`;
};
/**
 * @summary Create Lease Audit Run
 */
export const createLeaseAuditRunApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsPost = async ({ propertyId, leaseAuditId }, options) => {
    return customFetch(getCreateLeaseAuditRunApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsPostUrl({ propertyId, leaseAuditId }), {
        ...options,
        method: 'POST'
    });
};
export const getGetLeaseAuditRunsApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsGetUrl = ({ propertyId, leaseAuditId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/runs?${stringifiedParams}` : `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/runs`;
};
/**
 * @summary Get Lease Audit Runs
 */
export const getLeaseAuditRunsApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsGet = async ({ propertyId, leaseAuditId }, params, options) => {
    return customFetch(getGetLeaseAuditRunsApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsGetUrl({ propertyId, leaseAuditId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditDocumentsFromReconciliationSnapshotApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdReconciledDocumentsGetUrl = ({ propertyId, leaseAuditId, runId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/runs/${runId}/reconciled_documents?${stringifiedParams}` : `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/runs/${runId}/reconciled_documents`;
};
/**
 * @summary Get Lease Audit Documents From Reconciliation Snapshot
 */
export const getLeaseAuditDocumentsFromReconciliationSnapshotApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdReconciledDocumentsGet = async ({ propertyId, leaseAuditId, runId }, params, options) => {
    return customFetch(getGetLeaseAuditDocumentsFromReconciliationSnapshotApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdReconciledDocumentsGetUrl({ propertyId, leaseAuditId, runId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditDocumentsApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdDocumentsGetUrl = ({ propertyId, leaseAuditId, runId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/runs/${runId}/documents?${stringifiedParams}` : `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/runs/${runId}/documents`;
};
/**
 * @summary Get Lease Audit Documents
 */
export const getLeaseAuditDocumentsApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdDocumentsGet = async ({ propertyId, leaseAuditId, runId }, params, options) => {
    return customFetch(getGetLeaseAuditDocumentsApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdDocumentsGetUrl({ propertyId, leaseAuditId, runId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getCreateLeaseAuditRunCheckOverrideApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdChecksCheckIdOverridesOverrideTypePostUrl = ({ propertyId, leaseAuditId, runId, checkId, overrideType }) => {
    return `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/runs/${runId}/checks/${checkId}/overrides/${overrideType}`;
};
/**
 * Directly override a check
 * @summary Create Lease Audit Run Check Override
 */
export const createLeaseAuditRunCheckOverrideApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdChecksCheckIdOverridesOverrideTypePost = async ({ propertyId, leaseAuditId, runId, checkId, overrideType }, createLeaseAuditOverride, options) => {
    return customFetch(getCreateLeaseAuditRunCheckOverrideApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdChecksCheckIdOverridesOverrideTypePostUrl({ propertyId, leaseAuditId, runId, checkId, overrideType }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(createLeaseAuditOverride)
    });
};
export const getDeleteLeaseAuditRunCheckOverrideApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdChecksCheckIdOverridesOverrideTypeDeleteUrl = ({ propertyId, leaseAuditId, runId, checkId, overrideType }) => {
    return `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/runs/${runId}/checks/${checkId}/overrides/${overrideType}`;
};
/**
 * Delete an existing override
 * @summary Delete Lease Audit Run Check Override
 */
export const deleteLeaseAuditRunCheckOverrideApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdChecksCheckIdOverridesOverrideTypeDelete = async ({ propertyId, leaseAuditId, runId, checkId, overrideType }, options) => {
    return customFetch(getDeleteLeaseAuditRunCheckOverrideApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdChecksCheckIdOverridesOverrideTypeDeleteUrl({ propertyId, leaseAuditId, runId, checkId, overrideType }), {
        ...options,
        method: 'DELETE'
    });
};
export const getCreateLeaseAuditRunCheckRequestOverrideApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdChecksCheckIdOverridesOverrideTypeRequestPostUrl = ({ propertyId, leaseAuditId, runId, checkId, overrideType }) => {
    return `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/runs/${runId}/checks/${checkId}/overrides/${overrideType}/request`;
};
/**
 * Create a new lease audit check override request
 * @summary Create Lease Audit Run Check Request Override
 */
export const createLeaseAuditRunCheckRequestOverrideApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdChecksCheckIdOverridesOverrideTypeRequestPost = async ({ propertyId, leaseAuditId, runId, checkId, overrideType }, createLeaseAuditOverrideRequest, options) => {
    return customFetch(getCreateLeaseAuditRunCheckRequestOverrideApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdChecksCheckIdOverridesOverrideTypeRequestPostUrl({ propertyId, leaseAuditId, runId, checkId, overrideType }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(createLeaseAuditOverrideRequest)
    });
};
export const getUpdateLeaseAuditRunCheckRequestOverride2ApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdChecksCheckIdOverridesOverrideTypeRequestPutUrl = ({ propertyId, leaseAuditId, runId, checkId, overrideType }) => {
    return `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/runs/${runId}/checks/${checkId}/overrides/${overrideType}/request`;
};
/**
 * Approve or reject a check override request. Or set back to requested.
 * @summary Update Lease Audit Run Check Request Override2
 */
export const updateLeaseAuditRunCheckRequestOverride2ApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdChecksCheckIdOverridesOverrideTypeRequestPut = async ({ propertyId, leaseAuditId, runId, checkId, overrideType }, upsertLeaseAuditOverrideResponse, options) => {
    return customFetch(getUpdateLeaseAuditRunCheckRequestOverride2ApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdChecksCheckIdOverridesOverrideTypeRequestPutUrl({ propertyId, leaseAuditId, runId, checkId, overrideType }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(upsertLeaseAuditOverrideResponse)
    });
};
export const getDeleteLeaseAuditRunCheckRequestOverride2ApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdChecksCheckIdOverridesOverrideTypeRequestDeleteUrl = ({ propertyId, leaseAuditId, runId, checkId, overrideType }) => {
    return `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/runs/${runId}/checks/${checkId}/overrides/${overrideType}/request`;
};
/**
 * Delete a lease audit check override request.
 * This will only delete requests in the requested state.
 * @summary Delete Lease Audit Run Check Request Override2
 */
export const deleteLeaseAuditRunCheckRequestOverride2ApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdChecksCheckIdOverridesOverrideTypeRequestDelete = async ({ propertyId, leaseAuditId, runId, checkId, overrideType }, options) => {
    return customFetch(getDeleteLeaseAuditRunCheckRequestOverride2ApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdChecksCheckIdOverridesOverrideTypeRequestDeleteUrl({ propertyId, leaseAuditId, runId, checkId, overrideType }), {
        ...options,
        method: 'DELETE'
    });
};
export const getGetLeaseAuditPreviewImageApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdPreviewImagesPreviewImageIdGetUrl = ({ propertyId, leaseAuditId, previewImageId }) => {
    return `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/preview-images/${previewImageId}`;
};
/**
 * @summary Get Lease Audit Preview Image
 */
export const getLeaseAuditPreviewImageApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdPreviewImagesPreviewImageIdGet = async ({ propertyId, leaseAuditId, previewImageId }, options) => {
    return customFetch(getGetLeaseAuditPreviewImageApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdPreviewImagesPreviewImageIdGetUrl({ propertyId, leaseAuditId, previewImageId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditNotesApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdNotesGetUrl = ({ propertyId, leaseAuditId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/notes?${stringifiedParams}` : `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/notes`;
};
/**
 * @summary Get Lease Audit Notes
 */
export const getLeaseAuditNotesApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdNotesGet = async ({ propertyId, leaseAuditId }, params, options) => {
    return customFetch(getGetLeaseAuditNotesApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdNotesGetUrl({ propertyId, leaseAuditId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getCreateLeaseAuditNoteApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdNotesPostUrl = ({ propertyId, leaseAuditId }) => {
    return `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/notes`;
};
/**
 * @summary Create Lease Audit Note
 */
export const createLeaseAuditNoteApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdNotesPost = async ({ propertyId, leaseAuditId }, createLeaseAuditNoteRequest, options) => {
    return customFetch(getCreateLeaseAuditNoteApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdNotesPostUrl({ propertyId, leaseAuditId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(createLeaseAuditNoteRequest)
    });
};
export const getGetLeaseAuditActivitiesApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdActivitiesGetUrl = ({ propertyId, leaseAuditId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/activities?${stringifiedParams}` : `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/activities`;
};
/**
 * Get audit activities for a specific lease audit.
 * @summary Get Lease Audit Activities
 */
export const getLeaseAuditActivitiesApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdActivitiesGet = async ({ propertyId, leaseAuditId }, params, options) => {
    return customFetch(getGetLeaseAuditActivitiesApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdActivitiesGetUrl({ propertyId, leaseAuditId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditCheckTagsApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdCheckTagsGetUrl = ({ propertyId, leaseAuditId }) => {
    return `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/check-tags`;
};
/**
 * Get all check tags for a specific lease audit, organized by check_type.
 * @summary Get Lease Audit Check Tags
 */
export const getLeaseAuditCheckTagsApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdCheckTagsGet = async ({ propertyId, leaseAuditId }, options) => {
    return customFetch(getGetLeaseAuditCheckTagsApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdCheckTagsGetUrl({ propertyId, leaseAuditId }), {
        ...options,
        method: 'GET'
    });
};
export const getAssignLeaseAuditCheckApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdChecksCheckTypeAssignmentPutUrl = ({ propertyId, leaseAuditId, checkType }) => {
    return `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/checks/${checkType}/assignment`;
};
/**
 * Assigns a lease audit check to a user, or unassigns it when assigned_to is null.
 *
 * The assignment is keyed by check type and scoped to the audit, so it carries
 * through every run's instance of that check. The assigner needs LeaseAudits.Update
 * on the property (enforced by ValidatedPropertyId); the assignee must be a user in
 * the active tenant with LeaseAudits.Read on the property.
 * @summary Assign Lease Audit Check
 */
export const assignLeaseAuditCheckApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdChecksCheckTypeAssignmentPut = async ({ propertyId, leaseAuditId, checkType }, assignLeaseAuditCheckRequest, options) => {
    return customFetch(getAssignLeaseAuditCheckApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdChecksCheckTypeAssignmentPutUrl({ propertyId, leaseAuditId, checkType }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(assignLeaseAuditCheckRequest)
    });
};
export const getGetLeaseAuditAssignmentsApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdAssignmentsGetUrl = ({ propertyId, leaseAuditId }) => {
    return `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/assignments`;
};
/**
 * Get all check assignments for a specific lease audit, keyed by check_type.
 * @summary Get Lease Audit Assignments
 */
export const getLeaseAuditAssignmentsApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdAssignmentsGet = async ({ propertyId, leaseAuditId }, options) => {
    return customFetch(getGetLeaseAuditAssignmentsApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdAssignmentsGetUrl({ propertyId, leaseAuditId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditCheckAssignmentHistoryApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdChecksCheckTypeAssignmentHistoryGetUrl = ({ propertyId, leaseAuditId, checkType }) => {
    return `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/checks/${checkType}/assignment-history`;
};
/**
 * Get the assignment episodes for a check, most recent first. An episode with a null
 * unassigned_at is the currently active assignment.
 * @summary Get Lease Audit Check Assignment History
 */
export const getLeaseAuditCheckAssignmentHistoryApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdChecksCheckTypeAssignmentHistoryGet = async ({ propertyId, leaseAuditId, checkType }, options) => {
    return customFetch(getGetLeaseAuditCheckAssignmentHistoryApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdChecksCheckTypeAssignmentHistoryGetUrl({ propertyId, leaseAuditId, checkType }), {
        ...options,
        method: 'GET'
    });
};
export const getExplainLeaseAuditFailureApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdExplainFailurePostUrl = ({ propertyId, leaseAuditId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/explain-failure?${stringifiedParams}` : `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/explain-failure`;
};
/**
 * @summary Explain Lease Audit Failure
 */
export const explainLeaseAuditFailureApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdExplainFailurePost = async ({ propertyId, leaseAuditId }, params, options) => {
    return customFetch(getExplainLeaseAuditFailureApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdExplainFailurePostUrl({ propertyId, leaseAuditId }, params), {
        ...options,
        method: 'POST'
    });
};
export const getExplainLeaseAuditRunFailureApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdExplainFailurePostUrl = ({ propertyId, leaseAuditId, runId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/runs/${runId}/explain-failure?${stringifiedParams}` : `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/runs/${runId}/explain-failure`;
};
/**
 * @summary Explain Lease Audit Run Failure
 */
export const explainLeaseAuditRunFailureApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdExplainFailurePost = async ({ propertyId, leaseAuditId, runId }, params, options) => {
    return customFetch(getExplainLeaseAuditRunFailureApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdExplainFailurePostUrl({ propertyId, leaseAuditId, runId }, params), {
        ...options,
        method: 'POST'
    });
};
export const getExplainLeaseAuditVisionResultsApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdExplainVisionResultsPostUrl = ({ propertyId, leaseAuditId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/explain-vision-results?${stringifiedParams}` : `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/explain-vision-results`;
};
/**
 * @summary Explain Lease Audit Vision Results
 */
export const explainLeaseAuditVisionResultsApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdExplainVisionResultsPost = async ({ propertyId, leaseAuditId }, params, options) => {
    return customFetch(getExplainLeaseAuditVisionResultsApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdExplainVisionResultsPostUrl({ propertyId, leaseAuditId }, params), {
        ...options,
        method: 'POST'
    });
};
export const getExplainLeaseAuditRunVisionResultsApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdExplainVisionResultsPostUrl = ({ propertyId, leaseAuditId, runId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/runs/${runId}/explain-vision-results?${stringifiedParams}` : `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/runs/${runId}/explain-vision-results`;
};
/**
 * @summary Explain Lease Audit Run Vision Results
 */
export const explainLeaseAuditRunVisionResultsApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdExplainVisionResultsPost = async ({ propertyId, leaseAuditId, runId }, params, options) => {
    return customFetch(getExplainLeaseAuditRunVisionResultsApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdExplainVisionResultsPostUrl({ propertyId, leaseAuditId, runId }, params), {
        ...options,
        method: 'POST'
    });
};
export const getExplainCheckFailureApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdChecksCheckTypeExplainFailurePostUrl = ({ propertyId, leaseAuditId, runId, checkType }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/runs/${runId}/checks/${checkType}/explain-failure?${stringifiedParams}` : `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/runs/${runId}/checks/${checkType}/explain-failure`;
};
/**
 * @summary Explain Check Failure
 */
export const explainCheckFailureApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdChecksCheckTypeExplainFailurePost = async ({ propertyId, leaseAuditId, runId, checkType }, params, options) => {
    return customFetch(getExplainCheckFailureApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdChecksCheckTypeExplainFailurePostUrl({ propertyId, leaseAuditId, runId, checkType }, params), {
        ...options,
        method: 'POST'
    });
};
export const getUpdateExplanationApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdExplanationsExplanationIdPutUrl = ({ propertyId, leaseAuditId, runId, explanationId }) => {
    return `/api/properties/${propertyId}/lease-audits/${leaseAuditId}/runs/${runId}/explanations/${explanationId}`;
};
/**
 * @summary Update Explanation
 */
export const updateExplanationApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdExplanationsExplanationIdPut = async ({ propertyId, leaseAuditId, runId, explanationId }, updateAuditExplanation, options) => {
    return customFetch(getUpdateExplanationApiPropertiesPropertyIdLeaseAuditsLeaseAuditIdRunsRunIdExplanationsExplanationIdPutUrl({ propertyId, leaseAuditId, runId, explanationId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(updateAuditExplanation)
    });
};
export const getQueueAuditBatchApiLeaseAuditsQueueAuditBatchPostUrl = () => {
    return `/api/lease-audits/queue-audit-batch`;
};
/**
 * @summary Queue Audit Batch
 */
export const queueAuditBatchApiLeaseAuditsQueueAuditBatchPost = async (createLeaseAuditBatch, options) => {
    return customFetch(getQueueAuditBatchApiLeaseAuditsQueueAuditBatchPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(createLeaseAuditBatch)
    });
};
export const getGetCheckResultsReviewsApiLeaseAuditsCheckResultsReviewsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/check-results-reviews?${stringifiedParams}` : `/api/lease-audits/check-results-reviews`;
};
/**
 * Get check results reviews for the given properties. Admin only.
 * @summary Get Check Results Reviews
 */
export const getCheckResultsReviewsApiLeaseAuditsCheckResultsReviewsGet = async (params, options) => {
    return customFetch(getGetCheckResultsReviewsApiLeaseAuditsCheckResultsReviewsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getCreateCheckResultsReviewApiLeaseAuditsCheckResultsReviewsPostUrl = () => {
    return `/api/lease-audits/check-results-reviews`;
};
/**
 * Create a new check results review. Admin only.
 * @summary Create Check Results Review
 */
export const createCheckResultsReviewApiLeaseAuditsCheckResultsReviewsPost = async (checkResultsReviewCreate, options) => {
    return customFetch(getCreateCheckResultsReviewApiLeaseAuditsCheckResultsReviewsPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(checkResultsReviewCreate)
    });
};
export const getUpdateCheckResultsReviewApiLeaseAuditsCheckResultsReviewsPutUrl = () => {
    return `/api/lease-audits/check-results-reviews`;
};
/**
 * Update an existing check results review. Admin only.
 * @summary Update Check Results Review
 */
export const updateCheckResultsReviewApiLeaseAuditsCheckResultsReviewsPut = async (checkResultsReviewInput, options) => {
    return customFetch(getUpdateCheckResultsReviewApiLeaseAuditsCheckResultsReviewsPutUrl(), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(checkResultsReviewInput)
    });
};
export const getMarkCheckResultsReviewCompleteApiLeaseAuditsCheckResultsReviewsMarkCompletePostUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/check-results-reviews/mark-complete?${stringifiedParams}` : `/api/lease-audits/check-results-reviews/mark-complete`;
};
/**
 * Mark a check results review as complete. Admin only.
 * @summary Mark Check Results Review Complete
 */
export const markCheckResultsReviewCompleteApiLeaseAuditsCheckResultsReviewsMarkCompletePost = async (params, options) => {
    return customFetch(getMarkCheckResultsReviewCompleteApiLeaseAuditsCheckResultsReviewsMarkCompletePostUrl(params), {
        ...options,
        method: 'POST'
    });
};
export const getGetLatestCheckResultCountsApiLeaseAuditsCheckResultsReviewsLatestCountsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids", "check_types"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/check-results-reviews/latest-counts?${stringifiedParams}` : `/api/lease-audits/check-results-reviews/latest-counts`;
};
/**
 * Get latest check result counts for (property_id, check_type) pairs. Admin only.
 * @summary Get Latest Check Result Counts
 */
export const getLatestCheckResultCountsApiLeaseAuditsCheckResultsReviewsLatestCountsGet = async (params, options) => {
    return customFetch(getGetLatestCheckResultCountsApiLeaseAuditsCheckResultsReviewsLatestCountsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getBackfillTemporalMetricsForPropertyApiLeaseAuditsBackfillTemporalMetricsForPropertyGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/backfill-temporal-metrics-for-property?${stringifiedParams}` : `/api/lease-audits/backfill-temporal-metrics-for-property`;
};
/**
 * @summary Backfill Temporal Metrics For Property
 */
export const backfillTemporalMetricsForPropertyApiLeaseAuditsBackfillTemporalMetricsForPropertyGet = async (params, options) => {
    return customFetch(getBackfillTemporalMetricsForPropertyApiLeaseAuditsBackfillTemporalMetricsForPropertyGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getBackfillTemporalMetricsForTenantApiLeaseAuditsBackfillTemporalMetricsForTenantGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/backfill-temporal-metrics-for-tenant?${stringifiedParams}` : `/api/lease-audits/backfill-temporal-metrics-for-tenant`;
};
/**
 * @summary Backfill Temporal Metrics For Tenant
 */
export const backfillTemporalMetricsForTenantApiLeaseAuditsBackfillTemporalMetricsForTenantGet = async (params, options) => {
    return customFetch(getBackfillTemporalMetricsForTenantApiLeaseAuditsBackfillTemporalMetricsForTenantGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getQueueAuditRerunBatchApiLeaseAuditsQueueAuditRerunBatchPostUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["with_failing_check_types", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/queue-audit-rerun-batch?${stringifiedParams}` : `/api/lease-audits/queue-audit-rerun-batch`;
};
/**
 * why do we need this? we have queue_audit_batch right?
 * @summary Queue Audit Rerun Batch
 */
export const queueAuditRerunBatchApiLeaseAuditsQueueAuditRerunBatchPost = async (params, options) => {
    return customFetch(getQueueAuditRerunBatchApiLeaseAuditsQueueAuditRerunBatchPostUrl(params), {
        ...options,
        method: 'POST'
    });
};
export const getQueueLeaseDocumentIndexesApiLeaseAuditsQueueLeaseDocumentIndexesPostUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["specific_lease_ids", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/queue-lease-document-indexes?${stringifiedParams}` : `/api/lease-audits/queue-lease-document-indexes`;
};
/**
 * @summary Queue Lease Document Indexes
 */
export const queueLeaseDocumentIndexesApiLeaseAuditsQueueLeaseDocumentIndexesPost = async (params, options) => {
    return customFetch(getQueueLeaseDocumentIndexesApiLeaseAuditsQueueLeaseDocumentIndexesPostUrl(params), {
        ...options,
        method: 'POST'
    });
};
export const getGetAuditBatchApiLeaseAuditsAuditBatchesAuditBatchIdGetUrl = ({ auditBatchId }) => {
    return `/api/lease-audits/audit-batches/${auditBatchId}`;
};
/**
 * @summary Get Audit Batch
 */
export const getAuditBatchApiLeaseAuditsAuditBatchesAuditBatchIdGet = async ({ auditBatchId }, options) => {
    return customFetch(getGetAuditBatchApiLeaseAuditsAuditBatchesAuditBatchIdGetUrl({ auditBatchId }), {
        ...options,
        method: 'GET'
    });
};
export const getAttachInternalIssuesToBatchApiLeaseAuditsAuditBatchesAuditBatchIdInternalIssuesPostUrl = ({ auditBatchId }) => {
    return `/api/lease-audits/audit-batches/${auditBatchId}/internal-issues`;
};
/**
 * Append one or more internal issues to a completed batch. Position 0 of
 * internal_issue_ids has the highest precedence on check_type overlap.
 * Queues a single mea-culpa job that walks affected checks, resolves
 * winners per check_type, re-stamps internal_issue_id, and writes the
 * updated live list back onto targeting_params.
 * @summary Attach Internal Issues To Batch
 */
export const attachInternalIssuesToBatchApiLeaseAuditsAuditBatchesAuditBatchIdInternalIssuesPost = async ({ auditBatchId }, attachInternalIssuesToBatch, options) => {
    return customFetch(getAttachInternalIssuesToBatchApiLeaseAuditsAuditBatchesAuditBatchIdInternalIssuesPostUrl({ auditBatchId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(attachInternalIssuesToBatch)
    });
};
export const getDetachInternalIssueFromBatchApiLeaseAuditsAuditBatchesAuditBatchIdInternalIssuesInternalIssueIdDeleteUrl = ({ auditBatchId, internalIssueId }) => {
    return `/api/lease-audits/audit-batches/${auditBatchId}/internal-issues/${internalIssueId}`;
};
/**
 * Detach a specific internal issue from a completed batch. Queues a
 * mea-culpa job that reassigns affected checks to the next-highest
 * precedence live issue whose check_types match (or clears them if none
 * remains) and moves the attach+detach pair to
 * internal_issue_operations_archive.
 * @summary Detach Internal Issue From Batch
 */
export const detachInternalIssueFromBatchApiLeaseAuditsAuditBatchesAuditBatchIdInternalIssuesInternalIssueIdDelete = async ({ auditBatchId, internalIssueId }, options) => {
    return customFetch(getDetachInternalIssueFromBatchApiLeaseAuditsAuditBatchesAuditBatchIdInternalIssuesInternalIssueIdDeleteUrl({ auditBatchId, internalIssueId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getGetAuditBatchesApiLeaseAuditsAuditBatchesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/audit-batches?${stringifiedParams}` : `/api/lease-audits/audit-batches`;
};
/**
 * @summary Get Audit Batches
 */
export const getAuditBatchesApiLeaseAuditsAuditBatchesGet = async (params, options) => {
    return customFetch(getGetAuditBatchesApiLeaseAuditsAuditBatchesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetAuditBatchPercentCompleteApiLeaseAuditsAuditBatchesAuditBatchIdPercentCompleteGetUrl = ({ auditBatchId }) => {
    return `/api/lease-audits/audit-batches/${auditBatchId}/percent-complete`;
};
/**
 * @summary Get Audit Batch Percent Complete
 */
export const getAuditBatchPercentCompleteApiLeaseAuditsAuditBatchesAuditBatchIdPercentCompleteGet = async ({ auditBatchId }, options) => {
    return customFetch(getGetAuditBatchPercentCompleteApiLeaseAuditsAuditBatchesAuditBatchIdPercentCompleteGetUrl({ auditBatchId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditRunInitiatorsApiLeaseAuditsRunInitiatorsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/run-initiators?${stringifiedParams}` : `/api/lease-audits/run-initiators`;
};
/**
 * @summary Get Lease Audit Run Initiators
 */
export const getLeaseAuditRunInitiatorsApiLeaseAuditsRunInitiatorsGet = async (params, options) => {
    return customFetch(getGetLeaseAuditRunInitiatorsApiLeaseAuditsRunInitiatorsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetAuditResultsApiLeaseAuditsAuditResultsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/audit-results?${stringifiedParams}` : `/api/lease-audits/audit-results`;
};
/**
 * @summary Get Audit Results
 */
export const getAuditResultsApiLeaseAuditsAuditResultsGet = async (params, options) => {
    return customFetch(getGetAuditResultsApiLeaseAuditsAuditResultsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseAuditCheckDefinitionsApiLeaseAuditsAuditCheckDefinitionsGetUrl = () => {
    return `/api/lease-audits/audit-check-definitions`;
};
/**
 * @summary Get Lease Audit Check Definitions
 */
export const getLeaseAuditCheckDefinitionsApiLeaseAuditsAuditCheckDefinitionsGet = async (options) => {
    return customFetch(getGetLeaseAuditCheckDefinitionsApiLeaseAuditsAuditCheckDefinitionsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetChargeCodesApiChargeCodesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/charge_codes?${stringifiedParams}` : `/api/charge_codes`;
};
/**
 * @summary Get Charge Codes
 */
export const getChargeCodesApiChargeCodesGet = async (params, options) => {
    return customFetch(getGetChargeCodesApiChargeCodesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetChargeTypesApiChargeTypesGetUrl = () => {
    return `/api/charge_types`;
};
/**
 * @summary Get Charge Types
 */
export const getChargeTypesApiChargeTypesGet = async (options) => {
    return customFetch(getGetChargeTypesApiChargeTypesGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetSaasTenantChargeTypeMappingsApiChargeCodesMappingGetUrl = () => {
    return `/api/charge_codes/mapping`;
};
/**
 * @summary Get Saas Tenant Charge Type Mappings
 */
export const getSaasTenantChargeTypeMappingsApiChargeCodesMappingGet = async (options) => {
    return customFetch(getGetSaasTenantChargeTypeMappingsApiChargeCodesMappingGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetSaasTenantChargeTypeMappingApiChargeCodesMappingChargeCodeNameGetUrl = ({ chargeCodeName }) => {
    return `/api/charge_codes/mapping/${chargeCodeName}`;
};
/**
 * @summary Get Saas Tenant Charge Type Mapping
 */
export const getSaasTenantChargeTypeMappingApiChargeCodesMappingChargeCodeNameGet = async ({ chargeCodeName }, options) => {
    return customFetch(getGetSaasTenantChargeTypeMappingApiChargeCodesMappingChargeCodeNameGetUrl({ chargeCodeName }), {
        ...options,
        method: 'GET'
    });
};
export const getUpsertSaasTenantChargeTypeMappingApiChargeCodesMappingChargeCodeNamePutUrl = ({ chargeCodeName }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/charge_codes/mapping/${chargeCodeName}?${stringifiedParams}` : `/api/charge_codes/mapping/${chargeCodeName}`;
};
/**
 * @summary Upsert Saas Tenant Charge Type Mapping
 */
export const upsertSaasTenantChargeTypeMappingApiChargeCodesMappingChargeCodeNamePut = async ({ chargeCodeName }, params, options) => {
    return customFetch(getUpsertSaasTenantChargeTypeMappingApiChargeCodesMappingChargeCodeNamePutUrl({ chargeCodeName }, params), {
        ...options,
        method: 'PUT'
    });
};
export const getDeleteSaasTenantChargeTypeMappingApiChargeCodesMappingChargeCodeNameDeleteUrl = ({ chargeCodeName }) => {
    return `/api/charge_codes/mapping/${chargeCodeName}`;
};
/**
 * @summary Delete Saas Tenant Charge Type Mapping
 */
export const deleteSaasTenantChargeTypeMappingApiChargeCodesMappingChargeCodeNameDelete = async ({ chargeCodeName }, options) => {
    return customFetch(getDeleteSaasTenantChargeTypeMappingApiChargeCodesMappingChargeCodeNameDeleteUrl({ chargeCodeName }), {
        ...options,
        method: 'DELETE'
    });
};
export const getResolveChargeTypeApiChargeCodesMappingResolveMappingPostUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/charge_codes/mapping/resolve-mapping?${stringifiedParams}` : `/api/charge_codes/mapping/resolve-mapping`;
};
/**
 * @summary Resolve Charge Type
 */
export const resolveChargeTypeApiChargeCodesMappingResolveMappingPost = async (params, options) => {
    return customFetch(getResolveChargeTypeApiChargeCodesMappingResolveMappingPostUrl(params), {
        ...options,
        method: 'POST'
    });
};
export const getCreateAiIssueApiPropertyIdAiIssuesPostUrl = ({ propertyId }) => {
    return `/api/${propertyId}/ai_issues`;
};
/**
 * This endpoint allows users to create a new AI issue.
 *
 * NOTE: use this flow on the lease audit details page but also to support the SurfOps flow of disconnecting an override request from an existing issue and reassigning it to a new issue.
 * @summary Create Ai Issue
 */
export const createAiIssueApiPropertyIdAiIssuesPost = async ({ propertyId }, createAIIssue, options) => {
    return customFetch(getCreateAiIssueApiPropertyIdAiIssuesPostUrl({ propertyId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(createAIIssue)
    });
};
export const getGetAiIssuesApiAiIssuesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["status", "check_types", "sort", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/ai_issues?${stringifiedParams}` : `/api/ai_issues`;
};
/**
 * Used by customers and SurfOps.
 *
 * The caller states which view it is rendering with include_surfops_data rather
 * than having the route infer it from the session: the SurfOps issues page passes
 * true and gets the assigned_tos and properties facets, the customer page passes
 * false and skips those queries. Only admins may ask for them.
 * @summary Get Ai Issues
 */
export const getAiIssuesApiAiIssuesGet = async (params, options) => {
    return customFetch(getGetAiIssuesApiAiIssuesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetAiIssuesCreatedByApiAiIssuesFacetsCreatedByGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["check_types", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/ai_issues/facets/created_by?${stringifiedParams}` : `/api/ai_issues/facets/created_by`;
};
/**
 * @summary Get Ai Issues Created By
 */
export const getAiIssuesCreatedByApiAiIssuesFacetsCreatedByGet = async (params, options) => {
    return customFetch(getGetAiIssuesCreatedByApiAiIssuesFacetsCreatedByGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetAiIssueApiPropertyIdAiIssuesAiIssueIdGetUrl = ({ propertyId, aiIssueId }) => {
    return `/api/${propertyId}/ai_issues/${aiIssueId}`;
};
/**
 * @summary Get Ai Issue
 */
export const getAiIssueApiPropertyIdAiIssuesAiIssueIdGet = async ({ propertyId, aiIssueId }, options) => {
    return customFetch(getGetAiIssueApiPropertyIdAiIssuesAiIssueIdGetUrl({ propertyId, aiIssueId }), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateAiIssueApiPropertyIdAiIssuesAiIssueIdPutUrl = ({ propertyId, aiIssueId }) => {
    return `/api/${propertyId}/ai_issues/${aiIssueId}`;
};
/**
 * @summary Update Ai Issue
 */
export const updateAiIssueApiPropertyIdAiIssuesAiIssueIdPut = async ({ propertyId, aiIssueId }, updateAIIssue, options) => {
    return customFetch(getUpdateAiIssueApiPropertyIdAiIssuesAiIssueIdPutUrl({ propertyId, aiIssueId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(updateAIIssue)
    });
};
export const getUpdateAiIssueStatusApiPropertyIdAiIssuesAiIssueIdStatusPutUrl = ({ propertyId, aiIssueId }) => {
    return `/api/${propertyId}/ai_issues/${aiIssueId}/status`;
};
/**
 * @summary Update Ai Issue Status
 */
export const updateAiIssueStatusApiPropertyIdAiIssuesAiIssueIdStatusPut = async ({ propertyId, aiIssueId }, updateAIIssueStatus, options) => {
    return customFetch(getUpdateAiIssueStatusApiPropertyIdAiIssuesAiIssueIdStatusPutUrl({ propertyId, aiIssueId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(updateAIIssueStatus)
    });
};
export const getUpdateAiIssueIsCompleteApiPropertyIdAiIssuesAiIssueIdIsCompletePutUrl = ({ propertyId, aiIssueId }) => {
    return `/api/${propertyId}/ai_issues/${aiIssueId}/is_complete`;
};
/**
 * @summary Update Ai Issue Is Complete
 */
export const updateAiIssueIsCompleteApiPropertyIdAiIssuesAiIssueIdIsCompletePut = async ({ propertyId, aiIssueId }, updateAIIssueIsComplete, options) => {
    return customFetch(getUpdateAiIssueIsCompleteApiPropertyIdAiIssuesAiIssueIdIsCompletePutUrl({ propertyId, aiIssueId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(updateAIIssueIsComplete)
    });
};
export const getUpdateAiIssueAssignmentApiPropertyIdAiIssuesAiIssueIdAssignmentPutUrl = ({ propertyId, aiIssueId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/${propertyId}/ai_issues/${aiIssueId}/assignment?${stringifiedParams}` : `/api/${propertyId}/ai_issues/${aiIssueId}/assignment`;
};
/**
 * Assigns an AIIssue to a user.
 * @summary Update Ai Issue Assignment
 */
export const updateAiIssueAssignmentApiPropertyIdAiIssuesAiIssueIdAssignmentPut = async ({ propertyId, aiIssueId }, params, options) => {
    return customFetch(getUpdateAiIssueAssignmentApiPropertyIdAiIssuesAiIssueIdAssignmentPutUrl({ propertyId, aiIssueId }, params), {
        ...options,
        method: 'PUT'
    });
};
export const getGetAiIssueOverrideDetailsApiPropertyIdAiIssuesAiIssueIdOverridesGetUrl = ({ propertyId, aiIssueId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/${propertyId}/ai_issues/${aiIssueId}/overrides?${stringifiedParams}` : `/api/${propertyId}/ai_issues/${aiIssueId}/overrides`;
};
/**
 * Get the details of all overrides associated with a specific AI issue.
 * Supports real pagination with limit and offset parameters.
 * @summary Get Ai Issue Override Details
 */
export const getAiIssueOverrideDetailsApiPropertyIdAiIssuesAiIssueIdOverridesGet = async ({ propertyId, aiIssueId }, params, options) => {
    return customFetch(getGetAiIssueOverrideDetailsApiPropertyIdAiIssuesAiIssueIdOverridesGetUrl({ propertyId, aiIssueId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getAddOrMoveOverrideToAiIssueApiPropertyIdAiIssuesAiIssueIdOverridesPostUrl = ({ propertyId, aiIssueId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/${propertyId}/ai_issues/${aiIssueId}/overrides?${stringifiedParams}` : `/api/${propertyId}/ai_issues/${aiIssueId}/overrides`;
};
/**
 * Adds an override to an existing lease audit issue.
 * Also works to MOVE an override from one existing issue to another.
 * @summary Add Or Move Override To Ai Issue
 */
export const addOrMoveOverrideToAiIssueApiPropertyIdAiIssuesAiIssueIdOverridesPost = async ({ propertyId, aiIssueId }, params, options) => {
    return customFetch(getAddOrMoveOverrideToAiIssueApiPropertyIdAiIssuesAiIssueIdOverridesPostUrl({ propertyId, aiIssueId }, params), {
        ...options,
        method: 'POST'
    });
};
export const getGetAiIssueFailingChecksReportApiPropertyIdAiIssuesAiIssueIdFailingChecksReportGetUrl = ({ propertyId, aiIssueId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids", "failure_types"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/${propertyId}/ai_issues/${aiIssueId}/failing_checks_report?${stringifiedParams}` : `/api/${propertyId}/ai_issues/${aiIssueId}/failing_checks_report`;
};
/**
 * Get a dimensional report of failing checks across open audits
 * that share the same check_type as the given AI issue.
 * Dimensions: property_id, failure_type, age_bucket. Measure: failing_check_count.
 * Age is derived from when the failure episode first started (lease_audit_check_metric.failure_at).
 * @summary Get Ai Issue Failing Checks Report
 */
export const getAiIssueFailingChecksReportApiPropertyIdAiIssuesAiIssueIdFailingChecksReportGet = async ({ propertyId, aiIssueId }, params, options) => {
    return customFetch(getGetAiIssueFailingChecksReportApiPropertyIdAiIssuesAiIssueIdFailingChecksReportGetUrl({ propertyId, aiIssueId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getAddNoteToAiIssueApiPropertyIdAiIssuesAiIssueIdNotesPostUrl = ({ propertyId, aiIssueId }) => {
    return `/api/${propertyId}/ai_issues/${aiIssueId}/notes`;
};
/**
 * Adds a note to a lease audit issue.
 *
 * Used by customers and SurfOps. Visibility is decided here rather than taken from
 * the payload for non-admins: a customer can only ever write a customer-facing
 * note, whatever they send. SurfOps pick, and default to an internal note.
 * @summary Add Note To Ai Issue
 */
export const addNoteToAiIssueApiPropertyIdAiIssuesAiIssueIdNotesPost = async ({ propertyId, aiIssueId }, createAIIssueNote, options) => {
    return customFetch(getAddNoteToAiIssueApiPropertyIdAiIssuesAiIssueIdNotesPostUrl({ propertyId, aiIssueId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(createAIIssueNote)
    });
};
export const getGetDisallowedAuditRecordApiPropertiesPropertyIdLeasesLeaseIdLeasePeriodsLeasePeriodIdDisallowedAuditRecordGetUrl = ({ propertyId, leaseId, leasePeriodId }) => {
    return `/api/properties/${propertyId}/leases/${leaseId}/lease_periods/${leasePeriodId}/disallowed_audit_record`;
};
/**
 * @summary Get Disallowed Audit Record
 */
export const getDisallowedAuditRecordApiPropertiesPropertyIdLeasesLeaseIdLeasePeriodsLeasePeriodIdDisallowedAuditRecordGet = async ({ propertyId, leaseId, leasePeriodId }, options) => {
    return customFetch(getGetDisallowedAuditRecordApiPropertiesPropertyIdLeasesLeaseIdLeasePeriodsLeasePeriodIdDisallowedAuditRecordGetUrl({ propertyId, leaseId, leasePeriodId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetDisallowedAuditRecordsApiDisallowedAuditRecordsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/disallowed_audit_records?${stringifiedParams}` : `/api/disallowed_audit_records`;
};
/**
 * @summary Get Disallowed Audit Records
 */
export const getDisallowedAuditRecordsApiDisallowedAuditRecordsGet = async (params, options) => {
    return customFetch(getGetDisallowedAuditRecordsApiDisallowedAuditRecordsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getUpsertDisallowedByUserApiPropertiesPropertyIdLeasesLeaseIdLeasePeriodsLeasePeriodIdDisallowedAuditRecordUserPutUrl = ({ propertyId, leaseId, leasePeriodId }) => {
    return `/api/properties/${propertyId}/leases/${leaseId}/lease_periods/${leasePeriodId}/disallowed_audit_record/user`;
};
/**
 * Delete all audits for a lease period and disallow any further audits of that lease period until the disallowance is removed.
 * @summary Upsert Disallowed By User
 */
export const upsertDisallowedByUserApiPropertiesPropertyIdLeasesLeaseIdLeasePeriodsLeasePeriodIdDisallowedAuditRecordUserPut = async ({ propertyId, leaseId, leasePeriodId }, leaseAuditDisallowedRecordByUserUpsertRequest, options) => {
    return customFetch(getUpsertDisallowedByUserApiPropertiesPropertyIdLeasesLeaseIdLeasePeriodsLeasePeriodIdDisallowedAuditRecordUserPutUrl({ propertyId, leaseId, leasePeriodId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(leaseAuditDisallowedRecordByUserUpsertRequest)
    });
};
export const getDeleteUserDisallowedApiPropertiesPropertyIdLeasesLeaseIdLeasePeriodsLeasePeriodIdDisallowedAuditRecordUserDeleteUrl = ({ propertyId, leaseId, leasePeriodId }) => {
    return `/api/properties/${propertyId}/leases/${leaseId}/lease-periods/${leasePeriodId}/disallowed_audit_record/user`;
};
/**
 * @summary Delete User Disallowed
 */
export const deleteUserDisallowedApiPropertiesPropertyIdLeasesLeaseIdLeasePeriodsLeasePeriodIdDisallowedAuditRecordUserDelete = async ({ propertyId, leaseId, leasePeriodId }, options) => {
    return customFetch(getDeleteUserDisallowedApiPropertiesPropertyIdLeasesLeaseIdLeasePeriodsLeasePeriodIdDisallowedAuditRecordUserDeleteUrl({ propertyId, leaseId, leasePeriodId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getListInternalIssuesApiLeaseAuditsInternalIssuesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/internal-issues?${stringifiedParams}` : `/api/lease-audits/internal-issues`;
};
/**
 * List internal lease audit issues. Admin only.
 * @summary List Internal Issues
 */
export const listInternalIssuesApiLeaseAuditsInternalIssuesGet = async (params, options) => {
    return customFetch(getListInternalIssuesApiLeaseAuditsInternalIssuesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getCreateInternalIssueApiLeaseAuditsInternalIssuesPostUrl = () => {
    return `/api/lease-audits/internal-issues`;
};
/**
 * Create an internal lease audit issue. Admin only.
 * @summary Create Internal Issue
 */
export const createInternalIssueApiLeaseAuditsInternalIssuesPost = async (createLeaseAuditInternalIssue, options) => {
    return customFetch(getCreateInternalIssueApiLeaseAuditsInternalIssuesPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(createLeaseAuditInternalIssue)
    });
};
export const getGetMedicDocumentContextApiLeaseAuditsMedicAttemptsDocumentContextGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/medic-attempts/document-context?${stringifiedParams}` : `/api/lease-audits/medic-attempts/document-context`;
};
/**
 * Best-guess open audit for a SurfOps medic request. Admin only.
 *
 * Resolves the lease through ``document_index_lease``, never the
 * document-row ``lease_id``.
 * @summary Get Medic Document Context
 */
export const getMedicDocumentContextApiLeaseAuditsMedicAttemptsDocumentContextGet = async (params, options) => {
    return customFetch(getGetMedicDocumentContextApiLeaseAuditsMedicAttemptsDocumentContextGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getListMedicAttemptPropertiesApiLeaseAuditsMedicAttemptsPropertiesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/medic-attempts/properties?${stringifiedParams}` : `/api/lease-audits/medic-attempts/properties`;
};
/**
 * Distinct properties that have medic attempts in the given date window. Admin only.
 * @summary List Medic Attempt Properties
 */
export const listMedicAttemptPropertiesApiLeaseAuditsMedicAttemptsPropertiesGet = async (params, options) => {
    return customFetch(getListMedicAttemptPropertiesApiLeaseAuditsMedicAttemptsPropertiesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getSummarizeMedicAttemptsApiLeaseAuditsMedicAttemptsSummaryGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["status"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/medic-attempts/summary?${stringifiedParams}` : `/api/lease-audits/medic-attempts/summary`;
};
/**
 * SurfOps KPI summary for lease audit medic attempts. Admin only.
 *
 * Filters match ``GET /lease-audits/medic-attempts`` so the KPI cards
 * describe the same slice as the attempt table.
 * @summary Summarize Medic Attempts
 */
export const summarizeMedicAttemptsApiLeaseAuditsMedicAttemptsSummaryGet = async (params, options) => {
    return customFetch(getSummarizeMedicAttemptsApiLeaseAuditsMedicAttemptsSummaryGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getListMedicAttemptsApiLeaseAuditsMedicAttemptsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["status"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/medic-attempts?${stringifiedParams}` : `/api/lease-audits/medic-attempts`;
};
/**
 * List lease audit medic attempts. Admin only.
 * @summary List Medic Attempts
 */
export const listMedicAttemptsApiLeaseAuditsMedicAttemptsGet = async (params, options) => {
    return customFetch(getListMedicAttemptsApiLeaseAuditsMedicAttemptsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetInternalIssueApiLeaseAuditsInternalIssuesIssueIdGetUrl = ({ issueId }) => {
    return `/api/lease-audits/internal-issues/${issueId}`;
};
/**
 * Get an internal lease audit issue by id. Admin only.
 * @summary Get Internal Issue
 */
export const getInternalIssueApiLeaseAuditsInternalIssuesIssueIdGet = async ({ issueId }, options) => {
    return customFetch(getGetInternalIssueApiLeaseAuditsInternalIssuesIssueIdGetUrl({ issueId }), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateInternalIssueApiLeaseAuditsInternalIssuesIssueIdPutUrl = ({ issueId }) => {
    return `/api/lease-audits/internal-issues/${issueId}`;
};
/**
 * Update an internal lease audit issue. Admin only.
 * @summary Update Internal Issue
 */
export const updateInternalIssueApiLeaseAuditsInternalIssuesIssueIdPut = async ({ issueId }, updateLeaseAuditInternalIssue, options) => {
    return customFetch(getUpdateInternalIssueApiLeaseAuditsInternalIssuesIssueIdPutUrl({ issueId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(updateLeaseAuditInternalIssue)
    });
};
export const getDeleteInternalIssueApiLeaseAuditsInternalIssuesIssueIdDeleteUrl = ({ issueId }) => {
    return `/api/lease-audits/internal-issues/${issueId}`;
};
/**
 * Delete an internal lease audit issue. Admin only.
 * @summary Delete Internal Issue
 */
export const deleteInternalIssueApiLeaseAuditsInternalIssuesIssueIdDelete = async ({ issueId }, options) => {
    return customFetch(getDeleteInternalIssueApiLeaseAuditsInternalIssuesIssueIdDeleteUrl({ issueId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getArchiveInternalIssueApiLeaseAuditsInternalIssuesIssueIdArchivePostUrl = ({ issueId }) => {
    return `/api/lease-audits/internal-issues/${issueId}/archive`;
};
/**
 * Archive an internal lease audit issue. Admin only.
 * @summary Archive Internal Issue
 */
export const archiveInternalIssueApiLeaseAuditsInternalIssuesIssueIdArchivePost = async ({ issueId }, options) => {
    return customFetch(getArchiveInternalIssueApiLeaseAuditsInternalIssuesIssueIdArchivePostUrl({ issueId }), {
        ...options,
        method: 'POST'
    });
};
export const getUnarchiveInternalIssueApiLeaseAuditsInternalIssuesIssueIdUnarchivePostUrl = ({ issueId }) => {
    return `/api/lease-audits/internal-issues/${issueId}/unarchive`;
};
/**
 * Unarchive an internal lease audit issue. Admin only.
 * @summary Unarchive Internal Issue
 */
export const unarchiveInternalIssueApiLeaseAuditsInternalIssuesIssueIdUnarchivePost = async ({ issueId }, options) => {
    return customFetch(getUnarchiveInternalIssueApiLeaseAuditsInternalIssuesIssueIdUnarchivePostUrl({ issueId }), {
        ...options,
        method: 'POST'
    });
};
export const getGetAiIssuesCardsReportApiLeaseAuditsReportsAiIssuesCardsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/reports/ai-issues-cards?${stringifiedParams}` : `/api/lease-audits/reports/ai-issues-cards`;
};
/**
 * Get AI issues summary cards for the current tenant. Admin only.
 * @summary Get Ai Issues Cards Report
 */
export const getAiIssuesCardsReportApiLeaseAuditsReportsAiIssuesCardsGet = async (params, options) => {
    return customFetch(getGetAiIssuesCardsReportApiLeaseAuditsReportsAiIssuesCardsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getCanQueuePmsSyncApiPropertiesPropertyIdLeasesLeaseIdPmsSyncCanQueueGetUrl = ({ propertyId, leaseId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/leases/${leaseId}/pms-sync/can-queue?${stringifiedParams}` : `/api/properties/${propertyId}/leases/${leaseId}/pms-sync/can-queue`;
};
/**
 * Return true if a PMS sync pipeline could be queued right now: either no
 * directive exists yet, or the existing one is in a terminal state (and would
 * therefore be rerun from scratch).
 * @summary Can Queue Pms Sync
 */
export const canQueuePmsSyncApiPropertiesPropertyIdLeasesLeaseIdPmsSyncCanQueueGet = async ({ propertyId, leaseId }, params, options) => {
    return customFetch(getCanQueuePmsSyncApiPropertiesPropertyIdLeasesLeaseIdPmsSyncCanQueueGetUrl({ propertyId, leaseId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getIsNewAuditRunInFlightApiPropertiesPropertyIdLeasesLeaseIdPmsSyncIsNewAuditRunInFlightGetUrl = ({ propertyId, leaseId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/leases/${leaseId}/pms-sync/is-new-audit-run-in-flight?${stringifiedParams}` : `/api/properties/${propertyId}/leases/${leaseId}/pms-sync/is-new-audit-run-in-flight`;
};
/**
 * Return true if a PMS sync pipeline is currently in flight or if a new audit run is in progress.
 * @summary Is New Audit Run In Flight
 */
export const isNewAuditRunInFlightApiPropertiesPropertyIdLeasesLeaseIdPmsSyncIsNewAuditRunInFlightGet = async ({ propertyId, leaseId }, params, options) => {
    return customFetch(getIsNewAuditRunInFlightApiPropertiesPropertyIdLeasesLeaseIdPmsSyncIsNewAuditRunInFlightGetUrl({ propertyId, leaseId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getQueuePmsSyncApiPropertiesPropertyIdLeasesLeaseIdPmsSyncPostUrl = ({ propertyId, leaseId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/leases/${leaseId}/pms-sync?${stringifiedParams}` : `/api/properties/${propertyId}/leases/${leaseId}/pms-sync`;
};
/**
 * Queue a PMS sync (ledger + lease + document) for a lease. Idempotent: if a
 * sync is already running for this property/lease pair it is left unchanged; if the
 * previous run completed it is rerun from the first step.
 * @summary Queue Pms Sync
 */
export const queuePmsSyncApiPropertiesPropertyIdLeasesLeaseIdPmsSyncPost = async ({ propertyId, leaseId }, params, options) => {
    return customFetch(getQueuePmsSyncApiPropertiesPropertyIdLeasesLeaseIdPmsSyncPostUrl({ propertyId, leaseId }, params), {
        ...options,
        method: 'POST'
    });
};
export const getGetCheckHealthReportApiLeaseAuditsReportsCheckHealthGetUrl = () => {
    return `/api/lease-audits/reports/check-health`;
};
/**
 * Get per-check-type audit outcomes for the current tenant. Admin only.
 * @summary Get Check Health Report
 */
export const getCheckHealthReportApiLeaseAuditsReportsCheckHealthGet = async (options) => {
    return customFetch(getGetCheckHealthReportApiLeaseAuditsReportsCheckHealthGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetUserRolesApiUserrolesGetUrl = () => {
    return `/api/userroles`;
};
/**
 * @summary Get User Roles
 */
export const getUserRolesApiUserrolesGet = async (options) => {
    return customFetch(getGetUserRolesApiUserrolesGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetUserAvatarApiUsersUserIdAvatarGetUrl = ({ userId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/users/${userId}/avatar?${stringifiedParams}` : `/api/users/${userId}/avatar`;
};
/**
 * @summary Get User Avatar
 */
export const getUserAvatarApiUsersUserIdAvatarGet = async ({ userId }, params, options) => {
    return customFetch(getGetUserAvatarApiUsersUserIdAvatarGetUrl({ userId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetUserSsoProviderApiUsersUserIdSsoProviderGetUrl = ({ userId }) => {
    return `/api/users/${userId}/sso-provider`;
};
/**
 * @summary Get User Sso Provider
 */
export const getUserSsoProviderApiUsersUserIdSsoProviderGet = async ({ userId }, options) => {
    return customFetch(getGetUserSsoProviderApiUsersUserIdSsoProviderGetUrl({ userId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetUsersApiUsersGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["user_ids", "has_permission", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/users?${stringifiedParams}` : `/api/users`;
};
/**
 * @summary Get Users
 */
export const getUsersApiUsersGet = async (params, options) => {
    return customFetch(getGetUsersApiUsersGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getCreateUserApiUsersPostUrl = () => {
    return `/api/users`;
};
/**
 * @summary Create User
 */
export const createUserApiUsersPost = async (surfaceCoreApiEntitiesUserCreate, options) => {
    return customFetch(getCreateUserApiUsersPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(surfaceCoreApiEntitiesUserCreate)
    });
};
export const getUpdateUserApiUsersUserIdPutUrl = ({ userId }) => {
    return `/api/users/${userId}`;
};
/**
 * @summary Update User
 */
export const updateUserApiUsersUserIdPut = async ({ userId }, surfaceCoreApiEntitiesUserUpdate, options) => {
    return customFetch(getUpdateUserApiUsersUserIdPutUrl({ userId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(surfaceCoreApiEntitiesUserUpdate)
    });
};
export const getGetUsers2ApiUsers2GetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["user_ids", "has_permissions", "has_roles", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/users2?${stringifiedParams}` : `/api/users2`;
};
/**
 * API for tenant management of users
 * args:
 *     property_ids: list of property ids to filter users by
 *     has_permissions: list of permissions to filter users by
 *     has_roles: list of role names to filter users by
 *     permissions_to_properties_match_mode: mode to match permissions (ANY or ALL). Defaults to ALL, meaning users must have ONE of the requested roles in EACH property
 *     login_status: filter by logged in status
 *     enabled_status: filter by enabled status
 *     search: search term to filter users by
 *     limit: limit the number of users returned
 *     offset: offset for pagination
 *     sort_by: field to sort users by
 * @summary Get Users2
 */
export const getUsers2ApiUsers2Get = async (params, options) => {
    return customFetch(getGetUsers2ApiUsers2GetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetUserSummariesApiUsersummariesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["user_ids", "has_permissions", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/usersummaries?${stringifiedParams}` : `/api/usersummaries`;
};
/**
 * @summary Get User Summaries
 */
export const getUserSummariesApiUsersummariesGet = async (params, options) => {
    return customFetch(getGetUserSummariesApiUsersummariesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetUsersBulkExcelApiUsersBulkGetUrl = () => {
    return `/api/users/bulk`;
};
/**
 * @summary Get Users Bulk Excel
 */
export const getUsersBulkExcelApiUsersBulkGet = async (options) => {
    return customFetch(getGetUsersBulkExcelApiUsersBulkGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getUploadUserRolesExcelApiUsersBulkPostUrl = () => {
    return `/api/users/bulk`;
};
/**
 * @summary Upload User Roles Excel
 */
export const uploadUserRolesExcelApiUsersBulkPost = async (bodyUploadUserRolesExcelApiUsersBulkPost, options) => {
    const formData = new FormData();
    formData.append(`file`, bodyUploadUserRolesExcelApiUsersBulkPost.file);
    return customFetch(getUploadUserRolesExcelApiUsersBulkPostUrl(), {
        ...options,
        method: 'POST',
        body: formData
    });
};
export const getExtractedDocumentsIndexApiPmsfetchingestExtractedDocumentsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pmsfetchingest/extracted-documents?${stringifiedParams}` : `/api/pmsfetchingest/extracted-documents`;
};
/**
 * @summary Extracted Documents Index
 */
export const extractedDocumentsIndexApiPmsfetchingestExtractedDocumentsGet = async (params, options) => {
    return customFetch(getExtractedDocumentsIndexApiPmsfetchingestExtractedDocumentsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getExtractedDocumentsBulkDownloadApiPmsfetchingestExtractedDocumentsBulkDownloadGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pmsfetchingest/extracted-documents/bulk-download?${stringifiedParams}` : `/api/pmsfetchingest/extracted-documents/bulk-download`;
};
/**
 * Same filters as GET /extracted-documents unless document_ids is set (comma-separated fetched
 * row ids, e.g. from the current table). Returns a JSON attachment with file_id and contents per row.
 * @summary Extracted Documents Bulk Download
 */
export const extractedDocumentsBulkDownloadApiPmsfetchingestExtractedDocumentsBulkDownloadGet = async (params, options) => {
    return customFetch(getExtractedDocumentsBulkDownloadApiPmsfetchingestExtractedDocumentsBulkDownloadGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getExtractedDocumentsFindKeywordApiPmsfetchingestExtractedDocumentsFindKeywordGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pmsfetchingest/extracted-documents/find-keyword?${stringifiedParams}` : `/api/pmsfetchingest/extracted-documents/find-keyword`;
};
/**
 * Same filters as bulk-download (or comma-separated document_ids). Fetches each payload body and
 * returns row IDs whose JSON serialization contains the keyword (case-insensitive substring).
 * @summary Extracted Documents Find Keyword
 */
export const extractedDocumentsFindKeywordApiPmsfetchingestExtractedDocumentsFindKeywordGet = async (params, options) => {
    return customFetch(getExtractedDocumentsFindKeywordApiPmsfetchingestExtractedDocumentsFindKeywordGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getExtractedDocumentApiPmsfetchingestExtractedDocumentsDocumentIdGetUrl = ({ documentId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pmsfetchingest/extracted-documents/${documentId}?${stringifiedParams}` : `/api/pmsfetchingest/extracted-documents/${documentId}`;
};
/**
 * @summary Extracted Document
 */
export const extractedDocumentApiPmsfetchingestExtractedDocumentsDocumentIdGet = async ({ documentId }, params, options) => {
    return customFetch(getExtractedDocumentApiPmsfetchingestExtractedDocumentsDocumentIdGetUrl({ documentId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getExtractedDocumentSurfaceFileApiPmsfetchingestExtractedDocumentsDocumentIdContentsGetUrl = ({ documentId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pmsfetchingest/extracted-documents/${documentId}/contents?${stringifiedParams}` : `/api/pmsfetchingest/extracted-documents/${documentId}/contents`;
};
/**
 * @summary Extracted Document Surface File
 */
export const extractedDocumentSurfaceFileApiPmsfetchingestExtractedDocumentsDocumentIdContentsGet = async ({ documentId }, params, options) => {
    return customFetch(getExtractedDocumentSurfaceFileApiPmsfetchingestExtractedDocumentsDocumentIdContentsGetUrl({ documentId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getExtractedDocumentByIdApiPmsfetchingestExtractedDocumentsByIdDocumentIdGetUrl = ({ documentId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pmsfetchingest/extracted-documents/by-id/${documentId}?${stringifiedParams}` : `/api/pmsfetchingest/extracted-documents/by-id/${documentId}`;
};
/**
 * Look up a fetched document by ID. Requires tenant and property to determine which database to connect to.
 * @summary Extracted Document By Id
 */
export const extractedDocumentByIdApiPmsfetchingestExtractedDocumentsByIdDocumentIdGet = async ({ documentId }, params, options) => {
    return customFetch(getExtractedDocumentByIdApiPmsfetchingestExtractedDocumentsByIdDocumentIdGetUrl({ documentId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetJobDirectiveCountsApiPmsfetchingestJobDirectiveCountsJobProcessIdGetUrl = ({ jobProcessId }) => {
    return `/api/pmsfetchingest/job-directive-counts/${jobProcessId}`;
};
/**
 * Return job directive counts for a given job_process_id.
 * @summary Get Job Directive Counts
 */
export const getJobDirectiveCountsApiPmsfetchingestJobDirectiveCountsJobProcessIdGet = async ({ jobProcessId }, options) => {
    return customFetch(getGetJobDirectiveCountsApiPmsfetchingestJobDirectiveCountsJobProcessIdGetUrl({ jobProcessId }), {
        ...options,
        method: 'GET'
    });
};
export const getQueuePublishPropertyDocumentsZipToS3ApiPmsfetchingestPublishPropertyDocumentZipToS3QueuePostUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pmsfetchingest/publish-property-document-zip-to-s3/queue?${stringifiedParams}` : `/api/pmsfetchingest/publish-property-document-zip-to-s3/queue`;
};
/**
 * Queue a property-wide document publish to zipfile in S3 (enqueues DOCUMENTS_MIGRATION_TO_ZIP_FILE job).
 * @summary Queue Publish Property Documents Zip To S3
 */
export const queuePublishPropertyDocumentsZipToS3ApiPmsfetchingestPublishPropertyDocumentZipToS3QueuePost = async (params, options) => {
    return customFetch(getQueuePublishPropertyDocumentsZipToS3ApiPmsfetchingestPublishPropertyDocumentZipToS3QueuePostUrl(params), {
        ...options,
        method: 'POST'
    });
};
export const getYardiIntegrationTestHarnessApiYardiIntegrationTestHarnessGetUrl = () => {
    return `/api/yardi/integration-test-harness`;
};
/**
 * @summary Yardi Integration Test Harness
 */
export const yardiIntegrationTestHarnessApiYardiIntegrationTestHarnessGet = async (options) => {
    return customFetch(getYardiIntegrationTestHarnessApiYardiIntegrationTestHarnessGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getYardiTestCredentialsApiYardiTestCredentialsPostUrl = () => {
    return `/api/yardi/test-credentials`;
};
/**
 * @summary Yardi Test Credentials
 */
export const yardiTestCredentialsApiYardiTestCredentialsPost = async (yardiCredentials, options) => {
    return customFetch(getYardiTestCredentialsApiYardiTestCredentialsPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(yardiCredentials)
    });
};
export const getYardiSecretExistsApiYardiSecretExistsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/yardi/secret-exists?${stringifiedParams}` : `/api/yardi/secret-exists`;
};
/**
 * @summary Yardi Secret Exists
 */
export const yardiSecretExistsApiYardiSecretExistsGet = async (params, options) => {
    return customFetch(getYardiSecretExistsApiYardiSecretExistsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getYardiSecretUsernameApiYardiSecretUsernameGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/yardi/secret-username?${stringifiedParams}` : `/api/yardi/secret-username`;
};
/**
 * Proxy: return username and instance URL from the tenant Yardi secret (never password).
 * @summary Yardi Secret Username
 */
export const yardiSecretUsernameApiYardiSecretUsernameGet = async (params, options) => {
    return customFetch(getYardiSecretUsernameApiYardiSecretUsernameGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getYardiPushSecretToAwsApiYardiPushSecretToAwsPostUrl = () => {
    return `/api/yardi/push-secret-to-aws`;
};
/**
 * @summary Yardi Push Secret To Aws
 */
export const yardiPushSecretToAwsApiYardiPushSecretToAwsPost = async (pushSecretRequest, options) => {
    return customFetch(getYardiPushSecretToAwsApiYardiPushSecretToAwsPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(pushSecretRequest)
    });
};
export const getGetFetchStatesApiPmsfetchingestFetchStatesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pmsfetchingest/fetch-states?${stringifiedParams}` : `/api/pmsfetchingest/fetch-states`;
};
/**
 * Proxy endpoint to get fetch states for a Yardi tenant and property.
 * Resolves Surface property_id to Yardi external_property_id and calls the Yardi proxy.
 * @summary Get Fetch States
 */
export const getFetchStatesApiPmsfetchingestFetchStatesGet = async (params, options) => {
    return customFetch(getGetFetchStatesApiPmsfetchingestFetchStatesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getResetDocumentListStateApiPmsfetchingestResetDocumentListStatePostUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pmsfetchingest/reset-document-list-state?${stringifiedParams}` : `/api/pmsfetchingest/reset-document-list-state`;
};
/**
 * Reset document list fetch state to force a full repull on the next run.
 *
 * Sets lease_documents_last_date_fetched to NULL in resident_fetch_state and
 * deletes fetch_state rows for GetTenantLeaseDocuments.
 *
 * Args:
 *     saas_tenant_id: Required tenant ID.
 *     property_id: Optional Surface property ID. When omitted, resets all properties
 *         for the tenant (tenant-wide). When provided, resets only that property.
 * @summary Reset Document List State
 */
export const resetDocumentListStateApiPmsfetchingestResetDocumentListStatePost = async (params, options) => {
    return customFetch(getResetDocumentListStateApiPmsfetchingestResetDocumentListStatePostUrl(params), {
        ...options,
        method: 'POST'
    });
};
export const getFetchedPayloadsPageApiPmsfetchingestFetchedPayloadsGetUrl = () => {
    return `/api/pmsfetchingest/fetched-payloads`;
};
/**
 * HTML page for viewing fetched payloads
 * @summary Fetched Payloads Page
 */
export const fetchedPayloadsPageApiPmsfetchingestFetchedPayloadsGet = async (options) => {
    return customFetch(getFetchedPayloadsPageApiPmsfetchingestFetchedPayloadsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetServiceEndpointsApiPmsfetchingestServiceEndpointsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pmsfetchingest/service-endpoints?${stringifiedParams}` : `/api/pmsfetchingest/service-endpoints`;
};
/**
 * Get available service endpoints for a given external system type
 * Proxies to the PMS proxy service endpoints
 * @summary Get Service Endpoints
 */
export const getServiceEndpointsApiPmsfetchingestServiceEndpointsGet = async (params, options) => {
    return customFetch(getGetServiceEndpointsApiPmsfetchingestServiceEndpointsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetFetchOperationsApiPmsfetchingestFetchOperationsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pmsfetchingest/fetch-operations?${stringifiedParams}` : `/api/pmsfetchingest/fetch-operations`;
};
/**
 * Get available fetch operations for a specific endpoint
 * Currently only supports Yardi endpoints with mapped operations
 * @summary Get Fetch Operations
 */
export const getFetchOperationsApiPmsfetchingestFetchOperationsGet = async (params, options) => {
    return customFetch(getGetFetchOperationsApiPmsfetchingestFetchOperationsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetSeveredPropertiesApiPropertiesSeveredGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["order_by"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/severed?${stringifiedParams}` : `/api/properties/severed`;
};
/**
 * @summary Get Severed Properties
 */
export const getSeveredPropertiesApiPropertiesSeveredGet = async (params, options) => {
    return customFetch(getGetSeveredPropertiesApiPropertiesSeveredGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetDueDiligencePropertiesApiPropertiesDueDiligenceGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["order_by"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/due-diligence?${stringifiedParams}` : `/api/properties/due-diligence`;
};
/**
 * @summary Get Due Diligence Properties
 */
export const getDueDiligencePropertiesApiPropertiesDueDiligenceGet = async (params, options) => {
    return customFetch(getGetDueDiligencePropertiesApiPropertiesDueDiligenceGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getPostDueDiligenceMarkCompleteApiPropertiesPropertyIdDueDiligenceMarkCompletePostUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/due-diligence/mark-complete`;
};
/**
 * @summary Post Due Diligence Mark Complete
 */
export const postDueDiligenceMarkCompleteApiPropertiesPropertyIdDueDiligenceMarkCompletePost = async ({ propertyId }, dueDiligenceMarkCompleteRequest, options) => {
    return customFetch(getPostDueDiligenceMarkCompleteApiPropertiesPropertyIdDueDiligenceMarkCompletePostUrl({ propertyId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(dueDiligenceMarkCompleteRequest)
    });
};
export const getGetDueDiligenceReportDataApiPropertiesPropertyIdDueDiligenceReportDataReportDataIdGetUrl = ({ propertyId, reportDataId }) => {
    return `/api/properties/${propertyId}/due-diligence/report-data/${reportDataId}`;
};
/**
 * @summary Get Due Diligence Report Data
 */
export const getDueDiligenceReportDataApiPropertiesPropertyIdDueDiligenceReportDataReportDataIdGet = async ({ propertyId, reportDataId }, options) => {
    return customFetch(getGetDueDiligenceReportDataApiPropertiesPropertyIdDueDiligenceReportDataReportDataIdGetUrl({ propertyId, reportDataId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetSeveredPropertyApiPropertiesSeveredPropertyIdGetUrl = ({ propertyId }) => {
    return `/api/properties/severed/${propertyId}`;
};
/**
 * @summary Get Severed Property
 */
export const getSeveredPropertyApiPropertiesSeveredPropertyIdGet = async ({ propertyId }, options) => {
    return customFetch(getGetSeveredPropertyApiPropertiesSeveredPropertyIdGetUrl({ propertyId }), {
        ...options,
        method: 'GET'
    });
};
export const getCreateSeveredPropertyApiPropertiesPostUrl = () => {
    return `/api/properties`;
};
/**
 * @summary Create Severed Property
 */
export const createSeveredPropertyApiPropertiesPost = async (propertyCreate, options) => {
    return customFetch(getCreateSeveredPropertyApiPropertiesPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(propertyCreate)
    });
};
export const getGetPropertiesApiPropertiesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["order_by"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties?${stringifiedParams}` : `/api/properties`;
};
/**
 * @summary Get Properties
 */
export const getPropertiesApiPropertiesGet = async (params, options) => {
    return customFetch(getGetPropertiesApiPropertiesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getIngestRentRollApiPropertiesSeveredPropertyIdIngestRentRollPostUrl = ({ propertyId }) => {
    return `/api/properties/severed/${propertyId}/ingest_rent_roll`;
};
/**
 * @summary Ingest Rent Roll
 */
export const ingestRentRollApiPropertiesSeveredPropertyIdIngestRentRollPost = async ({ propertyId }, options) => {
    return customFetch(getIngestRentRollApiPropertiesSeveredPropertyIdIngestRentRollPostUrl({ propertyId }), {
        ...options,
        method: 'POST'
    });
};
export const getProcessRentRollApiPropertiesSeveredPropertyIdRentrollProcessPostUrl = ({ propertyId }) => {
    return `/api/properties/severed/${propertyId}/rentroll/process`;
};
/**
 * Queue async creation of property data from all valid staged rent rolls.
 * @summary Process Rent Roll
 */
export const processRentRollApiPropertiesSeveredPropertyIdRentrollProcessPost = async ({ propertyId }, options) => {
    return customFetch(getProcessRentRollApiPropertiesSeveredPropertyIdRentrollProcessPostUrl({ propertyId }), {
        ...options,
        method: 'POST'
    });
};
export const getUpsertRentRollApiPropertiesSeveredPropertyIdRentrollPostUrl = ({ propertyId }) => {
    return `/api/properties/severed/${propertyId}/rentroll`;
};
/**
 * @summary Upsert Rent Roll
 */
export const upsertRentRollApiPropertiesSeveredPropertyIdRentrollPost = async ({ propertyId }, bodyUpsertRentRollApiPropertiesSeveredPropertyIdRentrollPost, options) => {
    const formData = new FormData();
    formData.append(`file`, bodyUpsertRentRollApiPropertiesSeveredPropertyIdRentrollPost.file);
    return customFetch(getUpsertRentRollApiPropertiesSeveredPropertyIdRentrollPostUrl({ propertyId }), {
        ...options,
        method: 'POST',
        body: formData
    });
};
export const getGetRentRollsApiPropertiesSeveredPropertyIdRentrollGetUrl = ({ propertyId }) => {
    return `/api/properties/severed/${propertyId}/rentroll`;
};
/**
 * @summary Get Rent Rolls
 */
export const getRentRollsApiPropertiesSeveredPropertyIdRentrollGet = async ({ propertyId }, options) => {
    return customFetch(getGetRentRollsApiPropertiesSeveredPropertyIdRentrollGetUrl({ propertyId }), {
        ...options,
        method: 'GET'
    });
};
export const getExtractRentRollApiPropertiesSeveredPropertyIdRentrollLeasesAndUnitsExtractPostUrl = ({ propertyId }) => {
    return `/api/properties/severed/${propertyId}/rentroll/leases-and-units/extract`;
};
/**
 * @summary Extract Rent Roll
 */
export const extractRentRollApiPropertiesSeveredPropertyIdRentrollLeasesAndUnitsExtractPost = async ({ propertyId }, rentRollExtractRequest, options) => {
    return customFetch(getExtractRentRollApiPropertiesSeveredPropertyIdRentrollLeasesAndUnitsExtractPostUrl({ propertyId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(rentRollExtractRequest)
    });
};
export const getPreviewRentRollExtractionApiPropertiesSeveredPropertyIdRentrollRentRollIdExtractPreviewPostUrl = ({ propertyId, rentRollId }) => {
    return `/api/properties/severed/${propertyId}/rentroll/${rentRollId}/extract/preview`;
};
/**
 * @summary Preview Rent Roll Extraction
 */
export const previewRentRollExtractionApiPropertiesSeveredPropertyIdRentrollRentRollIdExtractPreviewPost = async ({ propertyId, rentRollId }, rentRollExtractPreviewRequest, options) => {
    return customFetch(getPreviewRentRollExtractionApiPropertiesSeveredPropertyIdRentrollRentRollIdExtractPreviewPostUrl({ propertyId, rentRollId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(rentRollExtractPreviewRequest)
    });
};
export const getGetRentRollLeasesApiPropertiesSeveredPropertyIdRentrollLeasesGetUrl = ({ propertyId }) => {
    return `/api/properties/severed/${propertyId}/rentroll/leases`;
};
/**
 * @summary Get Rent Roll Leases
 */
export const getRentRollLeasesApiPropertiesSeveredPropertyIdRentrollLeasesGet = async ({ propertyId }, options) => {
    return customFetch(getGetRentRollLeasesApiPropertiesSeveredPropertyIdRentrollLeasesGetUrl({ propertyId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetRentRollExtractorNamesApiPropertiesSeveredPropertyIdRentrollExtractorsGetUrl = ({ propertyId }) => {
    return `/api/properties/severed/${propertyId}/rentroll/extractors`;
};
/**
 * @summary Get Rent Roll Extractor Names
 */
export const getRentRollExtractorNamesApiPropertiesSeveredPropertyIdRentrollExtractorsGet = async ({ propertyId }, options) => {
    return customFetch(getGetRentRollExtractorNamesApiPropertiesSeveredPropertyIdRentrollExtractorsGetUrl({ propertyId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetMergedRentRollApiPropertiesSeveredPropertyIdRentrollMergedGetUrl = ({ propertyId }) => {
    return `/api/properties/severed/${propertyId}/rentroll/merged`;
};
/**
 * @summary Get Merged Rent Roll
 */
export const getMergedRentRollApiPropertiesSeveredPropertyIdRentrollMergedGet = async ({ propertyId }, options) => {
    return customFetch(getGetMergedRentRollApiPropertiesSeveredPropertyIdRentrollMergedGetUrl({ propertyId }), {
        ...options,
        method: 'GET'
    });
};
export const getAddRentRollUnitApiPropertiesSeveredPropertyIdRentrollUnitsPostUrl = ({ propertyId }) => {
    return `/api/properties/severed/${propertyId}/rentroll/units`;
};
/**
 * @summary Add Rent Roll Unit
 */
export const addRentRollUnitApiPropertiesSeveredPropertyIdRentrollUnitsPost = async ({ propertyId }, rentRollUnitCreateRequest, options) => {
    return customFetch(getAddRentRollUnitApiPropertiesSeveredPropertyIdRentrollUnitsPostUrl({ propertyId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(rentRollUnitCreateRequest)
    });
};
export const getClearRentRollManualOverridesApiPropertiesSeveredPropertyIdRentrollUnitsOverridesDeleteUrl = ({ propertyId }) => {
    return `/api/properties/severed/${propertyId}/rentroll/units/overrides`;
};
/**
 * @summary Clear Rent Roll Manual Overrides
 */
export const clearRentRollManualOverridesApiPropertiesSeveredPropertyIdRentrollUnitsOverridesDelete = async ({ propertyId }, options) => {
    return customFetch(getClearRentRollManualOverridesApiPropertiesSeveredPropertyIdRentrollUnitsOverridesDeleteUrl({ propertyId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getUpdateRentRollUnitApiPropertiesSeveredPropertyIdRentrollUnitsUnitNumberPatchUrl = ({ propertyId, unitNumber }) => {
    return `/api/properties/severed/${propertyId}/rentroll/units/${unitNumber}`;
};
/**
 * @summary Update Rent Roll Unit
 */
export const updateRentRollUnitApiPropertiesSeveredPropertyIdRentrollUnitsUnitNumberPatch = async ({ propertyId, unitNumber }, rentRollUnitUpdateRequest, options) => {
    return customFetch(getUpdateRentRollUnitApiPropertiesSeveredPropertyIdRentrollUnitsUnitNumberPatchUrl({ propertyId, unitNumber }), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(rentRollUnitUpdateRequest)
    });
};
export const getRevertRentRollUnitOverrideApiPropertiesSeveredPropertyIdRentrollUnitsUnitNumberDeleteUrl = ({ propertyId, unitNumber }) => {
    return `/api/properties/severed/${propertyId}/rentroll/units/${unitNumber}`;
};
/**
 * @summary Revert Rent Roll Unit Override
 */
export const revertRentRollUnitOverrideApiPropertiesSeveredPropertyIdRentrollUnitsUnitNumberDelete = async ({ propertyId, unitNumber }, options) => {
    return customFetch(getRevertRentRollUnitOverrideApiPropertiesSeveredPropertyIdRentrollUnitsUnitNumberDeleteUrl({ propertyId, unitNumber }), {
        ...options,
        method: 'DELETE'
    });
};
export const getDownloadRentRollTemplateApiPropertiesSeveredPropertyIdRentrollTemplateGetUrl = ({ propertyId }) => {
    return `/api/properties/severed/${propertyId}/rentroll/template`;
};
/**
 * @summary Download Rent Roll Template
 */
export const downloadRentRollTemplateApiPropertiesSeveredPropertyIdRentrollTemplateGet = async ({ propertyId }, options) => {
    return customFetch(getDownloadRentRollTemplateApiPropertiesSeveredPropertyIdRentrollTemplateGetUrl({ propertyId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetRentRollApiPropertiesSeveredPropertyIdRentrollRentRollIdGetUrl = ({ propertyId, rentRollId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/severed/${propertyId}/rentroll/${rentRollId}?${stringifiedParams}` : `/api/properties/severed/${propertyId}/rentroll/${rentRollId}`;
};
/**
 * @summary Get Rent Roll
 */
export const getRentRollApiPropertiesSeveredPropertyIdRentrollRentRollIdGet = async ({ propertyId, rentRollId }, params, options) => {
    return customFetch(getGetRentRollApiPropertiesSeveredPropertyIdRentrollRentRollIdGetUrl({ propertyId, rentRollId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getDeleteRentRollApiPropertiesSeveredPropertyIdRentrollRentRollIdDeleteUrl = ({ propertyId, rentRollId }) => {
    return `/api/properties/severed/${propertyId}/rentroll/${rentRollId}`;
};
/**
 * @summary Delete Rent Roll
 */
export const deleteRentRollApiPropertiesSeveredPropertyIdRentrollRentRollIdDelete = async ({ propertyId, rentRollId }, options) => {
    return customFetch(getDeleteRentRollApiPropertiesSeveredPropertyIdRentrollRentRollIdDeleteUrl({ propertyId, rentRollId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getAuditAllLeasesApiPropertiesSeveredPropertyIdPerformAuditsPostUrl = ({ propertyId }) => {
    return `/api/properties/severed/${propertyId}/perform_audits`;
};
/**
 * @summary Audit All Leases
 */
export const auditAllLeasesApiPropertiesSeveredPropertyIdPerformAuditsPost = async ({ propertyId }, options) => {
    return customFetch(getAuditAllLeasesApiPropertiesSeveredPropertyIdPerformAuditsPostUrl({ propertyId }), {
        ...options,
        method: 'POST'
    });
};
export const getRunDueDiligenceApiPropertiesPropertyIdRunDueDiligencePostUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/run_due_diligence`;
};
/**
 * Start the due diligence pipeline for a property
 * @summary Run Due Diligence
 */
export const runDueDiligenceApiPropertiesPropertyIdRunDueDiligencePost = async ({ propertyId }, runDueDiligenceRequest, options) => {
    return customFetch(getRunDueDiligenceApiPropertiesPropertyIdRunDueDiligencePostUrl({ propertyId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(runDueDiligenceRequest)
    });
};
export const getGetReportLayoutSettingsApiPropertiesSeveredPropertyIdReportLayoutSettingsGetUrl = ({ propertyId }) => {
    return `/api/properties/severed/${propertyId}/report/layout/settings`;
};
/**
 * @summary Get Report Layout Settings
 */
export const getReportLayoutSettingsApiPropertiesSeveredPropertyIdReportLayoutSettingsGet = async ({ propertyId }, options) => {
    return customFetch(getGetReportLayoutSettingsApiPropertiesSeveredPropertyIdReportLayoutSettingsGetUrl({ propertyId }), {
        ...options,
        method: 'GET'
    });
};
export const getUpsertReportLayoutSettingsApiPropertiesSeveredPropertyIdReportLayoutSettingsPostUrl = ({ propertyId }) => {
    return `/api/properties/severed/${propertyId}/report/layout/settings`;
};
/**
 * @summary Upsert Report Layout Settings
 */
export const upsertReportLayoutSettingsApiPropertiesSeveredPropertyIdReportLayoutSettingsPost = async ({ propertyId }, ddReportLayoutSettings, options) => {
    return customFetch(getUpsertReportLayoutSettingsApiPropertiesSeveredPropertyIdReportLayoutSettingsPostUrl({ propertyId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(ddReportLayoutSettings)
    });
};
export const getGetBuiltinPdfSummaryPromptGuidelinesApiDuediligenceReportSummaryPromptGuidelinesBuiltinGetUrl = () => {
    return `/api/duediligence/report/summary-prompt-guidelines/builtin`;
};
/**
 * @summary Get Builtin Pdf Summary Prompt Guidelines
 */
export const getBuiltinPdfSummaryPromptGuidelinesApiDuediligenceReportSummaryPromptGuidelinesBuiltinGet = async (options) => {
    return customFetch(getGetBuiltinPdfSummaryPromptGuidelinesApiDuediligenceReportSummaryPromptGuidelinesBuiltinGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetPdfSummaryPromptGuidelinesApiDuediligenceReportSummaryPromptGuidelinesGetUrl = () => {
    return `/api/duediligence/report/summary-prompt-guidelines`;
};
/**
 * @summary Get Pdf Summary Prompt Guidelines
 */
export const getPdfSummaryPromptGuidelinesApiDuediligenceReportSummaryPromptGuidelinesGet = async (options) => {
    return customFetch(getGetPdfSummaryPromptGuidelinesApiDuediligenceReportSummaryPromptGuidelinesGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getUpsertPdfSummaryPromptGuidelinesApiDuediligenceReportSummaryPromptGuidelinesPostUrl = () => {
    return `/api/duediligence/report/summary-prompt-guidelines`;
};
/**
 * @summary Upsert Pdf Summary Prompt Guidelines
 */
export const upsertPdfSummaryPromptGuidelinesApiDuediligenceReportSummaryPromptGuidelinesPost = async (ddSummaryPromptGuidelines, options) => {
    return customFetch(getUpsertPdfSummaryPromptGuidelinesApiDuediligenceReportSummaryPromptGuidelinesPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(ddSummaryPromptGuidelines)
    });
};
export const getGetDdPdfLayoutSettingsApiDuediligenceReportLayoutSettingsGetUrl = () => {
    return `/api/duediligence/report/layout-settings`;
};
/**
 * @summary Get Dd Pdf Layout Settings
 */
export const getDdPdfLayoutSettingsApiDuediligenceReportLayoutSettingsGet = async (options) => {
    return customFetch(getGetDdPdfLayoutSettingsApiDuediligenceReportLayoutSettingsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getUpsertDdPdfLayoutSettingsApiDuediligenceReportLayoutSettingsPostUrl = () => {
    return `/api/duediligence/report/layout-settings`;
};
/**
 * @summary Upsert Dd Pdf Layout Settings
 */
export const upsertDdPdfLayoutSettingsApiDuediligenceReportLayoutSettingsPost = async (ddReportLayoutSettings, options) => {
    return customFetch(getUpsertDdPdfLayoutSettingsApiDuediligenceReportLayoutSettingsPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(ddReportLayoutSettings)
    });
};
export const getGetDemographicReportsApiPropertiesSeveredPropertyIdDemographicReportsGetUrl = ({ propertyId }) => {
    return `/api/properties/severed/${propertyId}/demographic-reports`;
};
/**
 * @summary Get Demographic Reports
 */
export const getDemographicReportsApiPropertiesSeveredPropertyIdDemographicReportsGet = async ({ propertyId }, options) => {
    return customFetch(getGetDemographicReportsApiPropertiesSeveredPropertyIdDemographicReportsGetUrl({ propertyId }), {
        ...options,
        method: 'GET'
    });
};
export const getUpsertDemographicReportApiPropertiesSeveredPropertyIdDemographicReportsPostUrl = ({ propertyId }) => {
    return `/api/properties/severed/${propertyId}/demographic-reports`;
};
/**
 * @summary Upsert Demographic Report
 */
export const upsertDemographicReportApiPropertiesSeveredPropertyIdDemographicReportsPost = async ({ propertyId }, demographicReportInput, options) => {
    return customFetch(getUpsertDemographicReportApiPropertiesSeveredPropertyIdDemographicReportsPostUrl({ propertyId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(demographicReportInput)
    });
};
export const getGetDemographicReportApiPropertiesSeveredPropertyIdDemographicReportsReportIdGetUrl = ({ propertyId, reportId }) => {
    return `/api/properties/severed/${propertyId}/demographic-reports/${reportId}`;
};
/**
 * @summary Get Demographic Report
 */
export const getDemographicReportApiPropertiesSeveredPropertyIdDemographicReportsReportIdGet = async ({ propertyId, reportId }, options) => {
    return customFetch(getGetDemographicReportApiPropertiesSeveredPropertyIdDemographicReportsReportIdGetUrl({ propertyId, reportId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetTransitionDocumentClassificationsApiTransitionDocumentClassificationsGetUrl = () => {
    return `/api/transition-document-classifications`;
};
/**
 * @summary Get Transition Document Classifications
 */
export const getTransitionDocumentClassificationsApiTransitionDocumentClassificationsGet = async (options) => {
    return customFetch(getGetTransitionDocumentClassificationsApiTransitionDocumentClassificationsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetTransitionsApiTransitionsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["sort"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/transitions?${stringifiedParams}` : `/api/transitions`;
};
/**
 * @summary Get Transitions
 */
export const getTransitionsApiTransitionsGet = async (params, options) => {
    return customFetch(getGetTransitionsApiTransitionsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getCreateTransitionApiTransitionsPostUrl = () => {
    return `/api/transitions`;
};
/**
 * @summary Create Transition
 */
export const createTransitionApiTransitionsPost = async (transitionInput, options) => {
    return customFetch(getCreateTransitionApiTransitionsPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(transitionInput)
    });
};
export const getGetTransitionsHomeCardsApiTransitionsHomeCardsGetUrl = () => {
    return `/api/transitions/home-cards`;
};
/**
 * Aggregate counts for the Transitions Home tab.
 *
 * Returns three cards — needs_review, overdue, on_track — computed across
 * every open transition the caller can see. Scoping matches
 * ``GET /transitions`` and the paged task/milestone endpoints (guest
 * collection access when ``for_user_id`` is supplied, full-tenant
 * visibility otherwise).
 * @summary Get Transitions Home Cards
 */
export const getTransitionsHomeCardsApiTransitionsHomeCardsGet = async (options) => {
    return customFetch(getGetTransitionsHomeCardsApiTransitionsHomeCardsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetTransitionDocumentTasksApiTransitionsDocumentTasksGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["transition_ids", "sort"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/transitions/document-tasks?${stringifiedParams}` : `/api/transitions/document-tasks`;
};
/**
 * @summary Get Transition Document Tasks
 */
export const getTransitionDocumentTasksApiTransitionsDocumentTasksGet = async (params, options) => {
    return customFetch(getGetTransitionDocumentTasksApiTransitionsDocumentTasksGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetMilestonesApiTransitionsMilestonesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["transition_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/transitions/milestones?${stringifiedParams}` : `/api/transitions/milestones`;
};
/**
 * @summary Get Milestones
 */
export const getMilestonesApiTransitionsMilestonesGet = async (params, options) => {
    return customFetch(getGetMilestonesApiTransitionsMilestonesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetTransitionApiTransitionsTransitionIdGetUrl = ({ transitionId }) => {
    return `/api/transitions/${transitionId}`;
};
/**
 * @summary Get Transition
 */
export const getTransitionApiTransitionsTransitionIdGet = async ({ transitionId }, options) => {
    return customFetch(getGetTransitionApiTransitionsTransitionIdGetUrl({ transitionId }), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateTransitionApiTransitionsTransitionIdPatchUrl = ({ transitionId }) => {
    return `/api/transitions/${transitionId}`;
};
/**
 * @summary Update Transition
 */
export const updateTransitionApiTransitionsTransitionIdPatch = async ({ transitionId }, updateTransitionRequest, options) => {
    return customFetch(getUpdateTransitionApiTransitionsTransitionIdPatchUrl({ transitionId }), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(updateTransitionRequest)
    });
};
export const getDeleteTransitionApiTransitionsTransitionIdDeleteUrl = ({ transitionId }) => {
    return `/api/transitions/${transitionId}`;
};
/**
 * Delete a transition (real or template) by id.
 *
 * Requires ``Transitions_Template.Delete`` when the target row is a template, or
 * ``Transitions_Transition.Delete`` when it is a real transition.
 * @summary Delete Transition
 */
export const deleteTransitionApiTransitionsTransitionIdDelete = async ({ transitionId }, options) => {
    return customFetch(getDeleteTransitionApiTransitionsTransitionIdDeleteUrl({ transitionId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getCreateTransitionFromTemplateApiTransitionsFromTemplatePostUrl = () => {
    return `/api/transitions/from-template`;
};
/**
 * @summary Create Transition From Template
 */
export const createTransitionFromTemplateApiTransitionsFromTemplatePost = async (createTransitionFromTemplateRequest, options) => {
    return customFetch(getCreateTransitionFromTemplateApiTransitionsFromTemplatePostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(createTransitionFromTemplateRequest)
    });
};
export const getSaveTransitionAsTemplateApiTransitionsTransitionIdSaveAsTemplatePostUrl = ({ transitionId }) => {
    return `/api/transitions/${transitionId}/save-as-template`;
};
/**
 * Snapshot a transition's structure into a new *template* transition.
 *
 * Deep-clones the source transition's milestones, document tasks, and document
 * requirements with fresh ids via :meth:`Transition.clone_as_template`, then
 * persists the clone with ``is_template=True``. Runtime-only fields
 * (``property_id``, ``company_roles``, ``document_collections``,
 * ``target_completion_date``, ``completed_at``) are dropped on the template. The
 * source transition is left unchanged.
 * @summary Save Transition As Template
 */
export const saveTransitionAsTemplateApiTransitionsTransitionIdSaveAsTemplatePost = async ({ transitionId }, saveAsTemplateRequest, options) => {
    return customFetch(getSaveTransitionAsTemplateApiTransitionsTransitionIdSaveAsTemplatePostUrl({ transitionId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(saveAsTemplateRequest)
    });
};
export const getUpsertMilestonesApiTransitionsTransitionIdMilestonesPutUrl = ({ transitionId }) => {
    return `/api/transitions/${transitionId}/milestones`;
};
/**
 * @summary Upsert Milestones
 */
export const upsertMilestonesApiTransitionsTransitionIdMilestonesPut = async ({ transitionId }, upsertMilestonesRequest, options) => {
    return customFetch(getUpsertMilestonesApiTransitionsTransitionIdMilestonesPutUrl({ transitionId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(upsertMilestonesRequest)
    });
};
export const getGetTransitionTemplatesApiTransitionTemplatesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/transition-templates?${stringifiedParams}` : `/api/transition-templates`;
};
/**
 * @summary Get Transition Templates
 */
export const getTransitionTemplatesApiTransitionTemplatesGet = async (params, options) => {
    return customFetch(getGetTransitionTemplatesApiTransitionTemplatesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetCompaniesApiCompaniesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/companies?${stringifiedParams}` : `/api/companies`;
};
/**
 * @summary Get Companies
 */
export const getCompaniesApiCompaniesGet = async (params, options) => {
    return customFetch(getGetCompaniesApiCompaniesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getCreateCompanyApiCompaniesPostUrl = () => {
    return `/api/companies`;
};
/**
 * @summary Create Company
 */
export const createCompanyApiCompaniesPost = async (companyInput, options) => {
    return customFetch(getCreateCompanyApiCompaniesPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(companyInput)
    });
};
export const getGetCompanyApiCompaniesCompanyIdGetUrl = ({ companyId }) => {
    return `/api/companies/${companyId}`;
};
/**
 * @summary Get Company
 */
export const getCompanyApiCompaniesCompanyIdGet = async ({ companyId }, options) => {
    return customFetch(getGetCompanyApiCompaniesCompanyIdGetUrl({ companyId }), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateCompanyApiCompaniesCompanyIdPutUrl = ({ companyId }) => {
    return `/api/companies/${companyId}`;
};
/**
 * @summary Update Company
 */
export const updateCompanyApiCompaniesCompanyIdPut = async ({ companyId }, companyInput, options) => {
    return customFetch(getUpdateCompanyApiCompaniesCompanyIdPutUrl({ companyId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(companyInput)
    });
};
export const getGetCompanyTeamsApiCompaniesCompanyIdTeamsGetUrl = ({ companyId }) => {
    return `/api/companies/${companyId}/teams`;
};
/**
 * @summary Get Company Teams
 */
export const getCompanyTeamsApiCompaniesCompanyIdTeamsGet = async ({ companyId }, options) => {
    return customFetch(getGetCompanyTeamsApiCompaniesCompanyIdTeamsGetUrl({ companyId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetCompanyTeamMembersApiCompaniesCompanyIdTeamsTeamMembersGetUrl = ({ companyId, team }) => {
    return `/api/companies/${companyId}/teams/${team}/members`;
};
/**
 * @summary Get Company Team Members
 */
export const getCompanyTeamMembersApiCompaniesCompanyIdTeamsTeamMembersGet = async ({ companyId, team }, options) => {
    return customFetch(getGetCompanyTeamMembersApiCompaniesCompanyIdTeamsTeamMembersGetUrl({ companyId, team }), {
        ...options,
        method: 'GET'
    });
};
export const getAddCompanyTeamMemberApiCompaniesCompanyIdTeamsTeamMembersPostUrl = ({ companyId, team }) => {
    return `/api/companies/${companyId}/teams/${team}/members`;
};
/**
 * @summary Add Company Team Member
 */
export const addCompanyTeamMemberApiCompaniesCompanyIdTeamsTeamMembersPost = async ({ companyId, team }, addCompanyTeamMemberRequest, options) => {
    return customFetch(getAddCompanyTeamMemberApiCompaniesCompanyIdTeamsTeamMembersPostUrl({ companyId, team }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(addCompanyTeamMemberRequest)
    });
};
export const getRemoveCompanyTeamMemberApiCompaniesCompanyIdTeamsTeamMembersUserIdDeleteUrl = ({ companyId, team, userId }) => {
    return `/api/companies/${companyId}/teams/${team}/members/${userId}`;
};
/**
 * @summary Remove Company Team Member
 */
export const removeCompanyTeamMemberApiCompaniesCompanyIdTeamsTeamMembersUserIdDelete = async ({ companyId, team, userId }, options) => {
    return customFetch(getRemoveCompanyTeamMemberApiCompaniesCompanyIdTeamsTeamMembersUserIdDeleteUrl({ companyId, team, userId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getListTransitionBoundVariablesApiTransitionsTransitionIdVariablesGetUrl = ({ transitionId }) => {
    return `/api/transitions/${transitionId}/variables`;
};
/**
 * @summary List Transition Bound Variables
 */
export const listTransitionBoundVariablesApiTransitionsTransitionIdVariablesGet = async ({ transitionId }, options) => {
    return customFetch(getListTransitionBoundVariablesApiTransitionsTransitionIdVariablesGetUrl({ transitionId }), {
        ...options,
        method: 'GET'
    });
};
export const getBindTransitionVariableApiTransitionsTransitionIdVariablesPostUrl = ({ transitionId }) => {
    return `/api/transitions/${transitionId}/variables`;
};
/**
 * @summary Bind Transition Variable
 */
export const bindTransitionVariableApiTransitionsTransitionIdVariablesPost = async ({ transitionId }, bindTransitionVariableRequest, options) => {
    return customFetch(getBindTransitionVariableApiTransitionsTransitionIdVariablesPostUrl({ transitionId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(bindTransitionVariableRequest)
    });
};
export const getPatchTransitionVariableApiTransitionsTransitionIdVariablesDefinitionIdPatchUrl = ({ transitionId, definitionId }) => {
    return `/api/transitions/${transitionId}/variables/${definitionId}`;
};
/**
 * @summary Patch Transition Variable
 */
export const patchTransitionVariableApiTransitionsTransitionIdVariablesDefinitionIdPatch = async ({ transitionId, definitionId }, patchTransitionVariableBindingRequest, options) => {
    return customFetch(getPatchTransitionVariableApiTransitionsTransitionIdVariablesDefinitionIdPatchUrl({ transitionId, definitionId }), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchTransitionVariableBindingRequest)
    });
};
export const getUnbindTransitionVariableApiTransitionsTransitionIdVariablesDefinitionIdDeleteUrl = ({ transitionId, definitionId }) => {
    return `/api/transitions/${transitionId}/variables/${definitionId}`;
};
/**
 * @summary Unbind Transition Variable
 */
export const unbindTransitionVariableApiTransitionsTransitionIdVariablesDefinitionIdDelete = async ({ transitionId, definitionId }, options) => {
    return customFetch(getUnbindTransitionVariableApiTransitionsTransitionIdVariablesDefinitionIdDeleteUrl({ transitionId, definitionId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getGetTransitionDocumentTasksv1ApiTransitionsTransitionIdDocumentTasksGetUrl = ({ transitionId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["sort"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/transitions/${transitionId}/document-tasks?${stringifiedParams}` : `/api/transitions/${transitionId}/document-tasks`;
};
/**
 * @summary Get Transition Document Tasksv1
 */
export const getTransitionDocumentTasksv1ApiTransitionsTransitionIdDocumentTasksGet = async ({ transitionId }, params, options) => {
    return customFetch(getGetTransitionDocumentTasksv1ApiTransitionsTransitionIdDocumentTasksGetUrl({ transitionId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getCreateDocumentTaskApiTransitionsTransitionIdDocumentTasksPostUrl = ({ transitionId }) => {
    return `/api/transitions/${transitionId}/document-tasks`;
};
/**
 * @summary Create Document Task
 */
export const createDocumentTaskApiTransitionsTransitionIdDocumentTasksPost = async ({ transitionId }, documentTaskInput, options) => {
    return customFetch(getCreateDocumentTaskApiTransitionsTransitionIdDocumentTasksPostUrl({ transitionId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(documentTaskInput)
    });
};
export const getBulkUpdateDocumentTasksApiTransitionsTransitionIdDocumentTasksBulkPatchUrl = ({ transitionId }) => {
    return `/api/transitions/${transitionId}/document-tasks/bulk`;
};
/**
 * @summary Bulk Update Document Tasks
 */
export const bulkUpdateDocumentTasksApiTransitionsTransitionIdDocumentTasksBulkPatch = async ({ transitionId }, bulkUpdateDocumentTasksRequest, options) => {
    return customFetch(getBulkUpdateDocumentTasksApiTransitionsTransitionIdDocumentTasksBulkPatchUrl({ transitionId }), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(bulkUpdateDocumentTasksRequest)
    });
};
export const getGetTransitionDocumentTaskApiTransitionsTransitionIdDocumentTasksTaskIdGetUrl = ({ transitionId, taskId }) => {
    return `/api/transitions/${transitionId}/document-tasks/${taskId}`;
};
/**
 * @summary Get Transition Document Task
 */
export const getTransitionDocumentTaskApiTransitionsTransitionIdDocumentTasksTaskIdGet = async ({ transitionId, taskId }, options) => {
    return customFetch(getGetTransitionDocumentTaskApiTransitionsTransitionIdDocumentTasksTaskIdGetUrl({ transitionId, taskId }), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateDocumentTaskApiTransitionsTransitionIdDocumentTasksTaskIdPutUrl = ({ transitionId, taskId }) => {
    return `/api/transitions/${transitionId}/document-tasks/${taskId}`;
};
/**
 * @summary Update Document Task
 */
export const updateDocumentTaskApiTransitionsTransitionIdDocumentTasksTaskIdPut = async ({ transitionId, taskId }, documentTaskInput, options) => {
    return customFetch(getUpdateDocumentTaskApiTransitionsTransitionIdDocumentTasksTaskIdPutUrl({ transitionId, taskId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(documentTaskInput)
    });
};
export const getPatchDocumentTaskApiTransitionsTransitionIdDocumentTasksTaskIdPatchUrl = ({ transitionId, taskId }) => {
    return `/api/transitions/${transitionId}/document-tasks/${taskId}`;
};
/**
 * @summary Patch Document Task
 */
export const patchDocumentTaskApiTransitionsTransitionIdDocumentTasksTaskIdPatch = async ({ transitionId, taskId }, documentTaskPartialUpdate, options) => {
    return customFetch(getPatchDocumentTaskApiTransitionsTransitionIdDocumentTasksTaskIdPatchUrl({ transitionId, taskId }), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(documentTaskPartialUpdate)
    });
};
export const getGetDocumentTaskEligibleAssigneesApiTransitionsTransitionIdDocumentTasksTaskIdEligibleAssigneesGetUrl = ({ transitionId, taskId }) => {
    return `/api/transitions/${transitionId}/document-tasks/${taskId}/eligible-assignees`;
};
/**
 * @summary Get Document Task Eligible Assignees
 */
export const getDocumentTaskEligibleAssigneesApiTransitionsTransitionIdDocumentTasksTaskIdEligibleAssigneesGet = async ({ transitionId, taskId }, options) => {
    return customFetch(getGetDocumentTaskEligibleAssigneesApiTransitionsTransitionIdDocumentTasksTaskIdEligibleAssigneesGetUrl({ transitionId, taskId }), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateDocumentTaskAssignmentApiTransitionsTransitionIdDocumentTasksTaskIdAssignmentPatchUrl = ({ transitionId, taskId }) => {
    return `/api/transitions/${transitionId}/document-tasks/${taskId}/assignment`;
};
/**
 * @summary Update Document Task Assignment
 */
export const updateDocumentTaskAssignmentApiTransitionsTransitionIdDocumentTasksTaskIdAssignmentPatch = async ({ transitionId, taskId }, documentTaskAssignmentUpdate, options) => {
    return customFetch(getUpdateDocumentTaskAssignmentApiTransitionsTransitionIdDocumentTasksTaskIdAssignmentPatchUrl({ transitionId, taskId }), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(documentTaskAssignmentUpdate)
    });
};
export const getUpdateDocumentRequirementCompletionApiTransitionsTransitionIdDocumentTasksTaskIdDocumentRequirementCompletionPutUrl = ({ transitionId, taskId }) => {
    return `/api/transitions/${transitionId}/document-tasks/${taskId}/document-requirement-completion`;
};
/**
 * @summary Update Document Requirement Completion
 */
export const updateDocumentRequirementCompletionApiTransitionsTransitionIdDocumentTasksTaskIdDocumentRequirementCompletionPut = async ({ transitionId, taskId }, documentRequirementCompletionUpdate, options) => {
    return customFetch(getUpdateDocumentRequirementCompletionApiTransitionsTransitionIdDocumentTasksTaskIdDocumentRequirementCompletionPutUrl({ transitionId, taskId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(documentRequirementCompletionUpdate)
    });
};
export const getUpdateDocumentInclusionOutcomeApiTransitionsTransitionIdDocumentTasksTaskIdDocumentInclusionOutcomePutUrl = ({ transitionId, taskId }) => {
    return `/api/transitions/${transitionId}/document-tasks/${taskId}/document-inclusion-outcome`;
};
/**
 * @summary Update Document Inclusion Outcome
 */
export const updateDocumentInclusionOutcomeApiTransitionsTransitionIdDocumentTasksTaskIdDocumentInclusionOutcomePut = async ({ transitionId, taskId }, documentTaskDocumentInclusionOutcomeUpdate, options) => {
    return customFetch(getUpdateDocumentInclusionOutcomeApiTransitionsTransitionIdDocumentTasksTaskIdDocumentInclusionOutcomePutUrl({ transitionId, taskId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(documentTaskDocumentInclusionOutcomeUpdate)
    });
};
export const getGetDocumentTaskDocumentActionHistoryApiTransitionsTransitionIdDocumentTasksTaskIdDocumentActionHistoryGetUrl = ({ transitionId, taskId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/transitions/${transitionId}/document-tasks/${taskId}/document-action-history?${stringifiedParams}` : `/api/transitions/${transitionId}/document-tasks/${taskId}/document-action-history`;
};
/**
 * @summary Get Document Task Document Action History
 */
export const getDocumentTaskDocumentActionHistoryApiTransitionsTransitionIdDocumentTasksTaskIdDocumentActionHistoryGet = async ({ transitionId, taskId }, params, options) => {
    return customFetch(getGetDocumentTaskDocumentActionHistoryApiTransitionsTransitionIdDocumentTasksTaskIdDocumentActionHistoryGetUrl({ transitionId, taskId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getSearchTransitionDocumentsApiTransitionsDocumentsSearchGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["transition_ids", "classifications"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/transitions/documents/search?${stringifiedParams}` : `/api/transitions/documents/search`;
};
/**
 * @summary Search Transition Documents
 */
export const searchTransitionDocumentsApiTransitionsDocumentsSearchGet = async (params, options) => {
    return customFetch(getSearchTransitionDocumentsApiTransitionsDocumentsSearchGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getSearchTransitionDocumentsExportJobApiTransitionsTransitionIdDocumentsSearchExportJobGetUrl = ({ transitionId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["classifications"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/transitions/${transitionId}/documents/search/export_job?${stringifiedParams}` : `/api/transitions/${transitionId}/documents/search/export_job`;
};
/**
 * @summary Search Transition Documents Export Job
 */
export const searchTransitionDocumentsExportJobApiTransitionsTransitionIdDocumentsSearchExportJobGet = async ({ transitionId }, params, options) => {
    return customFetch(getSearchTransitionDocumentsExportJobApiTransitionsTransitionIdDocumentsSearchExportJobGetUrl({ transitionId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetTransitionDocumentApiTransitionsTransitionIdDocumentsDocumentIdGetUrl = ({ transitionId, documentId }) => {
    return `/api/transitions/${transitionId}/documents/${documentId}`;
};
/**
 * @summary Get Transition Document
 */
export const getTransitionDocumentApiTransitionsTransitionIdDocumentsDocumentIdGet = async ({ transitionId, documentId }, options) => {
    return customFetch(getGetTransitionDocumentApiTransitionsTransitionIdDocumentsDocumentIdGetUrl({ transitionId, documentId }), {
        ...options,
        method: 'GET'
    });
};
export const getDeleteTransitionDocumentApiTransitionsTransitionIdDocumentsDocumentIdDeleteUrl = ({ transitionId, documentId }) => {
    return `/api/transitions/${transitionId}/documents/${documentId}`;
};
/**
 * @summary Delete Transition Document
 */
export const deleteTransitionDocumentApiTransitionsTransitionIdDocumentsDocumentIdDelete = async ({ transitionId, documentId }, options) => {
    return customFetch(getDeleteTransitionDocumentApiTransitionsTransitionIdDocumentsDocumentIdDeleteUrl({ transitionId, documentId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getGetTransitionDocumentContentsApiTransitionsTransitionIdDocumentsDocumentIdContentsGetUrl = ({ transitionId, documentId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/transitions/${transitionId}/documents/${documentId}/contents?${stringifiedParams}` : `/api/transitions/${transitionId}/documents/${documentId}/contents`;
};
/**
 * @summary Get Transition Document Contents
 */
export const getTransitionDocumentContentsApiTransitionsTransitionIdDocumentsDocumentIdContentsGet = async ({ transitionId, documentId }, params, options) => {
    return customFetch(getGetTransitionDocumentContentsApiTransitionsTransitionIdDocumentsDocumentIdContentsGetUrl({ transitionId, documentId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetTransitionDocumentContentMetadataApiTransitionsTransitionIdDocumentsDocumentIdContentsMetadataGetUrl = ({ transitionId, documentId }) => {
    return `/api/transitions/${transitionId}/documents/${documentId}/contents/metadata`;
};
/**
 * @summary Get Transition Document Content Metadata
 */
export const getTransitionDocumentContentMetadataApiTransitionsTransitionIdDocumentsDocumentIdContentsMetadataGet = async ({ transitionId, documentId }, options) => {
    return customFetch(getGetTransitionDocumentContentMetadataApiTransitionsTransitionIdDocumentsDocumentIdContentsMetadataGetUrl({ transitionId, documentId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetTransitionDocumentProfileApiTransitionsTransitionIdDocumentsDocumentIdProfileGetUrl = ({ transitionId, documentId }) => {
    return `/api/transitions/${transitionId}/documents/${documentId}/profile`;
};
/**
 * @summary Get Transition Document Profile
 */
export const getTransitionDocumentProfileApiTransitionsTransitionIdDocumentsDocumentIdProfileGet = async ({ transitionId, documentId }, options) => {
    return customFetch(getGetTransitionDocumentProfileApiTransitionsTransitionIdDocumentsDocumentIdProfileGetUrl({ transitionId, documentId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetTransitionDocumentProfileSchemaApiTransitionsTransitionIdDocumentsDocumentIdProfileSchemaGetUrl = ({ transitionId, documentId }) => {
    return `/api/transitions/${transitionId}/documents/${documentId}/profile/schema`;
};
/**
 * @summary Get Transition Document Profile Schema
 */
export const getTransitionDocumentProfileSchemaApiTransitionsTransitionIdDocumentsDocumentIdProfileSchemaGet = async ({ transitionId, documentId }, options) => {
    return customFetch(getGetTransitionDocumentProfileSchemaApiTransitionsTransitionIdDocumentsDocumentIdProfileSchemaGetUrl({ transitionId, documentId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetTransitionDocumentProfileSchemasApiTransitionsSchemasDocumentProfilesGetUrl = () => {
    return `/api/transitions/schemas/document-profiles`;
};
/**
 * @summary Get Transition Document Profile Schemas
 */
export const getTransitionDocumentProfileSchemasApiTransitionsSchemasDocumentProfilesGet = async (options) => {
    return customFetch(getGetTransitionDocumentProfileSchemasApiTransitionsSchemasDocumentProfilesGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetTransitionDocumentProfileSchemaByTypeApiTransitionsSchemasDocumentProfilesProfileTypeGetUrl = ({ profileType }) => {
    return `/api/transitions/schemas/document-profiles/${profileType}`;
};
/**
 * @summary Get Transition Document Profile Schema By Type
 */
export const getTransitionDocumentProfileSchemaByTypeApiTransitionsSchemasDocumentProfilesProfileTypeGet = async ({ profileType }, options) => {
    return customFetch(getGetTransitionDocumentProfileSchemaByTypeApiTransitionsSchemasDocumentProfilesProfileTypeGetUrl({ profileType }), {
        ...options,
        method: 'GET'
    });
};
export const getTransitionDocumentUploadMetadataSchemaApiTransitionsSchemasDocumentUploadMetadataGetUrl = () => {
    return `/api/transitions/schemas/document-upload-metadata`;
};
/**
 * Example shape of the JSON object sent in the `transition_document` multipart field for POST /transitions/{transition_id}/documents. Use that POST endpoint to upload files.
 * @summary Reference: transition document upload metadata
 */
export const transitionDocumentUploadMetadataSchemaApiTransitionsSchemasDocumentUploadMetadataGet = async (options) => {
    return customFetch(getTransitionDocumentUploadMetadataSchemaApiTransitionsSchemasDocumentUploadMetadataGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getCreateTransitionDocumentApiTransitionsTransitionIdDocumentsPostUrl = ({ transitionId }) => {
    return `/api/transitions/${transitionId}/documents`;
};
/**
 * @summary Create Transition Document
 */
export const createTransitionDocumentApiTransitionsTransitionIdDocumentsPost = async ({ transitionId }, bodyCreateTransitionDocumentApiTransitionsTransitionIdDocumentsPost, options) => {
    const formData = new FormData();
    formData.append(`transition_document`, bodyCreateTransitionDocumentApiTransitionsTransitionIdDocumentsPost.transition_document);
    formData.append(`file`, bodyCreateTransitionDocumentApiTransitionsTransitionIdDocumentsPost.file);
    return customFetch(getCreateTransitionDocumentApiTransitionsTransitionIdDocumentsPostUrl({ transitionId }), {
        ...options,
        method: 'POST',
        body: formData
    });
};
export const getRegisterTransitionZipMultipartUploadApiTransitionsTransitionIdDocumentImportsUploadPutUrl = ({ transitionId }) => {
    return `/api/transitions/${transitionId}/document_imports/upload`;
};
/**
 * Register a multi-part S3 upload for a transition zip import.
 * @summary Register Transition Zip Multipart Upload
 */
export const registerTransitionZipMultipartUploadApiTransitionsTransitionIdDocumentImportsUploadPut = async ({ transitionId }, multiPartS3Upload, options) => {
    return customFetch(getRegisterTransitionZipMultipartUploadApiTransitionsTransitionIdDocumentImportsUploadPutUrl({ transitionId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(multiPartS3Upload)
    });
};
export const getFinalizeTransitionZipMultipartUploadApiTransitionsTransitionIdDocumentImportsUploadPostUrl = ({ transitionId }) => {
    return `/api/transitions/${transitionId}/document_imports/upload`;
};
/**
 * Finalize a multi-part S3 upload and log the transition zip file upload.
 * @summary Finalize Transition Zip Multipart Upload
 */
export const finalizeTransitionZipMultipartUploadApiTransitionsTransitionIdDocumentImportsUploadPost = async ({ transitionId }, multiPartS3Upload, options) => {
    return customFetch(getFinalizeTransitionZipMultipartUploadApiTransitionsTransitionIdDocumentImportsUploadPostUrl({ transitionId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(multiPartS3Upload)
    });
};
export const getListTransitionFileUploadStatusesApiTransitionsTransitionIdFileUploadsGetUrl = ({ transitionId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["status"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/transitions/${transitionId}/file-uploads?${stringifiedParams}` : `/api/transitions/${transitionId}/file-uploads`;
};
/**
 * @summary List Transition File Upload Statuses
 */
export const listTransitionFileUploadStatusesApiTransitionsTransitionIdFileUploadsGet = async ({ transitionId }, params, options) => {
    return customFetch(getListTransitionFileUploadStatusesApiTransitionsTransitionIdFileUploadsGetUrl({ transitionId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetTransitionFileUploadStatusApiTransitionsTransitionIdFileUploadsFileUploadIdGetUrl = ({ transitionId, fileUploadId }) => {
    return `/api/transitions/${transitionId}/file-uploads/${fileUploadId}`;
};
/**
 * @summary Get Transition File Upload Status
 */
export const getTransitionFileUploadStatusApiTransitionsTransitionIdFileUploadsFileUploadIdGet = async ({ transitionId, fileUploadId }, options) => {
    return customFetch(getGetTransitionFileUploadStatusApiTransitionsTransitionIdFileUploadsFileUploadIdGetUrl({ transitionId, fileUploadId }), {
        ...options,
        method: 'GET'
    });
};
export const getAddDocumentTaskNoteApiTransitionsTransitionIdDocumentTasksTaskIdNotesPostUrl = ({ transitionId, taskId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/transitions/${transitionId}/document-tasks/${taskId}/notes?${stringifiedParams}` : `/api/transitions/${transitionId}/document-tasks/${taskId}/notes`;
};
/**
 * @summary Add Document Task Note
 */
export const addDocumentTaskNoteApiTransitionsTransitionIdDocumentTasksTaskIdNotesPost = async ({ transitionId, taskId }, params, options) => {
    return customFetch(getAddDocumentTaskNoteApiTransitionsTransitionIdDocumentTasksTaskIdNotesPostUrl({ transitionId, taskId }, params), {
        ...options,
        method: 'POST'
    });
};
export const getUpdateDocumentTaskNoteApiTransitionsTransitionIdDocumentTasksTaskIdNotesNoteIdPutUrl = ({ transitionId, taskId, noteId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/transitions/${transitionId}/document-tasks/${taskId}/notes/${noteId}?${stringifiedParams}` : `/api/transitions/${transitionId}/document-tasks/${taskId}/notes/${noteId}`;
};
/**
 * @summary Update Document Task Note
 */
export const updateDocumentTaskNoteApiTransitionsTransitionIdDocumentTasksTaskIdNotesNoteIdPut = async ({ transitionId, taskId, noteId }, params, options) => {
    return customFetch(getUpdateDocumentTaskNoteApiTransitionsTransitionIdDocumentTasksTaskIdNotesNoteIdPutUrl({ transitionId, taskId, noteId }, params), {
        ...options,
        method: 'PUT'
    });
};
export const getDeleteDocumentTaskNoteApiTransitionsTransitionIdDocumentTasksTaskIdNotesNoteIdDeleteUrl = ({ transitionId, taskId, noteId }) => {
    return `/api/transitions/${transitionId}/document-tasks/${taskId}/notes/${noteId}`;
};
/**
 * @summary Delete Document Task Note
 */
export const deleteDocumentTaskNoteApiTransitionsTransitionIdDocumentTasksTaskIdNotesNoteIdDelete = async ({ transitionId, taskId, noteId }, options) => {
    return customFetch(getDeleteDocumentTaskNoteApiTransitionsTransitionIdDocumentTasksTaskIdNotesNoteIdDeleteUrl({ transitionId, taskId, noteId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getGenerateDocumentTaskRuleDefinitionApiTransitionsTransitionIdDocumentTasksTaskIdRuleDefinitionPostUrl = ({ transitionId, taskId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/transitions/${transitionId}/document-tasks/${taskId}/rule-definition?${stringifiedParams}` : `/api/transitions/${transitionId}/document-tasks/${taskId}/rule-definition`;
};
/**
 * @summary Generate Document Task Rule Definition
 */
export const generateDocumentTaskRuleDefinitionApiTransitionsTransitionIdDocumentTasksTaskIdRuleDefinitionPost = async ({ transitionId, taskId }, params, options) => {
    return customFetch(getGenerateDocumentTaskRuleDefinitionApiTransitionsTransitionIdDocumentTasksTaskIdRuleDefinitionPostUrl({ transitionId, taskId }, params), {
        ...options,
        method: 'POST'
    });
};
export const getCreateDocumentRequestApiTransitionsTransitionIdDocumentRequestsPostUrl = ({ transitionId }) => {
    return `/api/transitions/${transitionId}/document-requests`;
};
/**
 * @summary Create Document Request
 */
export const createDocumentRequestApiTransitionsTransitionIdDocumentRequestsPost = async ({ transitionId }, documentRequest, options) => {
    return customFetch(getCreateDocumentRequestApiTransitionsTransitionIdDocumentRequestsPostUrl({ transitionId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(documentRequest)
    });
};
export const getGetTransitionDocumentCollectionsApiTransitionsTransitionIdDocumentCollectionsGetUrl = ({ transitionId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/transitions/${transitionId}/document-collections?${stringifiedParams}` : `/api/transitions/${transitionId}/document-collections`;
};
/**
 * @summary Get Transition Document Collections
 */
export const getTransitionDocumentCollectionsApiTransitionsTransitionIdDocumentCollectionsGet = async ({ transitionId }, params, options) => {
    return customFetch(getGetTransitionDocumentCollectionsApiTransitionsTransitionIdDocumentCollectionsGetUrl({ transitionId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getCreateDocumentCollectionApiTransitionsTransitionIdDocumentCollectionsPostUrl = ({ transitionId }) => {
    return `/api/transitions/${transitionId}/document-collections`;
};
/**
 * @summary Create Document Collection
 */
export const createDocumentCollectionApiTransitionsTransitionIdDocumentCollectionsPost = async ({ transitionId }, documentCollection, options) => {
    return customFetch(getCreateDocumentCollectionApiTransitionsTransitionIdDocumentCollectionsPostUrl({ transitionId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(documentCollection)
    });
};
export const getUpdateDocumentCollectionApiDocumentCollectionsCollectionIdPutUrl = ({ collectionId }) => {
    return `/api/document-collections/${collectionId}`;
};
/**
 * @summary Update Document Collection
 */
export const updateDocumentCollectionApiDocumentCollectionsCollectionIdPut = async ({ collectionId }, documentCollection, options) => {
    return customFetch(getUpdateDocumentCollectionApiDocumentCollectionsCollectionIdPutUrl({ collectionId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(documentCollection)
    });
};
export const getAddTeamToDocumentCollectionApiDocumentCollectionsCollectionIdTeamsPostUrl = ({ collectionId }) => {
    return `/api/document-collections/${collectionId}/teams`;
};
/**
 * @summary Add Team To Document Collection
 */
export const addTeamToDocumentCollectionApiDocumentCollectionsCollectionIdTeamsPost = async ({ collectionId }, companyAndTeam, options) => {
    return customFetch(getAddTeamToDocumentCollectionApiDocumentCollectionsCollectionIdTeamsPostUrl({ collectionId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(companyAndTeam)
    });
};
export const getResolveTransitionsGuestUserApiTransitionsGuestUsersResolvePostUrl = () => {
    return `/api/transitions/guest-users/resolve`;
};
/**
 * @summary Resolve Transitions Guest User
 */
export const resolveTransitionsGuestUserApiTransitionsGuestUsersResolvePost = async (resolveTransitionsGuestUserRequest, options) => {
    return customFetch(getResolveTransitionsGuestUserApiTransitionsGuestUsersResolvePostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(resolveTransitionsGuestUserRequest)
    });
};
export const getGetTransitionsUsersSummariesApiTransitionsUsersSummariesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["user_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/transitions/users/summaries?${stringifiedParams}` : `/api/transitions/users/summaries`;
};
/**
 * Transitions-scoped mirror of ``/api/usersummaries`` used by the
 * transitions UI (collection editor's ad-hoc user grid, etc.). Returns
 * only the fields transitions surfaces render, with ``roles`` filtered
 * to transition-relevant role keys so guests never see unrelated role
 * names from other domains.
 * @summary Get Transitions Users Summaries
 */
export const getTransitionsUsersSummariesApiTransitionsUsersSummariesGet = async (params, options) => {
    return customFetch(getGetTransitionsUsersSummariesApiTransitionsUsersSummariesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getListTransitionAgentConversationsApiTransitionsTransitionIdAgentConversationsGetUrl = ({ transitionId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/transitions/${transitionId}/agent-conversations?${stringifiedParams}` : `/api/transitions/${transitionId}/agent-conversations`;
};
/**
 * @summary List Transition Agent Conversations
 */
export const listTransitionAgentConversationsApiTransitionsTransitionIdAgentConversationsGet = async ({ transitionId }, params, options) => {
    return customFetch(getListTransitionAgentConversationsApiTransitionsTransitionIdAgentConversationsGetUrl({ transitionId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetTransitionAgentConversationApiTransitionsTransitionIdAgentConversationsConversationIdGetUrl = ({ transitionId, conversationId }) => {
    return `/api/transitions/${transitionId}/agent-conversations/${conversationId}`;
};
/**
 * @summary Get Transition Agent Conversation
 */
export const getTransitionAgentConversationApiTransitionsTransitionIdAgentConversationsConversationIdGet = async ({ transitionId, conversationId }, options) => {
    return customFetch(getGetTransitionAgentConversationApiTransitionsTransitionIdAgentConversationsConversationIdGetUrl({ transitionId, conversationId }), {
        ...options,
        method: 'GET'
    });
};
export const getDeleteTransitionAgentConversationApiTransitionsTransitionIdAgentConversationsConversationIdDeleteUrl = ({ transitionId, conversationId }) => {
    return `/api/transitions/${transitionId}/agent-conversations/${conversationId}`;
};
/**
 * Soft-delete one agent conversation and cascade to its messages/notes.
 *
 * The service call updates `email_conversation`, every
 * `email_message` under it, and every `email_conversation_note`
 * under it in one transaction. After the delete, the conversation
 * stops appearing in `GET .../agent-conversations` /
 * `.../agent-conversations/{conversation_id}` and its messages
 * stop appearing in every other communications read (all reads
 * filter `deleted_at IS NULL`).
 *
 * `deleted_by` is populated from the caller's `UserSession.id`;
 * when this endpoint runs under a session with no `id` (should
 * never happen in practice because the FastAPI dependency
 * materializes a real user), the fallback is to leave
 * `deleted_by` NULL and stamp only `deleted_at`.
 * @summary Delete Transition Agent Conversation
 */
export const deleteTransitionAgentConversationApiTransitionsTransitionIdAgentConversationsConversationIdDelete = async ({ transitionId, conversationId }, options) => {
    return customFetch(getDeleteTransitionAgentConversationApiTransitionsTransitionIdAgentConversationsConversationIdDeleteUrl({ transitionId, conversationId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getDeleteTransitionAgentMessageApiTransitionsTransitionIdAgentConversationsConversationIdMessagesSurfaceMessageIdDeleteUrl = ({ transitionId, conversationId, surfaceMessageId }) => {
    return `/api/transitions/${transitionId}/agent-conversations/${conversationId}/messages/${surfaceMessageId}`;
};
/**
 * Soft-delete one message inside an agent conversation.
 *
 * The transition-ownership gate is identical to the conversation
 * delete: we resolve the conversation, verify it belongs to an
 * agentic doc request on this transition, THEN verify the message
 * actually lives on that conversation before soft-deleting it.
 * The message-on-conversation check keeps this endpoint from
 * being used as an "arbitrary message id -> deleted" proxy given
 * only path access to a valid conversation on the transition.
 * @summary Delete Transition Agent Message
 */
export const deleteTransitionAgentMessageApiTransitionsTransitionIdAgentConversationsConversationIdMessagesSurfaceMessageIdDelete = async ({ transitionId, conversationId, surfaceMessageId }, options) => {
    return customFetch(getDeleteTransitionAgentMessageApiTransitionsTransitionIdAgentConversationsConversationIdMessagesSurfaceMessageIdDeleteUrl({ transitionId, conversationId, surfaceMessageId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getListAgentsApiAgentsGetUrl = () => {
    return `/api/agents`;
};
/**
 * @summary List Agents
 */
export const listAgentsApiAgentsGet = async (options) => {
    return customFetch(getListAgentsApiAgentsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getCreateConversationApiAgentsAgentKeyConversationsPostUrl = ({ agentKey }) => {
    return `/api/agents/${agentKey}/conversations`;
};
/**
 * @summary Create Conversation
 */
export const createConversationApiAgentsAgentKeyConversationsPost = async ({ agentKey }, createConversationRequest, options) => {
    return customFetch(getCreateConversationApiAgentsAgentKeyConversationsPostUrl({ agentKey }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(createConversationRequest)
    });
};
export const getListConversationsApiAgentsAgentKeyConversationsGetUrl = ({ agentKey }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/agents/${agentKey}/conversations?${stringifiedParams}` : `/api/agents/${agentKey}/conversations`;
};
/**
 * @summary List Conversations
 */
export const listConversationsApiAgentsAgentKeyConversationsGet = async ({ agentKey }, params, options) => {
    return customFetch(getListConversationsApiAgentsAgentKeyConversationsGetUrl({ agentKey }, params), {
        ...options,
        method: 'GET'
    });
};
export const getSendMessageApiAgentsAgentKeyConversationsConversationIdMessagesPostUrl = ({ agentKey, conversationId }) => {
    return `/api/agents/${agentKey}/conversations/${conversationId}/messages`;
};
/**
 * @summary Send Message
 */
export const sendMessageApiAgentsAgentKeyConversationsConversationIdMessagesPost = async ({ agentKey, conversationId }, sendMessageRequest, options) => {
    return customFetch(getSendMessageApiAgentsAgentKeyConversationsConversationIdMessagesPostUrl({ agentKey, conversationId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(sendMessageRequest)
    });
};
export const getInterruptApiAgentsAgentKeyConversationsConversationIdInterruptPostUrl = ({ agentKey, conversationId }) => {
    return `/api/agents/${agentKey}/conversations/${conversationId}/interrupt`;
};
/**
 * @summary Interrupt
 */
export const interruptApiAgentsAgentKeyConversationsConversationIdInterruptPost = async ({ agentKey, conversationId }, options) => {
    return customFetch(getInterruptApiAgentsAgentKeyConversationsConversationIdInterruptPostUrl({ agentKey, conversationId }), {
        ...options,
        method: 'POST'
    });
};
export const getHistoryApiAgentsAgentKeyConversationsConversationIdHistoryGetUrl = ({ agentKey, conversationId }) => {
    return `/api/agents/${agentKey}/conversations/${conversationId}/history`;
};
/**
 * @summary History
 */
export const historyApiAgentsAgentKeyConversationsConversationIdHistoryGet = async ({ agentKey, conversationId }, options) => {
    return customFetch(getHistoryApiAgentsAgentKeyConversationsConversationIdHistoryGetUrl({ agentKey, conversationId }), {
        ...options,
        method: 'GET'
    });
};
export const getEventsApiAgentsAgentKeyConversationsConversationIdEventsGetUrl = ({ agentKey, conversationId }) => {
    return `/api/agents/${agentKey}/conversations/${conversationId}/events`;
};
/**
 * @summary Events
 */
export const eventsApiAgentsAgentKeyConversationsConversationIdEventsGet = async ({ agentKey, conversationId }, options) => {
    return customFetch(getEventsApiAgentsAgentKeyConversationsConversationIdEventsGetUrl({ agentKey, conversationId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetDocumentImportsApiPropertiesPropertyIdDocumentImportsGetUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/document_imports`;
};
/**
 * Get all document imports for a property
 * @summary Get Document Imports
 */
export const getDocumentImportsApiPropertiesPropertyIdDocumentImportsGet = async ({ propertyId }, options) => {
    return customFetch(getGetDocumentImportsApiPropertiesPropertyIdDocumentImportsGetUrl({ propertyId }), {
        ...options,
        method: 'GET'
    });
};
export const getDeleteDocumentImportApiPropertiesPropertyIdDocumentImportsFileNameDeleteUrl = ({ propertyId, fileName }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/document_imports/${fileName}?${stringifiedParams}` : `/api/properties/${propertyId}/document_imports/${fileName}`;
};
/**
 * Delete a document import
 * @summary Delete Document Import
 */
export const deleteDocumentImportApiPropertiesPropertyIdDocumentImportsFileNameDelete = async ({ propertyId, fileName }, params, options) => {
    return customFetch(getDeleteDocumentImportApiPropertiesPropertyIdDocumentImportsFileNameDeleteUrl({ propertyId, fileName }, params), {
        ...options,
        method: 'DELETE'
    });
};
export const getDeleteLeaseDocumentZipFileApiPropertiesPropertyIdLeaseDocumentsFileNameDeleteUrl = ({ propertyId, fileName }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/lease_documents/${fileName}?${stringifiedParams}` : `/api/properties/${propertyId}/lease_documents/${fileName}`;
};
/**
 * Delete a document import
 * @summary Delete Document Import
 */
export const deleteLeaseDocumentZipFileApiPropertiesPropertyIdLeaseDocumentsFileNameDelete = async ({ propertyId, fileName }, params, options) => {
    return customFetch(getDeleteLeaseDocumentZipFileApiPropertiesPropertyIdLeaseDocumentsFileNameDeleteUrl({ propertyId, fileName }, params), {
        ...options,
        method: 'DELETE'
    });
};
export const getIngestLeaseDocumentsApiPropertiesPropertyIdIngestLeaseDocumentsPostUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/ingest_lease_documents`;
};
/**
 * @summary Ingest Lease Documents
 */
export const ingestLeaseDocumentsApiPropertiesPropertyIdIngestLeaseDocumentsPost = async ({ propertyId }, ingestLeaseDocumentsRequest, options) => {
    return customFetch(getIngestLeaseDocumentsApiPropertiesPropertyIdIngestLeaseDocumentsPostUrl({ propertyId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(ingestLeaseDocumentsRequest)
    });
};
export const getMatchLeaseDocumentsApiPropertiesPropertyIdMatchLeaseDocumentsPostUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/match_lease_documents`;
};
/**
 * @summary Match Lease Documents
 */
export const matchLeaseDocumentsApiPropertiesPropertyIdMatchLeaseDocumentsPost = async ({ propertyId }, options) => {
    return customFetch(getMatchLeaseDocumentsApiPropertiesPropertyIdMatchLeaseDocumentsPostUrl({ propertyId }), {
        ...options,
        method: 'POST'
    });
};
export const getMatchLeaseDocumentsFromProfilesApiPropertiesPropertyIdMatchLeaseDocumentsFromProfilesPostUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/match_lease_documents_from_profiles`;
};
/**
 * @summary Match Lease Documents From Profiles
 */
export const matchLeaseDocumentsFromProfilesApiPropertiesPropertyIdMatchLeaseDocumentsFromProfilesPost = async ({ propertyId }, options) => {
    return customFetch(getMatchLeaseDocumentsFromProfilesApiPropertiesPropertyIdMatchLeaseDocumentsFromProfilesPostUrl({ propertyId }), {
        ...options,
        method: 'POST'
    });
};
export const getProfileDocumentsApiPropertiesPropertyIdProfileDocumentsPostUrl = ({ propertyId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["classifications"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/profile_documents?${stringifiedParams}` : `/api/properties/${propertyId}/profile_documents`;
};
/**
 * @summary Profile Documents
 */
export const profileDocumentsApiPropertiesPropertyIdProfileDocumentsPost = async ({ propertyId }, params, options) => {
    return customFetch(getProfileDocumentsApiPropertiesPropertyIdProfileDocumentsPostUrl({ propertyId }, params), {
        ...options,
        method: 'POST'
    });
};
export const getReprofileDocumentsApiPropertiesPropertyIdReprofileDocumentsPostUrl = ({ propertyId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["profile_types", "lease_stages"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/reprofile_documents?${stringifiedParams}` : `/api/properties/${propertyId}/reprofile_documents`;
};
/**
 * @summary Reprofile Documents
 */
export const reprofileDocumentsApiPropertiesPropertyIdReprofileDocumentsPost = async ({ propertyId }, params, options) => {
    return customFetch(getReprofileDocumentsApiPropertiesPropertyIdReprofileDocumentsPostUrl({ propertyId }, params), {
        ...options,
        method: 'POST'
    });
};
export const getPublishReconciledLeaseDocumentDataApiPropertiesPropertyIdPublishReconciledLeaseDocumentDataPostUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/publish_reconciled_lease_document_data`;
};
/**
 * @summary Publish Reconciled Lease Document Data
 */
export const publishReconciledLeaseDocumentDataApiPropertiesPropertyIdPublishReconciledLeaseDocumentDataPost = async ({ propertyId }, options) => {
    return customFetch(getPublishReconciledLeaseDocumentDataApiPropertiesPropertyIdPublishReconciledLeaseDocumentDataPostUrl({ propertyId }), {
        ...options,
        method: 'POST'
    });
};
export const getCreateManualLeasePacketApiPropertiesPropertyIdCreateManualLeasePacketPostUrl = ({ propertyId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/create_manual_lease_packet?${stringifiedParams}` : `/api/properties/${propertyId}/create_manual_lease_packet`;
};
/**
 * @summary Create Manual Lease Packet
 */
export const createManualLeasePacketApiPropertiesPropertyIdCreateManualLeasePacketPost = async ({ propertyId }, params, options) => {
    return customFetch(getCreateManualLeasePacketApiPropertiesPropertyIdCreateManualLeasePacketPostUrl({ propertyId }, params), {
        ...options,
        method: 'POST'
    });
};
export const getReindexDocumentsApiDocumentsReindexPostUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids", "classifications"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/documents/reindex?${stringifiedParams}` : `/api/documents/reindex`;
};
/**
 * @summary Reindex Documents
 */
export const reindexDocumentsApiDocumentsReindexPost = async (params, options) => {
    return customFetch(getReindexDocumentsApiDocumentsReindexPostUrl(params), {
        ...options,
        method: 'POST'
    });
};
export const getRegisterMultiPartS3UploadApiPropertiesPropertyIdDocumentImportsUploadPutUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/document_imports/upload`;
};
/**
 * Register a multi-part S3 upload for document import
 * @summary Register Multi Part S3 Upload
 */
export const registerMultiPartS3UploadApiPropertiesPropertyIdDocumentImportsUploadPut = async ({ propertyId }, multiPartS3Upload, options) => {
    return customFetch(getRegisterMultiPartS3UploadApiPropertiesPropertyIdDocumentImportsUploadPutUrl({ propertyId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(multiPartS3Upload)
    });
};
export const getFinalizeMultiPartS3UploadApiPropertiesPropertyIdDocumentImportsUploadPostUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/document_imports/upload`;
};
/**
 * Finalize a multi-part S3 upload for document import
 * @summary Finalize Multi Part S3 Upload
 */
export const finalizeMultiPartS3UploadApiPropertiesPropertyIdDocumentImportsUploadPost = async ({ propertyId }, multiPartS3Upload, options) => {
    return customFetch(getFinalizeMultiPartS3UploadApiPropertiesPropertyIdDocumentImportsUploadPostUrl({ propertyId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(multiPartS3Upload)
    });
};
export const getRegisterMultiPartS3UploadApiPropertiesPropertyIdMultiPartS3UploadPutUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/multi_part_s3_upload`;
};
/**
 * Register a multi-part S3 upload for document import
 * @summary Register Multi Part S3 Upload
 */
export const registerMultiPartS3UploadApiPropertiesPropertyIdMultiPartS3UploadPut = async ({ propertyId }, multiPartS3Upload, options) => {
    return customFetch(getRegisterMultiPartS3UploadApiPropertiesPropertyIdMultiPartS3UploadPutUrl({ propertyId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(multiPartS3Upload)
    });
};
export const getFinalizeMultiPartS3UploadApiPropertiesPropertyIdMultiPartS3UploadPostUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/multi_part_s3_upload`;
};
/**
 * Finalize a multi-part S3 upload for document import
 * @summary Finalize Multi Part S3 Upload
 */
export const finalizeMultiPartS3UploadApiPropertiesPropertyIdMultiPartS3UploadPost = async ({ propertyId }, multiPartS3Upload, options) => {
    return customFetch(getFinalizeMultiPartS3UploadApiPropertiesPropertyIdMultiPartS3UploadPostUrl({ propertyId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(multiPartS3Upload)
    });
};
export const getCreateLeaseMigrationApiPropertiesPropertyIdLeaseMigrationsPostUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/lease-migrations`;
};
/**
 * Creates a new lease migration for a property
 * @summary Create Lease Migration
 */
export const createLeaseMigrationApiPropertiesPropertyIdLeaseMigrationsPost = async ({ propertyId }, leaseMigrationCreationRequest, options) => {
    return customFetch(getCreateLeaseMigrationApiPropertiesPropertyIdLeaseMigrationsPostUrl({ propertyId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(leaseMigrationCreationRequest)
    });
};
export const getGetLeaseMigrationsApiPropertiesLeaseMigrationsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/lease-migrations?${stringifiedParams}` : `/api/properties/lease-migrations`;
};
/**
 * Gets paginated lease migrations for all properties with optional filtering
 * @summary Get Lease Migrations
 */
export const getLeaseMigrationsApiPropertiesLeaseMigrationsGet = async (params, options) => {
    return customFetch(getGetLeaseMigrationsApiPropertiesLeaseMigrationsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseMigrationApiPropertiesPropertyIdLeaseMigrationsMigrationIdGetUrl = ({ propertyId, migrationId }) => {
    return `/api/properties/${propertyId}/lease-migrations/${migrationId}`;
};
/**
 * Gets a lease migration by property ID and migration ID
 * @summary Get Lease Migration
 */
export const getLeaseMigrationApiPropertiesPropertyIdLeaseMigrationsMigrationIdGet = async ({ propertyId, migrationId }, options) => {
    return customFetch(getGetLeaseMigrationApiPropertiesPropertyIdLeaseMigrationsMigrationIdGetUrl({ propertyId, migrationId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseMigrationMetricsApiPropertiesPropertyIdLeaseMigrationsMigrationIdMetricsGetUrl = ({ propertyId, migrationId }) => {
    return `/api/properties/${propertyId}/lease-migrations/${migrationId}/metrics`;
};
/**
 * Gets metrics for a lease migration
 * @summary Get Lease Migration Metrics
 */
export const getLeaseMigrationMetricsApiPropertiesPropertyIdLeaseMigrationsMigrationIdMetricsGet = async ({ propertyId, migrationId }, options) => {
    return customFetch(getGetLeaseMigrationMetricsApiPropertiesPropertyIdLeaseMigrationsMigrationIdMetricsGetUrl({ propertyId, migrationId }), {
        ...options,
        method: 'GET'
    });
};
export const getProcessLeaseMigrationApiPropertiesPropertyIdLeaseMigrationsMigrationIdProcessPostUrl = ({ propertyId, migrationId }) => {
    return `/api/properties/${propertyId}/lease-migrations/${migrationId}/process`;
};
/**
 * Starts processing a lease migration pipeline for the specified lease migration
 * @summary Process Lease Migration
 */
export const processLeaseMigrationApiPropertiesPropertyIdLeaseMigrationsMigrationIdProcessPost = async ({ propertyId, migrationId }, leaseMigrationProcessRequest, options) => {
    return customFetch(getProcessLeaseMigrationApiPropertiesPropertyIdLeaseMigrationsMigrationIdProcessPostUrl({ propertyId, migrationId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(leaseMigrationProcessRequest)
    });
};
export const getPublishLeaseMigrationApiPropertiesPropertyIdLeaseMigrationsMigrationIdPublishPostUrl = ({ propertyId, migrationId }) => {
    return `/api/properties/${propertyId}/lease-migrations/${migrationId}/publish`;
};
/**
 * Publishes a lease migration
 * @summary Publish Lease Migration
 */
export const publishLeaseMigrationApiPropertiesPropertyIdLeaseMigrationsMigrationIdPublishPost = async ({ propertyId, migrationId }, options) => {
    return customFetch(getPublishLeaseMigrationApiPropertiesPropertyIdLeaseMigrationsMigrationIdPublishPostUrl({ propertyId, migrationId }), {
        ...options,
        method: 'POST'
    });
};
export const getRetryLeaseMigrationApiPropertiesPropertyIdLeaseMigrationsMigrationIdRetryPostUrl = ({ propertyId, migrationId }) => {
    return `/api/properties/${propertyId}/lease-migrations/${migrationId}/retry`;
};
/**
 * Retries a completed lease migration by rerunning from the MigrationStep
 * @summary Retry Lease Migration
 */
export const retryLeaseMigrationApiPropertiesPropertyIdLeaseMigrationsMigrationIdRetryPost = async ({ propertyId, migrationId }, options) => {
    return customFetch(getRetryLeaseMigrationApiPropertiesPropertyIdLeaseMigrationsMigrationIdRetryPostUrl({ propertyId, migrationId }), {
        ...options,
        method: 'POST'
    });
};
export const getGetLeaseMigrationDocumentsApiPropertiesPropertyIdLeaseMigrationsMigrationIdDocumentsGetUrl = ({ propertyId, migrationId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/lease-migrations/${migrationId}/documents?${stringifiedParams}` : `/api/properties/${propertyId}/lease-migrations/${migrationId}/documents`;
};
/**
 * Gets paginated lease migration documents for a specific migration with optional filtering
 * @summary Get Lease Migration Documents
 */
export const getLeaseMigrationDocumentsApiPropertiesPropertyIdLeaseMigrationsMigrationIdDocumentsGet = async ({ propertyId, migrationId }, params, options) => {
    return customFetch(getGetLeaseMigrationDocumentsApiPropertiesPropertyIdLeaseMigrationsMigrationIdDocumentsGetUrl({ propertyId, migrationId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseMigrationReportApiPropertiesPropertyIdLeaseMigrationsMigrationIdReportGetUrl = ({ propertyId, migrationId }) => {
    return `/api/properties/${propertyId}/lease-migrations/${migrationId}/report`;
};
/**
 * Queues an async export job for the migration report. Returns job_id and is_duplicate. User receives in-app notification when ready.
 * @summary Get Lease Migration Report
 */
export const getLeaseMigrationReportApiPropertiesPropertyIdLeaseMigrationsMigrationIdReportGet = async ({ propertyId, migrationId }, options) => {
    return customFetch(getGetLeaseMigrationReportApiPropertiesPropertyIdLeaseMigrationsMigrationIdReportGetUrl({ propertyId, migrationId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetPropertyDigestApiPropertiesDigestGetUrl = () => {
    return `/api/properties/digest`;
};
/**
 * @summary Get Property Digest
 */
export const getPropertyDigestApiPropertiesDigestGet = async (options) => {
    return customFetch(getGetPropertyDigestApiPropertiesDigestGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateUserPropertyEnabledDateApiPropertiesPropertyIdEnabledDatePutUrl = ({ propertyId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/enabled_date?${stringifiedParams}` : `/api/properties/${propertyId}/enabled_date`;
};
/**
 * @summary Update User Property Enabled Date
 */
export const updateUserPropertyEnabledDateApiPropertiesPropertyIdEnabledDatePut = async ({ propertyId }, params, options) => {
    return customFetch(getUpdateUserPropertyEnabledDateApiPropertiesPropertyIdEnabledDatePutUrl({ propertyId }, params), {
        ...options,
        method: 'PUT'
    });
};
export const getUpdatePropertyRolloutMonthApiPropertiesPropertyIdRolloutMonthPutUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/rollout_month`;
};
/**
 * @summary Update Property Rollout Month
 */
export const updatePropertyRolloutMonthApiPropertiesPropertyIdRolloutMonthPut = async ({ propertyId }, propertyRolloutMonthUpdate, options) => {
    return customFetch(getUpdatePropertyRolloutMonthApiPropertiesPropertyIdRolloutMonthPutUrl({ propertyId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(propertyRolloutMonthUpdate)
    });
};
export const getUpdatePropertyUnitCountApiPropertiesPropertyIdUnitCountPutUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/unit_count`;
};
/**
 * @summary Update Property Unit Count
 */
export const updatePropertyUnitCountApiPropertiesPropertyIdUnitCountPut = async ({ propertyId }, propertyUnitCountUpdate, options) => {
    return customFetch(getUpdatePropertyUnitCountApiPropertiesPropertyIdUnitCountPutUrl({ propertyId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(propertyUnitCountUpdate)
    });
};
export const getUpdatePropertyAdminVisibleOnlyApiPropertiesPropertyIdAdminVisibleOnlyPutUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/admin_visible_only`;
};
/**
 * @summary Update Property Admin Visible Only
 */
export const updatePropertyAdminVisibleOnlyApiPropertiesPropertyIdAdminVisibleOnlyPut = async ({ propertyId }, propertyAdminVisibleOnlyUpdate, options) => {
    return customFetch(getUpdatePropertyAdminVisibleOnlyApiPropertiesPropertyIdAdminVisibleOnlyPutUrl({ propertyId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(propertyAdminVisibleOnlyUpdate)
    });
};
export const getMarkPropertyPmsReadyApiPropertiesPropertyIdPmsReadyPostUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/pms-ready`;
};
/**
 * Operator override for PMS catch-up readiness. Sticky, so re-posting an already-ready property is a no-op.
 * @summary Mark Property Pms Ready
 */
export const markPropertyPmsReadyApiPropertiesPropertyIdPmsReadyPost = async ({ propertyId }, options) => {
    return customFetch(getMarkPropertyPmsReadyApiPropertiesPropertyIdPmsReadyPostUrl({ propertyId }), {
        ...options,
        method: 'POST'
    });
};
export const getUpdatePropertyOccupancyTypeApiPropertiesPropertyIdOccupancyTypePutUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/occupancy_type`;
};
/**
 * @summary Update Property Occupancy Type
 */
export const updatePropertyOccupancyTypeApiPropertiesPropertyIdOccupancyTypePut = async ({ propertyId }, updatePropertyOccupancyTypeApiPropertiesPropertyIdOccupancyTypePutBody, options) => {
    return customFetch(getUpdatePropertyOccupancyTypeApiPropertiesPropertyIdOccupancyTypePutUrl({ propertyId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(updatePropertyOccupancyTypeApiPropertiesPropertyIdOccupancyTypePutBody)
    });
};
export const getUpdatePropertyDetailsApiPropertiesPropertyIdDetailsPutUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/details`;
};
/**
 * @summary Update Property Details
 */
export const updatePropertyDetailsApiPropertiesPropertyIdDetailsPut = async ({ propertyId }, propertyDetailsUpdate, options) => {
    return customFetch(getUpdatePropertyDetailsApiPropertiesPropertyIdDetailsPutUrl({ propertyId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(propertyDetailsUpdate)
    });
};
export const getGetPropertyApiPropertiesPropertyIdGetUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}`;
};
/**
 * @summary Get Property
 */
export const getPropertyApiPropertiesPropertyIdGet = async ({ propertyId }, options) => {
    return customFetch(getGetPropertyApiPropertiesPropertyIdGetUrl({ propertyId }), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateExternalPropertiesApiPropertiesPropertyIdExternalPropertiesPutUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/external-properties`;
};
/**
 * Update external properties for a surface property.
 *
 * Note: Only the is_enabled flag can be updated. Other fields are immutable
 * as they are filled in by the external system itself.
 *
 * Args:
 *     property_id: The surface property ID
 *     external_properties: List of external properties to update
 *
 * Returns:
 *     HTTP 204 No Content on success
 *
 * Raises:
 *     HTTP 400: If validation fails
 *     HTTP 404: If property or external property not found
 * @summary Update External Properties
 */
export const updateExternalPropertiesApiPropertiesPropertyIdExternalPropertiesPut = async ({ propertyId }, externalProperty, options) => {
    return customFetch(getUpdateExternalPropertiesApiPropertiesPropertyIdExternalPropertiesPutUrl({ propertyId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(externalProperty)
    });
};
export const getGetManagingTenantApiPropertiesPropertyIdManagingTenantGetUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/managing-tenant`;
};
/**
 * Get the managing tenant for a surface property. Support SurfOps tenant-hopping
 *
 * Args:
 *     property_id: The surface property ID
 *
 * Returns:
 *     HTTP 200 OK with the managing tenant information
 *
 * Raises:
 *     HTTP 404: If property not found
 * @summary Get Managing Tenant
 */
export const getManagingTenantApiPropertiesPropertyIdManagingTenantGet = async ({ propertyId }, options) => {
    return customFetch(getGetManagingTenantApiPropertiesPropertyIdManagingTenantGetUrl({ propertyId }), {
        ...options,
        method: 'GET'
    });
};
export const getCreateLicensedFeatureApiPropertiesPropertyIdLicensedFeaturesPostUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/licensed-features`;
};
/**
 * Creates a new licensed feature for a property.
 *
 * Validations:
 * - License dates cannot overlap with another feature of the same type
 * - If a feature exists with no end date, a new one cannot be created that starts in the future
 * - The existing feature's end date must be updated first
 * @summary Create Licensed Feature
 */
export const createLicensedFeatureApiPropertiesPropertyIdLicensedFeaturesPost = async ({ propertyId }, surfaceCoreApiEntitiesLicensedFeature, options) => {
    return customFetch(getCreateLicensedFeatureApiPropertiesPropertyIdLicensedFeaturesPostUrl({ propertyId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(surfaceCoreApiEntitiesLicensedFeature)
    });
};
export const getGetTenantsApiTenantsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/tenants?${stringifiedParams}` : `/api/tenants`;
};
/**
 * @summary Get Tenants
 */
export const getTenantsApiTenantsGet = async (params, options) => {
    return customFetch(getGetTenantsApiTenantsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getCreateTenantApiTenantsPostUrl = () => {
    return `/api/tenants`;
};
/**
 * @summary Create Tenant
 */
export const createTenantApiTenantsPost = async (surfaceCoreApiEntitiesSaasTenantInput, options) => {
    return customFetch(getCreateTenantApiTenantsPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(surfaceCoreApiEntitiesSaasTenantInput)
    });
};
export const getGetTenantApiTenantsSaasTenantIdGetUrl = ({ saasTenantId }) => {
    return `/api/tenants/${saasTenantId}`;
};
/**
 * @summary Get Tenant
 */
export const getTenantApiTenantsSaasTenantIdGet = async ({ saasTenantId }, options) => {
    return customFetch(getGetTenantApiTenantsSaasTenantIdGetUrl({ saasTenantId }), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateTenantApiTenantsSaasTenantIdPutUrl = ({ saasTenantId }) => {
    return `/api/tenants/${saasTenantId}`;
};
/**
 * @summary Update Tenant
 */
export const updateTenantApiTenantsSaasTenantIdPut = async ({ saasTenantId }, surfaceCoreApiEntitiesSaasTenantInput, options) => {
    return customFetch(getUpdateTenantApiTenantsSaasTenantIdPutUrl({ saasTenantId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(surfaceCoreApiEntitiesSaasTenantInput)
    });
};
export const getCheckTenantHasPropertyDatabaseApiTenantsSaasTenantIdHasPropertyDatabaseGetUrl = ({ saasTenantId }) => {
    return `/api/tenants/${saasTenantId}/has-property-database`;
};
/**
 * Check if the tenant has a property database configured.
 * Returns a boolean indicating if the property database is set up.
 * @summary Check Tenant Has Property Database
 */
export const checkTenantHasPropertyDatabaseApiTenantsSaasTenantIdHasPropertyDatabaseGet = async ({ saasTenantId }, options) => {
    return customFetch(getCheckTenantHasPropertyDatabaseApiTenantsSaasTenantIdHasPropertyDatabaseGetUrl({ saasTenantId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetTenantConfigFilesApiTenantsSaasTenantIdConfigGetUrl = ({ saasTenantId }) => {
    return `/api/tenants/${saasTenantId}/config`;
};
/**
 * Return the raw YAML content of all environment config files for the tenant.
 *
 * Each key in the returned dict is the environment name (e.g. "prod", "stage",
 * "local", "test", "roles") and the value is the verbatim YAML text from the
 * corresponding file under ``config/tenants/{saas_tenant_id}/``.  Files that do
 * not end with ``.yaml`` are silently ignored.  An empty dict is returned when
 * no config directory exists for the tenant.
 * @summary Get Tenant Config Files
 */
export const getTenantConfigFilesApiTenantsSaasTenantIdConfigGet = async ({ saasTenantId }, options) => {
    return customFetch(getGetTenantConfigFilesApiTenantsSaasTenantIdConfigGetUrl({ saasTenantId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetTenantLogoNoCacheApiTenantsSaasTenantIdLogoNoCacheGetUrl = ({ saasTenantId }) => {
    return `/api/tenants/${saasTenantId}/logo-no-cache`;
};
/**
 * @summary Get Tenant Logo No Cache
 */
export const getTenantLogoNoCacheApiTenantsSaasTenantIdLogoNoCacheGet = async ({ saasTenantId }, options) => {
    return customFetch(getGetTenantLogoNoCacheApiTenantsSaasTenantIdLogoNoCacheGetUrl({ saasTenantId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetTenantLogoApiTenantsSaasTenantIdLogoGetUrl = ({ saasTenantId }) => {
    return `/api/tenants/${saasTenantId}/logo`;
};
/**
 * @summary Get Tenant Logo
 */
export const getTenantLogoApiTenantsSaasTenantIdLogoGet = async ({ saasTenantId }, options) => {
    return customFetch(getGetTenantLogoApiTenantsSaasTenantIdLogoGetUrl({ saasTenantId }), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateTenantLogoApiTenantsSaasTenantIdLogoPutUrl = ({ saasTenantId }) => {
    return `/api/tenants/${saasTenantId}/logo`;
};
/**
 * @summary Update Tenant Logo
 */
export const updateTenantLogoApiTenantsSaasTenantIdLogoPut = async ({ saasTenantId }, bodyUpdateTenantLogoApiTenantsSaasTenantIdLogoPut, options) => {
    const formData = new FormData();
    formData.append(`logo_file`, bodyUpdateTenantLogoApiTenantsSaasTenantIdLogoPut.logo_file);
    return customFetch(getUpdateTenantLogoApiTenantsSaasTenantIdLogoPutUrl({ saasTenantId }), {
        ...options,
        method: 'PUT',
        body: formData
    });
};
export const getGetPropertyImageApiPropertiesPropertyIdImageGetUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/image`;
};
/**
 * @summary Get Property Image
 */
export const getPropertyImageApiPropertiesPropertyIdImageGet = async ({ propertyId }, options) => {
    return customFetch(getGetPropertyImageApiPropertiesPropertyIdImageGetUrl({ propertyId }), {
        ...options,
        method: 'GET'
    });
};
export const getDeletePropertyImageApiPropertiesPropertyIdImageDeleteUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/image`;
};
/**
 * @summary Delete Property Image
 */
export const deletePropertyImageApiPropertiesPropertyIdImageDelete = async ({ propertyId }, options) => {
    return customFetch(getDeletePropertyImageApiPropertiesPropertyIdImageDeleteUrl({ propertyId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getUpdatePropertyImageApiPropertiesPropertyIdImagePutUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/image`;
};
/**
 * @summary Update Property Image
 */
export const updatePropertyImageApiPropertiesPropertyIdImagePut = async ({ propertyId }, bodyUpdatePropertyImageApiPropertiesPropertyIdImagePut, options) => {
    const formData = new FormData();
    formData.append(`image_file`, bodyUpdatePropertyImageApiPropertiesPropertyIdImagePut.image_file);
    return customFetch(getUpdatePropertyImageApiPropertiesPropertyIdImagePutUrl({ propertyId }), {
        ...options,
        method: 'PUT',
        body: formData
    });
};
export const getGetPropertyCommentsApiPropertiesPropertyIdCommentsGetUrl = ({ propertyId }) => {
    return `/api/properties/${propertyId}/comments`;
};
/**
 * Get all comments for a property
 * @summary Get Property Comments
 */
export const getPropertyCommentsApiPropertiesPropertyIdCommentsGet = async ({ propertyId }, options) => {
    return customFetch(getGetPropertyCommentsApiPropertiesPropertyIdCommentsGetUrl({ propertyId }), {
        ...options,
        method: 'GET'
    });
};
export const getCreatePropertyCommentApiPropertiesPropertyIdCommentsPostUrl = ({ propertyId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/comments?${stringifiedParams}` : `/api/properties/${propertyId}/comments`;
};
/**
 * Create a new comment on a property
 * @summary Create Property Comment
 */
export const createPropertyCommentApiPropertiesPropertyIdCommentsPost = async ({ propertyId }, params, options) => {
    return customFetch(getCreatePropertyCommentApiPropertiesPropertyIdCommentsPostUrl({ propertyId }, params), {
        ...options,
        method: 'POST'
    });
};
export const getGetAllConfigTypesApiConfigTypesGetUrl = () => {
    return `/api/config-types`;
};
/**
 * Get all available configuration types.
 * @summary Get All Config Types
 */
export const getAllConfigTypesApiConfigTypesGet = async (options) => {
    return customFetch(getGetAllConfigTypesApiConfigTypesGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetConfigTypeSchemaApiConfigTypesConfigTypeGetUrl = ({ configType }) => {
    return `/api/config-types/${configType}`;
};
/**
 * @summary Get Config Type Schema
 */
export const getConfigTypeSchemaApiConfigTypesConfigTypeGet = async ({ configType }, options) => {
    return customFetch(getGetConfigTypeSchemaApiConfigTypesConfigTypeGetUrl({ configType }), {
        ...options,
        method: 'GET'
    });
};
export const getGetAllConfigsApiConfigsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/configs?${stringifiedParams}` : `/api/configs`;
};
/**
 * Get all configuration instances with optional filters and pagination.
 *
 * Args:
 *     property_ids: List of property IDs to filter by
 *     config_type: Configuration type to filter by
 *     branch_name: Branch name to filter by
 *     user_id: User ID to filter by
 *     limit: Maximum number of results to return
 *     offset: Number of results to skip
 *     sort: Sort parameter for ordering results
 *     include_all_versions: If True, includes all historical versions. If False, only current versions.
 * @summary Get All Configs
 */
export const getAllConfigsApiConfigsGet = async (params, options) => {
    return customFetch(getGetAllConfigsApiConfigsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getUpsertPropertyConfigApiPropertiesPropertyIdConfigsConfigTypePostUrl = ({ propertyId, configType }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/configs/${configType}?${stringifiedParams}` : `/api/properties/${propertyId}/configs/${configType}`;
};
/**
 * @summary Upsert Property Config
 */
export const upsertPropertyConfigApiPropertiesPropertyIdConfigsConfigTypePost = async ({ propertyId, configType }, upsertPropertyConfigApiPropertiesPropertyIdConfigsConfigTypePostBody, params, options) => {
    return customFetch(getUpsertPropertyConfigApiPropertiesPropertyIdConfigsConfigTypePostUrl({ propertyId, configType }, params), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(upsertPropertyConfigApiPropertiesPropertyIdConfigsConfigTypePostBody)
    });
};
export const getPatchPropertyConfigApiPropertiesPropertyIdConfigsConfigTypePatchUrl = ({ propertyId, configType }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/configs/${configType}?${stringifiedParams}` : `/api/properties/${propertyId}/configs/${configType}`;
};
/**
 * @summary Patch Property Config
 */
export const patchPropertyConfigApiPropertiesPropertyIdConfigsConfigTypePatch = async ({ propertyId, configType }, patchPropertyConfigApiPropertiesPropertyIdConfigsConfigTypePatchBody, params, options) => {
    return customFetch(getPatchPropertyConfigApiPropertiesPropertyIdConfigsConfigTypePatchUrl({ propertyId, configType }, params), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchPropertyConfigApiPropertiesPropertyIdConfigsConfigTypePatchBody)
    });
};
export const getGetLatestPropertyConfigApiPropertiesPropertyIdConfigsConfigTypeGetUrl = ({ propertyId, configType }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/configs/${configType}?${stringifiedParams}` : `/api/properties/${propertyId}/configs/${configType}`;
};
/**
 * @summary Get Latest Property Config
 */
export const getLatestPropertyConfigApiPropertiesPropertyIdConfigsConfigTypeGet = async ({ propertyId, configType }, params, options) => {
    return customFetch(getGetLatestPropertyConfigApiPropertiesPropertyIdConfigsConfigTypeGetUrl({ propertyId, configType }, params), {
        ...options,
        method: 'GET'
    });
};
export const getValidatePropertyConfigApiPropertiesPropertyIdConfigsConfigTypeValidatePostUrl = ({ propertyId, configType }) => {
    return `/api/properties/${propertyId}/configs/${configType}/validate`;
};
/**
 * Validate a configuration payload without saving it.
 * @summary Validate Property Config
 */
export const validatePropertyConfigApiPropertiesPropertyIdConfigsConfigTypeValidatePost = async ({ propertyId, configType }, validatePropertyConfigApiPropertiesPropertyIdConfigsConfigTypeValidatePostBody, options) => {
    return customFetch(getValidatePropertyConfigApiPropertiesPropertyIdConfigsConfigTypeValidatePostUrl({ propertyId, configType }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(validatePropertyConfigApiPropertiesPropertyIdConfigsConfigTypeValidatePostBody)
    });
};
export const getGetPropertyConfigBranchesApiPropertiesPropertyIdConfigsConfigTypeBranchesGetUrl = ({ propertyId, configType }) => {
    return `/api/properties/${propertyId}/configs/${configType}/branches`;
};
/**
 * @summary Get Property Config Branches
 */
export const getPropertyConfigBranchesApiPropertiesPropertyIdConfigsConfigTypeBranchesGet = async ({ propertyId, configType }, options) => {
    return customFetch(getGetPropertyConfigBranchesApiPropertiesPropertyIdConfigsConfigTypeBranchesGetUrl({ propertyId, configType }), {
        ...options,
        method: 'GET'
    });
};
export const getGetPropertyConfigVersionApiPropertiesPropertyIdConfigsConfigTypeVersionsVersionNumberGetUrl = ({ propertyId, configType, versionNumber }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/configs/${configType}/versions/${versionNumber}?${stringifiedParams}` : `/api/properties/${propertyId}/configs/${configType}/versions/${versionNumber}`;
};
/**
 * @summary Get Property Config Version
 */
export const getPropertyConfigVersionApiPropertiesPropertyIdConfigsConfigTypeVersionsVersionNumberGet = async ({ propertyId, configType, versionNumber }, params, options) => {
    return customFetch(getGetPropertyConfigVersionApiPropertiesPropertyIdConfigsConfigTypeVersionsVersionNumberGetUrl({ propertyId, configType, versionNumber }, params), {
        ...options,
        method: 'GET'
    });
};
export const getPromotePropertyConfigVersionToLatestApiPropertiesPropertyIdConfigsConfigTypeVersionsVersionNumberPromotePostUrl = ({ propertyId, configType, versionNumber }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/configs/${configType}/versions/${versionNumber}/promote?${stringifiedParams}` : `/api/properties/${propertyId}/configs/${configType}/versions/${versionNumber}/promote`;
};
/**
 * @summary Promote Property Config Version To Latest
 */
export const promotePropertyConfigVersionToLatestApiPropertiesPropertyIdConfigsConfigTypeVersionsVersionNumberPromotePost = async ({ propertyId, configType, versionNumber }, params, options) => {
    return customFetch(getPromotePropertyConfigVersionToLatestApiPropertiesPropertyIdConfigsConfigTypeVersionsVersionNumberPromotePostUrl({ propertyId, configType, versionNumber }, params), {
        ...options,
        method: 'POST'
    });
};
export const getBranchPropertyConfigApiPropertiesPropertyIdConfigsConfigTypeCreateBranchPostUrl = ({ propertyId, configType }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/configs/${configType}/create-branch?${stringifiedParams}` : `/api/properties/${propertyId}/configs/${configType}/create-branch`;
};
/**
 * @summary Branch Property Config
 */
export const branchPropertyConfigApiPropertiesPropertyIdConfigsConfigTypeCreateBranchPost = async ({ propertyId, configType }, params, options) => {
    return customFetch(getBranchPropertyConfigApiPropertiesPropertyIdConfigsConfigTypeCreateBranchPostUrl({ propertyId, configType }, params), {
        ...options,
        method: 'POST'
    });
};
export const getDeletePropertyConfigBranchApiPropertiesPropertyIdConfigsConfigTypeBranchesBranchNameDeleteUrl = ({ propertyId, configType, branchName }) => {
    return `/api/properties/${propertyId}/configs/${configType}/branches/${branchName}`;
};
/**
 * @summary Delete Property Config Branch
 */
export const deletePropertyConfigBranchApiPropertiesPropertyIdConfigsConfigTypeBranchesBranchNameDelete = async ({ propertyId, configType, branchName }, options) => {
    return customFetch(getDeletePropertyConfigBranchApiPropertiesPropertyIdConfigsConfigTypeBranchesBranchNameDeleteUrl({ propertyId, configType, branchName }), {
        ...options,
        method: 'DELETE'
    });
};
export const getGetPropertyConfigVersionHistoryApiPropertiesPropertyIdConfigsConfigTypeVersionsGetUrl = ({ propertyId, configType }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/configs/${configType}/versions?${stringifiedParams}` : `/api/properties/${propertyId}/configs/${configType}/versions`;
};
/**
 * @summary Get Property Config Version History
 */
export const getPropertyConfigVersionHistoryApiPropertiesPropertyIdConfigsConfigTypeVersionsGet = async ({ propertyId, configType }, params, options) => {
    return customFetch(getGetPropertyConfigVersionHistoryApiPropertiesPropertyIdConfigsConfigTypeVersionsGetUrl({ propertyId, configType }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetTenantConfigApiSaasTenantsSaasTenantIdConfigsConfigTypeGetUrl = ({ saasTenantId, configType }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/saas_tenants/${saasTenantId}/configs/${configType}?${stringifiedParams}` : `/api/saas_tenants/${saasTenantId}/configs/${configType}`;
};
/**
 * Return the latest saved config, or a defaults blob if the
 * tenant has never configured any (so the admin form always has a
 * shape to render).
 * @summary Get Tenant Config
 */
export const getTenantConfigApiSaasTenantsSaasTenantIdConfigsConfigTypeGet = async ({ saasTenantId, configType }, params, options) => {
    return customFetch(getGetTenantConfigApiSaasTenantsSaasTenantIdConfigsConfigTypeGetUrl({ saasTenantId, configType }, params), {
        ...options,
        method: 'GET'
    });
};
export const getUpsertTenantConfigApiSaasTenantsSaasTenantIdConfigsConfigTypePostUrl = ({ saasTenantId, configType }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/saas_tenants/${saasTenantId}/configs/${configType}?${stringifiedParams}` : `/api/saas_tenants/${saasTenantId}/configs/${configType}`;
};
/**
 * Full upsert (mirrors ``POST /api/properties/.../configs/...``).
 *
 * Force-overrides ``saas_tenant_id`` and ``user_id`` on the payload
 * so the URL path is authoritative and admins cannot spoof
 * cross-tenant writes. Rejects a body whose discriminator disagrees
 * with the URL's ``config_type`` -- silently coercing would give
 * the admin the wrong impression of what actually saved.
 * @summary Upsert Tenant Config
 */
export const upsertTenantConfigApiSaasTenantsSaasTenantIdConfigsConfigTypePost = async ({ saasTenantId, configType }, transitionDocRequestAgentSettings, params, options) => {
    return customFetch(getUpsertTenantConfigApiSaasTenantsSaasTenantIdConfigsConfigTypePostUrl({ saasTenantId, configType }, params), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(transitionDocRequestAgentSettings)
    });
};
export const getPatchTenantConfigApiSaasTenantsSaasTenantIdConfigsConfigTypePatchUrl = ({ saasTenantId, configType }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/saas_tenants/${saasTenantId}/configs/${configType}?${stringifiedParams}` : `/api/saas_tenants/${saasTenantId}/configs/${configType}`;
};
/**
 * Partial update: read latest, merge unset fields, write back.
 *
 * Mirrors ``patch_property_config``; if nothing exists yet we
 * fall through to a fresh construction (Pydantic defaults fill in
 * the unset fields).
 * @summary Patch Tenant Config
 */
export const patchTenantConfigApiSaasTenantsSaasTenantIdConfigsConfigTypePatch = async ({ saasTenantId, configType }, transitionDocRequestAgentSettingsPartial, params, options) => {
    return customFetch(getPatchTenantConfigApiSaasTenantsSaasTenantIdConfigsConfigTypePatchUrl({ saasTenantId, configType }, params), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(transitionDocRequestAgentSettingsPartial)
    });
};
export const getGetTenantConfigVersionsApiSaasTenantsSaasTenantIdConfigsConfigTypeVersionsGetUrl = ({ saasTenantId, configType }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/saas_tenants/${saasTenantId}/configs/${configType}/versions?${stringifiedParams}` : `/api/saas_tenants/${saasTenantId}/configs/${configType}/versions`;
};
/**
 * Paginated version history (newest first).
 * @summary Get Tenant Config Versions
 */
export const getTenantConfigVersionsApiSaasTenantsSaasTenantIdConfigsConfigTypeVersionsGet = async ({ saasTenantId, configType }, params, options) => {
    return customFetch(getGetTenantConfigVersionsApiSaasTenantsSaasTenantIdConfigsConfigTypeVersionsGetUrl({ saasTenantId, configType }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetTenantConfigVersionApiSaasTenantsSaasTenantIdConfigsConfigTypeVersionsVersionNumberGetUrl = ({ saasTenantId, configType, versionNumber }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/saas_tenants/${saasTenantId}/configs/${configType}/versions/${versionNumber}?${stringifiedParams}` : `/api/saas_tenants/${saasTenantId}/configs/${configType}/versions/${versionNumber}`;
};
/**
 * @summary Get Tenant Config Version
 */
export const getTenantConfigVersionApiSaasTenantsSaasTenantIdConfigsConfigTypeVersionsVersionNumberGet = async ({ saasTenantId, configType, versionNumber }, params, options) => {
    return customFetch(getGetTenantConfigVersionApiSaasTenantsSaasTenantIdConfigsConfigTypeVersionsVersionNumberGetUrl({ saasTenantId, configType, versionNumber }, params), {
        ...options,
        method: 'GET'
    });
};
export const getPromoteTenantConfigVersionApiSaasTenantsSaasTenantIdConfigsConfigTypeVersionsVersionNumberPromotePostUrl = ({ saasTenantId, configType, versionNumber }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/saas_tenants/${saasTenantId}/configs/${configType}/versions/${versionNumber}/promote?${stringifiedParams}` : `/api/saas_tenants/${saasTenantId}/configs/${configType}/versions/${versionNumber}/promote`;
};
/**
 * Revert to a historical version by promoting it as a new head.
 * @summary Promote Tenant Config Version
 */
export const promoteTenantConfigVersionApiSaasTenantsSaasTenantIdConfigsConfigTypeVersionsVersionNumberPromotePost = async ({ saasTenantId, configType, versionNumber }, params, options) => {
    return customFetch(getPromoteTenantConfigVersionApiSaasTenantsSaasTenantIdConfigsConfigTypeVersionsVersionNumberPromotePostUrl({ saasTenantId, configType, versionNumber }, params), {
        ...options,
        method: 'POST'
    });
};
export const getPreviewTenantConfigEmailApiSaasTenantsSaasTenantIdConfigsConfigTypePreviewEmailPostUrl = ({ saasTenantId, configType }) => {
    return `/api/saas_tenants/${saasTenantId}/configs/${configType}/preview-email`;
};
/**
 * Render a wrapped email against the caller's in-flight settings.
 *
 * Currently only ``TransitionDocRequestAgentSettings`` implements
 * preview -- other tenant configs return 400. Rejecting rather
 * than silently 200-ing an unrelated config_type makes it obvious
 * when a UI calls the wrong endpoint. The admin form never
 * persists ``settings`` here; the whole point is to see the effect
 * of unsaved edits.
 * @summary Preview Tenant Config Email
 */
export const previewTenantConfigEmailApiSaasTenantsSaasTenantIdConfigsConfigTypePreviewEmailPost = async ({ saasTenantId, configType }, transitionAgentPreviewEmailRequest, options) => {
    return customFetch(getPreviewTenantConfigEmailApiSaasTenantsSaasTenantIdConfigsConfigTypePreviewEmailPostUrl({ saasTenantId, configType }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(transitionAgentPreviewEmailRequest)
    });
};
export const getGetExperimentRunsApiExperimentsExperimentIdRunsGetUrl = ({ experimentId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/experiments/${experimentId}/runs?${stringifiedParams}` : `/api/experiments/${experimentId}/runs`;
};
/**
 * Get all runs for a specific experiment
 * @summary Get Experiment Runs
 */
export const getExperimentRunsApiExperimentsExperimentIdRunsGet = async ({ experimentId }, params, options) => {
    return customFetch(getGetExperimentRunsApiExperimentsExperimentIdRunsGetUrl({ experimentId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getCreateExperimentRunApiExperimentsExperimentIdRunsPostUrl = ({ experimentId }) => {
    return `/api/experiments/${experimentId}/runs`;
};
/**
 * Create a new experiment run and queue it for execution
 * @summary Create Experiment Run
 */
export const createExperimentRunApiExperimentsExperimentIdRunsPost = async ({ experimentId }, options) => {
    return customFetch(getCreateExperimentRunApiExperimentsExperimentIdRunsPostUrl({ experimentId }), {
        ...options,
        method: 'POST'
    });
};
export const getGetExperimentRunApiExperimentsExperimentIdRunsRunIdGetUrl = ({ experimentId, runId }) => {
    return `/api/experiments/${experimentId}/runs/${runId}`;
};
/**
 * Get a specific experiment run by ID
 * @summary Get Experiment Run
 */
export const getExperimentRunApiExperimentsExperimentIdRunsRunIdGet = async ({ experimentId, runId }, options) => {
    return customFetch(getGetExperimentRunApiExperimentsExperimentIdRunsRunIdGetUrl({ experimentId, runId }), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateExperimentRunNoteApiExperimentsExperimentIdRunsRunIdNotesPutUrl = ({ experimentId, runId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/experiments/${experimentId}/runs/${runId}/notes?${stringifiedParams}` : `/api/experiments/${experimentId}/runs/${runId}/notes`;
};
/**
 * Update the notes for an experiment run
 * @summary Update Experiment Run Note
 */
export const updateExperimentRunNoteApiExperimentsExperimentIdRunsRunIdNotesPut = async ({ experimentId, runId }, params, options) => {
    return customFetch(getUpdateExperimentRunNoteApiExperimentsExperimentIdRunsRunIdNotesPutUrl({ experimentId, runId }, params), {
        ...options,
        method: 'PUT'
    });
};
export const getGetGroundTruthRecordsApiExperimentsGroundTruthRecordsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["tags", "property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/experiments/ground_truth_records?${stringifiedParams}` : `/api/experiments/ground_truth_records`;
};
/**
 * Get ground truth records with filtering and pagination
 * @summary Get Ground Truth Records
 */
export const getGroundTruthRecordsApiExperimentsGroundTruthRecordsGet = async (params, options) => {
    return customFetch(getGetGroundTruthRecordsApiExperimentsGroundTruthRecordsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getCreateGroundTruthRecordApiExperimentsGroundTruthRecordsPostUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/experiments/ground_truth_records?${stringifiedParams}` : `/api/experiments/ground_truth_records`;
};
/**
 * @summary Create Ground Truth Record
 */
export const createGroundTruthRecordApiExperimentsGroundTruthRecordsPost = async (params, options) => {
    return customFetch(getCreateGroundTruthRecordApiExperimentsGroundTruthRecordsPostUrl(params), {
        ...options,
        method: 'POST'
    });
};
export const getDeleteGroundTruthRecordApiExperimentsGroundTruthRecordsDeleteUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/experiments/ground_truth_records?${stringifiedParams}` : `/api/experiments/ground_truth_records`;
};
/**
 * @summary Delete Ground Truth Record
 */
export const deleteGroundTruthRecordApiExperimentsGroundTruthRecordsDelete = async (params, options) => {
    return customFetch(getDeleteGroundTruthRecordApiExperimentsGroundTruthRecordsDeleteUrl(params), {
        ...options,
        method: 'DELETE'
    });
};
export const getGetGroundTruthRecordApiExperimentsGroundTruthRecordsEntityIdGetUrl = ({ entityId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/experiments/ground_truth_records/${entityId}?${stringifiedParams}` : `/api/experiments/ground_truth_records/${entityId}`;
};
/**
 * Get a specific ground truth record and compare it with current document data
 * @summary Get Ground Truth Record
 */
export const getGroundTruthRecordApiExperimentsGroundTruthRecordsEntityIdGet = async ({ entityId }, params, options) => {
    return customFetch(getGetGroundTruthRecordApiExperimentsGroundTruthRecordsEntityIdGetUrl({ entityId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateGroundTruthRecordApiExperimentsGroundTruthRecordsEntityIdPutUrl = ({ entityId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/experiments/ground_truth_records/${entityId}?${stringifiedParams}` : `/api/experiments/ground_truth_records/${entityId}`;
};
/**
 * @summary Update Ground Truth Record
 */
export const updateGroundTruthRecordApiExperimentsGroundTruthRecordsEntityIdPut = async ({ entityId }, params, options) => {
    return customFetch(getUpdateGroundTruthRecordApiExperimentsGroundTruthRecordsEntityIdPutUrl({ entityId }, params), {
        ...options,
        method: 'PUT'
    });
};
export const getGenerateGroundTruthRecordApiExperimentsGroundTruthRecordsGeneratePostUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/experiments/ground_truth_records/generate?${stringifiedParams}` : `/api/experiments/ground_truth_records/generate`;
};
/**
 * @summary Generate Ground Truth Record
 */
export const generateGroundTruthRecordApiExperimentsGroundTruthRecordsGeneratePost = async (params, options) => {
    return customFetch(getGenerateGroundTruthRecordApiExperimentsGroundTruthRecordsGeneratePostUrl(params), {
        ...options,
        method: 'POST'
    });
};
export const getGetGroundTruthForExperimentApiExperimentsExperimentIdGroundTruthRecordsGetUrl = ({ experimentId }) => {
    return `/api/experiments/${experimentId}/ground_truth_records`;
};
/**
 * Get ground truth records that match an experiment's criteria
 * @summary Get Ground Truth For Experiment
 */
export const getGroundTruthForExperimentApiExperimentsExperimentIdGroundTruthRecordsGet = async ({ experimentId }, options) => {
    return customFetch(getGetGroundTruthForExperimentApiExperimentsExperimentIdGroundTruthRecordsGetUrl({ experimentId }), {
        ...options,
        method: 'GET'
    });
};
export const getAddAdHocRecordToExperimentApiExperimentsExperimentIdAdHocRecordsPutUrl = ({ experimentId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/experiments/${experimentId}/ad_hoc_records?${stringifiedParams}` : `/api/experiments/${experimentId}/ad_hoc_records`;
};
/**
 * Add a document as an ad hoc record to an experiment
 * @summary Add Ad Hoc Record To Experiment
 */
export const addAdHocRecordToExperimentApiExperimentsExperimentIdAdHocRecordsPut = async ({ experimentId }, params, options) => {
    return customFetch(getAddAdHocRecordToExperimentApiExperimentsExperimentIdAdHocRecordsPutUrl({ experimentId }, params), {
        ...options,
        method: 'PUT'
    });
};
export const getRemoveAdHocRecordFromExperimentApiExperimentsExperimentIdAdHocRecordsDeleteUrl = ({ experimentId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/experiments/${experimentId}/ad_hoc_records?${stringifiedParams}` : `/api/experiments/${experimentId}/ad_hoc_records`;
};
/**
 * Remove a document from an experiment's ad hoc records
 * @summary Remove Ad Hoc Record From Experiment
 */
export const removeAdHocRecordFromExperimentApiExperimentsExperimentIdAdHocRecordsDelete = async ({ experimentId }, params, options) => {
    return customFetch(getRemoveAdHocRecordFromExperimentApiExperimentsExperimentIdAdHocRecordsDeleteUrl({ experimentId }, params), {
        ...options,
        method: 'DELETE'
    });
};
export const getGetAdHocRecordsForExperimentApiExperimentsExperimentIdAdHocRecordsGetUrl = ({ experimentId }) => {
    return `/api/experiments/${experimentId}/ad_hoc_records`;
};
/**
 * Get ad hoc records for a specific experiment
 * @summary Get Ad Hoc Records For Experiment
 */
export const getAdHocRecordsForExperimentApiExperimentsExperimentIdAdHocRecordsGet = async ({ experimentId }, options) => {
    return customFetch(getGetAdHocRecordsForExperimentApiExperimentsExperimentIdAdHocRecordsGetUrl({ experimentId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetExperimentsApiExperimentsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids", "entity_subtypes"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/experiments?${stringifiedParams}` : `/api/experiments`;
};
/**
 * Get experiments with filtering and pagination
 * @summary Get Experiments
 */
export const getExperimentsApiExperimentsGet = async (params, options) => {
    return customFetch(getGetExperimentsApiExperimentsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getCreateExperimentApiExperimentsPostUrl = () => {
    return `/api/experiments`;
};
/**
 * Create a new experiment
 * @summary Create Experiment
 */
export const createExperimentApiExperimentsPost = async (evalExperiment, options) => {
    return customFetch(getCreateExperimentApiExperimentsPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(evalExperiment)
    });
};
export const getUpdateExperimentApiExperimentsExperimentIdPutUrl = ({ experimentId }) => {
    return `/api/experiments/${experimentId}`;
};
/**
 * Update an existing experiment
 * @summary Update Experiment
 */
export const updateExperimentApiExperimentsExperimentIdPut = async ({ experimentId }, evalExperiment, options) => {
    return customFetch(getUpdateExperimentApiExperimentsExperimentIdPutUrl({ experimentId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(evalExperiment)
    });
};
export const getDeleteExperimentApiExperimentsExperimentIdDeleteUrl = ({ experimentId }) => {
    return `/api/experiments/${experimentId}`;
};
/**
 * Delete an experiment
 * @summary Delete Experiment
 */
export const deleteExperimentApiExperimentsExperimentIdDelete = async ({ experimentId }, options) => {
    return customFetch(getDeleteExperimentApiExperimentsExperimentIdDeleteUrl({ experimentId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getGetExperimentApiExperimentsExperimentIdGetUrl = ({ experimentId }) => {
    return `/api/experiments/${experimentId}`;
};
/**
 * Get a specific experiment by ID
 * @summary Get Experiment
 */
export const getExperimentApiExperimentsExperimentIdGet = async ({ experimentId }, options) => {
    return customFetch(getGetExperimentApiExperimentsExperimentIdGetUrl({ experimentId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetExecutiveSummaryApiLeaseAuditsDiscoveryTenantsTenantIdExecutiveSummaryGetUrl = ({ tenantId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/discovery/tenants/${tenantId}/executive-summary?${stringifiedParams}` : `/api/lease-audits/discovery/tenants/${tenantId}/executive-summary`;
};
/**
 * Returns the executive summary for a specific property, check type, and tag.
 * @summary Get Executive Summary
 */
export const getExecutiveSummaryApiLeaseAuditsDiscoveryTenantsTenantIdExecutiveSummaryGet = async ({ tenantId }, params, options) => {
    return customFetch(getGetExecutiveSummaryApiLeaseAuditsDiscoveryTenantsTenantIdExecutiveSummaryGetUrl({ tenantId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetTagDetailsApiLeaseAuditsDiscoveryTenantsTenantIdTagDetailsTagGetUrl = ({ tenantId, tag }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/discovery/tenants/${tenantId}/tag-details/${tag}?${stringifiedParams}` : `/api/lease-audits/discovery/tenants/${tenantId}/tag-details/${tag}`;
};
/**
 * Returns details of all lease audits that have a specific tag for a specific check type.
 * Special case: if tag is "untagged", returns audits that have the check type but no tags.
 * Optionally filters to a specific property if property_id is provided.
 * If check_type is None or empty, returns audits for all check types.
 * @summary Get Tag Details
 */
export const getTagDetailsApiLeaseAuditsDiscoveryTenantsTenantIdTagDetailsTagGet = async ({ tenantId, tag }, params, options) => {
    return customFetch(getGetTagDetailsApiLeaseAuditsDiscoveryTenantsTenantIdTagDetailsTagGetUrl({ tenantId, tag }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetPropertyOpenChecksApiLeaseAuditsDiscoveryPropertiesPropertyIdOpenChecksGetUrl = ({ propertyId }) => {
    return `/api/lease-audits/discovery/properties/${propertyId}/open-checks`;
};
/**
 * Latest-run check breakdown for every open lease audit on one property.
 *
 * Same population as the discovery checks-by-property grid: open tasks only,
 * failing-check tags, and open review markers.
 * @summary Get Property Open Checks
 */
export const getPropertyOpenChecksApiLeaseAuditsDiscoveryPropertiesPropertyIdOpenChecksGet = async ({ propertyId }, options) => {
    return customFetch(getGetPropertyOpenChecksApiLeaseAuditsDiscoveryPropertiesPropertyIdOpenChecksGetUrl({ propertyId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetIncompleteReviewsApiLeaseAuditsDiscoveryTenantsTenantIdIncompleteReviewsGetUrl = ({ tenantId }) => {
    return `/api/lease-audits/discovery/tenants/${tenantId}/incomplete-reviews`;
};
/**
 * Returns HTML page listing all incomplete check results reviews for the tenant.
 * Includes review data, latest check result counts, and links to lease audits.
 * @summary Get Incomplete Reviews
 */
export const getIncompleteReviewsApiLeaseAuditsDiscoveryTenantsTenantIdIncompleteReviewsGet = async ({ tenantId }, options) => {
    return customFetch(getGetIncompleteReviewsApiLeaseAuditsDiscoveryTenantsTenantIdIncompleteReviewsGetUrl({ tenantId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetOverviewApiLeaseAuditsDiscoveryTenantsTenantIdChecksByPropertyGetUrl = ({ tenantId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/discovery/tenants/${tenantId}/checks-by-property?${stringifiedParams}` : `/api/lease-audits/discovery/tenants/${tenantId}/checks-by-property`;
};
/**
 * Returns HTML that shows a table of all the properties in rows and all the checks in columns.
 * Each cell represents a check and is divided to show the breakdown of tags associated with the check.
 * Also represents lease audits with no check tags as a count, color coded by severity.
 * This page exclusively shows failing checks.
 * @summary Get Overview
 */
export const getOverviewApiLeaseAuditsDiscoveryTenantsTenantIdChecksByPropertyGet = async ({ tenantId }, params, options) => {
    return customFetch(getGetOverviewApiLeaseAuditsDiscoveryTenantsTenantIdChecksByPropertyGetUrl({ tenantId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getAuditConfigurationVersionsUnifiedDiffApiLeaseAuditsRevenueRealizationAuditConfigurationDiffGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/revenue-realization/audit-configuration-diff?${stringifiedParams}` : `/api/lease-audits/revenue-realization/audit-configuration-diff`;
};
/**
 * @summary Audit Configuration Versions Unified Diff
 */
export const auditConfigurationVersionsUnifiedDiffApiLeaseAuditsRevenueRealizationAuditConfigurationDiffGet = async (params, options) => {
    return customFetch(getAuditConfigurationVersionsUnifiedDiffApiLeaseAuditsRevenueRealizationAuditConfigurationDiffGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getListRevenueRealizationPageCommentsApiLeaseAuditsRevenueRealizationCommentsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/revenue-realization/comments?${stringifiedParams}` : `/api/lease-audits/revenue-realization/comments`;
};
/**
 * @summary List Revenue Realization Page Comments
 */
export const listRevenueRealizationPageCommentsApiLeaseAuditsRevenueRealizationCommentsGet = async (params, options) => {
    return customFetch(getListRevenueRealizationPageCommentsApiLeaseAuditsRevenueRealizationCommentsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getCreateRevenueRealizationPageCommentApiLeaseAuditsRevenueRealizationCommentsPostUrl = () => {
    return `/api/lease-audits/revenue-realization/comments`;
};
/**
 * @summary Create Revenue Realization Page Comment
 */
export const createRevenueRealizationPageCommentApiLeaseAuditsRevenueRealizationCommentsPost = async (revenueRealizationPageCommentCreate, options) => {
    return customFetch(getCreateRevenueRealizationPageCommentApiLeaseAuditsRevenueRealizationCommentsPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(revenueRealizationPageCommentCreate)
    });
};
export const getAuditRevenueRealizationPageApiLeaseAuditsRevenueRealizationGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/lease-audits/revenue-realization?${stringifiedParams}` : `/api/lease-audits/revenue-realization`;
};
/**
 * @summary Audit Revenue Realization Page
 */
export const auditRevenueRealizationPageApiLeaseAuditsRevenueRealizationGet = async (params, options) => {
    return customFetch(getAuditRevenueRealizationPageApiLeaseAuditsRevenueRealizationGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetPropertyRevenueRealizationApiRevenueRealizationGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/revenue-realization?${stringifiedParams}` : `/api/revenue-realization`;
};
/**
 * @summary Get Property Revenue Realization
 */
export const getPropertyRevenueRealizationApiRevenueRealizationGet = async (params, options) => {
    return customFetch(getGetPropertyRevenueRealizationApiRevenueRealizationGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetPolicyDocumentsApiPolicyDocumentsGetUrl = () => {
    return `/api/policy-documents`;
};
/**
 * Get all policy documents for the current tenant
 * @summary Get Policy Documents
 */
export const getPolicyDocumentsApiPolicyDocumentsGet = async (options) => {
    return customFetch(getGetPolicyDocumentsApiPolicyDocumentsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getUploadPolicyDocumentsApiPolicyDocumentsPostUrl = () => {
    return `/api/policy-documents`;
};
/**
 * Upload one or more policy documents (PDF, DOCX, PNG, JPEG)
 * @summary Upload Policy Documents
 */
export const uploadPolicyDocumentsApiPolicyDocumentsPost = async (bodyUploadPolicyDocumentsApiPolicyDocumentsPost, options) => {
    const formData = new FormData();
    bodyUploadPolicyDocumentsApiPolicyDocumentsPost.files.forEach(value => formData.append(`files`, value));
    return customFetch(getUploadPolicyDocumentsApiPolicyDocumentsPostUrl(), {
        ...options,
        method: 'POST',
        body: formData
    });
};
export const getGetPolicyDocumentApiPolicyDocumentsDocumentIdGetUrl = ({ documentId }) => {
    return `/api/policy-documents/${documentId}`;
};
/**
 * Get a specific policy document by ID
 * @summary Get Policy Document
 */
export const getPolicyDocumentApiPolicyDocumentsDocumentIdGet = async ({ documentId }, options) => {
    return customFetch(getGetPolicyDocumentApiPolicyDocumentsDocumentIdGetUrl({ documentId }), {
        ...options,
        method: 'GET'
    });
};
export const getDeletePolicyDocumentApiPolicyDocumentsDocumentIdDeleteUrl = ({ documentId }) => {
    return `/api/policy-documents/${documentId}`;
};
/**
 * Delete a policy document
 * @summary Delete Policy Document
 */
export const deletePolicyDocumentApiPolicyDocumentsDocumentIdDelete = async ({ documentId }, options) => {
    return customFetch(getDeletePolicyDocumentApiPolicyDocumentsDocumentIdDeleteUrl({ documentId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getGetPolicyDocumentContentApiPolicyDocumentsDocumentIdContentGetUrl = ({ documentId }) => {
    return `/api/policy-documents/${documentId}/content`;
};
/**
 * Download/view the content of a policy document
 * @summary Get Policy Document Content
 */
export const getPolicyDocumentContentApiPolicyDocumentsDocumentIdContentGet = async ({ documentId }, options) => {
    return customFetch(getGetPolicyDocumentContentApiPolicyDocumentsDocumentIdContentGetUrl({ documentId }), {
        ...options,
        method: 'GET'
    });
};
export const getUpsertConnectionApiPmsScrapeConnectionsConnectionIdPutUrl = ({ connectionId }) => {
    return `/api/pms-scrape/connections/${connectionId}`;
};
/**
 * @summary Upsert Connection
 */
export const upsertConnectionApiPmsScrapeConnectionsConnectionIdPut = async ({ connectionId }, upsertPmsConnectionRequest, options) => {
    return customFetch(getUpsertConnectionApiPmsScrapeConnectionsConnectionIdPutUrl({ connectionId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(upsertPmsConnectionRequest)
    });
};
export const getGetConnectionApiPmsScrapeConnectionsConnectionIdGetUrl = ({ connectionId }) => {
    return `/api/pms-scrape/connections/${connectionId}`;
};
/**
 * @summary Get Connection
 */
export const getConnectionApiPmsScrapeConnectionsConnectionIdGet = async ({ connectionId }, options) => {
    return customFetch(getGetConnectionApiPmsScrapeConnectionsConnectionIdGetUrl({ connectionId }), {
        ...options,
        method: 'GET'
    });
};
export const getDeleteConnectionApiPmsScrapeConnectionsConnectionIdDeleteUrl = ({ connectionId }) => {
    return `/api/pms-scrape/connections/${connectionId}`;
};
/**
 * @summary Delete Connection
 */
export const deleteConnectionApiPmsScrapeConnectionsConnectionIdDelete = async ({ connectionId }, options) => {
    return customFetch(getDeleteConnectionApiPmsScrapeConnectionsConnectionIdDeleteUrl({ connectionId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getTestConnectionApiPmsScrapeConnectionsConnectionIdTestPostUrl = ({ connectionId }) => {
    return `/api/pms-scrape/connections/${connectionId}/test`;
};
/**
 * @summary Test Connection
 */
export const testConnectionApiPmsScrapeConnectionsConnectionIdTestPost = async ({ connectionId }, sessionCookiesRequest, options) => {
    return customFetch(getTestConnectionApiPmsScrapeConnectionsConnectionIdTestPostUrl({ connectionId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(sessionCookiesRequest)
    });
};
export const getSubmitMfaApiPmsScrapeConnectionsConnectionIdAuthMfaPostUrl = ({ connectionId }) => {
    return `/api/pms-scrape/connections/${connectionId}/auth/mfa`;
};
/**
 * @summary Submit Mfa
 */
export const submitMfaApiPmsScrapeConnectionsConnectionIdAuthMfaPost = async ({ connectionId }, submitMfaRequest, options) => {
    return customFetch(getSubmitMfaApiPmsScrapeConnectionsConnectionIdAuthMfaPostUrl({ connectionId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(submitMfaRequest)
    });
};
export const getRestartAuthApiPmsScrapeConnectionsConnectionIdAuthRestartPostUrl = ({ connectionId }) => {
    return `/api/pms-scrape/connections/${connectionId}/auth/restart`;
};
/**
 * @summary Restart Auth
 */
export const restartAuthApiPmsScrapeConnectionsConnectionIdAuthRestartPost = async ({ connectionId }, options) => {
    return customFetch(getRestartAuthApiPmsScrapeConnectionsConnectionIdAuthRestartPostUrl({ connectionId }), {
        ...options,
        method: 'POST'
    });
};
export const getStartScrapeApiPmsScrapeRunsPostUrl = () => {
    return `/api/pms-scrape/runs`;
};
/**
 * @summary Start Scrape
 */
export const startScrapeApiPmsScrapeRunsPost = async (startPmsScrapeRequest, options) => {
    return customFetch(getStartScrapeApiPmsScrapeRunsPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(startPmsScrapeRequest)
    });
};
export const getListScrapeRunsApiPmsScrapeRunsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/pms-scrape/runs?${stringifiedParams}` : `/api/pms-scrape/runs`;
};
/**
 * @summary List Scrape Runs
 */
export const listScrapeRunsApiPmsScrapeRunsGet = async (params, options) => {
    return customFetch(getListScrapeRunsApiPmsScrapeRunsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetScrapeRunApiPmsScrapeRunsScrapeRunIdGetUrl = ({ scrapeRunId }) => {
    return `/api/pms-scrape/runs/${scrapeRunId}`;
};
/**
 * @summary Get Scrape Run
 */
export const getScrapeRunApiPmsScrapeRunsScrapeRunIdGet = async ({ scrapeRunId }, options) => {
    return customFetch(getGetScrapeRunApiPmsScrapeRunsScrapeRunIdGetUrl({ scrapeRunId }), {
        ...options,
        method: 'GET'
    });
};
export const getRetryScrapeRunApiPmsScrapeRunsScrapeRunIdRetryPostUrl = ({ scrapeRunId }) => {
    return `/api/pms-scrape/runs/${scrapeRunId}/retry`;
};
/**
 * @summary Retry Scrape Run
 */
export const retryScrapeRunApiPmsScrapeRunsScrapeRunIdRetryPost = async ({ scrapeRunId }, options) => {
    return customFetch(getRetryScrapeRunApiPmsScrapeRunsScrapeRunIdRetryPostUrl({ scrapeRunId }), {
        ...options,
        method: 'POST'
    });
};
export const getPmsScrapeDevHarnessAdminPmsScrapeGetUrl = () => {
    return `/admin/pms-scrape`;
};
/**
 * @summary Pms Scrape Dev Harness
 */
export const pmsScrapeDevHarnessAdminPmsScrapeGet = async (options) => {
    return customFetch(getPmsScrapeDevHarnessAdminPmsScrapeGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getListRemotesApiSurfopsCloudsyncRemotesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/cloudsync/remotes?${stringifiedParams}` : `/api/surfops/cloudsync/remotes`;
};
/**
 * List remotes. With limit, returns paginated {items, total}. Without, returns all (for dropdowns).
 * @summary List Remotes
 */
export const listRemotesApiSurfopsCloudsyncRemotesGet = async (params, options) => {
    return customFetch(getListRemotesApiSurfopsCloudsyncRemotesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getCreateRemoteApiSurfopsCloudsyncRemotesPostUrl = () => {
    return `/api/surfops/cloudsync/remotes`;
};
/**
 * Create a new source remote.
 * @summary Create Remote
 */
export const createRemoteApiSurfopsCloudsyncRemotesPost = async (remoteConfigRequest, options) => {
    return customFetch(getCreateRemoteApiSurfopsCloudsyncRemotesPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(remoteConfigRequest)
    });
};
export const getGetRemoteApiSurfopsCloudsyncRemotesNameGetUrl = ({ name }) => {
    return `/api/surfops/cloudsync/remotes/${name}`;
};
/**
 * Get a remote by name.
 * @summary Get Remote
 */
export const getRemoteApiSurfopsCloudsyncRemotesNameGet = async ({ name }, options) => {
    return customFetch(getGetRemoteApiSurfopsCloudsyncRemotesNameGetUrl({ name }), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateRemoteApiSurfopsCloudsyncRemotesNamePutUrl = ({ name }) => {
    return `/api/surfops/cloudsync/remotes/${name}`;
};
/**
 * Update a remote by name.
 * @summary Update Remote
 */
export const updateRemoteApiSurfopsCloudsyncRemotesNamePut = async ({ name }, remoteConfigRequest, options) => {
    return customFetch(getUpdateRemoteApiSurfopsCloudsyncRemotesNamePutUrl({ name }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(remoteConfigRequest)
    });
};
export const getDeleteRemoteApiSurfopsCloudsyncRemotesNameDeleteUrl = ({ name }) => {
    return `/api/surfops/cloudsync/remotes/${name}`;
};
/**
 * Delete a remote by name.
 * @summary Delete Remote
 */
export const deleteRemoteApiSurfopsCloudsyncRemotesNameDelete = async ({ name }, options) => {
    return customFetch(getDeleteRemoteApiSurfopsCloudsyncRemotesNameDeleteUrl({ name }), {
        ...options,
        method: 'DELETE'
    });
};
export const getTestRemoteApiSurfopsCloudsyncRemotesNameTestPostUrl = ({ name }) => {
    return `/api/surfops/cloudsync/remotes/${name}/test`;
};
/**
 * Test that a remote connection is valid using rclone. Optional source for folder-restricted access.
 * @summary Test Remote
 */
export const testRemoteApiSurfopsCloudsyncRemotesNameTestPost = async ({ name }, testRemoteRequest, options) => {
    return customFetch(getTestRemoteApiSurfopsCloudsyncRemotesNameTestPostUrl({ name }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(testRemoteRequest)
    });
};
export const getStartRemoteImportJobApiSurfopsCloudsyncJobsPostUrl = () => {
    return `/api/surfops/cloudsync/jobs`;
};
/**
 * Kick off a REMOTE_IMPORT job.
 * @summary Start Remote Import Job
 */
export const startRemoteImportJobApiSurfopsCloudsyncJobsPost = async (remoteImportJobRequest, options) => {
    return customFetch(getStartRemoteImportJobApiSurfopsCloudsyncJobsPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(remoteImportJobRequest)
    });
};
export const getGetRemoteImportJobsApiSurfopsCloudsyncJobsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/cloudsync/jobs?${stringifiedParams}` : `/api/surfops/cloudsync/jobs`;
};
/**
 * Get REMOTE_IMPORT job status/history (paginated, max 10 per page).
 * @summary Get Remote Import Jobs
 */
export const getRemoteImportJobsApiSurfopsCloudsyncJobsGet = async (params, options) => {
    return customFetch(getGetRemoteImportJobsApiSurfopsCloudsyncJobsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseDocumentSyncQueueStateApiSurfopsDocumentContentSyncQueueStateGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/document-content-sync/queue-state?${stringifiedParams}` : `/api/surfops/document-content-sync/queue-state`;
};
/**
 * Get the current sync queue state for a specific lease.
 * Requires both property_id and lease_id.
 * Returns None if no queue state exists for the lease.
 * @summary Get Lease Document Sync Queue State
 */
export const getLeaseDocumentSyncQueueStateApiSurfopsDocumentContentSyncQueueStateGet = async (params, options) => {
    return customFetch(getGetLeaseDocumentSyncQueueStateApiSurfopsDocumentContentSyncQueueStateGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLeaseDocumentSyncHistoryApiSurfopsDocumentContentSyncSyncHistoryGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/document-content-sync/sync-history?${stringifiedParams}` : `/api/surfops/document-content-sync/sync-history`;
};
/**
 * Get the sync history for a specific lease.
 * Requires both property_id and lease_id.
 * Returns a list of sync log entries ordered by sync_time descending.
 * @summary Get Lease Document Sync History
 */
export const getLeaseDocumentSyncHistoryApiSurfopsDocumentContentSyncSyncHistoryGet = async (params, options) => {
    return customFetch(getGetLeaseDocumentSyncHistoryApiSurfopsDocumentContentSyncSyncHistoryGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetDocumentContentSyncJobsApiSurfopsDocumentContentSyncJobsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/document-content-sync/jobs?${stringifiedParams}` : `/api/surfops/document-content-sync/jobs`;
};
/**
 * Get document content sync jobs related to a specific property and lease.
 * Searches for DOCUMENT_CONTENT_SYNC jobs where the directive contains
 * both the property_id and lease_id as top-level keys.
 * @summary Get Document Content Sync Jobs
 */
export const getDocumentContentSyncJobsApiSurfopsDocumentContentSyncJobsGet = async (params, options) => {
    return customFetch(getGetDocumentContentSyncJobsApiSurfopsDocumentContentSyncJobsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getListDocumentReindexPropertiesApiSurfopsDocumentReindexPropertiesGetUrl = () => {
    return `/api/surfops/document-reindex/properties`;
};
/**
 * Id, name, and address for every property on the current tenant.
 * @summary List Document Reindex Properties
 */
export const listDocumentReindexPropertiesApiSurfopsDocumentReindexPropertiesGet = async (options) => {
    return customFetch(getListDocumentReindexPropertiesApiSurfopsDocumentReindexPropertiesGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getListStuckLeaseAuditRunsApiSurfopsOperationalIntegrityStuckLeaseAuditRunsGetUrl = () => {
    return `/api/surfops/operational-integrity/stuck-lease-audit-runs`;
};
/**
 * @summary List Stuck Lease Audit Runs
 */
export const listStuckLeaseAuditRunsApiSurfopsOperationalIntegrityStuckLeaseAuditRunsGet = async (options) => {
    return customFetch(getListStuckLeaseAuditRunsApiSurfopsOperationalIntegrityStuckLeaseAuditRunsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getListErroredLeaseAuditRunsApiSurfopsOperationalIntegrityErroredLeaseAuditRunsGetUrl = () => {
    return `/api/surfops/operational-integrity/errored-lease-audit-runs`;
};
/**
 * @summary List Errored Lease Audit Runs
 */
export const listErroredLeaseAuditRunsApiSurfopsOperationalIntegrityErroredLeaseAuditRunsGet = async (options) => {
    return customFetch(getListErroredLeaseAuditRunsApiSurfopsOperationalIntegrityErroredLeaseAuditRunsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getListPastLeasesOpenLeaseAuditsApiSurfopsOperationalIntegrityPastLeasesOpenLeaseAuditsGetUrl = () => {
    return `/api/surfops/operational-integrity/past-leases-open-lease-audits`;
};
/**
 * @summary List Past Leases Open Lease Audits
 */
export const listPastLeasesOpenLeaseAuditsApiSurfopsOperationalIntegrityPastLeasesOpenLeaseAuditsGet = async (options) => {
    return customFetch(getListPastLeasesOpenLeaseAuditsApiSurfopsOperationalIntegrityPastLeasesOpenLeaseAuditsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getListPastLeasesOpenLeaseAuditDetailsApiSurfopsOperationalIntegrityPastLeasesOpenLeaseAuditsDetailGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/operational-integrity/past-leases-open-lease-audits/detail?${stringifiedParams}` : `/api/surfops/operational-integrity/past-leases-open-lease-audits/detail`;
};
/**
 * @summary List Past Leases Open Lease Audit Details
 */
export const listPastLeasesOpenLeaseAuditDetailsApiSurfopsOperationalIntegrityPastLeasesOpenLeaseAuditsDetailGet = async (params, options) => {
    return customFetch(getListPastLeasesOpenLeaseAuditDetailsApiSurfopsOperationalIntegrityPastLeasesOpenLeaseAuditsDetailGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetCoverageApiSurfopsExtractionQualityCoverageGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/extraction-quality/coverage?${stringifiedParams}` : `/api/surfops/extraction-quality/coverage`;
};
/**
 * @summary Get Coverage
 */
export const getCoverageApiSurfopsExtractionQualityCoverageGet = async (params, options) => {
    return customFetch(getGetCoverageApiSurfopsExtractionQualityCoverageGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getListRepresentedPropertiesApiSurfopsExtractionQualityPropertiesGetUrl = () => {
    return `/api/surfops/extraction-quality/properties`;
};
/**
 * @summary List Represented Properties
 */
export const listRepresentedPropertiesApiSurfopsExtractionQualityPropertiesGet = async (options) => {
    return customFetch(getListRepresentedPropertiesApiSurfopsExtractionQualityPropertiesGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getListFindingsApiSurfopsExtractionQualityFindingsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/extraction-quality/findings?${stringifiedParams}` : `/api/surfops/extraction-quality/findings`;
};
/**
 * @summary List Findings
 */
export const listFindingsApiSurfopsExtractionQualityFindingsGet = async (params, options) => {
    return customFetch(getListFindingsApiSurfopsExtractionQualityFindingsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetFindingApiSurfopsExtractionQualityFindingsFindingIdGetUrl = ({ findingId }) => {
    return `/api/surfops/extraction-quality/findings/${findingId}`;
};
/**
 * @summary Get Finding
 */
export const getFindingApiSurfopsExtractionQualityFindingsFindingIdGet = async ({ findingId }, options) => {
    return customFetch(getGetFindingApiSurfopsExtractionQualityFindingsFindingIdGetUrl({ findingId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetFindingImageApiSurfopsExtractionQualityFindingsFindingIdImageGetUrl = ({ findingId }) => {
    return `/api/surfops/extraction-quality/findings/${findingId}/image`;
};
/**
 * @summary Get Finding Image
 */
export const getFindingImageApiSurfopsExtractionQualityFindingsFindingIdImageGet = async ({ findingId }, options) => {
    return customFetch(getGetFindingImageApiSurfopsExtractionQualityFindingsFindingIdImageGetUrl({ findingId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetFindingArchetypeApiSurfopsExtractionQualityFindingsFindingIdArchetypeGetUrl = ({ findingId }) => {
    return `/api/surfops/extraction-quality/findings/${findingId}/archetype`;
};
/**
 * @summary Get Finding Archetype
 */
export const getFindingArchetypeApiSurfopsExtractionQualityFindingsFindingIdArchetypeGet = async ({ findingId }, options) => {
    return customFetch(getGetFindingArchetypeApiSurfopsExtractionQualityFindingsFindingIdArchetypeGetUrl({ findingId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetFindingArchetypeImageApiSurfopsExtractionQualityFindingsFindingIdArchetypeImageGetUrl = ({ findingId }) => {
    return `/api/surfops/extraction-quality/findings/${findingId}/archetype/image`;
};
/**
 * @summary Get Finding Archetype Image
 */
export const getFindingArchetypeImageApiSurfopsExtractionQualityFindingsFindingIdArchetypeImageGet = async ({ findingId }, options) => {
    return customFetch(getGetFindingArchetypeImageApiSurfopsExtractionQualityFindingsFindingIdArchetypeImageGetUrl({ findingId }), {
        ...options,
        method: 'GET'
    });
};
export const getReviewFindingApiSurfopsExtractionQualityFindingsFindingIdReviewPostUrl = ({ findingId }) => {
    return `/api/surfops/extraction-quality/findings/${findingId}/review`;
};
/**
 * @summary Review Finding
 */
export const reviewFindingApiSurfopsExtractionQualityFindingsFindingIdReviewPost = async ({ findingId }, extractionQualityReviewRequest, options) => {
    return customFetch(getReviewFindingApiSurfopsExtractionQualityFindingsFindingIdReviewPostUrl({ findingId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(extractionQualityReviewRequest)
    });
};
export const getGetClusterReviewApiSurfopsExtractionQualityArchetypesArchetypeIdFindingsGetUrl = ({ archetypeId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/extraction-quality/archetypes/${archetypeId}/findings?${stringifiedParams}` : `/api/surfops/extraction-quality/archetypes/${archetypeId}/findings`;
};
/**
 * @summary Get Cluster Review
 */
export const getClusterReviewApiSurfopsExtractionQualityArchetypesArchetypeIdFindingsGet = async ({ archetypeId }, params, options) => {
    return customFetch(getGetClusterReviewApiSurfopsExtractionQualityArchetypesArchetypeIdFindingsGetUrl({ archetypeId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getSetClusterOptInApiSurfopsExtractionQualityArchetypesArchetypeIdOptInPostUrl = ({ archetypeId }) => {
    return `/api/surfops/extraction-quality/archetypes/${archetypeId}/opt-in`;
};
/**
 * @summary Set Cluster Opt In
 */
export const setClusterOptInApiSurfopsExtractionQualityArchetypesArchetypeIdOptInPost = async ({ archetypeId }, extractionQualityOptInRequest, options) => {
    return customFetch(getSetClusterOptInApiSurfopsExtractionQualityArchetypesArchetypeIdOptInPostUrl({ archetypeId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(extractionQualityOptInRequest)
    });
};
export const getReviewClusterApiSurfopsExtractionQualityArchetypesArchetypeIdReviewPostUrl = ({ archetypeId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/extraction-quality/archetypes/${archetypeId}/review?${stringifiedParams}` : `/api/surfops/extraction-quality/archetypes/${archetypeId}/review`;
};
/**
 * @summary Review Cluster
 */
export const reviewClusterApiSurfopsExtractionQualityArchetypesArchetypeIdReviewPost = async ({ archetypeId }, extractionQualityReviewRequest, params, options) => {
    return customFetch(getReviewClusterApiSurfopsExtractionQualityArchetypesArchetypeIdReviewPostUrl({ archetypeId }, params), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(extractionQualityReviewRequest)
    });
};
export const getListBatchesApiSurfopsTrialAuditsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/trial-audits?${stringifiedParams}` : `/api/surfops/trial-audits`;
};
/**
 * @summary List Batches
 */
export const listBatchesApiSurfopsTrialAuditsGet = async (params, options) => {
    return customFetch(getListBatchesApiSurfopsTrialAuditsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getStartBatchApiSurfopsTrialAuditsPostUrl = () => {
    return `/api/surfops/trial-audits`;
};
/**
 * @summary Start Batch
 */
export const startBatchApiSurfopsTrialAuditsPost = async (trialAuditStartRequest, options) => {
    return customFetch(getStartBatchApiSurfopsTrialAuditsPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(trialAuditStartRequest)
    });
};
export const getListRepresentedPropertiesApiSurfopsTrialAuditsPropertiesGetUrl = () => {
    return `/api/surfops/trial-audits/properties`;
};
/**
 * @summary List Represented Properties
 */
export const listRepresentedPropertiesApiSurfopsTrialAuditsPropertiesGet = async (options) => {
    return customFetch(getListRepresentedPropertiesApiSurfopsTrialAuditsPropertiesGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getAddAuditsApiSurfopsTrialAuditsBatchIdAuditsPostUrl = ({ batchId }) => {
    return `/api/surfops/trial-audits/${batchId}/audits`;
};
/**
 * @summary Add Audits
 */
export const addAuditsApiSurfopsTrialAuditsBatchIdAuditsPost = async ({ batchId }, trialAuditAddAuditsRequest, options) => {
    return customFetch(getAddAuditsApiSurfopsTrialAuditsBatchIdAuditsPostUrl({ batchId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(trialAuditAddAuditsRequest)
    });
};
export const getRerunBatchApiSurfopsTrialAuditsBatchIdRerunPostUrl = ({ batchId }) => {
    return `/api/surfops/trial-audits/${batchId}/rerun`;
};
/**
 * @summary Rerun Batch
 */
export const rerunBatchApiSurfopsTrialAuditsBatchIdRerunPost = async ({ batchId }, options) => {
    return customFetch(getRerunBatchApiSurfopsTrialAuditsBatchIdRerunPostUrl({ batchId }), {
        ...options,
        method: 'POST'
    });
};
export const getGetSummaryApiSurfopsTrialAuditsBatchIdSummaryGetUrl = ({ batchId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/trial-audits/${batchId}/summary?${stringifiedParams}` : `/api/surfops/trial-audits/${batchId}/summary`;
};
/**
 * @summary Get Summary
 */
export const getSummaryApiSurfopsTrialAuditsBatchIdSummaryGet = async ({ batchId }, params, options) => {
    return customFetch(getGetSummaryApiSurfopsTrialAuditsBatchIdSummaryGetUrl({ batchId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getListChecksApiSurfopsTrialAuditsBatchIdChecksGetUrl = ({ batchId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/trial-audits/${batchId}/checks?${stringifiedParams}` : `/api/surfops/trial-audits/${batchId}/checks`;
};
/**
 * @summary List Checks
 */
export const listChecksApiSurfopsTrialAuditsBatchIdChecksGet = async ({ batchId }, params, options) => {
    return customFetch(getListChecksApiSurfopsTrialAuditsBatchIdChecksGetUrl({ batchId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetCheckApiSurfopsTrialAuditsBatchIdChecksCheckIdGetUrl = ({ batchId, checkId }) => {
    return `/api/surfops/trial-audits/${batchId}/checks/${checkId}`;
};
/**
 * @summary Get Check
 */
export const getCheckApiSurfopsTrialAuditsBatchIdChecksCheckIdGet = async ({ batchId, checkId }, options) => {
    return customFetch(getGetCheckApiSurfopsTrialAuditsBatchIdChecksCheckIdGetUrl({ batchId, checkId }), {
        ...options,
        method: 'GET'
    });
};
export const getReviewCheckApiSurfopsTrialAuditsBatchIdChecksCheckIdReviewPostUrl = ({ batchId, checkId }) => {
    return `/api/surfops/trial-audits/${batchId}/checks/${checkId}/review`;
};
/**
 * @summary Review Check
 */
export const reviewCheckApiSurfopsTrialAuditsBatchIdChecksCheckIdReviewPost = async ({ batchId, checkId }, trialAuditCheckReviewRequest, options) => {
    return customFetch(getReviewCheckApiSurfopsTrialAuditsBatchIdChecksCheckIdReviewPostUrl({ batchId, checkId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(trialAuditCheckReviewRequest)
    });
};
export const getListTaskTypesApiSurfopsEvalTaskTypesGetUrl = () => {
    return `/api/surfops/eval/task-types`;
};
/**
 * @summary List Task Types
 */
export const listTaskTypesApiSurfopsEvalTaskTypesGet = async (options) => {
    return customFetch(getListTaskTypesApiSurfopsEvalTaskTypesGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getListIndexingModelsApiSurfopsEvalModelsGetUrl = () => {
    return `/api/surfops/eval/models`;
};
/**
 * @summary List Indexing Models
 */
export const listIndexingModelsApiSurfopsEvalModelsGet = async (options) => {
    return customFetch(getListIndexingModelsApiSurfopsEvalModelsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getListConfigBranchesApiSurfopsEvalConfigBranchesGetUrl = () => {
    return `/api/surfops/eval/config-branches`;
};
/**
 * @summary List Config Branches
 */
export const listConfigBranchesApiSurfopsEvalConfigBranchesGet = async (options) => {
    return customFetch(getListConfigBranchesApiSurfopsEvalConfigBranchesGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getListDatasetsApiSurfopsEvalDatasetsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/eval/datasets?${stringifiedParams}` : `/api/surfops/eval/datasets`;
};
/**
 * @summary List Datasets
 */
export const listDatasetsApiSurfopsEvalDatasetsGet = async (params, options) => {
    return customFetch(getListDatasetsApiSurfopsEvalDatasetsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getCreateDatasetApiSurfopsEvalDatasetsPostUrl = () => {
    return `/api/surfops/eval/datasets`;
};
/**
 * @summary Create Dataset
 */
export const createDatasetApiSurfopsEvalDatasetsPost = async (createDatasetRequest, options) => {
    return customFetch(getCreateDatasetApiSurfopsEvalDatasetsPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(createDatasetRequest)
    });
};
export const getGetDatasetApiSurfopsEvalDatasetsDatasetIdGetUrl = ({ datasetId }) => {
    return `/api/surfops/eval/datasets/${datasetId}`;
};
/**
 * @summary Get Dataset
 */
export const getDatasetApiSurfopsEvalDatasetsDatasetIdGet = async ({ datasetId }, options) => {
    return customFetch(getGetDatasetApiSurfopsEvalDatasetsDatasetIdGetUrl({ datasetId }), {
        ...options,
        method: 'GET'
    });
};
export const getDeleteDatasetApiSurfopsEvalDatasetsDatasetIdDeleteUrl = ({ datasetId }) => {
    return `/api/surfops/eval/datasets/${datasetId}`;
};
/**
 * @summary Delete Dataset
 */
export const deleteDatasetApiSurfopsEvalDatasetsDatasetIdDelete = async ({ datasetId }, options) => {
    return customFetch(getDeleteDatasetApiSurfopsEvalDatasetsDatasetIdDeleteUrl({ datasetId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getGetSamplingScopeApiSurfopsEvalSampleScopeGetUrl = () => {
    return `/api/surfops/eval/sample/scope`;
};
/**
 * @summary Get Sampling Scope
 */
export const getSamplingScopeApiSurfopsEvalSampleScopeGet = async (options) => {
    return customFetch(getGetSamplingScopeApiSurfopsEvalSampleScopeGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getPreviewSampleFromSpecApiSurfopsEvalSamplePreviewPostUrl = () => {
    return `/api/surfops/eval/sample/preview`;
};
/**
 * @summary Preview Sample From Spec
 */
export const previewSampleFromSpecApiSurfopsEvalSamplePreviewPost = async (previewSampleRequest, options) => {
    return customFetch(getPreviewSampleFromSpecApiSurfopsEvalSamplePreviewPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(previewSampleRequest)
    });
};
export const getPreviewSampleApiSurfopsEvalDatasetsDatasetIdSamplePreviewPostUrl = ({ datasetId }) => {
    return `/api/surfops/eval/datasets/${datasetId}/sample/preview`;
};
/**
 * @summary Preview Sample
 */
export const previewSampleApiSurfopsEvalDatasetsDatasetIdSamplePreviewPost = async ({ datasetId }, options) => {
    return customFetch(getPreviewSampleApiSurfopsEvalDatasetsDatasetIdSamplePreviewPostUrl({ datasetId }), {
        ...options,
        method: 'POST'
    });
};
export const getStartSampleApiSurfopsEvalDatasetsDatasetIdSamplePostUrl = ({ datasetId }) => {
    return `/api/surfops/eval/datasets/${datasetId}/sample`;
};
/**
 * @summary Start Sample
 */
export const startSampleApiSurfopsEvalDatasetsDatasetIdSamplePost = async ({ datasetId }, options) => {
    return customFetch(getStartSampleApiSurfopsEvalDatasetsDatasetIdSamplePostUrl({ datasetId }), {
        ...options,
        method: 'POST'
    });
};
export const getMarkDatasetReadyApiSurfopsEvalDatasetsDatasetIdReadyPostUrl = ({ datasetId }) => {
    return `/api/surfops/eval/datasets/${datasetId}/ready`;
};
/**
 * @summary Mark Dataset Ready
 */
export const markDatasetReadyApiSurfopsEvalDatasetsDatasetIdReadyPost = async ({ datasetId }, options) => {
    return customFetch(getMarkDatasetReadyApiSurfopsEvalDatasetsDatasetIdReadyPostUrl({ datasetId }), {
        ...options,
        method: 'POST'
    });
};
export const getListItemsApiSurfopsEvalDatasetsDatasetIdItemsGetUrl = ({ datasetId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/eval/datasets/${datasetId}/items?${stringifiedParams}` : `/api/surfops/eval/datasets/${datasetId}/items`;
};
/**
 * @summary List Items
 */
export const listItemsApiSurfopsEvalDatasetsDatasetIdItemsGet = async ({ datasetId }, params, options) => {
    return customFetch(getListItemsApiSurfopsEvalDatasetsDatasetIdItemsGetUrl({ datasetId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetCoverageApiSurfopsEvalDatasetsDatasetIdCoverageGetUrl = ({ datasetId }) => {
    return `/api/surfops/eval/datasets/${datasetId}/coverage`;
};
/**
 * @summary Get Coverage
 */
export const getCoverageApiSurfopsEvalDatasetsDatasetIdCoverageGet = async ({ datasetId }, options) => {
    return customFetch(getGetCoverageApiSurfopsEvalDatasetsDatasetIdCoverageGetUrl({ datasetId }), {
        ...options,
        method: 'GET'
    });
};
export const getListBookmarkLabelsApiSurfopsEvalDatasetsDatasetIdBookmarkLabelsGetUrl = ({ datasetId }) => {
    return `/api/surfops/eval/datasets/${datasetId}/bookmark-labels`;
};
/**
 * @summary List Bookmark Labels
 */
export const listBookmarkLabelsApiSurfopsEvalDatasetsDatasetIdBookmarkLabelsGet = async ({ datasetId }, options) => {
    return customFetch(getListBookmarkLabelsApiSurfopsEvalDatasetsDatasetIdBookmarkLabelsGetUrl({ datasetId }), {
        ...options,
        method: 'GET'
    });
};
export const getListAssignmentsApiSurfopsEvalDatasetsDatasetIdAssignmentsGetUrl = ({ datasetId }) => {
    return `/api/surfops/eval/datasets/${datasetId}/assignments`;
};
/**
 * @summary List Assignments
 */
export const listAssignmentsApiSurfopsEvalDatasetsDatasetIdAssignmentsGet = async ({ datasetId }, options) => {
    return customFetch(getListAssignmentsApiSurfopsEvalDatasetsDatasetIdAssignmentsGetUrl({ datasetId }), {
        ...options,
        method: 'GET'
    });
};
export const getCreateAssignmentApiSurfopsEvalDatasetsDatasetIdAssignmentsPostUrl = ({ datasetId }) => {
    return `/api/surfops/eval/datasets/${datasetId}/assignments`;
};
/**
 * @summary Create Assignment
 */
export const createAssignmentApiSurfopsEvalDatasetsDatasetIdAssignmentsPost = async ({ datasetId }, createAssignmentRequest, options) => {
    return customFetch(getCreateAssignmentApiSurfopsEvalDatasetsDatasetIdAssignmentsPostUrl({ datasetId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(createAssignmentRequest)
    });
};
export const getClaimAssignmentApiSurfopsEvalDatasetsDatasetIdAssignmentsClaimPostUrl = ({ datasetId }) => {
    return `/api/surfops/eval/datasets/${datasetId}/assignments/claim`;
};
/**
 * @summary Claim Assignment
 */
export const claimAssignmentApiSurfopsEvalDatasetsDatasetIdAssignmentsClaimPost = async ({ datasetId }, claimAssignmentRequest, options) => {
    return customFetch(getClaimAssignmentApiSurfopsEvalDatasetsDatasetIdAssignmentsClaimPostUrl({ datasetId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(claimAssignmentRequest)
    });
};
export const getGetAssignmentApiSurfopsEvalAssignmentsAssignmentIdGetUrl = ({ assignmentId }) => {
    return `/api/surfops/eval/assignments/${assignmentId}`;
};
/**
 * @summary Get Assignment
 */
export const getAssignmentApiSurfopsEvalAssignmentsAssignmentIdGet = async ({ assignmentId }, options) => {
    return customFetch(getGetAssignmentApiSurfopsEvalAssignmentsAssignmentIdGetUrl({ assignmentId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetAssignmentQueueApiSurfopsEvalAssignmentsAssignmentIdQueueGetUrl = ({ assignmentId }) => {
    return `/api/surfops/eval/assignments/${assignmentId}/queue`;
};
/**
 * @summary Get Assignment Queue
 */
export const getAssignmentQueueApiSurfopsEvalAssignmentsAssignmentIdQueueGet = async ({ assignmentId }, options) => {
    return customFetch(getGetAssignmentQueueApiSurfopsEvalAssignmentsAssignmentIdQueueGetUrl({ assignmentId }), {
        ...options,
        method: 'GET'
    });
};
export const getReleaseAssignmentApiSurfopsEvalAssignmentsAssignmentIdReleasePostUrl = ({ assignmentId }) => {
    return `/api/surfops/eval/assignments/${assignmentId}/release`;
};
/**
 * @summary Release Assignment
 */
export const releaseAssignmentApiSurfopsEvalAssignmentsAssignmentIdReleasePost = async ({ assignmentId }, options) => {
    return customFetch(getReleaseAssignmentApiSurfopsEvalAssignmentsAssignmentIdReleasePostUrl({ assignmentId }), {
        ...options,
        method: 'POST'
    });
};
export const getDeferItemApiSurfopsEvalAssignmentsAssignmentIdItemsItemIdDeferPostUrl = ({ assignmentId, itemId }) => {
    return `/api/surfops/eval/assignments/${assignmentId}/items/${itemId}/defer`;
};
/**
 * @summary Defer Item
 */
export const deferItemApiSurfopsEvalAssignmentsAssignmentIdItemsItemIdDeferPost = async ({ assignmentId, itemId }, options) => {
    return customFetch(getDeferItemApiSurfopsEvalAssignmentsAssignmentIdItemsItemIdDeferPostUrl({ assignmentId, itemId }), {
        ...options,
        method: 'POST'
    });
};
export const getGetItemApiSurfopsEvalItemsItemIdGetUrl = ({ itemId }) => {
    return `/api/surfops/eval/items/${itemId}`;
};
/**
 * @summary Get Item
 */
export const getItemApiSurfopsEvalItemsItemIdGet = async ({ itemId }, options) => {
    return customFetch(getGetItemApiSurfopsEvalItemsItemIdGetUrl({ itemId }), {
        ...options,
        method: 'GET'
    });
};
export const getSubmitLabelApiSurfopsEvalItemsItemIdLabelPutUrl = ({ itemId }) => {
    return `/api/surfops/eval/items/${itemId}/label`;
};
/**
 * @summary Submit Label
 */
export const submitLabelApiSurfopsEvalItemsItemIdLabelPut = async ({ itemId }, labelSubmitRequest, options) => {
    return customFetch(getSubmitLabelApiSurfopsEvalItemsItemIdLabelPutUrl({ itemId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(labelSubmitRequest)
    });
};
export const getConfirmGroundTruthApiSurfopsEvalItemsItemIdConfirmGroundTruthPostUrl = ({ itemId }) => {
    return `/api/surfops/eval/items/${itemId}/confirm-ground-truth`;
};
/**
 * @summary Confirm Ground Truth
 */
export const confirmGroundTruthApiSurfopsEvalItemsItemIdConfirmGroundTruthPost = async ({ itemId }, options) => {
    return customFetch(getConfirmGroundTruthApiSurfopsEvalItemsItemIdConfirmGroundTruthPostUrl({ itemId }), {
        ...options,
        method: 'POST'
    });
};
export const getSaveDraftApiSurfopsEvalItemsItemIdDraftPutUrl = ({ itemId }) => {
    return `/api/surfops/eval/items/${itemId}/draft`;
};
/**
 * @summary Save Draft
 */
export const saveDraftApiSurfopsEvalItemsItemIdDraftPut = async ({ itemId }, draftLabelRequest, options) => {
    return customFetch(getSaveDraftApiSurfopsEvalItemsItemIdDraftPutUrl({ itemId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(draftLabelRequest)
    });
};
export const getExcludeItemApiSurfopsEvalItemsItemIdExcludePostUrl = ({ itemId }) => {
    return `/api/surfops/eval/items/${itemId}/exclude`;
};
/**
 * @summary Exclude Item
 */
export const excludeItemApiSurfopsEvalItemsItemIdExcludePost = async ({ itemId }, reviewDispositionRequest, options) => {
    return customFetch(getExcludeItemApiSurfopsEvalItemsItemIdExcludePostUrl({ itemId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(reviewDispositionRequest)
    });
};
export const getSetItemStarredApiSurfopsEvalItemsItemIdStarPutUrl = ({ itemId }) => {
    return `/api/surfops/eval/items/${itemId}/star`;
};
/**
 * @summary Set Item Starred
 */
export const setItemStarredApiSurfopsEvalItemsItemIdStarPut = async ({ itemId }, starItemRequest, options) => {
    return customFetch(getSetItemStarredApiSurfopsEvalItemsItemIdStarPutUrl({ itemId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(starItemRequest)
    });
};
export const getListRunsApiSurfopsEvalDatasetsDatasetIdRunsGetUrl = ({ datasetId }) => {
    return `/api/surfops/eval/datasets/${datasetId}/runs`;
};
/**
 * @summary List Runs
 */
export const listRunsApiSurfopsEvalDatasetsDatasetIdRunsGet = async ({ datasetId }, options) => {
    return customFetch(getListRunsApiSurfopsEvalDatasetsDatasetIdRunsGetUrl({ datasetId }), {
        ...options,
        method: 'GET'
    });
};
export const getCreateRunApiSurfopsEvalDatasetsDatasetIdRunsPostUrl = ({ datasetId }) => {
    return `/api/surfops/eval/datasets/${datasetId}/runs`;
};
/**
 * @summary Create Run
 */
export const createRunApiSurfopsEvalDatasetsDatasetIdRunsPost = async ({ datasetId }, createRunRequest, options) => {
    return customFetch(getCreateRunApiSurfopsEvalDatasetsDatasetIdRunsPostUrl({ datasetId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(createRunRequest)
    });
};
export const getEstimateRunCostApiSurfopsEvalDatasetsDatasetIdRunsCostEstimateGetUrl = ({ datasetId }) => {
    return `/api/surfops/eval/datasets/${datasetId}/runs/cost-estimate`;
};
/**
 * @summary Estimate Run Cost
 */
export const estimateRunCostApiSurfopsEvalDatasetsDatasetIdRunsCostEstimateGet = async ({ datasetId }, options) => {
    return customFetch(getEstimateRunCostApiSurfopsEvalDatasetsDatasetIdRunsCostEstimateGetUrl({ datasetId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetRunApiSurfopsEvalRunsRunIdGetUrl = ({ runId }) => {
    return `/api/surfops/eval/runs/${runId}`;
};
/**
 * @summary Get Run
 */
export const getRunApiSurfopsEvalRunsRunIdGet = async ({ runId }, options) => {
    return customFetch(getGetRunApiSurfopsEvalRunsRunIdGetUrl({ runId }), {
        ...options,
        method: 'GET'
    });
};
export const getDeleteRunApiSurfopsEvalRunsRunIdDeleteUrl = ({ runId }) => {
    return `/api/surfops/eval/runs/${runId}`;
};
/**
 * @summary Delete Run
 */
export const deleteRunApiSurfopsEvalRunsRunIdDelete = async ({ runId }, options) => {
    return customFetch(getDeleteRunApiSurfopsEvalRunsRunIdDeleteUrl({ runId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getListRunResultsApiSurfopsEvalRunsRunIdResultsGetUrl = ({ runId }) => {
    return `/api/surfops/eval/runs/${runId}/results`;
};
/**
 * @summary List Run Results
 */
export const listRunResultsApiSurfopsEvalRunsRunIdResultsGet = async ({ runId }, options) => {
    return customFetch(getListRunResultsApiSurfopsEvalRunsRunIdResultsGetUrl({ runId }), {
        ...options,
        method: 'GET'
    });
};
export const getCompareRunsApiSurfopsEvalRunsRunIdCompareBaselineRunIdGetUrl = ({ runId, baselineRunId }) => {
    return `/api/surfops/eval/runs/${runId}/compare/${baselineRunId}`;
};
/**
 * @summary Compare Runs
 */
export const compareRunsApiSurfopsEvalRunsRunIdCompareBaselineRunIdGet = async ({ runId, baselineRunId }, options) => {
    return customFetch(getCompareRunsApiSurfopsEvalRunsRunIdCompareBaselineRunIdGetUrl({ runId, baselineRunId }), {
        ...options,
        method: 'GET'
    });
};
export const getListPipelineDefinitionsApiSurfopsPipelinesDefinitionsGetUrl = () => {
    return `/api/surfops/pipelines/definitions`;
};
/**
 * @summary List Pipeline Definitions
 */
export const listPipelineDefinitionsApiSurfopsPipelinesDefinitionsGet = async (options) => {
    return customFetch(getListPipelineDefinitionsApiSurfopsPipelinesDefinitionsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getStartPipelineRunApiSurfopsPipelinesStartPostUrl = () => {
    return `/api/surfops/pipelines/start`;
};
/**
 * Queue a new pipeline run (creates a ``PipelineDirective`` and enqueues the ``PIPELINE`` worker job).
 * @summary Start Pipeline Run
 */
export const startPipelineRunApiSurfopsPipelinesStartPost = async (queuePipelineRequest, options) => {
    return customFetch(getStartPipelineRunApiSurfopsPipelinesStartPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(queuePipelineRequest)
    });
};
export const getListPipelineRunsApiSurfopsPipelinesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["status"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/pipelines?${stringifiedParams}` : `/api/surfops/pipelines`;
};
/**
 * @summary List Pipeline Runs
 */
export const listPipelineRunsApiSurfopsPipelinesGet = async (params, options) => {
    return customFetch(getListPipelineRunsApiSurfopsPipelinesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetPipelineRunApiSurfopsPipelinesPipelineDirectiveIdGetUrl = ({ pipelineDirectiveId }) => {
    return `/api/surfops/pipelines/${pipelineDirectiveId}`;
};
/**
 * @summary Get Pipeline Run
 */
export const getPipelineRunApiSurfopsPipelinesPipelineDirectiveIdGet = async ({ pipelineDirectiveId }, options) => {
    return customFetch(getGetPipelineRunApiSurfopsPipelinesPipelineDirectiveIdGetUrl({ pipelineDirectiveId }), {
        ...options,
        method: 'GET'
    });
};
export const getListStepAwaitablesApiSurfopsPipelinesPipelineDirectiveIdStepsStepDirectiveIdAwaitablesGetUrl = ({ pipelineDirectiveId, stepDirectiveId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["status", "kind"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/pipelines/${pipelineDirectiveId}/steps/${stepDirectiveId}/awaitables?${stringifiedParams}` : `/api/surfops/pipelines/${pipelineDirectiveId}/steps/${stepDirectiveId}/awaitables`;
};
/**
 * Page through one step's awaitables, enriched with each target's current
 * state. Backs the pipeline-run UI's "view all" drill-in so the detail
 * endpoint can stay lightweight (aggregate counts + a small preview) even
 * when a step is fanned out across thousands of awaitables.
 * @summary List Step Awaitables
 */
export const listStepAwaitablesApiSurfopsPipelinesPipelineDirectiveIdStepsStepDirectiveIdAwaitablesGet = async ({ pipelineDirectiveId, stepDirectiveId }, params, options) => {
    return customFetch(getListStepAwaitablesApiSurfopsPipelinesPipelineDirectiveIdStepsStepDirectiveIdAwaitablesGetUrl({ pipelineDirectiveId, stepDirectiveId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getRerunPipelineFromStepApiSurfopsPipelinesPipelineDirectiveIdRerunFromStepPostUrl = ({ pipelineDirectiveId }) => {
    return `/api/surfops/pipelines/${pipelineDirectiveId}/rerun-from-step`;
};
/**
 * @summary Rerun Pipeline From Step
 */
export const rerunPipelineFromStepApiSurfopsPipelinesPipelineDirectiveIdRerunFromStepPost = async ({ pipelineDirectiveId }, rerunFromStepRequest, options) => {
    return customFetch(getRerunPipelineFromStepApiSurfopsPipelinesPipelineDirectiveIdRerunFromStepPostUrl({ pipelineDirectiveId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(rerunFromStepRequest)
    });
};
export const getRestartPipelineRunApiSurfopsPipelinesPipelineDirectiveIdRestartPostUrl = ({ pipelineDirectiveId }) => {
    return `/api/surfops/pipelines/${pipelineDirectiveId}/restart`;
};
/**
 * Re-enqueue a worker job for a stranded pipeline (one whose job_id is null
 * or whose assigned job has already finished).  Use this when a pipeline is
 * stuck because no worker is processing it, without resetting any step state.
 * @summary Restart Pipeline Run
 */
export const restartPipelineRunApiSurfopsPipelinesPipelineDirectiveIdRestartPost = async ({ pipelineDirectiveId }, options) => {
    return customFetch(getRestartPipelineRunApiSurfopsPipelinesPipelineDirectiveIdRestartPostUrl({ pipelineDirectiveId }), {
        ...options,
        method: 'POST'
    });
};
export const getUnpausePipelineRunApiSurfopsPipelinesPipelineDirectiveIdUnpausePostUrl = ({ pipelineDirectiveId }) => {
    return `/api/surfops/pipelines/${pipelineDirectiveId}/unpause`;
};
/**
 * @summary Unpause Pipeline Run
 */
export const unpausePipelineRunApiSurfopsPipelinesPipelineDirectiveIdUnpausePost = async ({ pipelineDirectiveId }, options) => {
    return customFetch(getUnpausePipelineRunApiSurfopsPipelinesPipelineDirectiveIdUnpausePostUrl({ pipelineDirectiveId }), {
        ...options,
        method: 'POST'
    });
};
export const getCancelPipelineRunApiSurfopsPipelinesPipelineDirectiveIdCancelPostUrl = ({ pipelineDirectiveId }) => {
    return `/api/surfops/pipelines/${pipelineDirectiveId}/cancel`;
};
/**
 * Move a non-terminal pipeline to the terminal CANCELLED state. Used to lay
 * a zombied pipeline (its job finished but it never reached a terminal
 * status) to rest so it stops showing as stuck.
 * @summary Cancel Pipeline Run
 */
export const cancelPipelineRunApiSurfopsPipelinesPipelineDirectiveIdCancelPost = async ({ pipelineDirectiveId }, options) => {
    return customFetch(getCancelPipelineRunApiSurfopsPipelinesPipelineDirectiveIdCancelPostUrl({ pipelineDirectiveId }), {
        ...options,
        method: 'POST'
    });
};
export const getReschedulePipelineRunApiSurfopsPipelinesPipelineDirectiveIdReschedulePostUrl = ({ pipelineDirectiveId }) => {
    return `/api/surfops/pipelines/${pipelineDirectiveId}/reschedule`;
};
/**
 * Queue a fresh worker job and attach it to an existing (zombied) pipeline
 * so it resumes from its current step. No step state is reset.
 * @summary Reschedule Pipeline Run
 */
export const reschedulePipelineRunApiSurfopsPipelinesPipelineDirectiveIdReschedulePost = async ({ pipelineDirectiveId }, options) => {
    return customFetch(getReschedulePipelineRunApiSurfopsPipelinesPipelineDirectiveIdReschedulePostUrl({ pipelineDirectiveId }), {
        ...options,
        method: 'POST'
    });
};
export const getReschedulePipelineFromStepApiSurfopsPipelinesPipelineDirectiveIdRescheduleFromStepPostUrl = ({ pipelineDirectiveId }) => {
    return `/api/surfops/pipelines/${pipelineDirectiveId}/reschedule-from-step`;
};
/**
 * Reset a zombied (non-terminal) pipeline back to a specific step, then
 * queue a fresh worker job and attach it so the pipeline resumes from that
 * step. Like ``reschedule`` but also rewinds the pipeline's step state.
 * @summary Reschedule Pipeline From Step
 */
export const reschedulePipelineFromStepApiSurfopsPipelinesPipelineDirectiveIdRescheduleFromStepPost = async ({ pipelineDirectiveId }, rerunFromStepRequest, options) => {
    return customFetch(getReschedulePipelineFromStepApiSurfopsPipelinesPipelineDirectiveIdRescheduleFromStepPostUrl({ pipelineDirectiveId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(rerunFromStepRequest)
    });
};
export const getListExternalJobsApiSurfopsExternalJobsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["job_type", "status"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/external-jobs?${stringifiedParams}` : `/api/surfops/external-jobs`;
};
/**
 * Paginated external jobs, newest first.
 *
 * ``document_id`` / ``property_id`` match the indexed ``filter_metadata``
 * projection, so they only find rows of a type that declares them in
 * ``get_filter_metadata()`` — batch rows carry neither, and rows created before that
 * column existed carry nothing at all.
 * @summary List External Jobs
 */
export const listExternalJobsApiSurfopsExternalJobsGet = async (params, options) => {
    return customFetch(getListExternalJobsApiSurfopsExternalJobsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetBatchCircuitBreakerStatusApiSurfopsExternalJobsCircuitBreakerGetUrl = () => {
    return `/api/surfops/external-jobs/circuit-breaker`;
};
/**
 * Whether batch submission is currently shut off, and why.
 *
 * ``tripped`` true means every extraction is running inline (batches are not being
 * attempted) until the breaker is reset; ``providers`` carries the provider that
 * rate-limited us, when, and the provider error. ``backend`` is ``redis`` when the
 * state is shared fleet-wide, or ``in_process`` when Redis is unavailable and the
 * answer only describes this API process.
 * @summary Get Batch Circuit Breaker Status
 */
export const getBatchCircuitBreakerStatusApiSurfopsExternalJobsCircuitBreakerGet = async (options) => {
    return customFetch(getGetBatchCircuitBreakerStatusApiSurfopsExternalJobsCircuitBreakerGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getResetBatchCircuitBreakerApiSurfopsExternalJobsCircuitBreakerResetPostUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/external-jobs/circuit-breaker/reset?${stringifiedParams}` : `/api/surfops/external-jobs/circuit-breaker/reset`;
};
/**
 * Close the breaker and resume batching. Jobs already awaiting a provider batch are
 * unaffected either way — this only governs whether *new* batches are attempted.
 *
 * 503 if the shared breaker store could not be updated: batching is still shut off
 * for the providers named in the detail, and reporting success would tell an
 * operator batching is back when every worker is still shedding to inline.
 * @summary Reset Batch Circuit Breaker
 */
export const resetBatchCircuitBreakerApiSurfopsExternalJobsCircuitBreakerResetPost = async (params, options) => {
    return customFetch(getResetBatchCircuitBreakerApiSurfopsExternalJobsCircuitBreakerResetPostUrl(params), {
        ...options,
        method: 'POST'
    });
};
export const getGetExternalJobsForDocumentApiSurfopsExternalJobsByDocumentDocumentIdGetUrl = ({ documentId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/external-jobs/by-document/${documentId}?${stringifiedParams}` : `/api/surfops/external-jobs/by-document/${documentId}`;
};
/**
 * Every external job that touched a document, the batches they were pooled into, and
 * the lease audit runs that evaluated it.
 *
 * Deliberately *blind-linkable*: a caller with only a document id can hit this and
 * get an empty answer rather than a 404, because not every document is ever part of
 * an external job, and external jobs are eventually deleted.
 * @summary Get External Jobs For Document
 */
export const getExternalJobsForDocumentApiSurfopsExternalJobsByDocumentDocumentIdGet = async ({ documentId }, params, options) => {
    return customFetch(getGetExternalJobsForDocumentApiSurfopsExternalJobsByDocumentDocumentIdGetUrl({ documentId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetExternalJobApiSurfopsExternalJobsExternalJobIdGetUrl = ({ externalJobId }) => {
    return `/api/surfops/external-jobs/${externalJobId}`;
};
/**
 * @summary Get External Job
 */
export const getExternalJobApiSurfopsExternalJobsExternalJobIdGet = async ({ externalJobId }, options) => {
    return customFetch(getGetExternalJobApiSurfopsExternalJobsExternalJobIdGetUrl({ externalJobId }), {
        ...options,
        method: 'GET'
    });
};
export const getProxyExternalJobResourceApiSurfopsExternalJobsExternalJobIdProxyGetUrl = ({ externalJobId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/external-jobs/${externalJobId}/proxy?${stringifiedParams}` : `/api/surfops/external-jobs/${externalJobId}/proxy`;
};
/**
 * Fetch one external job's state from wherever it actually lives, and return the
 * request and the response side by side.
 *
 * **Why an endpoint and not a link to the provider console.** A row's
 * ``external_id`` is a Gemini/OpenAI batch id in *our* account: nobody can open it
 * without our credentials, and the row's ``status`` is our mapping of what the
 * provider last said, refreshed only when a worker happened to poll. This asks the
 * provider now, with the credentials the fleet uses, and shows the raw answer — so
 * "the row says in_progress" and "the provider says failed" become distinguishable
 * without a shell on a worker.
 *
 * **Read-only, always.** Nothing here submits, cancels, or advances a job — cancel
 * is its own endpoint precisely so this one can be linked from a page and opened
 * without consequence.
 *
 * The five resources, and which rows answer them, are on
 * :class:`ExternalJobProxyResource`; a row's own list is ``proxy_resources`` on its
 * detail response. Provider failures come back as 502 with the provider's message
 * rather than as an empty payload, because "the call failed" and "the batch is
 * empty" are the two answers this exists to tell apart.
 * @summary Proxy External Job Resource
 */
export const proxyExternalJobResourceApiSurfopsExternalJobsExternalJobIdProxyGet = async ({ externalJobId }, params, options) => {
    return customFetch(getProxyExternalJobResourceApiSurfopsExternalJobsExternalJobIdProxyGetUrl({ externalJobId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getCancelExternalJobApiSurfopsExternalJobsExternalJobIdCancelPostUrl = ({ externalJobId }) => {
    return `/api/surfops/external-jobs/${externalJobId}/cancel`;
};
/**
 * Stop a non-terminal external job. Resolves the job's manager from its class_type
 * and calls ``cancel()`` (for a batch: provider cancel + mark batch and items
 * CANCELLED). Implementation-agnostic so it works for any external-job type.
 * @summary Cancel External Job
 */
export const cancelExternalJobApiSurfopsExternalJobsExternalJobIdCancelPost = async ({ externalJobId }, options) => {
    return customFetch(getCancelExternalJobApiSurfopsExternalJobsExternalJobIdCancelPostUrl({ externalJobId }), {
        ...options,
        method: 'POST'
    });
};
export const getListEmailOutboxEntriesApiSurfopsEmailOutboxGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/email-outbox?${stringifiedParams}` : `/api/surfops/email-outbox`;
};
/**
 * @summary List Email Outbox Entries
 */
export const listEmailOutboxEntriesApiSurfopsEmailOutboxGet = async (params, options) => {
    return customFetch(getListEmailOutboxEntriesApiSurfopsEmailOutboxGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getListTransitionFileUploadsApiSurfopsTransitionsFileUploadsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/transitions/file-uploads?${stringifiedParams}` : `/api/surfops/transitions/file-uploads`;
};
/**
 * @summary List Transition File Uploads
 */
export const listTransitionFileUploadsApiSurfopsTransitionsFileUploadsGet = async (params, options) => {
    return customFetch(getListTransitionFileUploadsApiSurfopsTransitionsFileUploadsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetTransitionFileUploadApiSurfopsTransitionsFileUploadsFileUploadIdGetUrl = ({ fileUploadId }) => {
    return `/api/surfops/transitions/file-uploads/${fileUploadId}`;
};
/**
 * @summary Get Transition File Upload
 */
export const getTransitionFileUploadApiSurfopsTransitionsFileUploadsFileUploadIdGet = async ({ fileUploadId }, options) => {
    return customFetch(getGetTransitionFileUploadApiSurfopsTransitionsFileUploadsFileUploadIdGetUrl({ fileUploadId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetTransitionFileUploadManifestApiSurfopsTransitionsFileUploadsFileUploadIdManifestGetUrl = ({ fileUploadId }) => {
    return `/api/surfops/transitions/file-uploads/${fileUploadId}/manifest`;
};
/**
 * @summary Get Transition File Upload Manifest
 */
export const getTransitionFileUploadManifestApiSurfopsTransitionsFileUploadsFileUploadIdManifestGet = async ({ fileUploadId }, options) => {
    return customFetch(getGetTransitionFileUploadManifestApiSurfopsTransitionsFileUploadsFileUploadIdManifestGetUrl({ fileUploadId }), {
        ...options,
        method: 'GET'
    });
};
export const getListTransitionFileUploadFolderFiltersApiSurfopsTransitionsFileUploadsFileUploadIdFolderFiltersGetUrl = ({ fileUploadId }) => {
    return `/api/surfops/transitions/file-uploads/${fileUploadId}/folder-filters`;
};
/**
 * @summary List Transition File Upload Folder Filters
 */
export const listTransitionFileUploadFolderFiltersApiSurfopsTransitionsFileUploadsFileUploadIdFolderFiltersGet = async ({ fileUploadId }, options) => {
    return customFetch(getListTransitionFileUploadFolderFiltersApiSurfopsTransitionsFileUploadsFileUploadIdFolderFiltersGetUrl({ fileUploadId }), {
        ...options,
        method: 'GET'
    });
};
export const getResolveTransitionFileUploadFolderFilterApiSurfopsTransitionsFileUploadsFileUploadIdFolderFiltersFolderFilterIdPatchUrl = ({ fileUploadId, folderFilterId }) => {
    return `/api/surfops/transitions/file-uploads/${fileUploadId}/folder-filters/${folderFilterId}`;
};
/**
 * @summary Resolve Transition File Upload Folder Filter
 */
export const resolveTransitionFileUploadFolderFilterApiSurfopsTransitionsFileUploadsFileUploadIdFolderFiltersFolderFilterIdPatch = async ({ fileUploadId, folderFilterId }, resolveFolderFilterRequest, options) => {
    return customFetch(getResolveTransitionFileUploadFolderFilterApiSurfopsTransitionsFileUploadsFileUploadIdFolderFiltersFolderFilterIdPatchUrl({ fileUploadId, folderFilterId }), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(resolveFolderFilterRequest)
    });
};
export const getContinueTransitionFileUploadApiSurfopsTransitionsFileUploadsFileUploadIdContinuePostUrl = ({ fileUploadId }) => {
    return `/api/surfops/transitions/file-uploads/${fileUploadId}/continue`;
};
/**
 * @summary Continue Transition File Upload
 */
export const continueTransitionFileUploadApiSurfopsTransitionsFileUploadsFileUploadIdContinuePost = async ({ fileUploadId }, options) => {
    return customFetch(getContinueTransitionFileUploadApiSurfopsTransitionsFileUploadsFileUploadIdContinuePostUrl({ fileUploadId }), {
        ...options,
        method: 'POST'
    });
};
export const getApproveTransitionFileUploadSizeApiSurfopsTransitionsFileUploadsFileUploadIdApproveSizePostUrl = ({ fileUploadId }) => {
    return `/api/surfops/transitions/file-uploads/${fileUploadId}/approve-size`;
};
/**
 * @summary Approve Transition File Upload Size
 */
export const approveTransitionFileUploadSizeApiSurfopsTransitionsFileUploadsFileUploadIdApproveSizePost = async ({ fileUploadId }, options) => {
    return customFetch(getApproveTransitionFileUploadSizeApiSurfopsTransitionsFileUploadsFileUploadIdApproveSizePostUrl({ fileUploadId }), {
        ...options,
        method: 'POST'
    });
};
export const getRejectTransitionFileUploadSizeApiSurfopsTransitionsFileUploadsFileUploadIdRejectSizePostUrl = ({ fileUploadId }) => {
    return `/api/surfops/transitions/file-uploads/${fileUploadId}/reject-size`;
};
/**
 * @summary Reject Transition File Upload Size
 */
export const rejectTransitionFileUploadSizeApiSurfopsTransitionsFileUploadsFileUploadIdRejectSizePost = async ({ fileUploadId }, options) => {
    return customFetch(getRejectTransitionFileUploadSizeApiSurfopsTransitionsFileUploadsFileUploadIdRejectSizePostUrl({ fileUploadId }), {
        ...options,
        method: 'POST'
    });
};
export const getListTransitionDocumentsApiSurfopsTransitionsDocumentsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/transitions/documents?${stringifiedParams}` : `/api/surfops/transitions/documents`;
};
/**
 * @summary List Transition Documents
 */
export const listTransitionDocumentsApiSurfopsTransitionsDocumentsGet = async (params, options) => {
    return customFetch(getListTransitionDocumentsApiSurfopsTransitionsDocumentsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getListTransitionOptionsApiSurfopsTransitionsTransitionOptionsGetUrl = () => {
    return `/api/surfops/transitions/transition-options`;
};
/**
 * @summary List Transition Options
 */
export const listTransitionOptionsApiSurfopsTransitionsTransitionOptionsGet = async (options) => {
    return customFetch(getListTransitionOptionsApiSurfopsTransitionsTransitionOptionsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetTransitionDocumentApiSurfopsTransitionsTransitionIdDocumentsDocumentIdGetUrl = ({ transitionId, documentId }) => {
    return `/api/surfops/transitions/${transitionId}/documents/${documentId}`;
};
/**
 * @summary Get Transition Document
 */
export const getTransitionDocumentApiSurfopsTransitionsTransitionIdDocumentsDocumentIdGet = async ({ transitionId, documentId }, options) => {
    return customFetch(getGetTransitionDocumentApiSurfopsTransitionsTransitionIdDocumentsDocumentIdGetUrl({ transitionId, documentId }), {
        ...options,
        method: 'GET'
    });
};
export const getResolveTransitionDocumentSensitivityApiSurfopsTransitionsTransitionIdDocumentsDocumentIdSensitivityResolvePostUrl = ({ transitionId, documentId }) => {
    return `/api/surfops/transitions/${transitionId}/documents/${documentId}/sensitivity/resolve`;
};
/**
 * @summary Resolve Transition Document Sensitivity
 */
export const resolveTransitionDocumentSensitivityApiSurfopsTransitionsTransitionIdDocumentsDocumentIdSensitivityResolvePost = async ({ transitionId, documentId }, resolveTransitionDocumentSensitivityRequest, options) => {
    return customFetch(getResolveTransitionDocumentSensitivityApiSurfopsTransitionsTransitionIdDocumentsDocumentIdSensitivityResolvePostUrl({ transitionId, documentId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(resolveTransitionDocumentSensitivityRequest)
    });
};
export const getListTransitionDocumentClassificationObservationsApiSurfopsTransitionsTransitionIdDocumentsDocumentIdClassificationObservationsGetUrl = ({ transitionId, documentId }) => {
    return `/api/surfops/transitions/${transitionId}/documents/${documentId}/classification-observations`;
};
/**
 * @summary List Transition Document Classification Observations
 */
export const listTransitionDocumentClassificationObservationsApiSurfopsTransitionsTransitionIdDocumentsDocumentIdClassificationObservationsGet = async ({ transitionId, documentId }, options) => {
    return customFetch(getListTransitionDocumentClassificationObservationsApiSurfopsTransitionsTransitionIdDocumentsDocumentIdClassificationObservationsGetUrl({ transitionId, documentId }), {
        ...options,
        method: 'GET'
    });
};
export const getCreateTransitionDocumentClassificationObservationApiSurfopsTransitionsTransitionIdDocumentsDocumentIdClassificationObservationsPostUrl = ({ transitionId, documentId }) => {
    return `/api/surfops/transitions/${transitionId}/documents/${documentId}/classification-observations`;
};
/**
 * @summary Create Transition Document Classification Observation
 */
export const createTransitionDocumentClassificationObservationApiSurfopsTransitionsTransitionIdDocumentsDocumentIdClassificationObservationsPost = async ({ transitionId, documentId }, createTransitionDocumentClassificationObservationRequest, options) => {
    return customFetch(getCreateTransitionDocumentClassificationObservationApiSurfopsTransitionsTransitionIdDocumentsDocumentIdClassificationObservationsPostUrl({ transitionId, documentId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(createTransitionDocumentClassificationObservationRequest)
    });
};
export const getClearTransitionDocumentClassificationObservationsApiSurfopsTransitionsTransitionIdDocumentsDocumentIdClassificationObservationsDeleteUrl = ({ transitionId, documentId }) => {
    return `/api/surfops/transitions/${transitionId}/documents/${documentId}/classification-observations`;
};
/**
 * @summary Clear Transition Document Classification Observations
 */
export const clearTransitionDocumentClassificationObservationsApiSurfopsTransitionsTransitionIdDocumentsDocumentIdClassificationObservationsDelete = async ({ transitionId, documentId }, options) => {
    return customFetch(getClearTransitionDocumentClassificationObservationsApiSurfopsTransitionsTransitionIdDocumentsDocumentIdClassificationObservationsDeleteUrl({ transitionId, documentId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getGetTransitionDocumentProfileApiSurfopsTransitionsTransitionIdDocumentsDocumentIdProfileGetUrl = ({ transitionId, documentId }) => {
    return `/api/surfops/transitions/${transitionId}/documents/${documentId}/profile`;
};
/**
 * @summary Get Transition Document Profile
 */
export const getTransitionDocumentProfileApiSurfopsTransitionsTransitionIdDocumentsDocumentIdProfileGet = async ({ transitionId, documentId }, options) => {
    return customFetch(getGetTransitionDocumentProfileApiSurfopsTransitionsTransitionIdDocumentsDocumentIdProfileGetUrl({ transitionId, documentId }), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateTransitionDocumentProfileApiSurfopsTransitionsTransitionIdDocumentsDocumentIdProfilePutUrl = ({ transitionId, documentId }) => {
    return `/api/surfops/transitions/${transitionId}/documents/${documentId}/profile`;
};
/**
 * @summary Update Transition Document Profile
 */
export const updateTransitionDocumentProfileApiSurfopsTransitionsTransitionIdDocumentsDocumentIdProfilePut = async ({ transitionId, documentId }, updateTransitionDocumentProfileApiSurfopsTransitionsTransitionIdDocumentsDocumentIdProfilePutBody, options) => {
    return customFetch(getUpdateTransitionDocumentProfileApiSurfopsTransitionsTransitionIdDocumentsDocumentIdProfilePutUrl({ transitionId, documentId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(updateTransitionDocumentProfileApiSurfopsTransitionsTransitionIdDocumentsDocumentIdProfilePutBody)
    });
};
export const getGetTransitionDocumentExtractionApiSurfopsTransitionsTransitionIdDocumentsDocumentIdExtractionGetUrl = ({ transitionId, documentId }) => {
    return `/api/surfops/transitions/${transitionId}/documents/${documentId}/extraction`;
};
/**
 * @summary Get Transition Document Extraction
 */
export const getTransitionDocumentExtractionApiSurfopsTransitionsTransitionIdDocumentsDocumentIdExtractionGet = async ({ transitionId, documentId }, options) => {
    return customFetch(getGetTransitionDocumentExtractionApiSurfopsTransitionsTransitionIdDocumentsDocumentIdExtractionGetUrl({ transitionId, documentId }), {
        ...options,
        method: 'GET'
    });
};
export const getUpdateTransitionDocumentExtractionApiSurfopsTransitionsTransitionIdDocumentsDocumentIdExtractionPutUrl = ({ transitionId, documentId }) => {
    return `/api/surfops/transitions/${transitionId}/documents/${documentId}/extraction`;
};
/**
 * @summary Update Transition Document Extraction
 */
export const updateTransitionDocumentExtractionApiSurfopsTransitionsTransitionIdDocumentsDocumentIdExtractionPut = async ({ transitionId, documentId }, transitionDocumentExtractionUpdateRequest, options) => {
    return customFetch(getUpdateTransitionDocumentExtractionApiSurfopsTransitionsTransitionIdDocumentsDocumentIdExtractionPutUrl({ transitionId, documentId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(transitionDocumentExtractionUpdateRequest)
    });
};
export const getUpdateTransitionDocumentIndexApiSurfopsTransitionsTransitionIdDocumentsDocumentIdIndexPutUrl = ({ transitionId, documentId }) => {
    return `/api/surfops/transitions/${transitionId}/documents/${documentId}/index`;
};
/**
 * @summary Update Transition Document Index
 */
export const updateTransitionDocumentIndexApiSurfopsTransitionsTransitionIdDocumentsDocumentIdIndexPut = async ({ transitionId, documentId }, transitionIndexedDocumentUpdateRequest, options) => {
    return customFetch(getUpdateTransitionDocumentIndexApiSurfopsTransitionsTransitionIdDocumentsDocumentIdIndexPutUrl({ transitionId, documentId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(transitionIndexedDocumentUpdateRequest)
    });
};
export const getGetTransitionDocumentContentsApiSurfopsTransitionsTransitionIdDocumentsDocumentIdContentsGetUrl = ({ transitionId, documentId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/transitions/${transitionId}/documents/${documentId}/contents?${stringifiedParams}` : `/api/surfops/transitions/${transitionId}/documents/${documentId}/contents`;
};
/**
 * @summary Get Transition Document Contents
 */
export const getTransitionDocumentContentsApiSurfopsTransitionsTransitionIdDocumentsDocumentIdContentsGet = async ({ transitionId, documentId }, params, options) => {
    return customFetch(getGetTransitionDocumentContentsApiSurfopsTransitionsTransitionIdDocumentsDocumentIdContentsGetUrl({ transitionId, documentId }, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetTransitionDocumentContentMetadataApiSurfopsTransitionsTransitionIdDocumentsDocumentIdContentsMetadataGetUrl = ({ transitionId, documentId }) => {
    return `/api/surfops/transitions/${transitionId}/documents/${documentId}/contents/metadata`;
};
/**
 * @summary Get Transition Document Content Metadata
 */
export const getTransitionDocumentContentMetadataApiSurfopsTransitionsTransitionIdDocumentsDocumentIdContentsMetadataGet = async ({ transitionId, documentId }, options) => {
    return customFetch(getGetTransitionDocumentContentMetadataApiSurfopsTransitionsTransitionIdDocumentsDocumentIdContentsMetadataGetUrl({ transitionId, documentId }), {
        ...options,
        method: 'GET'
    });
};
export const getReindexTransitionDocumentApiSurfopsTransitionsTransitionIdDocumentsDocumentIdReindexPostUrl = ({ transitionId, documentId }) => {
    return `/api/surfops/transitions/${transitionId}/documents/${documentId}/reindex`;
};
/**
 * @summary Reindex Transition Document
 */
export const reindexTransitionDocumentApiSurfopsTransitionsTransitionIdDocumentsDocumentIdReindexPost = async ({ transitionId, documentId }, options) => {
    return customFetch(getReindexTransitionDocumentApiSurfopsTransitionsTransitionIdDocumentsDocumentIdReindexPostUrl({ transitionId, documentId }), {
        ...options,
        method: 'POST'
    });
};
export const getListClassificationsApiSurfopsClassificationSetupGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/classification-setup?${stringifiedParams}` : `/api/surfops/classification-setup`;
};
/**
 * @summary List Classifications
 */
export const listClassificationsApiSurfopsClassificationSetupGet = async (params, options) => {
    return customFetch(getListClassificationsApiSurfopsClassificationSetupGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetClassificationSetupApiSurfopsClassificationSetupClassificationGetUrl = ({ classification }) => {
    return `/api/surfops/classification-setup/${classification}`;
};
/**
 * @summary Get Classification Setup
 */
export const getClassificationSetupApiSurfopsClassificationSetupClassificationGet = async ({ classification }, options) => {
    return customFetch(getGetClassificationSetupApiSurfopsClassificationSetupClassificationGetUrl({ classification }), {
        ...options,
        method: 'GET'
    });
};
export const getUpsertClassificationSetupApiSurfopsClassificationSetupClassificationPutUrl = ({ classification }) => {
    return `/api/surfops/classification-setup/${classification}`;
};
/**
 * @summary Upsert Classification Setup
 */
export const upsertClassificationSetupApiSurfopsClassificationSetupClassificationPut = async ({ classification }, classificationSetupUpdateRequest, options) => {
    return customFetch(getUpsertClassificationSetupApiSurfopsClassificationSetupClassificationPutUrl({ classification }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(classificationSetupUpdateRequest)
    });
};
export const getCreateDebugDocumentRequestApiSurfopsTransitionsTransitionIdDebugDocumentRequestsPostUrl = ({ transitionId }) => {
    return `/api/surfops/transitions/${transitionId}/debug/document-requests`;
};
/**
 * Create a debug-only `document_request` and kick off its first turn.
 *
 * Body is a `DocumentRequest` in all but name — the underlying
 * `TransitionDocumentRequestService.create_document_request`
 * flow runs unchanged. What differs:
 *
 * - `name` is prepended with `[DEBUG] ` so the delete endpoint
 *   can safely refuse anything without the prefix. Refuses if
 *   the caller already includes `[DEBUG]` (avoids double-prefix).
 * - The whole call happens under `using_agent_debug`, so
 *   `_initiate_agentic_document_request` → `start_document_request`
 *   → `queue_turn` snapshot the debug marker onto the directive
 *   via `JobQueueClient` and the worker restores it before
 *   `action()` runs.
 * - `is_agentic=True` is forced; the legacy email path is not
 *   debuggable by this endpoint.
 * @summary Create Debug Document Request
 */
export const createDebugDocumentRequestApiSurfopsTransitionsTransitionIdDebugDocumentRequestsPost = async ({ transitionId }, createDebugDocumentRequestBody, options) => {
    return customFetch(getCreateDebugDocumentRequestApiSurfopsTransitionsTransitionIdDebugDocumentRequestsPostUrl({ transitionId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(createDebugDocumentRequestBody)
    });
};
export const getStartDebugDocumentRequestApiSurfopsTransitionsTransitionIdDocumentRequestsDocumentRequestIdDebugStartDocumentRequestPostUrl = ({ transitionId, documentRequestId }) => {
    return `/api/surfops/transitions/${transitionId}/document-requests/${documentRequestId}/debug/start-document-request`;
};
/**
 * Queue a first-turn job for every recipient of the doc request.
 *
 * Used when running debug against an *existing* production doc
 * request (e.g. clicking "Debug this agent" on a real request).
 * Fans out over every recipient
 * `_build_document_request_recipients` returns — matching
 * production `_initiate_agentic_document_request` semantics —
 * rather than scoping to one recipient. Under `using_agent_debug`,
 * `OperatorRepo` namespaces every `agent_conversation` lookup
 * to `debug:{recipient_email}`, so the debug session slots
 * never touch production memory.
 * @summary Start Debug Document Request
 */
export const startDebugDocumentRequestApiSurfopsTransitionsTransitionIdDocumentRequestsDocumentRequestIdDebugStartDocumentRequestPost = async ({ transitionId, documentRequestId }, options) => {
    return customFetch(getStartDebugDocumentRequestApiSurfopsTransitionsTransitionIdDocumentRequestsDocumentRequestIdDebugStartDocumentRequestPostUrl({ transitionId, documentRequestId }), {
        ...options,
        method: 'POST'
    });
};
export const getSimulateInboundDebugEmailApiSurfopsTransitionsTransitionIdDocumentRequestsDocumentRequestIdDebugInboundEmailPostUrl = ({ transitionId, documentRequestId }) => {
    return `/api/surfops/transitions/${transitionId}/document-requests/${documentRequestId}/debug/inbound-email`;
};
/**
 * Persist a synthetic inbound email and queue a debug INBOUND turn.
 *
 * The admin-only debug UI wants full parity with production's
 * inbound-reply pipeline: same sender-is-a-user guard, same
 * tenant permission guard, same coordinator prompt shape. We
 * get that by persisting the debug email row inline (so the
 * `debug-not-sent-*` provider ids are stamped end-to-end) and
 * then handing the persisted entity to
 * `TransitionDocRequestAgentService2.handle_inbound_email` for
 * the guards + `queue_turn` call. The debug row is always
 * persisted; a `None` `job_id` in the response indicates the
 * service skipped queueing (e.g. sender not resolvable), which
 * the UI surfaces so the admin can see why.
 *
 * `to_address` defaults to the tenant's agent user email — the
 * debug UI locks its reply form to that value so replies land
 * on the agent inbox by default. When the tenant hasn't
 * configured `agent_user_id` and the caller also omitted
 * `to_address`, we 400 rather than silently persisting a row
 * with an empty `to:` field.
 *
 * Threading:
 * - If the request body carries `reply_to_provider_conversation_id`
 *   we stitch onto that thread and set `in_reply_to` from the body
 *   so the coordinator sees the reply as threaded.
 * - Otherwise (cold inbound) we mint a fresh
 *   `debug-not-sent-conv-*` id — one thread per cold inbound.
 * - The old behaviour of always grabbing "the first debug
 *   conversation" was wrong once multiple debug threads existed;
 *   the UI now passes the clicked message's ids explicitly.
 * @summary Simulate Inbound Debug Email
 */
export const simulateInboundDebugEmailApiSurfopsTransitionsTransitionIdDocumentRequestsDocumentRequestIdDebugInboundEmailPost = async ({ transitionId, documentRequestId }, simulateInboundEmailBody, options) => {
    return customFetch(getSimulateInboundDebugEmailApiSurfopsTransitionsTransitionIdDocumentRequestsDocumentRequestIdDebugInboundEmailPostUrl({ transitionId, documentRequestId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(simulateInboundEmailBody)
    });
};
export const getResetDebugConversationApiSurfopsTransitionsTransitionIdDocumentRequestsDocumentRequestIdDebugResetPostUrl = ({ transitionId, documentRequestId }) => {
    return `/api/surfops/transitions/${transitionId}/document-requests/${documentRequestId}/debug/reset`;
};
/**
 * Wipe every debug session + debug email thread on the doc request.
 *
 * Deletes:
 * - the `agent_conversation` row keyed on `debug:{recipient}`
 *   for *every* recipient the doc request currently resolves
 *   (via `_build_document_request_recipients`) so the next
 *   Start mints fresh Anthropic sessions across the board;
 * - every debug `email_conversation` / `email_message` tied to
 *   this doc request.
 *
 * The Anthropic sessions are orphaned by design (beta.sessions
 * has no delete primitive) — that's fine because the composite
 * session-slot key changes on the next start.
 * @summary Reset Debug Conversation
 */
export const resetDebugConversationApiSurfopsTransitionsTransitionIdDocumentRequestsDocumentRequestIdDebugResetPost = async ({ transitionId, documentRequestId }, options) => {
    return customFetch(getResetDebugConversationApiSurfopsTransitionsTransitionIdDocumentRequestsDocumentRequestIdDebugResetPostUrl({ transitionId, documentRequestId }), {
        ...options,
        method: 'POST'
    });
};
export const getListTurnLogsApiSurfopsTransitionsTransitionIdDocumentRequestsDocumentRequestIdTurnLogsGetUrl = ({ transitionId, documentRequestId }) => {
    return `/api/surfops/transitions/${transitionId}/document-requests/${documentRequestId}/turn-logs`;
};
/**
 * List the recent turn-log records for a document request.
 *
 * Each row corresponds to one queued turn. The actual log
 * contents live in S3 and are fetched lazily via the sibling
 * ``.../turn-logs/{job_id}/content`` endpoint when the admin
 * expands a row in the panel.
 *
 * We enforce transition scope first (404 if the doc request is
 * not on this transition) so an admin cannot use this endpoint
 * to enumerate other transitions' log rows by guessing ids.
 * @summary List Turn Logs
 */
export const listTurnLogsApiSurfopsTransitionsTransitionIdDocumentRequestsDocumentRequestIdTurnLogsGet = async ({ transitionId, documentRequestId }, options) => {
    return customFetch(getListTurnLogsApiSurfopsTransitionsTransitionIdDocumentRequestsDocumentRequestIdTurnLogsGetUrl({ transitionId, documentRequestId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetTurnLogContentApiSurfopsTransitionsTransitionIdDocumentRequestsDocumentRequestIdTurnLogsJobIdContentGetUrl = ({ transitionId, documentRequestId, jobId }) => {
    return `/api/surfops/transitions/${transitionId}/document-requests/${documentRequestId}/turn-logs/${jobId}/content`;
};
/**
 * Fetch the full S3-backed log contents for one turn.
 *
 * Two authorization checks before we hit S3:
 *
 * 1. The document request must belong to this transition (404 if
 *    not) — same shape as ``list_turn_logs``.
 * 2. There must be a turn-log row for ``job_id`` scoped to this
 *    doc request (404 if not). This ensures an admin cannot use
 *    this endpoint as an arbitrary S3-read proxy — they can only
 *    fetch objects that a worker previously registered.
 *
 * The response body carries the entire log as a single UTF-8
 * string; the frontend renders it in a scrollable ``<pre>``.
 * @summary Get Turn Log Content
 */
export const getTurnLogContentApiSurfopsTransitionsTransitionIdDocumentRequestsDocumentRequestIdTurnLogsJobIdContentGet = async ({ transitionId, documentRequestId, jobId }, options) => {
    return customFetch(getGetTurnLogContentApiSurfopsTransitionsTransitionIdDocumentRequestsDocumentRequestIdTurnLogsJobIdContentGetUrl({ transitionId, documentRequestId, jobId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetDebugAgentConfigApiSurfopsTransitionsTransitionIdDebugAgentConfigGetUrl = ({ transitionId }) => {
    return `/api/surfops/transitions/${transitionId}/debug/agent-config`;
};
/**
 * Return the agent user config the debug UI needs to compose replies.
 *
 * The reply-compose form in the Conversations tab locks its
 * ``to:`` field to the agent user's email so admins can't
 * accidentally address a simulated inbound to anyone but the
 * agent. This endpoint returns the resolved email (falling back
 * to ``None`` when the tenant hasn't configured
 * `TransitionDocRequestAgentSettings.agent_user_id` yet) so the
 * UI can render the locked field before the first mutation
 * instead of waiting for a failure.
 *
 * Scoped by `transition_id` for path symmetry with the rest of
 * the debug endpoints; the settings themselves are tenant-scoped
 * so `transition_id` is only used to gate access. Admin-gated
 * via `Depends(get_admin_user)`.
 * @summary Get Debug Agent Config
 */
export const getDebugAgentConfigApiSurfopsTransitionsTransitionIdDebugAgentConfigGet = async ({ transitionId }, options) => {
    return customFetch(getGetDebugAgentConfigApiSurfopsTransitionsTransitionIdDebugAgentConfigGetUrl({ transitionId }), {
        ...options,
        method: 'GET'
    });
};
export const getLlmCostsPageApiSurfopsLlmCostsGetUrl = () => {
    return `/api/surfops/llm-costs`;
};
/**
 * LLM Costs page with Chart.js visualization and date range picker
 * @summary Llm Costs Page
 */
export const llmCostsPageApiSurfopsLlmCostsGet = async (options) => {
    return customFetch(getLlmCostsPageApiSurfopsLlmCostsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getLlmCostsDataApiSurfopsLlmCostsDataGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/llm-costs/data?${stringifiedParams}` : `/api/surfops/llm-costs/data`;
};
/**
 * Get LLM costs data for the specified time range.
 * Returns data grouped by time and caller (use case).
 * @summary Llm Costs Data
 */
export const llmCostsDataApiSurfopsLlmCostsDataGet = async (params, options) => {
    return customFetch(getLlmCostsDataApiSurfopsLlmCostsDataGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getLlmCostsPropertyPickerDataApiSurfopsLlmCostsPropertyPickerDataGetUrl = () => {
    return `/api/surfops/llm-costs/property-picker-data`;
};
/**
 * SaaS tenants for the Property Start Up tab; properties load via /api/pms-portal/properties.
 * @summary Llm Costs Property Picker Data
 */
export const llmCostsPropertyPickerDataApiSurfopsLlmCostsPropertyPickerDataGet = async (options) => {
    return customFetch(getLlmCostsPropertyPickerDataApiSurfopsLlmCostsPropertyPickerDataGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getLlmCostsPostSyncBreakdownApiSurfopsLlmCostsPostSyncBreakdownPostUrl = () => {
    return `/api/surfops/llm-costs/post-sync-breakdown`;
};
/**
 * @summary Llm Costs Post Sync Breakdown
 */
export const llmCostsPostSyncBreakdownApiSurfopsLlmCostsPostSyncBreakdownPost = async (postSyncBreakdownRequest, options) => {
    return customFetch(getLlmCostsPostSyncBreakdownApiSurfopsLlmCostsPostSyncBreakdownPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(postSyncBreakdownRequest)
    });
};
export const getLlmCostsPostSyncBreakdownDetailApiSurfopsLlmCostsPostSyncBreakdownDetailGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/llm-costs/post-sync-breakdown/detail?${stringifiedParams}` : `/api/surfops/llm-costs/post-sync-breakdown/detail`;
};
/**
 * @summary Llm Costs Post Sync Breakdown Detail
 */
export const llmCostsPostSyncBreakdownDetailApiSurfopsLlmCostsPostSyncBreakdownDetailGet = async (params, options) => {
    return customFetch(getLlmCostsPostSyncBreakdownDetailApiSurfopsLlmCostsPostSyncBreakdownDetailGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetInvoicedItemsForPeriodApiInternalReportingInvoicedItemsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/internal-reporting/invoiced-items/?${stringifiedParams}` : `/api/internal-reporting/invoiced-items/`;
};
/**
 * @summary Get Invoiced Items For Period
 */
export const getInvoicedItemsForPeriodApiInternalReportingInvoicedItemsGet = async (params, options) => {
    return customFetch(getGetInvoicedItemsForPeriodApiInternalReportingInvoicedItemsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetRevenueEarnedInPeriodApiInternalReportingInvoicedItemsEarnedGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/internal-reporting/invoiced-items-earned/?${stringifiedParams}` : `/api/internal-reporting/invoiced-items-earned/`;
};
/**
 * @summary Get Revenue Earned In Period
 */
export const getRevenueEarnedInPeriodApiInternalReportingInvoicedItemsEarnedGet = async (params, options) => {
    return customFetch(getGetRevenueEarnedInPeriodApiInternalReportingInvoicedItemsEarnedGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetContractedRevenuePlacedInPeriodApiInternalReportingContractedRevenuePlacedInPeriodGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/internal-reporting/contracted-revenue-placed-in-period/?${stringifiedParams}` : `/api/internal-reporting/contracted-revenue-placed-in-period/`;
};
/**
 * @summary Get Contracted Revenue Placed In Period
 */
export const getContractedRevenuePlacedInPeriodApiInternalReportingContractedRevenuePlacedInPeriodGet = async (params, options) => {
    return customFetch(getGetContractedRevenuePlacedInPeriodApiInternalReportingContractedRevenuePlacedInPeriodGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetActiveContractedRevenueAtPointInTimeApiInternalReportingActiveContractedRevenueGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/internal-reporting/active-contracted-revenue/?${stringifiedParams}` : `/api/internal-reporting/active-contracted-revenue/`;
};
/**
 * @summary Get Active Contracted Revenue At Point In Time
 */
export const getActiveContractedRevenueAtPointInTimeApiInternalReportingActiveContractedRevenueGet = async (params, options) => {
    return customFetch(getGetActiveContractedRevenueAtPointInTimeApiInternalReportingActiveContractedRevenueGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetCustomerTotalRevenueApiInternalReportingCustomerTotalRevenueGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["customer_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/internal-reporting/customer-total-revenue/?${stringifiedParams}` : `/api/internal-reporting/customer-total-revenue/`;
};
/**
 * @summary Get Customer Total Revenue
 */
export const getCustomerTotalRevenueApiInternalReportingCustomerTotalRevenueGet = async (params, options) => {
    return customFetch(getGetCustomerTotalRevenueApiInternalReportingCustomerTotalRevenueGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetRecentIncompletePropertiesApiInternalReportingRecentIncompletePropertiesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/internal-reporting/recent-incomplete-properties/?${stringifiedParams}` : `/api/internal-reporting/recent-incomplete-properties/`;
};
/**
 * @summary Get Recent Incomplete Properties
 */
export const getRecentIncompletePropertiesApiInternalReportingRecentIncompletePropertiesGet = async (params, options) => {
    return customFetch(getGetRecentIncompletePropertiesApiInternalReportingRecentIncompletePropertiesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetRecentlyCompletedPropertiesApiInternalReportingRecentlyCompletedPropertiesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/internal-reporting/recently-completed-properties/?${stringifiedParams}` : `/api/internal-reporting/recently-completed-properties/`;
};
/**
 * @summary Get Recently Completed Properties
 */
export const getRecentlyCompletedPropertiesApiInternalReportingRecentlyCompletedPropertiesGet = async (params, options) => {
    return customFetch(getGetRecentlyCompletedPropertiesApiInternalReportingRecentlyCompletedPropertiesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetUnplacedOrdersRecentlyCreatedApiInternalReportingUnplacedOrdersRecentlyCreatedGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/internal-reporting/unplaced-orders-recently-created/?${stringifiedParams}` : `/api/internal-reporting/unplaced-orders-recently-created/`;
};
/**
 * @summary Get Unplaced Orders Recently Created
 */
export const getUnplacedOrdersRecentlyCreatedApiInternalReportingUnplacedOrdersRecentlyCreatedGet = async (params, options) => {
    return customFetch(getGetUnplacedOrdersRecentlyCreatedApiInternalReportingUnplacedOrdersRecentlyCreatedGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetRecentlyPlacedOrdersNotPrepurchasedWithOpenLedgersApiInternalReportingRecentlyPlacedOrdersNotPrepurchasedWithOpenLedgersGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/internal-reporting/recently-placed-orders-not-prepurchased-with-open-ledgers/?${stringifiedParams}` : `/api/internal-reporting/recently-placed-orders-not-prepurchased-with-open-ledgers/`;
};
/**
 * @summary Get Recently Placed Orders Not Prepurchased With Open Ledgers
 */
export const getRecentlyPlacedOrdersNotPrepurchasedWithOpenLedgersApiInternalReportingRecentlyPlacedOrdersNotPrepurchasedWithOpenLedgersGet = async (params, options) => {
    return customFetch(getGetRecentlyPlacedOrdersNotPrepurchasedWithOpenLedgersApiInternalReportingRecentlyPlacedOrdersNotPrepurchasedWithOpenLedgersGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetSummaryApiSurfopsAuditingShadowSummaryGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids", "check_types"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/auditing-shadow/summary?${stringifiedParams}` : `/api/surfops/auditing-shadow/summary`;
};
/**
 * @summary Get Summary
 */
export const getSummaryApiSurfopsAuditingShadowSummaryGet = async (params, options) => {
    return customFetch(getGetSummaryApiSurfopsAuditingShadowSummaryGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetDetailApiSurfopsAuditingShadowDetailGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids", "check_types", "shadow_states", "check_states"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/auditing-shadow/detail?${stringifiedParams}` : `/api/surfops/auditing-shadow/detail`;
};
/**
 * @summary Get Detail
 */
export const getDetailApiSurfopsAuditingShadowDetailGet = async (params, options) => {
    return customFetch(getGetDetailApiSurfopsAuditingShadowDetailGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetCheckTypesApiSurfopsAuditingShadowCheckTypesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/auditing-shadow/check_types?${stringifiedParams}` : `/api/surfops/auditing-shadow/check_types`;
};
/**
 * @summary Get Check Types
 */
export const getCheckTypesApiSurfopsAuditingShadowCheckTypesGet = async (params, options) => {
    return customFetch(getGetCheckTypesApiSurfopsAuditingShadowCheckTypesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetAllCheckTypesApiSurfopsAuditingShadowAllCheckTypesGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/auditing-shadow/all_check_types?${stringifiedParams}` : `/api/surfops/auditing-shadow/all_check_types`;
};
/**
 * @summary Get All Check Types
 */
export const getAllCheckTypesApiSurfopsAuditingShadowAllCheckTypesGet = async (params, options) => {
    return customFetch(getGetAllCheckTypesApiSurfopsAuditingShadowAllCheckTypesGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetVersionReportApiSurfopsAuditingShadowVersionReportGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/auditing-shadow/version_report?${stringifiedParams}` : `/api/surfops/auditing-shadow/version_report`;
};
/**
 * For a tenant, returns the lease_audit_check.logic_version distribution
 * aggregated across the latest run of every open audit over auditable
 * lease periods, broken down by check_type and (within check_type) by
 * property. Null logic_version values are bucketed as "None".
 * @summary Get Version Report
 */
export const getVersionReportApiSurfopsAuditingShadowVersionReportGet = async (params, options) => {
    return customFetch(getGetVersionReportApiSurfopsAuditingShadowVersionReportGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getShadowResultsPageApiSurfopsAuditingShadowResultsGetUrl = () => {
    return `/api/surfops/auditing-shadow/results`;
};
/**
 * @summary Shadow Results Page
 */
export const shadowResultsPageApiSurfopsAuditingShadowResultsGet = async (options) => {
    return customFetch(getShadowResultsPageApiSurfopsAuditingShadowResultsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getShadowDetailPageApiSurfopsAuditingShadowDetailViewGetUrl = () => {
    return `/api/surfops/auditing-shadow/detail-view`;
};
/**
 * @summary Shadow Detail Page
 */
export const shadowDetailPageApiSurfopsAuditingShadowDetailViewGet = async (options) => {
    return customFetch(getShadowDetailPageApiSurfopsAuditingShadowDetailViewGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetDeniedReasonsApiSurfopsAuditingDisallowDeniedReasonsGetUrl = () => {
    return `/api/surfops/auditing-disallow/denied_reasons`;
};
/**
 * @summary Get Denied Reasons
 */
export const getDeniedReasonsApiSurfopsAuditingDisallowDeniedReasonsGet = async (options) => {
    return customFetch(getGetDeniedReasonsApiSurfopsAuditingDisallowDeniedReasonsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetSummaryApiSurfopsAuditingDisallowSummaryGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/auditing-disallow/summary?${stringifiedParams}` : `/api/surfops/auditing-disallow/summary`;
};
/**
 * @summary Get Summary
 */
export const getSummaryApiSurfopsAuditingDisallowSummaryGet = async (params, options) => {
    return customFetch(getGetSummaryApiSurfopsAuditingDisallowSummaryGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetDetailApiSurfopsAuditingDisallowDetailGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/auditing-disallow/detail?${stringifiedParams}` : `/api/surfops/auditing-disallow/detail`;
};
/**
 * @summary Get Detail
 */
export const getDetailApiSurfopsAuditingDisallowDetailGet = async (params, options) => {
    return customFetch(getGetDetailApiSurfopsAuditingDisallowDetailGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getDeleteUserDisallowApiSurfopsAuditingDisallowUserDisallowDeleteUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/auditing-disallow/user_disallow?${stringifiedParams}` : `/api/surfops/auditing-disallow/user_disallow`;
};
/**
 * @summary Delete User Disallow
 */
export const deleteUserDisallowApiSurfopsAuditingDisallowUserDisallowDelete = async (params, options) => {
    return customFetch(getDeleteUserDisallowApiSurfopsAuditingDisallowUserDisallowDeleteUrl(params), {
        ...options,
        method: 'DELETE'
    });
};
export const getDisallowResultsPageApiSurfopsAuditingDisallowResultsGetUrl = () => {
    return `/api/surfops/auditing-disallow/results`;
};
/**
 * @summary Disallow Results Page
 */
export const disallowResultsPageApiSurfopsAuditingDisallowResultsGet = async (options) => {
    return customFetch(getDisallowResultsPageApiSurfopsAuditingDisallowResultsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetFailingAndClosedAuditsApiSurfopsAuditingReportingFailingAndClosedAuditsGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/auditing-reporting/failing-and-closed-audits?${stringifiedParams}` : `/api/surfops/auditing-reporting/failing-and-closed-audits`;
};
/**
 * Paginated audits in the ``failing_and_closed`` bucket of the
 * lease-health-by-property report for lease periods that are currently
 * auditable.
 * @summary Get Failing And Closed Audits
 */
export const getFailingAndClosedAuditsApiSurfopsAuditingReportingFailingAndClosedAuditsGet = async (params, options) => {
    return customFetch(getGetFailingAndClosedAuditsApiSurfopsAuditingReportingFailingAndClosedAuditsGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetFailingAndClosedAuditsCsvApiSurfopsAuditingReportingFailingAndClosedAuditsCsvGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/auditing-reporting/failing-and-closed-audits.csv?${stringifiedParams}` : `/api/surfops/auditing-reporting/failing-and-closed-audits.csv`;
};
/**
 * CSV export (unpaginated) of the failing_and_closed audits for
 * currently auditable lease periods.
 * @summary Get Failing And Closed Audits Csv
 */
export const getFailingAndClosedAuditsCsvApiSurfopsAuditingReportingFailingAndClosedAuditsCsvGet = async (params, options) => {
    return customFetch(getGetFailingAndClosedAuditsCsvApiSurfopsAuditingReportingFailingAndClosedAuditsCsvGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetAuditConfigReportingApiSurfopsAuditingReportingAuditConfigGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["property_ids"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/auditing-reporting/audit-config?${stringifiedParams}` : `/api/surfops/auditing-reporting/audit-config`;
};
/**
 * Aggregates the effective enabled audit checks across the eligible
 * properties for a tenant in one of three modes.
 *
 * The aggregation itself lives in ``configfleetreporting`` so the
 * SurfOps config specialist's ``summarize_audit_checks`` tool reports
 * the same numbers this page does.
 * @summary Get Audit Config Reporting
 */
export const getAuditConfigReportingApiSurfopsAuditingReportingAuditConfigGet = async (params, options) => {
    return customFetch(getGetAuditConfigReportingApiSurfopsAuditingReportingAuditConfigGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getAuditConfigResultsPageApiSurfopsAuditingReportingAuditConfigResultsGetUrl = () => {
    return `/api/surfops/auditing-reporting/audit-config/results`;
};
/**
 * @summary Audit Config Results Page
 */
export const auditConfigResultsPageApiSurfopsAuditingReportingAuditConfigResultsGet = async (options) => {
    return customFetch(getAuditConfigResultsPageApiSurfopsAuditingReportingAuditConfigResultsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getListOnboardingRunsApiSurfopsLeaseAuditPropertyOnboardingGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/lease-audit-property-onboarding?${stringifiedParams}` : `/api/surfops/lease-audit-property-onboarding`;
};
/**
 * @summary List Onboarding Runs
 */
export const listOnboardingRunsApiSurfopsLeaseAuditPropertyOnboardingGet = async (params, options) => {
    return customFetch(getListOnboardingRunsApiSurfopsLeaseAuditPropertyOnboardingGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetLatestOnboardingRunForPropertyApiSurfopsLeaseAuditPropertyOnboardingPropertiesPropertyIdGetUrl = ({ propertyId }) => {
    return `/api/surfops/lease-audit-property-onboarding/properties/${propertyId}`;
};
/**
 * @summary Get Latest Onboarding Run For Property
 */
export const getLatestOnboardingRunForPropertyApiSurfopsLeaseAuditPropertyOnboardingPropertiesPropertyIdGet = async ({ propertyId }, options) => {
    return customFetch(getGetLatestOnboardingRunForPropertyApiSurfopsLeaseAuditPropertyOnboardingPropertiesPropertyIdGetUrl({ propertyId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetOnboardingRunApiSurfopsLeaseAuditPropertyOnboardingRunIdGetUrl = ({ runId }) => {
    return `/api/surfops/lease-audit-property-onboarding/${runId}`;
};
/**
 * @summary Get Onboarding Run
 */
export const getOnboardingRunApiSurfopsLeaseAuditPropertyOnboardingRunIdGet = async ({ runId }, options) => {
    return customFetch(getGetOnboardingRunApiSurfopsLeaseAuditPropertyOnboardingRunIdGetUrl({ runId }), {
        ...options,
        method: 'GET'
    });
};
export const getStartOnboardingApiSurfopsLeaseAuditPropertyOnboardingPropertiesPropertyIdStartPostUrl = ({ propertyId }) => {
    return `/api/surfops/lease-audit-property-onboarding/properties/${propertyId}/start`;
};
/**
 * @summary Start Onboarding
 */
export const startOnboardingApiSurfopsLeaseAuditPropertyOnboardingPropertiesPropertyIdStartPost = async ({ propertyId }, startOnboardingApiSurfopsLeaseAuditPropertyOnboardingPropertiesPropertyIdStartPostBody, options) => {
    return customFetch(getStartOnboardingApiSurfopsLeaseAuditPropertyOnboardingPropertiesPropertyIdStartPostUrl({ propertyId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(startOnboardingApiSurfopsLeaseAuditPropertyOnboardingPropertiesPropertyIdStartPostBody)
    });
};
export const getResumeOnboardingAfterTagsApiSurfopsLeaseAuditPropertyOnboardingRunIdResumePostUrl = ({ runId }) => {
    return `/api/surfops/lease-audit-property-onboarding/${runId}/resume`;
};
/**
 * @summary Resume Onboarding After Tags
 */
export const resumeOnboardingAfterTagsApiSurfopsLeaseAuditPropertyOnboardingRunIdResumePost = async ({ runId }, options) => {
    return customFetch(getResumeOnboardingAfterTagsApiSurfopsLeaseAuditPropertyOnboardingRunIdResumePostUrl({ runId }), {
        ...options,
        method: 'POST'
    });
};
export const getRetryOnboardingAnalysisApiSurfopsLeaseAuditPropertyOnboardingRunIdRetryAnalysisPostUrl = ({ runId }) => {
    return `/api/surfops/lease-audit-property-onboarding/${runId}/retry-analysis`;
};
/**
 * @summary Retry Onboarding Analysis
 */
export const retryOnboardingAnalysisApiSurfopsLeaseAuditPropertyOnboardingRunIdRetryAnalysisPost = async ({ runId }, options) => {
    return customFetch(getRetryOnboardingAnalysisApiSurfopsLeaseAuditPropertyOnboardingRunIdRetryAnalysisPostUrl({ runId }), {
        ...options,
        method: 'POST'
    });
};
export const getRequeueIdleOnboardingAuditsApiSurfopsLeaseAuditPropertyOnboardingRunIdRequeueIdleAuditsPostUrl = ({ runId }) => {
    return `/api/surfops/lease-audit-property-onboarding/${runId}/requeue-idle-audits`;
};
/**
 * @summary Requeue Idle Onboarding Audits
 */
export const requeueIdleOnboardingAuditsApiSurfopsLeaseAuditPropertyOnboardingRunIdRequeueIdleAuditsPost = async ({ runId }, requeueIdleOnboardingAuditsApiSurfopsLeaseAuditPropertyOnboardingRunIdRequeueIdleAuditsPostBody, options) => {
    return customFetch(getRequeueIdleOnboardingAuditsApiSurfopsLeaseAuditPropertyOnboardingRunIdRequeueIdleAuditsPostUrl({ runId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(requeueIdleOnboardingAuditsApiSurfopsLeaseAuditPropertyOnboardingRunIdRequeueIdleAuditsPostBody)
    });
};
export const getRerunOnboardingLeaseApiSurfopsLeaseAuditPropertyOnboardingRunIdRerunLeasePostUrl = ({ runId }) => {
    return `/api/surfops/lease-audit-property-onboarding/${runId}/rerun-lease`;
};
/**
 * @summary Rerun Onboarding Lease
 */
export const rerunOnboardingLeaseApiSurfopsLeaseAuditPropertyOnboardingRunIdRerunLeasePost = async ({ runId }, options) => {
    return customFetch(getRerunOnboardingLeaseApiSurfopsLeaseAuditPropertyOnboardingRunIdRerunLeasePostUrl({ runId }), {
        ...options,
        method: 'POST'
    });
};
export const getWrapOrExpandOnboardingApiSurfopsLeaseAuditPropertyOnboardingRunIdWrapPostUrl = ({ runId }) => {
    return `/api/surfops/lease-audit-property-onboarding/${runId}/wrap`;
};
/**
 * @summary Wrap Or Expand Onboarding
 */
export const wrapOrExpandOnboardingApiSurfopsLeaseAuditPropertyOnboardingRunIdWrapPost = async ({ runId }, wrapOrExpandOnboardingApiSurfopsLeaseAuditPropertyOnboardingRunIdWrapPostBody, options) => {
    return customFetch(getWrapOrExpandOnboardingApiSurfopsLeaseAuditPropertyOnboardingRunIdWrapPostUrl({ runId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(wrapOrExpandOnboardingApiSurfopsLeaseAuditPropertyOnboardingRunIdWrapPostBody)
    });
};
export const getListConfigPropagationRecipientsApiSurfopsLeaseAuditPropertyOnboardingRunIdConfigPropagationRecipientsGetUrl = ({ runId }) => {
    return `/api/surfops/lease-audit-property-onboarding/${runId}/config-propagation/recipients`;
};
/**
 * @summary List Config Propagation Recipients
 */
export const listConfigPropagationRecipientsApiSurfopsLeaseAuditPropertyOnboardingRunIdConfigPropagationRecipientsGet = async ({ runId }, options) => {
    return customFetch(getListConfigPropagationRecipientsApiSurfopsLeaseAuditPropertyOnboardingRunIdConfigPropagationRecipientsGetUrl({ runId }), {
        ...options,
        method: 'GET'
    });
};
export const getPreviewConfigPropagationApiSurfopsLeaseAuditPropertyOnboardingRunIdConfigPropagationPreviewPostUrl = ({ runId }) => {
    return `/api/surfops/lease-audit-property-onboarding/${runId}/config-propagation/preview`;
};
/**
 * @summary Preview Config Propagation
 */
export const previewConfigPropagationApiSurfopsLeaseAuditPropertyOnboardingRunIdConfigPropagationPreviewPost = async ({ runId }, previewConfigPropagationInput, options) => {
    return customFetch(getPreviewConfigPropagationApiSurfopsLeaseAuditPropertyOnboardingRunIdConfigPropagationPreviewPostUrl({ runId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(previewConfigPropagationInput)
    });
};
export const getApplyConfigPropagationApiSurfopsLeaseAuditPropertyOnboardingRunIdConfigPropagationApplyPostUrl = ({ runId }) => {
    return `/api/surfops/lease-audit-property-onboarding/${runId}/config-propagation/apply`;
};
/**
 * @summary Apply Config Propagation
 */
export const applyConfigPropagationApiSurfopsLeaseAuditPropertyOnboardingRunIdConfigPropagationApplyPost = async ({ runId }, applyConfigPropagationInput, options) => {
    return customFetch(getApplyConfigPropagationApiSurfopsLeaseAuditPropertyOnboardingRunIdConfigPropagationApplyPostUrl({ runId }), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(applyConfigPropagationInput)
    });
};
export const getDiscardConfigPropagationApiSurfopsLeaseAuditPropertyOnboardingRunIdConfigPropagationDiscardPostUrl = ({ runId }, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/lease-audit-property-onboarding/${runId}/config-propagation/discard?${stringifiedParams}` : `/api/surfops/lease-audit-property-onboarding/${runId}/config-propagation/discard`;
};
/**
 * @summary Discard Config Propagation
 */
export const discardConfigPropagationApiSurfopsLeaseAuditPropertyOnboardingRunIdConfigPropagationDiscardPost = async ({ runId }, params, options) => {
    return customFetch(getDiscardConfigPropagationApiSurfopsLeaseAuditPropertyOnboardingRunIdConfigPropagationDiscardPostUrl({ runId }, params), {
        ...options,
        method: 'POST'
    });
};
export const getStartOnboardingAuditsApiSurfopsLeaseAuditPropertyOnboardingRunIdStartAuditsPostUrl = ({ runId }) => {
    return `/api/surfops/lease-audit-property-onboarding/${runId}/start-audits`;
};
/**
 * @summary Start Onboarding Audits
 */
export const startOnboardingAuditsApiSurfopsLeaseAuditPropertyOnboardingRunIdStartAuditsPost = async ({ runId }, options) => {
    return customFetch(getStartOnboardingAuditsApiSurfopsLeaseAuditPropertyOnboardingRunIdStartAuditsPostUrl({ runId }), {
        ...options,
        method: 'POST'
    });
};
export const getGetPropertyChargeAnalysisApiSurfopsPropertiesPropertyIdChargeAnalysisGetUrl = ({ propertyId }) => {
    return `/api/surfops/properties/${propertyId}/charge-analysis`;
};
/**
 * Current and future lease charge codes for one property.
 * @summary Get Property Charge Analysis
 */
export const getPropertyChargeAnalysisApiSurfopsPropertiesPropertyIdChargeAnalysisGet = async ({ propertyId }, options) => {
    return customFetch(getGetPropertyChargeAnalysisApiSurfopsPropertiesPropertyIdChargeAnalysisGetUrl({ propertyId }), {
        ...options,
        method: 'GET'
    });
};
export const getGetTenantChargeAnalysisApiSurfopsTenantsSaasTenantIdChargeAnalysisGetUrl = ({ saasTenantId }) => {
    return `/api/surfops/tenants/${saasTenantId}/charge-analysis`;
};
/**
 * Charge-code distribution across every property for a tenant.
 * @summary Get Tenant Charge Analysis
 */
export const getTenantChargeAnalysisApiSurfopsTenantsSaasTenantIdChargeAnalysisGet = async ({ saasTenantId }, options) => {
    return customFetch(getGetTenantChargeAnalysisApiSurfopsTenantsSaasTenantIdChargeAnalysisGetUrl({ saasTenantId }), {
        ...options,
        method: 'GET'
    });
};
export const getListConfigsApiSurfopsOktaConfigsGetUrl = () => {
    return `/api/surfops/okta/configs`;
};
/**
 * Every tenant that has an Okta config, joined with the tenant name
 * and the (secret-stripped) credentials from Secrets Manager.
 * @summary List Configs
 */
export const listConfigsApiSurfopsOktaConfigsGet = async (options) => {
    return customFetch(getListConfigsApiSurfopsOktaConfigsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getListAvailableTenantsApiSurfopsOktaAvailableTenantsGetUrl = () => {
    return `/api/surfops/okta/available-tenants`;
};
/**
 * Tenants that do NOT yet have an Okta config — the candidates for
 * creating a new one.
 * @summary List Available Tenants
 */
export const listAvailableTenantsApiSurfopsOktaAvailableTenantsGet = async (options) => {
    return customFetch(getListAvailableTenantsApiSurfopsOktaAvailableTenantsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetConfigApiSurfopsOktaConfigsSaasTenantIdGetUrl = ({ saasTenantId }) => {
    return `/api/surfops/okta/configs/${saasTenantId}`;
};
/**
 * @summary Get Config
 */
export const getConfigApiSurfopsOktaConfigsSaasTenantIdGet = async ({ saasTenantId }, options) => {
    return customFetch(getGetConfigApiSurfopsOktaConfigsSaasTenantIdGetUrl({ saasTenantId }), {
        ...options,
        method: 'GET'
    });
};
export const getUpsertConfigApiSurfopsOktaConfigsSaasTenantIdPutUrl = ({ saasTenantId }) => {
    return `/api/surfops/okta/configs/${saasTenantId}`;
};
/**
 * @summary Upsert Config
 */
export const upsertConfigApiSurfopsOktaConfigsSaasTenantIdPut = async ({ saasTenantId }, oktaConfigRequest, options) => {
    return customFetch(getUpsertConfigApiSurfopsOktaConfigsSaasTenantIdPutUrl({ saasTenantId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(oktaConfigRequest)
    });
};
export const getDeleteConfigApiSurfopsOktaConfigsSaasTenantIdDeleteUrl = ({ saasTenantId }) => {
    return `/api/surfops/okta/configs/${saasTenantId}`;
};
/**
 * @summary Delete Config
 */
export const deleteConfigApiSurfopsOktaConfigsSaasTenantIdDelete = async ({ saasTenantId }, options) => {
    return customFetch(getDeleteConfigApiSurfopsOktaConfigsSaasTenantIdDeleteUrl({ saasTenantId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getOktaResultsPageApiSurfopsOktaResultsGetUrl = () => {
    return `/api/surfops/okta/results`;
};
/**
 * @summary Okta Results Page
 */
export const oktaResultsPageApiSurfopsOktaResultsGet = async (options) => {
    return customFetch(getOktaResultsPageApiSurfopsOktaResultsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getListUsagePlansApiSurfopsUsagePlansGetUrl = () => {
    return `/api/surfops/usage-plans`;
};
/**
 * List API Gateway usage plans (name, throttle, quota).
 * @summary List Usage Plans
 */
export const listUsagePlansApiSurfopsUsagePlansGet = async (options) => {
    return customFetch(getListUsagePlansApiSurfopsUsagePlansGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getCreateApiKeyApiSurfopsApiKeysPostUrl = () => {
    return `/api/surfops/api-keys`;
};
/**
 * Provision a new customer API key. Returns the raw key exactly once.
 * @summary Create Api Key
 */
export const createApiKeyApiSurfopsApiKeysPost = async (apiKeyCreateRequest, options) => {
    return customFetch(getCreateApiKeyApiSurfopsApiKeysPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(apiKeyCreateRequest)
    });
};
export const getListApiKeysApiSurfopsApiKeysGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/surfops/api-keys?${stringifiedParams}` : `/api/surfops/api-keys`;
};
/**
 * List API keys. Omit tenant_id to return keys across all tenants.
 * @summary List Api Keys
 */
export const listApiKeysApiSurfopsApiKeysGet = async (params, options) => {
    return customFetch(getListApiKeysApiSurfopsApiKeysGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getRevokeApiKeyApiSurfopsApiKeysKeyIdDeleteUrl = ({ keyId }) => {
    return `/api/surfops/api-keys/${keyId}`;
};
/**
 * Revoke a customer API key
 * @summary Revoke Api Key
 */
export const revokeApiKeyApiSurfopsApiKeysKeyIdDelete = async ({ keyId }, options) => {
    return customFetch(getRevokeApiKeyApiSurfopsApiKeysKeyIdDeleteUrl({ keyId }), {
        ...options,
        method: 'DELETE'
    });
};
export const getGetMsftUserInfoApiSurfopsUsersUserIdMsftUserInfoGetUrl = ({ userId }) => {
    return `/api/surfops/users/${userId}/msft-user-info`;
};
/**
 * Return the `msft_user_info` row for a Surface user, or `null`
 * when the user has never been enrolled.
 *
 * Returning `null` (rather than 404) keeps the admin UI's empty-form
 * state straightforward: the caller can pre-fill defaults and PUT to
 * create.
 * @summary Get Msft User Info
 */
export const getMsftUserInfoApiSurfopsUsersUserIdMsftUserInfoGet = async ({ userId }, options) => {
    return customFetch(getGetMsftUserInfoApiSurfopsUsersUserIdMsftUserInfoGetUrl({ userId }), {
        ...options,
        method: 'GET'
    });
};
export const getUpsertMsftUserInfoApiSurfopsUsersUserIdMsftUserInfoPutUrl = ({ userId }) => {
    return `/api/surfops/users/${userId}/msft-user-info`;
};
/**
 * Upsert the caller-specified fields onto the target user's row.
 *
 * Validation:
 * - Target Surface user must exist (404 otherwise).
 * - `email_address` is not part of the payload. On update we keep the
 *   stored email; on create we seed it from the Surface user's current
 *   `email`, which mirrors how the enrollment pipeline resolves
 *   identity.
 * @summary Upsert Msft User Info
 */
export const upsertMsftUserInfoApiSurfopsUsersUserIdMsftUserInfoPut = async ({ userId }, msftUserInfoUpdate, options) => {
    return customFetch(getUpsertMsftUserInfoApiSurfopsUsersUserIdMsftUserInfoPutUrl({ userId }), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(msftUserInfoUpdate)
    });
};
export const getPingRedisApiInfraRedisPingGetUrl = () => {
    return `/api/infra/redis/ping`;
};
/**
 * @summary Ping Redis
 */
export const pingRedisApiInfraRedisPingGet = async (options) => {
    return customFetch(getPingRedisApiInfraRedisPingGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetRedisKeyApiInfraRedisKeysGetUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/infra/redis/keys?${stringifiedParams}` : `/api/infra/redis/keys`;
};
/**
 * @summary Get Redis Key
 */
export const getRedisKeyApiInfraRedisKeysGet = async (params, options) => {
    return customFetch(getGetRedisKeyApiInfraRedisKeysGetUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getPutRedisKeyApiInfraRedisKeysPutUrl = () => {
    return `/api/infra/redis/keys`;
};
/**
 * @summary Put Redis Key
 */
export const putRedisKeyApiInfraRedisKeysPut = async (redisSetKeyRequest, options) => {
    return customFetch(getPutRedisKeyApiInfraRedisKeysPutUrl(), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(redisSetKeyRequest)
    });
};
export const getDeleteRedisKeyApiInfraRedisKeysDeleteUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/infra/redis/keys?${stringifiedParams}` : `/api/infra/redis/keys`;
};
/**
 * @summary Delete Redis Key
 */
export const deleteRedisKeyApiInfraRedisKeysDelete = async (params, options) => {
    return customFetch(getDeleteRedisKeyApiInfraRedisKeysDeleteUrl(params), {
        ...options,
        method: 'DELETE'
    });
};
export const getRootApiCheckGetUrl = () => {
    return `/api/check`;
};
/**
 * @summary Root
 */
export const rootApiCheckGet = async (options) => {
    return customFetch(getRootApiCheckGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getMicrosoftIdentityAssociationWellKnownMicrosoftIdentityAssociationJsonGetUrl = () => {
    return `/.well-known/microsoft-identity-association.json`;
};
/**
 * @summary Microsoft Identity Association
 */
export const microsoftIdentityAssociationWellKnownMicrosoftIdentityAssociationJsonGet = async (options) => {
    return customFetch(getMicrosoftIdentityAssociationWellKnownMicrosoftIdentityAssociationJsonGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getUppyGoldenRetrieverServiceWorkerUppyGoldenRetrieverSwJsGetUrl = () => {
    return `/uppy-golden-retriever-sw.js`;
};
/**
 * @summary Uppy Golden Retriever Service Worker
 */
export const uppyGoldenRetrieverServiceWorkerUppyGoldenRetrieverSwJsGet = async (options) => {
    return customFetch(getUppyGoldenRetrieverServiceWorkerUppyGoldenRetrieverSwJsGetUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getFallbackFallbackPathGetUrl = ({ fallbackPath }) => {
    return `/${fallbackPath}`;
};
/**
 * @summary Fallback
 */
export const fallbackFallbackPathGet = async ({ fallbackPath }, options) => {
    return customFetch(getFallbackFallbackPathGetUrl({ fallbackPath }), {
        ...options,
        method: 'GET'
    });
};
